window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var id = container.getAttribute('data-section-id');
    var type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = this.instances.filter(function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onSelect === 'function'
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onDeselect === 'function'
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockSelect === 'function'
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockDeselect === 'function'
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function(container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  resizeSelects: function(selects) {
    selects.forEach(function(select) {
      var arrowWidth = 55;

      var test = document.createElement('span');
      test.innerHTML = select.selectedOptions[0].label;

      document.querySelector('.site-footer').appendChild(test);

      var width = test.offsetWidth + arrowWidth;
      test.remove();

      select.style.width = width + 'px';
    });
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.tables - Elements of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.tables.forEach(function(table) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.tableWrapperClass);

      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {NodeList} options.iframes - Elements of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.iframes.forEach(function(iframe) {
      var wrapper = document.createElement('div');
      wrapper.classList.add(options.iframeWrapperClass);

      iframe.parentNode.insertBefore(wrapper, iframe);
      wrapper.appendChild(iframe);

      iframe.src = iframe.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  state: {
    firstFocusable: null,
    lastFocusable: null
  },
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects
   *
   * @param {HTMLElement} element - The element to be acted upon
   */
  pageLinkFocus: function(element) {
    if (!element) return;
    var focusClass = 'js-focus-hidden';

    element.setAttribute('tabIndex', '-1');
    element.focus();
    element.classList.add(focusClass);
    element.addEventListener('blur', callback, { once: true });

    function callback() {
      element.classList.remove(focusClass);
      element.removeAttribute('tabindex');
    }
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   * @param {HTMLElement} options.elementToFocus - Element to be focused when focus leaves container
   */
  trapFocus: function(options) {
    var focusableElements = Array.from(
      options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      )
    ).filter(function(element) {
      var width = element.offsetWidth;
      var height = element.offsetHeight;

      return (
        width !== 0 &&
        height !== 0 &&
        getComputedStyle(element).getPropertyValue('display') !== 'none'
      );
    });

    this.state.firstFocusable = focusableElements[0];
    this.state.lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    this._setupHandlers();

    document.addEventListener('focusin', this._onFocusInHandler);
    document.addEventListener('focusout', this._onFocusOutHandler);
  },

  _setupHandlers: function() {
    if (!this._onFocusInHandler) {
      this._onFocusInHandler = this._onFocusIn.bind(this);
    }

    if (!this._onFocusOutHandler) {
      this._onFocusOutHandler = this._onFocusIn.bind(this);
    }

    if (!this._manageFocusHandler) {
      this._manageFocusHandler = this._manageFocus.bind(this);
    }
  },

  _onFocusOut: function() {
    document.removeEventListener('keydown', this._manageFocusHandler);
  },

  _onFocusIn: function(evt) {
    if (
      evt.target !== this.state.lastFocusable &&
      evt.target !== this.state.firstFocusable
    )
      return;

    document.addEventListener('keydown', this._manageFocusHandler);
  },

  _manageFocus: function(evt) {
    if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

    /**
     * On the last focusable element and tab forward,
     * focus the first element.
     */
    if (evt.target === this.state.lastFocusable && !evt.shiftKey) {
      evt.preventDefault();
      this.state.firstFocusable.focus();
    }
    /**
     * On the first focusable element and tab backward,
     * focus the last element.
     */
    if (evt.target === this.state.firstFocusable && evt.shiftKey) {
      evt.preventDefault();
      this.state.lastFocusable.focus();
    }
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {HTMLElement} options.container - Container to trap focus within
   */
  removeTrapFocus: function(options) {
    if (options.container) {
      options.container.removeAttribute('tabindex');
    }
    document.removeEventListener('focusin', this._onFocusInHandler);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {HTMLElement} options.links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.links === undefined || !options.links.length) {
      options.links = document.querySelectorAll(
        'a[href]:not([aria-describedby])'
      );
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = Object.assign(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite(link) {
      var hostname = window.location.hostname;

      return link.hostname !== hostname;
    }

    options.links.forEach(function(link) {
      var target = link.getAttribute('target');
      var rel = link.getAttribute('rel');
      var isExternal = _externalSite(link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        link.setAttribute('aria-describedby', idSelectors.external);
      }

      if (isTargetBlank) {
        if (!rel || rel.indexOf('noopener') === -1) {
          var relValue = rel === undefined ? '' : rel + ' ';
          relValue = relValue + 'noopener';
          link.setAttribute('rel', relValue);
        }

        link.setAttribute('aria-describedby', idSelectors.newWindow);
      }

      if (isExternal && isTargetBlank) {
        link.setAttribute('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.container = options.container;
    this.product = options.product;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.singleOptions = this.container.querySelectorAll(
      options.singleOptionSelector
    );
    this.currentVariant = this._getVariantFromOptions();

    this.singleOptions.forEach(
      function(option) {
        option.addEventListener('change', this._onSelectChange.bind(this));
      }.bind(this)
    );
  }

  Variants.prototype = Object.assign({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var result = [];

      this.singleOptions.forEach(function(option) {
        var type = option.getAttribute('type');
        var isRadioOrCheckbox = type === 'radio' || type === 'checkbox';

        if (!isRadioOrCheckbox || option.checked) {
          result.push({
            value: option.value,
            index: option.getAttribute('data-index')
          });
        }
      });

      return result;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = variants.find(function(variant) {
        return selectedValues.every(function(values) {
          return variant[values.index] === values.value;
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.container.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantImageChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantPriceChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.container.dispatchEvent(
        new CustomEvent('variantSKUChange', {
          detail: {
            variant: variant
          },
          bubbles: true,
          cancelable: true
        })
      );
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      var masterSelect = this.container.querySelector(this.originalSelectorId);

      if (!masterSelect) return;
      masterSelect.value = variant.id;
    }
  });

  return Variants;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearch = (function() {
  'use strict';

  function validateQuery(query) {
    var error;

    if (query === null || query === undefined) {
      error = new TypeError("'query' is missing");
      error.type = 'argument';
      throw error;
    }

    if (typeof query !== 'string') {
      error = new TypeError("'query' is not a string");
      error.type = 'argument';
      throw error;
    }
  }

  function GenericError() {
    var error = Error.call(this);

    error.name = 'Server error';
    error.message = 'Something went wrong on the server';
    error.status = 500;

    return error;
  }

  function NotFoundError(status) {
    var error = Error.call(this);

    error.name = 'Not found';
    error.message = 'Not found';
    error.status = status;

    return error;
  }

  function ServerError() {
    var error = Error.call(this);

    error.name = 'Server error';
    error.message = 'Something went wrong on the server';
    error.status = 500;

    return error;
  }

  function ContentTypeError(status) {
    var error = Error.call(this);

    error.name = 'Content-Type error';
    error.message = 'Content-Type was not provided or is of wrong type';
    error.status = status;

    return error;
  }

  function JsonParseError(status) {
    var error = Error.call(this);

    error.name = 'JSON parse error';
    error.message = 'JSON syntax error';
    error.status = status;

    return error;
  }

  function ThrottledError(status, name, message, retryAfter) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;
    error.retryAfter = retryAfter;

    return error;
  }

  function InvalidParameterError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function ExpectationFailedError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function request(configParams, query, onSuccess, onError) {
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function() {
      if (xhr.readyState !== XMLHttpRequest.DONE) {
        return;
      }

      var contentType = xhr.getResponseHeader('Content-Type');

      if (xhr.status >= 500) {
        onError(new ServerError());

        return;
      }

      if (xhr.status === 404) {
        onError(new NotFoundError(xhr.status));

        return;
      }

      if (
        typeof contentType !== 'string' ||
        contentType.toLowerCase().match('application/json') === null
      ) {
        onError(new ContentTypeError(xhr.status));

        return;
      }

      if (xhr.status === 417) {
        try {
          var invalidParameterJson = JSON.parse(xhr.responseText);

          onError(
            new InvalidParameterError(
              xhr.status,
              invalidParameterJson.message,
              invalidParameterJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 422) {
        try {
          var expectationFailedJson = JSON.parse(xhr.responseText);

          onError(
            new ExpectationFailedError(
              xhr.status,
              expectationFailedJson.message,
              expectationFailedJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 429) {
        try {
          var throttledJson = JSON.parse(xhr.responseText);

          onError(
            new ThrottledError(
              xhr.status,
              throttledJson.message,
              throttledJson.description,
              xhr.getResponseHeader('Retry-After')
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          res.query = query;
          onSuccess(res);
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      try {
        var genericErrorJson = JSON.parse(xhr.responseText);
        onError(
          new GenericError(
            xhr.status,
            genericErrorJson.message,
            genericErrorJson.description
          )
        );
      } catch (error) {
        onError(new JsonParseError(xhr.status));
      }

      return;
    };

    xhr.open(
      'get',
      '/search/suggest.json?q=' + encodeURIComponent(query) + '&' + configParams
    );

    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.send();
  }

  function Cache(config) {
    this._store = {};
    this._keys = [];
    if (config && config.bucketSize) {
      this.bucketSize = config.bucketSize;
    } else {
      this.bucketSize = 20;
    }
  }

  Cache.prototype.set = function(key, value) {
    if (this.count() >= this.bucketSize) {
      var deleteKey = this._keys.splice(0, 1);
      this.delete(deleteKey);
    }

    this._keys.push(key);
    this._store[key] = value;

    return this._store;
  };

  Cache.prototype.get = function(key) {
    return this._store[key];
  };

  Cache.prototype.has = function(key) {
    return Boolean(this._store[key]);
  };

  Cache.prototype.count = function() {
    return Object.keys(this._store).length;
  };

  Cache.prototype.delete = function(key) {
    var exists = Boolean(this._store[key]);
    delete this._store[key];
    return exists && !this._store[key];
  };

  function Dispatcher() {
    this.events = {};
  }

  Dispatcher.prototype.on = function(eventName, callback) {
    var event = this.events[eventName];
    if (!event) {
      event = new DispatcherEvent(eventName);
      this.events[eventName] = event;
    }
    event.registerCallback(callback);
  };

  Dispatcher.prototype.off = function(eventName, callback) {
    var event = this.events[eventName];
    if (event && event.callbacks.indexOf(callback) > -1) {
      event.unregisterCallback(callback);
      if (event.callbacks.length === 0) {
        delete this.events[eventName];
      }
    }
  };

  Dispatcher.prototype.dispatch = function(eventName, payload) {
    var event = this.events[eventName];
    if (event) {
      event.fire(payload);
    }
  };

  function DispatcherEvent(eventName) {
    this.eventName = eventName;
    this.callbacks = [];
  }

  DispatcherEvent.prototype.registerCallback = function(callback) {
    this.callbacks.push(callback);
  };

  DispatcherEvent.prototype.unregisterCallback = function(callback) {
    var index = this.callbacks.indexOf(callback);
    if (index > -1) {
      this.callbacks.splice(index, 1);
    }
  };

  DispatcherEvent.prototype.fire = function(payload) {
    var callbacks = this.callbacks.slice(0);
    callbacks.forEach(function(callback) {
      callback(payload);
    });
  };

  function debounce(func, wait) {
    var timeout = null;
    return function() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        timeout = null;
        func.apply(context, args);
      }, wait || 0);
    };
  }

  function objectToQueryParams(obj, parentKey) {
    var output = '';
    parentKey = parentKey || null;

    Object.keys(obj).forEach(function(key) {
      var outputKey = key + '=';
      if (parentKey) {
        outputKey = parentKey + '[' + key + ']';
      }

      switch (trueTypeOf(obj[key])) {
        case 'object':
          output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
          break;
        case 'array':
          output += outputKey + '=' + obj[key].join(',') + '&';
          break;
        default:
          if (parentKey) {
            outputKey += '=';
          }
          output += outputKey + encodeURIComponent(obj[key]) + '&';
          break;
      }
    });

    return output;
  }

  function trueTypeOf(obj) {
    return Object.prototype.toString
      .call(obj)
      .slice(8, -1)
      .toLowerCase();
  }

  var DEBOUNCE_RATE = 10;
  var requestDebounced = debounce(request, DEBOUNCE_RATE);

  function PredictiveSearch(config) {
    if (!config) {
      throw new TypeError('No config object was specified');
    }

    this._retryAfter = null;
    this._currentQuery = null;

    this.dispatcher = new Dispatcher();
    this.cache = new Cache({ bucketSize: 40 });
    this.configParams = objectToQueryParams(config);
  }

  PredictiveSearch.TYPES = {
    PRODUCT: 'product',
    PAGE: 'page',
    ARTICLE: 'article'
  };

  PredictiveSearch.FIELDS = {
    AUTHOR: 'author',
    BODY: 'body',
    PRODUCT_TYPE: 'product_type',
    TAG: 'tag',
    TITLE: 'title',
    VARIANTS_BARCODE: 'variants.barcode',
    VARIANTS_SKU: 'variants.sku',
    VARIANTS_TITLE: 'variants.title',
    VENDOR: 'vendor'
  };

  PredictiveSearch.UNAVAILABLE_PRODUCTS = {
    SHOW: 'show',
    HIDE: 'hide',
    LAST: 'last'
  };

  PredictiveSearch.prototype.query = function query(query) {
    try {
      validateQuery(query);
    } catch (error) {
      this.dispatcher.dispatch('error', error);
      return;
    }

    if (query === '') {
      return this;
    }

    this._currentQuery = normalizeQuery(query);
    var cacheResult = this.cache.get(this._currentQuery);
    if (cacheResult) {
      this.dispatcher.dispatch('success', cacheResult);
      return this;
    }

    requestDebounced(
      this.configParams,
      query,
      function(result) {
        this.cache.set(normalizeQuery(result.query), result);
        if (normalizeQuery(result.query) === this._currentQuery) {
          this._retryAfter = null;
          this.dispatcher.dispatch('success', result);
        }
      }.bind(this),
      function(error) {
        if (error.retryAfter) {
          this._retryAfter = error.retryAfter;
        }
        this.dispatcher.dispatch('error', error);
      }.bind(this)
    );

    return this;
  };

  PredictiveSearch.prototype.on = function on(eventName, callback) {
    this.dispatcher.on(eventName, callback);

    return this;
  };

  PredictiveSearch.prototype.off = function on(eventName, callback) {
    this.dispatcher.off(eventName, callback);

    return this;
  };

  function normalizeQuery(query) {
    if (typeof query !== 'string') {
      return null;
    }

    return query
      .trim()
      .replace(' ', '-')
      .toLowerCase();
  }

  return PredictiveSearch;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearchComponent = (function(PredictiveSearch) {
  'use strict';

  PredictiveSearch =
    PredictiveSearch && PredictiveSearch.hasOwnProperty('default')
      ? PredictiveSearch['default']
      : PredictiveSearch;

  var DEFAULT_PREDICTIVE_SEARCH_API_CONFIG = {
    resources: {
      type: [PredictiveSearch.TYPES.PRODUCT],
      options: {
        unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
        fields: [
          PredictiveSearch.FIELDS.TITLE,
          PredictiveSearch.FIELDS.VENDOR,
          PredictiveSearch.FIELDS.PRODUCT_TYPE,
          PredictiveSearch.FIELDS.VARIANTS_TITLE
        ]
      }
    }
  };

  function PredictiveSearchComponent(config) {
    // validate config
    if (
      !config ||
      !config.selectors ||
      !config.selectors.input ||
      !isString(config.selectors.input) ||
      !config.selectors.result ||
      !isString(config.selectors.result) ||
      !config.resultTemplateFct ||
      !isFunction(config.resultTemplateFct) ||
      !config.numberOfResultsTemplateFct ||
      !isFunction(config.numberOfResultsTemplateFct) ||
      !config.loadingResultsMessageTemplateFct ||
      !isFunction(config.loadingResultsMessageTemplateFct)
    ) {
      var error = new TypeError(
        'PredictiveSearchComponent config is not valid'
      );
      error.type = 'argument';
      throw error;
    }

    // Find nodes
    this.nodes = findNodes(config.selectors);

    // Validate nodes
    if (!isValidNodes(this.nodes)) {
      // eslint-disable-next-line no-console
      console.warn('Could not find valid nodes');
      return;
    }

    // Store the keyword that was used for the search
    this._searchKeyword = '';

    // Assign result template
    this.resultTemplateFct = config.resultTemplateFct;

    // Assign number of results template
    this.numberOfResultsTemplateFct = config.numberOfResultsTemplateFct;

    // Assign loading state template function
    this.loadingResultsMessageTemplateFct =
      config.loadingResultsMessageTemplateFct;

    // Assign number of search results
    this.numberOfResults = config.numberOfResults || 4;

    // Set classes
    this.classes = {
      visibleVariant: config.visibleVariant
        ? config.visibleVariant
        : 'predictive-search-wrapper--visible',
      itemSelected: config.itemSelectedClass
        ? config.itemSelectedClass
        : 'predictive-search-item--selected',
      clearButtonVisible: config.clearButtonVisibleClass
        ? config.clearButtonVisibleClass
        : 'predictive-search__clear-button--visible'
    };

    this.selectors = {
      searchResult: config.searchResult
        ? config.searchResult
        : '[data-search-result]'
    };

    // Assign callbacks
    this.callbacks = assignCallbacks(config);

    // Add input attributes
    addInputAttributes(this.nodes.input);

    // Add input event listeners
    this._addInputEventListeners();

    // Add body listener
    this._addBodyEventListener();

    // Add accessibility announcer
    this._addAccessibilityAnnouncer();

    // Display the reset button if the input is not empty
    this._toggleClearButtonVisibility();

    // Instantiate Predictive Search API
    this.predictiveSearch = new PredictiveSearch(
      config.PredictiveSearchAPIConfig
        ? config.PredictiveSearchAPIConfig
        : DEFAULT_PREDICTIVE_SEARCH_API_CONFIG
    );

    // Add predictive search success event listener
    this.predictiveSearch.on(
      'success',
      this._handlePredictiveSearchSuccess.bind(this)
    );

    // Add predictive search error event listener
    this.predictiveSearch.on(
      'error',
      this._handlePredictiveSearchError.bind(this)
    );
  }

  /**
   * Private methods
   */
  function findNodes(selectors) {
    return {
      input: document.querySelector(selectors.input),
      reset: document.querySelector(selectors.reset),
      result: document.querySelector(selectors.result)
    };
  }

  function isValidNodes(nodes) {
    if (
      !nodes ||
      !nodes.input ||
      !nodes.result ||
      nodes.input.tagName !== 'INPUT'
    ) {
      return false;
    }

    return true;
  }

  function assignCallbacks(config) {
    return {
      onBodyMousedown: config.onBodyMousedown,
      onBeforeOpen: config.onBeforeOpen,
      onOpen: config.onOpen,
      onBeforeClose: config.onBeforeClose,
      onClose: config.onClose,
      onInputFocus: config.onInputFocus,
      onInputKeyup: config.onInputKeyup,
      onInputBlur: config.onInputBlur,
      onInputReset: config.onInputReset,
      onBeforeDestroy: config.onBeforeDestroy,
      onDestroy: config.onDestroy
    };
  }

  function addInputAttributes(input) {
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
  }

  function removeInputAttributes(input) {
    input.removeAttribute('autocorrect', 'off');
    input.removeAttribute('autocomplete', 'off');
    input.removeAttribute('autocapitalize', 'off');
    input.removeAttribute('spellcheck', 'false');
  }

  /**
   * Public variables
   */
  PredictiveSearchComponent.prototype.isResultVisible = false;
  PredictiveSearchComponent.prototype.results = {};

  /**
   * "Private" variables
   */
  PredictiveSearchComponent.prototype._latencyTimer = null;
  PredictiveSearchComponent.prototype._resultNodeClicked = false;

  /**
   * "Private" instance methods
   */
  PredictiveSearchComponent.prototype._addInputEventListeners = function() {
    var input = this.nodes.input;
    var reset = this.nodes.reset;

    if (!input) {
      return;
    }

    this._handleInputFocus = this._handleInputFocus.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
    this._handleInputKeyup = this._handleInputKeyup.bind(this);
    this._handleInputKeydown = this._handleInputKeydown.bind(this);

    input.addEventListener('focus', this._handleInputFocus);
    input.addEventListener('blur', this._handleInputBlur);
    input.addEventListener('keyup', this._handleInputKeyup);
    input.addEventListener('keydown', this._handleInputKeydown);

    if (reset) {
      this._handleInputReset = this._handleInputReset.bind(this);
      reset.addEventListener('click', this._handleInputReset);
    }
  };

  PredictiveSearchComponent.prototype._removeInputEventListeners = function() {
    var input = this.nodes.input;

    input.removeEventListener('focus', this._handleInputFocus);
    input.removeEventListener('blur', this._handleInputBlur);
    input.removeEventListener('keyup', this._handleInputKeyup);
    input.removeEventListener('keydown', this._handleInputKeydown);
  };

  PredictiveSearchComponent.prototype._addBodyEventListener = function() {
    this._handleBodyMousedown = this._handleBodyMousedown.bind(this);

    document
      .querySelector('body')
      .addEventListener('mousedown', this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeBodyEventListener = function() {
    document
      .querySelector('body')
      .removeEventListener('mousedown', this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeClearButtonEventListener = function() {
    var reset = this.nodes.reset;

    if (!reset) {
      return;
    }

    reset.removeEventListener('click', this._handleInputReset);
  };

  /**
   * Event handlers
   */
  PredictiveSearchComponent.prototype._handleBodyMousedown = function(evt) {
    if (this.isResultVisible && this.nodes !== null) {
      if (
        evt.target.isEqualNode(this.nodes.input) ||
        this.nodes.input.contains(evt.target) ||
        evt.target.isEqualNode(this.nodes.result) ||
        this.nodes.result.contains(evt.target)
      ) {
        this._resultNodeClicked = true;
      } else {
        if (isFunction(this.callbacks.onBodyMousedown)) {
          var returnedValue = this.callbacks.onBodyMousedown(this.nodes);
          if (isBoolean(returnedValue) && returnedValue) {
            this.close();
          }
        } else {
          this.close();
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._handleInputFocus = function(evt) {
    if (isFunction(this.callbacks.onInputFocus)) {
      var returnedValue = this.callbacks.onInputFocus(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputBlur = function() {
    // This has to be done async, to wait for the focus to be on the next
    // element and avoid closing the results.
    // Example: Going from the input to the reset button.
    setTimeout(
      function() {
        if (isFunction(this.callbacks.onInputBlur)) {
          var returnedValue = this.callbacks.onInputBlur(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        if (document.activeElement.isEqualNode(this.nodes.reset)) {
          return false;
        }

        if (this._resultNodeClicked) {
          this._resultNodeClicked = false;
          return false;
        }

        this.close();
      }.bind(this)
    );

    return true;
  };

  PredictiveSearchComponent.prototype._addAccessibilityAnnouncer = function() {
    this._accessibilityAnnouncerDiv = window.document.createElement('div');

    this._accessibilityAnnouncerDiv.setAttribute(
      'style',
      'position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;'
    );

    this._accessibilityAnnouncerDiv.setAttribute('data-search-announcer', '');
    this._accessibilityAnnouncerDiv.setAttribute('aria-live', 'polite');
    this._accessibilityAnnouncerDiv.setAttribute('aria-atomic', 'true');

    this.nodes.result.parentElement.appendChild(
      this._accessibilityAnnouncerDiv
    );
  };

  PredictiveSearchComponent.prototype._removeAccessibilityAnnouncer = function() {
    this.nodes.result.parentElement.removeChild(
      this._accessibilityAnnouncerDiv
    );
  };

  PredictiveSearchComponent.prototype._updateAccessibilityAttributesAfterSelectingElement = function(
    previousSelectedElement,
    currentSelectedElement
  ) {
    // Update the active descendant on the search input
    this.nodes.input.setAttribute(
      'aria-activedescendant',
      currentSelectedElement.id
    );

    // Unmark the previousSelected elemented as selected
    if (previousSelectedElement) {
      previousSelectedElement.removeAttribute('aria-selected');
    }

    // Mark the element as selected
    currentSelectedElement.setAttribute('aria-selected', true);
  };

  PredictiveSearchComponent.prototype._clearAriaActiveDescendant = function() {
    this.nodes.input.setAttribute('aria-activedescendant', '');
  };

  PredictiveSearchComponent.prototype._announceNumberOfResultsFound = function(
    results
  ) {
    var currentAnnouncedMessage = this._accessibilityAnnouncerDiv.innerHTML;
    var newMessage = this.numberOfResultsTemplateFct(results);

    // If the messages are the same, they won't get announced
    // add white space so it gets announced
    if (currentAnnouncedMessage === newMessage) {
      newMessage = newMessage + '&nbsp;';
    }

    this._accessibilityAnnouncerDiv.innerHTML = newMessage;
  };

  PredictiveSearchComponent.prototype._announceLoadingState = function() {
    this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
  };

  PredictiveSearchComponent.prototype._handleInputKeyup = function(evt) {
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;
    var RETURN_KEY_CODE = 13;
    var ESCAPE_KEY_CODE = 27;

    if (isFunction(this.callbacks.onInputKeyup)) {
      var returnedValue = this.callbacks.onInputKeyup(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this._toggleClearButtonVisibility();

    if (this.isResultVisible && this.nodes !== null) {
      if (evt.keyCode === UP_ARROW_KEY_CODE) {
        this._navigateOption(evt, 'UP');
        return true;
      }

      if (evt.keyCode === DOWN_ARROW_KEY_CODE) {
        this._navigateOption(evt, 'DOWN');
        return true;
      }

      if (evt.keyCode === RETURN_KEY_CODE) {
        this._selectOption();
        return true;
      }

      if (evt.keyCode === ESCAPE_KEY_CODE) {
        this.close();
      }
    }

    if (evt.target.value.length <= 0) {
      this.close();
      this._setKeyword('');
    } else if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputKeydown = function(evt) {
    var RETURN_KEY_CODE = 13;
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;

    // Prevent the form default submission if there is a selected option
    if (evt.keyCode === RETURN_KEY_CODE && this._getSelectedOption() !== null) {
      evt.preventDefault();
    }

    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      evt.keyCode === UP_ARROW_KEY_CODE ||
      evt.keyCode === DOWN_ARROW_KEY_CODE
    ) {
      evt.preventDefault();
    }
  };

  PredictiveSearchComponent.prototype._handleInputReset = function(evt) {
    evt.preventDefault();

    if (isFunction(this.callbacks.onInputReset)) {
      var returnedValue = this.callbacks.onInputReset(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.input.value = '';
    this.nodes.input.focus();
    this._toggleClearButtonVisibility();
    this.close();

    return true;
  };

  PredictiveSearchComponent.prototype._navigateOption = function(
    evt,
    direction
  ) {
    var currentOption = this._getSelectedOption();

    if (!currentOption) {
      var firstOption = this.nodes.result.querySelector(
        this.selectors.searchResult
      );
      firstOption.classList.add(this.classes.itemSelected);
      this._updateAccessibilityAttributesAfterSelectingElement(
        null,
        firstOption
      );
    } else {
      if (direction === 'DOWN') {
        var nextOption = currentOption.nextElementSibling;
        if (nextOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          nextOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            nextOption
          );
        }
      } else {
        var previousOption = currentOption.previousElementSibling;
        if (previousOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          previousOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            previousOption
          );
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._getSelectedOption = function() {
    return this.nodes.result.querySelector('.' + this.classes.itemSelected);
  };

  PredictiveSearchComponent.prototype._selectOption = function() {
    var selectedOption = this._getSelectedOption();

    if (selectedOption) {
      selectedOption.querySelector('a, button').click();
    }
  };

  PredictiveSearchComponent.prototype._search = function() {
    var newSearchKeyword = this.nodes.input.value;

    if (this._searchKeyword === newSearchKeyword) {
      return;
    }

    clearTimeout(this._latencyTimer);
    this._latencyTimer = setTimeout(
      function() {
        this.results.isLoading = true;

        // Annonuce that we're loading the results
        this._announceLoadingState();

        this.nodes.result.classList.add(this.classes.visibleVariant);
        // NOTE: We could benifit in using DOMPurify.
        // https://github.com/cure53/DOMPurify
        this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      }.bind(this),
      500
    );

    this.predictiveSearch.query(newSearchKeyword);
    this._setKeyword(newSearchKeyword);
  };

  PredictiveSearchComponent.prototype._handlePredictiveSearchSuccess = function(
    json
  ) {
    clearTimeout(this._latencyTimer);
    this.results = json.resources.results;

    this.results.isLoading = false;
    this.results.products = this.results.products.slice(
      0,
      this.numberOfResults
    );
    this.results.canLoadMore =
      this.numberOfResults <= this.results.products.length;
    this.results.searchQuery = this.nodes.input.value;

    if (this.results.products.length > 0 || this.results.searchQuery) {
      this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      this._announceNumberOfResultsFound(this.results);
      this.open();
    } else {
      this.nodes.result.innerHTML = '';

      this._closeOnNoResults();
    }
  };

  PredictiveSearchComponent.prototype._handlePredictiveSearchError = function() {
    clearTimeout(this._latencyTimer);
    this.nodes.result.innerHTML = '';

    this._closeOnNoResults();
  };

  PredictiveSearchComponent.prototype._closeOnNoResults = function() {
    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.isResultVisible = false;
  };

  PredictiveSearchComponent.prototype._setKeyword = function(keyword) {
    this._searchKeyword = keyword;
  };

  PredictiveSearchComponent.prototype._toggleClearButtonVisibility = function() {
    if (!this.nodes.reset) {
      return;
    }

    if (this.nodes.input.value.length > 0) {
      this.nodes.reset.classList.add(this.classes.clearButtonVisible);
    } else {
      this.nodes.reset.classList.remove(this.classes.clearButtonVisible);
    }
  };

  /**
   * Public methods
   */
  PredictiveSearchComponent.prototype.open = function() {
    if (this.isResultVisible) {
      return;
    }

    if (isFunction(this.callbacks.onBeforeOpen)) {
      var returnedValue = this.callbacks.onBeforeOpen(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.add(this.classes.visibleVariant);
    this.nodes.input.setAttribute('aria-expanded', true);
    this.isResultVisible = true;

    if (isFunction(this.callbacks.onOpen)) {
      return this.callbacks.onOpen(this.nodes) || true;
    }

    return true;
  };

  PredictiveSearchComponent.prototype.close = function() {
    if (!this.isResultVisible) {
      return true;
    }

    if (isFunction(this.callbacks.onBeforeClose)) {
      var returnedValue = this.callbacks.onBeforeClose(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.nodes.input.setAttribute('aria-expanded', false);
    this._clearAriaActiveDescendant();
    this._setKeyword('');

    if (isFunction(this.callbacks.onClose)) {
      this.callbacks.onClose(this.nodes);
    }

    this.isResultVisible = false;
    this.results = {};

    return true;
  };

  PredictiveSearchComponent.prototype.destroy = function() {
    this.close();

    if (isFunction(this.callbacks.onBeforeDestroy)) {
      var returnedValue = this.callbacks.onBeforeDestroy(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.remove(this.classes.visibleVariant);
    removeInputAttributes(this.nodes.input);
    this._removeInputEventListeners();
    this._removeBodyEventListener();
    this._removeAccessibilityAnnouncer();
    this._removeClearButtonEventListener();

    if (isFunction(this.callbacks.onDestroy)) {
      this.callbacks.onDestroy(this.nodes);
    }

    return true;
  };

  PredictiveSearchComponent.prototype.clearAndClose = function() {
    this.nodes.input.value = '';
    this.close();
  };

  /**
   * Utilities
   */
  function getTypeOf(value) {
    return Object.prototype.toString.call(value);
  }

  function isString(value) {
    return getTypeOf(value) === '[object String]';
  }

  function isBoolean(value) {
    return getTypeOf(value) === '[object Boolean]';
  }

  function isFunction(value) {
    return getTypeOf(value) === '[object Function]';
  }

  return PredictiveSearchComponent;
})(Shopify.theme.PredictiveSearch);

window.theme = window.theme || {};

theme.TouchEvents = function TouchEvents(element, options) {
  this.axis;
  this.checkEvents = [];
  this.eventHandlers = {};
  this.eventModel = {};
  this.events = [
    ['touchstart', 'touchmove', 'touchend', 'touchcancel'],
    ['pointerdown', 'pointermove', 'pointerup', 'pointercancel'],
    ['mousedown', 'mousemove', 'mouseup']
  ];
  this.eventType;
  this.difference = {};
  this.direction;
  this.start = {};

  this.element = element;
  this.options = Object.assign(
    {},
    {
      dragThreshold: 10,
      start: function() {}, // eslint-disable-line
      move: function() {}, // eslint-disable-line
      end: function() {} // eslint-disable-line
    },
    options
  );

  this.checkEvents = this._getCheckEvents();
  this.eventModel = this._getEventModel();

  this._setupEventHandlers();
};

theme.TouchEvents.prototype = Object.assign({}, theme.TouchEvents.prototype, {
  destroy: function() {
    this.element.removeEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    this.element.removeEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    if (!this.eventModel) {
      this.element.removeEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    this.element.removeEventListener('click', this.eventHandlers.preventClick);
  },

  _setupEventHandlers: function() {
    this.eventHandlers.preventDefault = this._preventDefault.bind(this);
    this.eventHandlers.preventClick = this._preventClick.bind(this);
    this.eventHandlers.touchStart = this._touchStart.bind(this);
    this.eventHandlers.touchMove = this._touchMove.bind(this);
    this.eventHandlers.touchEnd = this._touchEnd.bind(this);

    // Prevent element from dragging when using mouse
    this.element.addEventListener(
      'dragstart',
      this.eventHandlers.preventDefault
    );

    // Bind the touchstart/pointerdown event
    this.element.addEventListener(
      this.events[this.eventModel][0],
      this.eventHandlers.touchStart
    );

    // Bind mousedown if necessary
    if (!this.eventModel) {
      this.element.addEventListener(
        this.events[2][0],
        this.eventHandlers.touchStart
      );
    }

    // No clicking during touch
    this.element.addEventListener('click', this.eventHandlers.preventClick);
  },

  _touchStart: function(event) {
    this.eventType = this.eventModel;

    if (event.type === 'mousedown' && !this.eventModel) {
      this.eventType = 2;
    }

    if (this.checkEvents[this.eventType](event)) return;
    if (this.eventType) this._preventDefault(event);

    document.addEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.addEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.addEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    this.start = {
      xPosition: this.eventType ? event.clientX : event.touches[0].clientX,
      yPosition: this.eventType ? event.clientY : event.touches[0].clientY,
      time: new Date().getTime()
    };

    // Ensure we empty out the this.difference object
    Object.keys(this.difference).forEach(
      function(key) {
        delete this.difference[key];
      }.bind(this)
    );

    this.options.start(event);
  },

  _touchMove: function(event) {
    this.difference = this._getDifference(event);

    // Prevent document from scrolling during swipe gesture
    document['on' + this.events[this.eventType][1]] = function(event) {
      this._preventDefault(event);
    }.bind(this);

    // Get the direction user is dragging
    if (!this.axis) {
      if (this.options.dragThreshold < Math.abs(this.difference.xPosition)) {
        this.axis = 'xPosition';
      } else if (
        this.options.dragThreshold < Math.abs(this.difference.yPosition)
      ) {
        this.axis = 'yPosition';
      } else {
        this.axis = false;
      }
    } else if (this.axis === 'xPosition') {
      this.direction = this.difference.xPosition < 0 ? 'left' : 'right';
    } else if (this.axis === 'yPosition') {
      this.direction = this.difference.yPosition < 0 ? 'up' : 'down';
    }

    this.options.move(event, this.direction, this.difference);
  },

  _touchEnd: function(event) {
    document.removeEventListener(
      this.events[this.eventType][1],
      this.eventHandlers.touchMove
    );

    document.removeEventListener(
      this.events[this.eventType][2],
      this.eventHandlers.touchEnd
    );

    if (this.eventType < 2) {
      document.removeEventListener(
        this.events[this.eventType][3],
        this.eventHandlers.touchEnd
      );
    }

    // Re-enable document scrolling
    document['on' + this.events[this.eventType][1]] = function() {
      return true;
    };

    this.options.end(event, this.direction, this.difference);
    this.axis = false;
  },

  _getDifference: function(event) {
    return {
      xPosition:
        (this.eventType ? event.clientX : event.touches[0].clientX) -
        this.start.xPosition,
      yPosition:
        (this.eventType ? event.clientY : event.touches[0].clientY) -
        this.start.yPosition,
      time: new Date().getTime() - this.start.time
    };
  },

  _getCheckEvents: function() {
    return [
      // Touch events
      function(event) {
        // Skip the event if it's a multi-touch or pinch move
        return (
          (event.touches && event.touches.length > 1) ||
          (event.scale && event.scale !== 1)
        );
      },
      // Pointer events
      function(event) {
        // Skip it, if:
        // 1. The event is not primary (other pointers during multi-touch),
        // 2. Left mouse button is not pressed,
        // 3. Event is not a touch event
        return (
          !event.isPrimary ||
          (event.buttons && event.buttons !== 1) ||
          (event.pointerType !== 'touch' && event.pointerType !== 'pen')
        );
      },
      // Mouse events
      function(event) {
        // Skip the event if left mouse button is not pressed
        return event.buttons && event.buttons !== 1;
      }
    ];
  },

  _getEventModel: function() {
    return window.navigator.pointerEnabled ? 1 : 0;
  },

  _preventDefault: function(event) {
    event.preventDefault ? event.preventDefault() : (event.returnValue = false);
  },

  _preventClick: function(event) {
    if (Math.abs(this.difference.xPosition) > this.options.dragThreshold) {
      this._preventDefault(event);
    }
  }
});


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var DEFAULT_OPEN_CLASS = 'js-drawer-open';
    var DEFAULT_CLOSE_CLASS = 'js-drawer-close';

    var defaults = {
      selectors: {
        openVariant: '.' + DEFAULT_OPEN_CLASS + '-' + position,
        close: '.' + DEFAULT_CLOSE_CLASS
      },
      classes: {
        open: DEFAULT_OPEN_CLASS,
        openVariant: DEFAULT_OPEN_CLASS + '-' + position
      },
      withPredictiveSearch: false
    };

    this.nodes = {
      parents: [document.documentElement, document.body],
      page: document.getElementById('PageContainer')
    };

    this.eventHandlers = {};

    this.config = Object.assign({}, defaults, options);
    this.position = position;
    this.drawer = document.getElementById(id);

    if (!this.drawer) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    document
      .querySelector(this.config.selectors.openVariant)
      .addEventListener('click', this.open.bind(this));
    this.drawer
      .querySelector(this.config.selectors.close)
      .addEventListener('click', this.close.bind(this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget;
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function(parent) {
        parent.classList.add(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    this.drawerIsOpen = true;

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'true');
    }

    // Set focus on drawer
    var trapFocusConfig = {
      container: this.drawer
    };

    if (this.config.elementToFocusOnOpen) {
      trapFocusConfig.elementToFocus = this.config.elementToFocusOnOpen;
    }

    slate.a11y.trapFocus(trapFocusConfig);

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    document.activeElement.dispatchEvent(
      new CustomEvent('blur', { bubbles: true, cancelable: true })
    );

    // Ensure closing transition is applied to moved elements, like the nav
    if (!this.config.withPredictiveSearch) {
      theme.Helpers.prepareTransition(this.drawer);
    }

    this.nodes.parents.forEach(
      function(parent) {
        parent.classList.remove(
          this.config.classes.open,
          this.config.classes.openVariant
        );
      }.bind(this)
    );

    if (this.activeSource && this.activeSource.hasAttribute('aria-expanded')) {
      this.activeSource.setAttribute('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      container: this.drawer
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.eventHandlers.drawerKeyupHandler = function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      } else {
        return true;
      }
    }.bind(this);

    this.eventHandlers.drawerTouchmoveHandler = function() {
      return false;
    };

    this.eventHandlers.drawerClickHandler = function() {
      this.close();
      return false;
    }.bind(this);

    // Add event listener to document body
    document.body.addEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );

    // Lock scrolling on mobile
    this.nodes.page.addEventListener(
      'touchmove',
      this.eventHandlers.drawerTouchmoveHandler
    );

    this.nodes.page.addEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.page.removeEventListener(
      'touchmove',
      this.eventHandlers.drawerTouchmoveHandler
    );
    this.nodes.page.removeEventListener(
      'click',
      this.eventHandlers.drawerClickHandler
    );
    document.body.removeEventListener(
      'keyup',
      this.eventHandlers.drawerKeyupHandler
    );
  };

  return Drawer;
})();

theme.Helpers = (function() {
  var touchDevice = false;

  var classes = {
    preventScrolling: 'prevent-scrolling'
  };

  var scrollPosition = window.pageYOffset;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }

  function enableScrollLock() {
    scrollPosition = window.pageYOffset;
    document.body.style.top = '-' + scrollPosition + 'px';
    document.body.classList.add(classes.preventScrolling);
  }

  function disableScrollLock() {
    document.body.classList.remove(classes.preventScrolling);
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollPosition);
  }

  function debounce(func, wait, immediate) {
    var timeout;

    return function() {
      var context = this,
        args = arguments;

      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };

      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  function getScript(source, beforeEl) {
    return new Promise(function(resolve, reject) {
      var script = document.createElement('script');
      var prior = beforeEl || document.getElementsByTagName('script')[0];

      script.async = true;
      script.defer = true;

      // eslint-disable-next-line shopify/prefer-early-return
      function onloadHander(_, isAbort) {
        if (
          isAbort ||
          !script.readyState ||
          /loaded|complete/.test(script.readyState)
        ) {
          script.onload = null;
          script.onreadystatechange = null;
          script = undefined;

          if (isAbort) {
            reject();
          } else {
            resolve();
          }
        }
      }

      script.onload = onloadHander;
      script.onreadystatechange = onloadHander;

      script.src = source;
      prior.parentNode.insertBefore(script, prior);
    });
  }

  /* Based on the prepareTransition by Jonathan Snook */
  /* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
  function prepareTransition(element) {
    element.addEventListener(
      'transitionend',
      function(event) {
        event.currentTarget.classList.remove('is-transitioning');
      },
      { once: true }
    );

    var properties = [
      'transition-duration',
      '-moz-transition-duration',
      '-webkit-transition-duration',
      '-o-transition-duration'
    ];

    var duration = 0;

    properties.forEach(function(property) {
      var computedValue = getComputedStyle(element)[property];

      if (computedValue) {
        computedValue.replace(/\D/g, '');
        duration || (duration = parseFloat(computedValue));
      }
    });

    if (duration !== 0) {
      element.classList.add('is-transitioning');
      element.offsetWidth;
    }
  }

  /*!
   * Serialize all form data into a SearchParams string
   * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Node}   form The form to serialize
   * @return {String}      The serialized form data
   */
  function serialize(form) {
    var arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach(function(option) {
          if (!option.selected) return;
          arr.push(
            encodeURIComponent(field.name) +
              '=' +
              encodeURIComponent(option.value)
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
      );
    });
    return arr.join('&');
  }
  function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }

  function promiseStylesheet(stylesheet) {
    var stylesheetUrl = stylesheet || theme.stylesheet;

    if (typeof this.stylesheetPromise === 'undefined') {
      this.stylesheetPromise = new Promise(function(resolve) {
        var link = document.querySelector('link[href="' + stylesheetUrl + '"]');

        if (link.loaded) resolve();

        link.addEventListener('load', function() {
          setTimeout(resolve, 0);
        });
      });
    }

    return this.stylesheetPromise;
  }

  return {
    setTouch: setTouch,
    isTouch: isTouch,
    enableScrollLock: enableScrollLock,
    disableScrollLock: disableScrollLock,
    debounce: debounce,
    getScript: getScript,
    prepareTransition: prepareTransition,
    serialize: serialize,
    cookiesEnabled: cookiesEnabled,
    promiseStylesheet: promiseStylesheet
  };
})();

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '[data-has-dropdowns]',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
    siteNavCenteredDropdown: '.site-nav__dropdown--centered',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavDropdown: '.site-nav__dropdown',
    siteHeader: '.site-header'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    rightDropdownClass: 'site-nav__dropdown--right',
    leftDropdownClass: 'site-nav__dropdown--left'
  };

  var cache = {};

  function init() {
    cacheSelectors();
    styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();

    cache.parents.forEach(function(element) {
      element.addEventListener('click', submenuParentClickHandler);
    });

    // check when we're leaving a dropdown and close the active dropdown
    cache.siteNavChildLink.forEach(function(element) {
      element.addEventListener('focusout', submenuFocusoutHandler);
    });

    cache.topLevel.forEach(function(element) {
      element.addEventListener('focus', hideDropdown);
    });

    cache.subMenuLinks.forEach(function(element) {
      element.addEventListener('click', stopImmediatePropagation);
    });

    window.addEventListener('resize', resizeHandler);
  }

  function stopImmediatePropagation(event) {
    event.stopImmediatePropagation();
  }

  function cacheSelectors() {
    var navigation = document.querySelector(selectors.navigation);

    cache = {
      nav: navigation,
      topLevel: document.querySelectorAll(selectors.siteNavLinkMain),
      parents: navigation.querySelectorAll(selectors.siteNavHasDropdown),
      subMenuLinks: document.querySelectorAll(selectors.siteNavChildLinks),
      activeDropdown: document.querySelector(selectors.siteNavActiveDropdown),
      siteHeader: document.querySelector(selectors.siteHeader),
      siteNavChildLink: document.querySelectorAll(selectors.siteNavChildLink)
    };
  }

  function showDropdown(element) {
    element.classList.add(config.activeClass);

    if (cache.activeDropdown) hideDropdown();

    cache.activeDropdown = element;

    element
      .querySelector(selectors.siteNavLinkMain)
      .setAttribute('aria-expanded', 'true');

    setTimeout(function() {
      window.addEventListener('keyup', keyUpHandler);
      document.body.addEventListener('click', hideDropdown);
    }, 250);
  }

  function hideDropdown() {
    if (!cache.activeDropdown) return;

    cache.activeDropdown
      .querySelector(selectors.siteNavLinkMain)
      .setAttribute('aria-expanded', 'false');
    cache.activeDropdown.classList.remove(config.activeClass);

    cache.activeDropdown = document.querySelector(
      selectors.siteNavActiveDropdown
    );

    window.removeEventListener('keyup', keyUpHandler);
    document.body.removeEventListener('click', hideDropdown);
  }

  function styleDropdowns(dropdownListItems) {
    dropdownListItems.forEach(function(item) {
      var dropdownLi = item.querySelector(selectors.siteNavDropdown);

      if (!dropdownLi) return;

      if (isRightOfLogo(item)) {
        dropdownLi.classList.remove(config.leftDropdownClass);
        dropdownLi.classList.add(config.rightDropdownClass);
      } else {
        dropdownLi.classList.remove(config.rightDropdownClass);
        dropdownLi.classList.add(config.leftDropdownClass);
      }
    });
  }

  function isRightOfLogo(item) {
    var rect = item.getBoundingClientRect();
    var win = item.ownerDocument.defaultView;
    var leftOffset = rect.left + win.pageXOffset;

    var headerWidth = Math.floor(cache.siteHeader.offsetWidth) / 2;
    return leftOffset > headerWidth;
  }

  function positionFullWidthDropdowns() {
    document
      .querySelectorAll(selectors.siteNavHasCenteredDropdown)
      .forEach(function(el) {
        var fullWidthDropdown = el.querySelector(
          selectors.siteNavCenteredDropdown
        );

        var fullWidthDropdownOffset = el.offsetTop + 41;
        fullWidthDropdown.style.top = fullWidthDropdownOffset + 'px';
      });
  }

  function keyUpHandler(event) {
    if (event.keyCode === 27) hideDropdown();
  }

  function resizeHandler() {
    adjustStyleAndPosition();
  }

  function submenuParentClickHandler(event) {
    var element = event.currentTarget;

    element.classList.contains(config.activeClass)
      ? hideDropdown()
      : showDropdown(element);
  }

  function submenuFocusoutHandler() {
    setTimeout(function() {
      if (
        document.activeElement.classList.contains(config.childLinkClass) ||
        !cache.activeDropdown
      ) {
        return;
      }

      hideDropdown();
    });
  }

  var adjustStyleAndPosition = theme.Helpers.debounce(function() {
    styleDropdowns(document.querySelectorAll(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();
  }, 50);

  function unload() {
    cache.topLevel.forEach(function(element) {
      element.removeEventListener('focus', hideDropdown);
    });

    cache.subMenuLinks.forEach(function(element) {
      element.removeEventListener('click', stopImmediatePropagation);
    });

    cache.parents.forEach(function(element) {
      element.removeEventListener('click', submenuParentClickHandler);
    });

    cache.siteNavChildLink.forEach(function(element) {
      element.removeEventListener('focusout', submenuFocusoutHandler);
    });

    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('keyup', keyUpHandler);
    document.body.removeEventListener('click', hideDropdown);
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };

  var cache = {};
  var isTransitioning;
  var activeSubNav;
  var activeTrigger;
  var menuLevel = 1;
  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';
  var mql = window.matchMedia(mediumUpQuery);

  function init() {
    cacheSelectors();

    if (cache.mobileNavToggle) {
      cache.mobileNavToggle.addEventListener('click', toggleMobileNav);
    }

    cache.subNavToggleBtns.forEach(function(element) {
      element.addEventListener('click', toggleSubNav);
    });

    mql.addListener(initBreakpoints);
  }

  function initBreakpoints() {
    if (
      mql.matches &&
      cache.mobileNavContainer.classList.contains(classes.navOpen)
    ) {
      closeMobileNav();
    }
  }

  function toggleMobileNav() {
    var mobileNavIsOpen = cache.mobileNavToggle.classList.contains(
      classes.mobileNavCloseIcon
    );

    if (mobileNavIsOpen) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      pageContainer: document.querySelector('#PageContainer'),
      siteHeader: document.querySelector('.site-header'),
      mobileNavToggle: document.querySelector('.js-mobile-nav-toggle'),
      mobileNavContainer: document.querySelector('.mobile-nav-wrapper'),
      mobileNav: document.querySelector('#MobileNav'),
      sectionHeader: document.querySelector('#shopify-section-header'),
      subNavToggleBtns: document.querySelectorAll('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.siteHeader.offsetHeight;

    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.add(classes.navOpen);

    cache.mobileNavContainer.style.transform =
      'translateY(' + translateHeaderHeight + 'px)';

    cache.pageContainer.style.transform =
      'translate3d(0, ' + cache.mobileNavContainer.scrollHeight + 'px, 0)';

    slate.a11y.trapFocus({
      container: cache.sectionHeader,
      elementToFocus: cache.mobileNavToggle
    });

    cache.mobileNavToggle.classList.add(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.setAttribute('aria-expanded', true);

    window.addEventListener('keyup', keyUpHandler);
  }

  function keyUpHandler(event) {
    if (event.which === 27) {
      closeMobileNav();
    }
  }

  function closeMobileNav() {
    theme.Helpers.prepareTransition(cache.mobileNavContainer);
    cache.mobileNavContainer.classList.remove(classes.navOpen);
    cache.mobileNavContainer.style.transform = 'translateY(-100%)';
    cache.pageContainer.setAttribute('style', '');

    slate.a11y.trapFocus({
      container: document.querySelector('html'),
      elementToFocus: document.body
    });

    cache.mobileNavContainer.addEventListener(
      'transitionend',
      mobileNavRemoveTrapFocus,
      { once: true }
    );

    cache.mobileNavToggle.classList.add(classes.mobileNavOpenIcon);
    cache.mobileNavToggle.classList.remove(classes.mobileNavCloseIcon);
    cache.mobileNavToggle.setAttribute('aria-expanded', false);
    cache.mobileNavToggle.focus();

    window.removeEventListener('keyup', keyUpHandler);
    window.scrollTo(0, 0);
  }

  function mobileNavRemoveTrapFocus() {
    slate.a11y.removeTrapFocus({
      container: cache.mobileNav
    });
  }

  function toggleSubNav(event) {
    if (isTransitioning) return;

    var toggleBtn = event.currentTarget;
    var isReturn = toggleBtn.classList.contains(classes.return);

    isTransitioning = true;

    if (isReturn) {
      var subNavToggleBtn = document.querySelectorAll(
        '.' + classes.subNavToggleBtn + "[data-level='" + (menuLevel - 1) + "']"
      );

      subNavToggleBtn.forEach(function(element) {
        element.classList.remove(classes.subNavActive);
      });

      if (activeTrigger) {
        activeTrigger.classList.remove(classes.subNavActive);
      }
    } else {
      toggleBtn.classList.add(classes.subNavActive);
    }

    activeTrigger = toggleBtn;

    goToSubnav(toggleBtn.getAttribute('data-target'));
  }

  function goToSubnav(target) {
    var targetMenu = target
      ? document.querySelector(
          '.mobile-nav__dropdown[data-parent="' + target + '"]'
        )
      : cache.mobileNav;

    menuLevel = targetMenu.dataset.level ? Number(targetMenu.dataset.level) : 1;

    if (activeSubNav) {
      theme.Helpers.prepareTransition(activeSubNav);
      activeSubNav.classList.add(classes.subNavClosing);
    }

    activeSubNav = targetMenu;

    var translateMenuHeight = targetMenu.offsetHeight;

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.mobileNavContainer.style.height = translateMenuHeight + 'px';
    cache.mobileNavContainer.classList.remove(classes.thirdNavShowing);
    cache.mobileNavContainer.classList.add(openNavClass);

    if (!target) {
      cache.mobileNavContainer.classList.remove(
        classes.thirdNavShowing,
        classes.subNavShowing
      );
    }

    /* if going back to first subnav, focus is on whole header */
    var container = menuLevel === 1 ? cache.sectionHeader : targetMenu;

    cache.mobileNavContainer.addEventListener(
      'transitionend',
      trapMobileNavFocus,
      { once: true }
    );

    function trapMobileNavFocus() {
      slate.a11y.trapFocus({
        container: container
      });

      cache.mobileNavContainer.removeEventListener(
        'transitionend',
        trapMobileNavFocus
      );

      isTransitioning = false;
    }

    // Match height of subnav
    cache.pageContainer.style.transform =
      'translateY(' + translateMenuHeight + 'px)';

    activeSubNav.classList.remove(classes.subNavClosing);
  }

  function unload() {
    mql.removeListener(initBreakpoints);
  }

  return {
    init: init,
    unload: unload,
    closeMobileNav: closeMobileNav
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var backButton = document.querySelector(selectors.backButton);

  if (!document.referrer || !backButton || !window.history.length) {
    return;
  }

  backButton.addEventListener(
    'click',
    function(evt) {
      evt.preventDefault();

      var referrerDomain = urlDomain(document.referrer);
      var shopDomain = urlDomain(window.location.href);

      if (shopDomain === referrerDomain) {
        history.back();
      }

      return false;
    },
    { once: true }
  );

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  var selectors = {
    button: '[data-slider-button]',
    indicator: '[data-slider-indicator]',
    indicators: '[data-slider-indicators]',
    pause: '[data-slider-pause]',
    slider: '[data-slider]',
    sliderItem: '[data-slider-item]',
    sliderItemLink: '[data-slider-item-link]',
    sliderTrack: '[data-slider-track]',
    sliderContainer: '[data-slider-container]'
  };

  var classes = {
    isPaused: 'slideshow__pause--is-paused',
    indicator: 'slider-indicators__item',
    indicatorActive: 'slick-active',
    sliderInitialized: 'slick-initialized',
    slideActive: 'slideshow__slide--active',
    slideClone: 'slick-cloned'
  };

  var attributes = {
    buttonNext: 'data-slider-button-next'
  };

  function Slideshow(container, options) {
    this.container = container;
    this.slider = this.container.querySelector(selectors.slider);

    if (!this.slider) return;

    this.eventHandlers = {};
    this.lastSlide = 0;
    this.slideIndex = 0;
    this.sliderContainer = null;
    this.slides = [];
    this.options = Object.assign(
      {},
      {
        autoplay: false,
        canUseKeyboardArrows: true,
        canUseTouchEvents: false,
        slideActiveClass: classes.slideActive,
        slideInterval: 0,
        slidesToShow: 0,
        slidesToScroll: 1,
        type: 'fade'
      },
      options
    );

    this.sliderContainer = this.slider.querySelector(selectors.sliderContainer);
    this.adaptHeight =
      this.sliderContainer.getAttribute('data-adapt-height') === 'true';
    this.slides = Array.from(
      this.sliderContainer.querySelectorAll(selectors.sliderItem)
    );
    // adding -1 to accomodate Array order
    this.lastSlide = this.slides.length - 1;
    this.buttons = this.container.querySelectorAll(selectors.button);
    this.pause = this.container.querySelector(selectors.pause);
    this.indicators = this.container.querySelectorAll(selectors.indicators);

    if (this.slides.length <= 1) return;

    this.timeout = 250;

    if (this.options.autoplay) {
      this.startAutoplay();
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight();
    }

    if (this.options.type === 'slide') {
      this.isFirstSlide = false;
      this.isLastSlide = false;
      this.sliderItemWidthTotal = 0;
      this.sliderTrack = this.slider.querySelector(selectors.sliderTrack);
      // added setTimeout due to matchMedia calling too early
      // which result wrong value when getting dimension from an element
      this.sliderItemWidthTotal = 0;
      theme.Helpers.promiseStylesheet().then(
        function() {
          this._setupSlideType();
        }.bind(this)
      );
    } else {
      this.setupSlider(0);
    }

    this._setupEventHandlers();
  }

  Slideshow.prototype = Object.assign({}, Slideshow.prototype, {
    /**
     * Moves to the previous slide
     */
    previousSlide: function() {
      this._move();
    },

    /**
     * Moves to the next slide
     */
    nextSlide: function() {
      this._move('next');
    },

    /**
     * Moves to the specified slide
     * @param {Number} index - The index of the slide to move to
     */
    setSlide: function(index) {
      this._setPosition(Number(index));
    },

    /**
     * Starts autoplaying the slider if autoplay is enabled
     */
    startAutoplay: function() {
      this.isAutoPlaying = true;

      window.clearTimeout(this.autoTimeOut);

      this.autoTimeOut = window.setTimeout(
        function() {
          var nextSlideIndex = this._getNextSlideIndex('next');
          this._setPosition(nextSlideIndex);
        }.bind(this),
        this.options.slideInterval
      );
    },

    /**
     * Stops autoplaying the slider if autoplay is enabled
     */
    stopAutoplay: function() {
      this.isAutoPlaying = false;

      window.clearTimeout(this.autoTimeOut);
    },

    /**
     * Set active states for sliders and indicators
     * @param {index} integer - Slide index to set up slider from
     */
    setupSlider: function(index) {
      this.slideIndex = index;

      if (this.indicators.length) {
        this._setActiveIndicator(index);
      }

      this._setupActiveSlide(index);
    },

    /**
     * Removes event listeners, among other things when wanting to destroy the
     * slider instance. This method needs to be called manually and will most
     * likely be included in a section's onUnload() method.
     */
    destroy: function() {
      if (this.adaptHeight) {
        window.removeEventListener('resize', this.eventHandlers.debounceResize);
      }

      this.container.removeEventListener(
        'focus',
        this.eventHandlers.focus,
        true
      );
      this.slider.removeEventListener(
        'focusin',
        this.eventHandlers.focusIn,
        true
      );
      this.slider.removeEventListener(
        'focusout',
        this.eventHandlers.focusOut,
        true
      );
      this.container.removeEventListener('blur', this.eventHandlers.blur, true);

      if (this.buttons) {
        this.buttons.forEach(
          function(button) {
            button.removeEventListener('click', this.eventHandlers.clickButton);
          }.bind(this)
        );
      }

      this.indicators.forEach(function(indicatorWrapper) {
        indicatorWrapper.childNodes.forEach(function(indicator) {
          indicator.firstElementChild.removeEventListener(
            'click',
            this.eventHandlers.onClickIndicator
          );

          indicator.firstElementChild.removeEventListener(
            'keydown',
            this.eventHandlers.onKeydownIndicator
          );
        }, this);
      }, this);

      if (this.options.type === 'slide') {
        window.removeEventListener(
          'resize',
          this.eventHandlers.debounceResizeSlideIn
        );

        if (this.touchEvents && this.options.canUseTouchEvents) {
          this.touchEvents.destroy();
          this.touchEvents = null;
        }
      }
    },

    _setupEventHandlers: function() {
      this.eventHandlers.focus = this._onFocus.bind(this);
      this.eventHandlers.focusIn = this._onFocusIn.bind(this);
      this.eventHandlers.focusOut = this._onFocusOut.bind(this);
      this.eventHandlers.blur = this._onBlur.bind(this);
      this.eventHandlers.keyUp = this._onKeyUp.bind(this);
      this.eventHandlers.clickButton = this._onClickButton.bind(this);
      this.eventHandlers.onClickIndicator = this._onClickIndicator.bind(this);
      this.eventHandlers.onKeydownIndicator = this._onKeydownIndicator.bind(
        this
      );
      this.eventHandlers.onClickPause = this._onClickPause.bind(this);

      if (this.adaptHeight) {
        this.eventHandlers.debounceResize = theme.Helpers.debounce(
          function() {
            this.setSlideshowHeight();
          }.bind(this),
          50
        );

        window.addEventListener('resize', this.eventHandlers.debounceResize);
      }

      this.container.addEventListener('focus', this.eventHandlers.focus, true);
      this.slider.addEventListener('focusin', this.eventHandlers.focusIn, true);
      this.slider.addEventListener(
        'focusout',
        this.eventHandlers.focusOut,
        true
      );
      this.container.addEventListener('blur', this.eventHandlers.blur, true);

      if (this.buttons) {
        this.buttons.forEach(
          function(button) {
            button.addEventListener('click', this.eventHandlers.clickButton);
          }.bind(this)
        );
      }

      if (this.pause) {
        this.pause.addEventListener('click', this.eventHandlers.onClickPause);
      }

      this.indicators.forEach(function(indicatorWrapper) {
        indicatorWrapper.childNodes.forEach(function(indicator) {
          indicator.firstElementChild.addEventListener(
            'click',
            this.eventHandlers.onClickIndicator
          );

          indicator.firstElementChild.addEventListener(
            'keydown',
            this.eventHandlers.onKeydownIndicator
          );
        }, this);
      }, this);

      if (this.options.type === 'slide') {
        this.eventHandlers.debounceResizeSlideIn = theme.Helpers.debounce(
          function() {
            this.sliderItemWidthTotal = 0;
            this._setupSlideType(true);
          }.bind(this),
          50
        );

        window.addEventListener(
          'resize',
          this.eventHandlers.debounceResizeSlideIn
        );

        if (
          this.options.canUseTouchEvents &&
          this.options.slidesToScroll < this.slides.length
        ) {
          this._setupTouchEvents();
        }
      }
    },

    _setupTouchEvents: function() {
      this.touchEvents = new theme.TouchEvents(this.sliderTrack, {
        start: function() {
          this._onTouchStart();
        }.bind(this),
        move: function(event, direction, difference) {
          this._onTouchMove(event, direction, difference);
        }.bind(this),
        end: function(event, direction, difference) {
          this._onTouchEnd(event, direction, difference);
        }.bind(this)
      });
    },

    /**
     * Set slideshop for "slide-in" effect
     * @param {Boolean} onResize if function call came from resize event
     */
    _setupSlideType: function(onResize) {
      this.sliderItemWidth = Math.floor(
        this.sliderContainer.offsetWidth / this.options.slidesToShow
      );
      this.sliderTranslateXMove =
        this.sliderItemWidth * this.options.slidesToScroll;

      if (!onResize) {
        this.sliderContainer.classList.add(classes.sliderInitialized);
      }

      // Loop through all slider items
      // Set width according to the number of items to show in 1 slide
      // Set container width to accomodate all items
      this.slides.forEach(function(sliderItem, index) {
        var sliderItemLink = sliderItem.querySelector(selectors.sliderItemLink);
        sliderItem.style.width = this.sliderItemWidth + 'px';
        sliderItem.setAttribute('aria-hidden', true);
        sliderItem.setAttribute('tabindex', -1);
        this.sliderItemWidthTotal =
          this.sliderItemWidthTotal + sliderItem.offsetWidth;

        if (sliderItemLink) {
          sliderItemLink.setAttribute('tabindex', -1);
        }

        if (index < this.options.slidesToShow) {
          sliderItem.setAttribute('aria-hidden', false);
          sliderItem.classList.add(this.options.slideActiveClass);

          if (sliderItemLink) {
            sliderItemLink.setAttribute('tabindex', 0);
          }
        }
      }, this);

      this.sliderTrack.style.width =
        Math.floor(this.sliderItemWidthTotal) + 'px';
      this.sliderTrack.style.transform = 'translateX(-0px)';

      // set disabled attribute on Previous button
      if (this.buttons.length) {
        this.buttons[0].setAttribute('aria-disabled', true);
        this.buttons[1].removeAttribute('aria-disabled');
      }

      if (this.indicators.length) {
        this._setActiveIndicator(0);
      }
    },

    _onTouchStart: function() {
      this.touchStartPosition = this._getTranslateXPosition();
    },

    _onTouchMove: function(event, direction, difference) {
      // Fix touch events cause unexpected behaviour
      // when the dragging motion goes beyond the theme editor preview.
      var threshold = 80;
      if (
        Shopify.designMode &&
        (event.clientX <= threshold ||
          event.clientX >= window.innerWidth - threshold)
      ) {
        event.target.dispatchEvent(
          new MouseEvent('mouseup', {
            bubbles: true,
            cancelable: true
          })
        );
        return;
      }

      if (direction !== 'left' && direction !== 'right') return;

      this.touchMovePosition = this.touchStartPosition + difference.xPosition;

      this.sliderTrack.style.transform =
        'translateX(' + this.touchMovePosition + 'px';
    },

    _onTouchEnd: function(event, direction, difference) {
      var nextTranslateXPosition = 0;

      if (Object.keys(difference).length === 0) return;

      var slideDirection = direction === 'left' ? 'next' : '';

      if (direction === 'left') {
        if (this._isNextTranslateXLast(this.touchStartPosition)) {
          nextTranslateXPosition = this.touchStartPosition;
        } else {
          nextTranslateXPosition =
            this.touchStartPosition - this.sliderTranslateXMove;
        }
      } else {
        nextTranslateXPosition =
          this.touchStartPosition + this.sliderTranslateXMove;
        if (this._isNextTranslateXFirst(this.touchStartPosition)) {
          nextTranslateXPosition = 0;
        }
      }

      this.slideIndex = this._getNextSlideIndex(slideDirection);

      this.sliderTrack.style.transition = 'transform 500ms ease 0s';
      this.sliderTrack.style.transform =
        'translateX(' + nextTranslateXPosition + 'px';

      window.setTimeout(
        function() {
          this.sliderTrack.style.transition = '';
        }.bind(this),
        500
      );

      this._verifyFirstLastSlideTranslateX(nextTranslateXPosition);

      this._postTransitionEnd();
    },

    /**
     * Events handlers for next and previous button
     * @param {Object} event event handler
     */
    _onClickButton: function(event) {
      // prevent multiple clicks
      if (event.detail > 1) return;

      var button = event.currentTarget;
      var nextButton = button.hasAttribute(attributes.buttonNext);

      if (
        this.options.type === 'slide' &&
        button.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      if (this.options.autoplay && this.isAutoPlaying) {
        this.stopAutoplay();
      }

      if (nextButton) {
        this.nextSlide();
      } else {
        this.previousSlide();
      }
    },

    _onClickIndicator: function(event) {
      event.preventDefault();

      if (event.target.classList.contains(classes.indicatorActive)) return;

      if (this.options.autoplay && this.isAutoPlaying) {
        this.stopAutoplay();
      }

      this.slideIndex = Number(event.target.dataset.slideNumber);
      this.goToSlideByIndex(this.slideIndex);
    },

    goToSlideByIndex: function(index) {
      this._setPosition(index);

      if (this.options.type === 'slide' && this.sliderTrack) {
        this.sliderTrack.style.transition = 'transform 500ms ease 0s';
        var newPosition = index * this.slides[0].offsetWidth;

        this.sliderTrack.style.transform = 'translateX(-' + newPosition + 'px)';

        if (this.options.slidesToShow > 1) {
          this._verifyFirstLastSlideTranslateX(newPosition);

          if (this.buttons.length) {
            this._disableArrows();
          }

          this._setupMultipleActiveSlide(
            index,
            index + (this.options.slidesToShow - 1)
          );
        }
      }
    },

    _onKeydownIndicator: function(event) {
      if (event.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      this._onClickIndicator(event);

      this.slider.focus();
    },

    _onClickPause: function(event) {
      if (!event.currentTarget.classList.contains(classes.isPaused)) {
        event.currentTarget.classList.add(classes.isPaused);
        this.stopAutoplay();
      } else {
        event.currentTarget.classList.remove(classes.isPaused);
        this.startAutoplay();
      }
    },

    _onFocus: function() {
      this.container.addEventListener('keyup', this.eventHandlers.keyUp);
    },

    _onFocusIn: function() {
      if (this.slider.hasAttribute('aria-live')) return;

      if (this.options.autoplay && this.isAutoPlaying) {
        this.stopAutoplay();
      }

      this.slider.setAttribute('aria-live', 'polite');
    },

    _onBlur: function() {
      this.container.removeEventListener('keyup', this.eventHandlers.keyUp);
    },

    _onFocusOut: function() {
      this.slider.removeAttribute('aria-live');

      // Adding a setTimeout because everytime we focus out
      // It automatically goes to <body>
      // We want to resume autoplay when focus is outside of the slideshow container
      setTimeout(
        function() {
          if (
            !document.activeElement.closest(
              '#' + this.slider.getAttribute('id')
            )
          ) {
            if (
              this.options.autoplay &&
              !this.isAutoPlaying &&
              !this.pause.classList.contains(classes.isPaused)
            ) {
              this.startAutoplay();
            }
          }
        }.bind(this),
        this.timeout
      );
    },

    _onKeyUp: function(event) {
      switch (event.keyCode) {
        case slate.utils.keyboardKeys.LEFTARROW:
          if (!this.options.canUseKeyboardArrows) return;

          if (this.options.type === 'slide' && this.isFirstSlide) {
            return;
          }

          this.previousSlide();

          break;
        case slate.utils.keyboardKeys.RIGHTARROW:
          if (!this.options.canUseKeyboardArrows) return;

          if (this.options.type === 'slide' && this.isLastSlide) {
            return;
          }

          this.nextSlide();

          break;
        case slate.utils.keyboardKeys.ESCAPE:
          this.slider.blur();
          break;
      }
    },

    _move: function(direction) {
      if (this.options.type === 'slide') {
        this.slideIndex = this._getNextSlideIndex(direction);
        this._moveSlideshow(direction);
      } else {
        var nextSlideIndex = this._getNextSlideIndex(direction);
        this._setPosition(nextSlideIndex);
      }
    },

    _moveSlideshow: function(direction) {
      this.direction = direction;
      var valueXToMove = 0;

      // Get current position of translateX
      var currentTranslateXPosition = this._getTranslateXPosition();
      var currentActiveSlidesIndex = this._getActiveSlidesIndex();

      // In the future, we'll use ES6 deconstructure
      // Math.min(...currentActiveSlidesIndex);
      var currentActiveSlidesMinIndex = Math.min.apply(
        Math,
        currentActiveSlidesIndex
      );
      var currentActiveSlidesMaxIndex = Math.max.apply(
        Math,
        currentActiveSlidesIndex
      );

      // Set the next active state depending on the direction
      // We bump up the index depending on the "slidesToShow" option
      this.nextMinIndex =
        direction === 'next'
          ? currentActiveSlidesMinIndex + this.options.slidesToShow
          : currentActiveSlidesMinIndex - this.options.slidesToShow;
      this.nextMaxIndex =
        direction === 'next'
          ? currentActiveSlidesMaxIndex + this.options.slidesToShow
          : currentActiveSlidesMinIndex - 1;

      this.sliderTrack.style.transition = 'transform 500ms ease 0s';

      if (direction === 'next') {
        valueXToMove = currentTranslateXPosition - this.sliderTranslateXMove;
        this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
      } else {
        valueXToMove = currentTranslateXPosition + this.sliderTranslateXMove;
        this.sliderTrack.style.transform = 'translateX(' + valueXToMove + 'px)';
      }

      this._verifyFirstLastSlideTranslateX(valueXToMove);

      this._postTransitionEnd();

      this._setupMultipleActiveSlide(this.nextMinIndex, this.nextMaxIndex);
    },

    _setPosition: function(nextSlideIndex) {
      this.slideIndex = nextSlideIndex;

      if (this.indicators.length) {
        this._setActiveIndicator(nextSlideIndex);
      }

      this._setupActiveSlide(nextSlideIndex);

      if (this.options.autoplay && this.isAutoPlaying) {
        this.startAutoplay();
      }

      this.container.dispatchEvent(
        new CustomEvent('slider_slide_changed', {
          detail: nextSlideIndex
        })
      );
    },

    _setupActiveSlide: function(index) {
      this.slides.forEach(function(slide) {
        slide.setAttribute('aria-hidden', true);
        slide.classList.remove(this.options.slideActiveClass);
      }, this);

      this.slides[index].setAttribute('aria-hidden', false);
      this.slides[index].classList.add(this.options.slideActiveClass);
    },

    /**
     * Loops through all slide items
     * Set the active state depending the direction and slide indexes
     * Because slide-in effect can have multiple items in 1 slide, we need to target multiple active elements
     * @param {String} direction "next" for next slides or empty string for previous
     * @param {*} minIndex the current active minimum index
     * @param {*} maxIndex the current active maximum index
     */
    _setupMultipleActiveSlide: function(minIndex, maxIndex) {
      this.slides.forEach(function(slide) {
        var sliderIndex = Number(slide.getAttribute('data-slider-slide-index'));
        var sliderItemLink = slide.querySelector(selectors.sliderItemLink);

        slide.setAttribute('aria-hidden', true);
        slide.classList.remove(this.options.slideActiveClass);
        if (sliderItemLink) {
          sliderItemLink.setAttribute('tabindex', -1);
        }

        if (sliderIndex >= minIndex && sliderIndex <= maxIndex) {
          slide.setAttribute('aria-hidden', false);
          slide.classList.add(this.options.slideActiveClass);

          if (sliderItemLink) {
            sliderItemLink.setAttribute('tabindex', 0);
          }
        }
      }, this);
    },

    _setActiveIndicator: function(index) {
      this.indicators.forEach(function(indicatorWrapper) {
        var activeIndicator = indicatorWrapper.querySelector(
          '.' + classes.indicatorActive
        );

        var nextIndicator = indicatorWrapper.childNodes[index];

        if (activeIndicator) {
          activeIndicator.setAttribute('aria-selected', false);
          activeIndicator.classList.remove(classes.indicatorActive);
          activeIndicator.firstElementChild.removeAttribute('aria-current');
        }

        nextIndicator.classList.add(classes.indicatorActive);
        nextIndicator.setAttribute('aria-selected', true);
        nextIndicator.firstElementChild.setAttribute('aria-current', true);
      }, this);
    },

    setSlideshowHeight: function() {
      var minAspectRatio = this.sliderContainer.getAttribute(
        'data-min-aspect-ratio'
      );
      this.sliderContainer.style.height =
        document.documentElement.offsetWidth / minAspectRatio + 'px';
    },

    /**
     * Increase or decrease index position of the slideshow
     * Automatically auto-rotate
     * - Last slide goes to first slide when clicking "next"
     * - First slide goes to last slide when clicking "previous"
     * @param {String} direction "next" as a String, other empty string is previous slide
     */
    _getNextSlideIndex: function(direction) {
      var counter = direction === 'next' ? 1 : -1;

      if (direction === 'next') {
        if (this.slideIndex === this.lastSlide) {
          return this.options.type === 'slide' ? this.lastSlide : 0;
        }
      } else if (!this.slideIndex) {
        return this.options.type === 'slide' ? 0 : this.lastSlide;
      }

      return this.slideIndex + counter;
    },

    /**
     * In "slide-in" type, multiple items are active in 1 slide
     * This will return an array containing their indexes
     */
    _getActiveSlidesIndex: function() {
      var currentActiveSlides = this.slides.filter(function(sliderItem) {
        if (sliderItem.classList.contains(this.options.slideActiveClass)) {
          return sliderItem;
        }
      }, this);
      var currentActiveSlidesIndex = currentActiveSlides.map(function(
        sliderItem
      ) {
        return Number(sliderItem.getAttribute('data-slider-slide-index'));
      });

      return currentActiveSlidesIndex;
    },

    /**
     * This checks the next "translateX" value and verifies
     * If it's at the last slide or beginning of the slide
     * So we can disable the arrow buttons
     */
    _disableArrows: function() {
      if (this.buttons.length === 0) return;

      var previousButton = this.buttons[0];
      var nextButton = this.buttons[1];

      // first slide
      if (this.isFirstSlide) {
        previousButton.setAttribute('aria-disabled', true);
      } else {
        previousButton.removeAttribute('aria-disabled');
      }

      // last slide
      if (this.isLastSlide) {
        nextButton.setAttribute('aria-disabled', true);
      } else {
        nextButton.removeAttribute('aria-disabled');
      }
    },

    /**
     * Verify if translateX reaches at first or last slide
     * @param {Number} translateXValue
     */
    _verifyFirstLastSlideTranslateX: function(translateXValue) {
      // first slide
      if (this._isNextTranslateXFirst(translateXValue)) {
        this.isFirstSlide = true;
      } else {
        this.isFirstSlide = false;
      }

      // last slide
      if (this._isNextTranslateXLast(translateXValue)) {
        this.isLastSlide = true;
      } else {
        this.isLastSlide = false;
      }
    },

    _getTranslateXPosition: function() {
      return Number(this.sliderTrack.style.transform.match(/(-?[0-9]+)/g)[0]);
    },

    _isNextTranslateXFirst: function(translateXValue) {
      return translateXValue === 0;
    },

    _isNextTranslateXLast: function(translateXValue) {
      // because translateX values are using negative, I'm converting into positive value
      var translateXValueAbsolute = Math.abs(translateXValue);
      var nextTranslateXValue =
        translateXValueAbsolute + this.sliderTranslateXMove;

      return nextTranslateXValue >= this.sliderItemWidthTotal;
    },

    _postTransitionEnd: function() {
      if (this.buttons.length) {
        this._disableArrows();
      }

      if (this.indicators.length) {
        this._setActiveIndicator(this.slideIndex);
      }
    }
  });

  return Slideshow;
})();

theme.Video = (function() {
  var autoplayCheckComplete = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height'
  };

  var selectors = {
    section: '.video-section',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause',
    pauseVideoStop: '.video__pause-stop',
    pauseVideoResume: '.video__pause-resume',
    fallbackText: '.icon__fallback-text'
  };

  /**
   * Public functions
   */
  function init(video) {
    if (!video) return;

    videos[video.id] = {
      id: video.id,
      videoId: video.dataset.id,
      type: video.dataset.type,
      status:
        video.dataset.type === 'image_with_play' ? 'closed' : 'background', // closed, open, background
      video: video,
      videoWrapper: video.closest(selectors.videoWrapper),
      section: video.closest(selectors.section),
      controls: video.dataset.type === 'background' ? 0 : 1
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var videoWrapper = videoData.videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      videoWrapper.classList.remove(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    } else {
      player.playVideo();
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    document.documentElement.classList.remove(
      classes.supportsAutoplay,
      classes.supportsNoAutoplay
    );
    document.documentElement.classList.add(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function playOnClickCheck() {
    if (playOnClickChecked) {
      return;
    }

    if (isMobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);
    var videoTitle = evt.target.getVideoData().title;
    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    document.getElementById(videoData.id).setAttribute('tabindex', '-1');

    sizeBackgroundVideos();
    setButtonLabels(videoData.videoWrapper, videoTitle);

    // Customize based on options from the video ID
    if (videoData.type === 'background') {
      evt.target.mute();
      privatePlayVideo(videoData.id);
    }

    videoData.videoWrapper.classList.add(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    if (
      videoData.status === 'background' &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING ||
        evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true);
      autoplayCheckComplete = true;
      videoData.videoWrapper.classList.remove(classes.loading);
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData);
        break;
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function() {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData);
          }
        }, 200);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'image_with_play':
        closeVideo(videoData.id);
        toggleExpandVideo(videoData.id, false);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var videoWrapper = videoData.videoWrapper;
    var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);

    videoWrapper.classList.remove(classes.loading);

    if (pauseButton.classList.contains(classes.userPaused)) {
      pauseButton.classList.remove(classes.userPaused);
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    document.getElementById(videoData.id).setAttribute('tabindex', '0');

    if (videoData.type === 'image_with_play') {
      videoWrapper.classList.remove(classes.paused);
      videoWrapper.classList.add(classes.playing);
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function() {
      videoWrapper.querySelector(selectors.closeVideoBtn).focus();
    }, videoOptions.scrollAnimationDuration);
  }

  function setAsPaused(videoData) {
    var videoWrapper = videoData.videoWrapper;

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === 'image_with_play') {
      if (videoData.status === 'closed') {
        videoWrapper.classList.remove(classes.paused);
      } else {
        videoWrapper.classList.add(classes.paused);
      }
    }

    videoWrapper.classList.remove(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var videoWrapper = videoData.videoWrapper;

    document.getElementById(videoData.id).setAttribute('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'image_with_play':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
      case 'background':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
    }

    videoWrapper.classList.remove(classes.paused, classes.playing);
  }

  function getVideoOptions(evt) {
    var id = evt.target.getIframe().id;
    return videos[id];
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId];
    var elementTop =
      video.videoWrapper.getBoundingClientRect().top + window.pageYOffset;
    var playButton = video.videoWrapper.querySelector(selectors.playVideoBtn);
    var offset = 0;
    var newHeight = 0;

    if (isMobile()) {
      video.videoWrapper.parentElement.classList.toggle('page-width', !expand);
    }

    if (expand) {
      if (isMobile()) {
        newHeight = window.innerWidth / videoOptions.ratio;
      } else {
        newHeight = video.videoWrapper.offsetWidth / videoOptions.ratio;
      }
      offset = (window.innerHeight - newHeight) / 2;

      video.videoWrapper.style.height =
        video.videoWrapper.getBoundingClientRect().height + 'px';
      video.videoWrapper.classList.remove(classes.wrapperMinHeight);
      video.videoWrapper.style.height = newHeight + 'px';

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        var scrollBehavior = document.documentElement.style.scrollBehavior;
        document.documentElement.style.scrollBehavior = 'smooth';
        window.scrollTo({ top: elementTop - offset });
        document.documentElement.style.scrollBehavior = scrollBehavior;
      }
    } else {
      if (isMobile()) {
        newHeight = video.videoWrapper.dataset.mobileHeight;
      } else {
        newHeight = video.videoWrapper.dataset.desktopHeight;
      }

      video.videoWrapper.style.height = newHeight + 'px';

      setTimeout(function() {
        video.videoWrapper.classList.add(classes.wrapperMinHeight);
      }, 600);
      // Set focus on play button, but don't scroll page
      var x = window.scrollX;
      var y = window.scrollY;
      playButton.focus();
      window.scrollTo(x, y);
    }
  }

  function togglePause(playerId) {
    var pauseButton = videos[playerId].videoWrapper.querySelector(
      selectors.pauseVideoBtn
    );
    var paused = pauseButton.classList.contains(classes.userPaused);
    if (paused) {
      pauseButton.classList.remove(classes.userPaused);
      customPlayVideo(playerId);
    } else {
      pauseButton.classList.add(classes.userPaused);
      pauseVideo(playerId);
    }
    pauseButton.setAttribute('aria-pressed', !paused);
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId];

    // add loading class to wrapper
    video.videoWrapper.classList.add(classes.loading);

    // Explicity set the video wrapper height (needed for height transition)
    video.videoWrapper.style.height = video.videoWrapper.offsetHeight + 'px';

    video.status = 'open';

    switch (video.type) {
      case 'image_with_play':
        privatePlayVideo(playerId, true);
        break;
      case 'background':
        unsetBackgroundVideo(playerId, video);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
    }

    toggleExpandVideo(playerId, true);

    // esc to close video player
    document.addEventListener('keydown', handleVideoPlayerKeydown);
  }

  var handleVideoPlayerKeydown = function(evt) {
    var playerId = document.activeElement.dataset.controls;
    if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
      return;
    }

    closeVideo(playerId);
    toggleExpandVideo(playerId, false);
  };

  function sizeBackgroundVideos() {
    var backgroundVideos = document.querySelectorAll(
      '.' + classes.backgroundVideo
    );
    backgroundVideos.forEach(function(el) {
      sizeBackgroundVideo(el);
    });
  }

  function sizeBackgroundVideo(videoPlayer) {
    if (!youtubeLoaded) {
      return;
    }

    if (isMobile()) {
      videoPlayer.style.cssText = null;
    } else {
      var videoWrapper = videoPlayer.closest(selectors.videoWrapper);
      var videoWidth = videoWrapper.clientWidth;
      var playerWidth = videoPlayer.clientWidth;
      var desktopHeight = videoWrapper.dataset.desktopHeight;

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
        var styles =
          'width: ' +
          playerWidth +
          'px; height: ' +
          desktopHeight +
          'px; left: ' +
          (videoWidth - playerWidth) / 2 +
          'px; top: 0;';
        videoPlayer.style.cssText = styles;
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
        var styles2 =
          'width: ' +
          videoWidth +
          'px; height: ' +
          desktopHeight +
          'px; top: ' +
          (desktopHeight - desktopHeight) / 2 +
          'px; left: 0;'; // player height is greater, offset top; reset left
        videoPlayer.style.cssText = styles2;
      }

      theme.Helpers.prepareTransition(videoPlayer);
      videoWrapper.classList.add(classes.loaded);
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    var player = document.getElementById(playerId);
    player.classList.remove(classes.backgroundVideo);
    player.classList.add(classes.videoWithImage);

    setTimeout(function() {
      document.getElementById(playerId).style.cssText = null;
    }, 600);

    videos[playerId].videoWrapper.classList.remove(
      classes.backgroundVideoWrapper
    );
    videos[playerId].videoWrapper.classList.add(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    var player = document.getElementById(playerId);
    player.classList.remove(classes.videoWithImage);
    player.classList.add(classes.backgroundVideo);

    videos[playerId].videoWrapper.classList.add(classes.backgroundVideoWrapper);

    videos[playerId].status = 'background';
    sizeBackgroundVideo(player);
  }

  function isMobile() {
    return window.innerWidth < theme.breakpoints.medium;
  }

  var handleWindowResize = theme.Helpers.debounce(function() {
    if (!youtubeLoaded) return;
    var key;
    var fullscreen = window.innerHeight === screen.height;
    sizeBackgroundVideos();

    if (isMobile()) {
      for (key in videos) {
        if (videos.hasOwnProperty(key)) {
          if (videos[key].videoWrapper.classList.contains(classes.playing)) {
            if (!fullscreen) {
              pauseVideo(key);
              setAsPaused(videos[key]);
            }
          }
          videos[key].videoWrapper.style.height =
            document.documentElement.clientWidth / videoOptions.ratio + 'px';
        }
      }
      setAutoplaySupport(false);
    } else {
      setAutoplaySupport(true);
      for (key in videos) {
        var videosWithImage = videos[key].videoWrapper.querySelectorAll(
          '.' + classes.videoWithImage
        );
        if (videosWithImage.length) {
          continue;
        }
        videoPlayers[key].playVideo();
        setAsPlaying(videos[key]);
      }
    }
  }, 200);

  var handleWindowScroll = theme.Helpers.debounce(function() {
    if (!youtubeLoaded) return;

    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var videoWrapper = videos[key].videoWrapper;
        var condition =
          videoWrapper.getBoundingClientRect().top +
            window.pageYOffset +
            videoWrapper.offsetHeight * 0.75 <
            window.pageYOffset ||
          videoWrapper.getBoundingClientRect().top +
            window.pageYOffset +
            videoWrapper.offsetHeight * 0.25 >
            window.pageYOffset + window.innerHeight;

        // Close the video if more than 75% of it is scrolled out of view
        if (videoWrapper.classList.contains(classes.playing)) {
          if (!condition) return;
          closeVideo(key);
          toggleExpandVideo(key, false);
        }
      }
    }
  }, 50);

  function initEvents() {
    var playVideoBtns = document.querySelectorAll(selectors.playVideoBtn);
    var closeVideoBtns = document.querySelectorAll(selectors.closeVideoBtn);
    var pauseVideoBtns = document.querySelectorAll(selectors.pauseVideoBtn);

    playVideoBtns.forEach(function(btn) {
      btn.addEventListener('click', function(evt) {
        var playerId = evt.currentTarget.dataset.controls;
        startVideoOnClick(playerId);
      });
    });

    closeVideoBtns.forEach(function(btn) {
      btn.addEventListener('click', function(evt) {
        var playerId = evt.currentTarget.dataset.controls;

        evt.currentTarget.blur();
        closeVideo(playerId);
        toggleExpandVideo(playerId, false);
      });
    });

    pauseVideoBtns.forEach(function(btn) {
      btn.addEventListener('click', function(evt) {
        var playerId = evt.currentTarget.dataset.controls;
        togglePause(playerId);
      });
    });

    // Listen to resize to keep a background-size:cover-like layout
    window.addEventListener('resize', handleWindowResize);

    window.addEventListener('scroll', handleWindowScroll);
  }

  function createPlayer(key) {
    var args = Object.assign(videoOptions, videos[key]);

    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
  }

  function removeEvents() {
    document.removeEventListener('keydown', handleVideoPlayerKeydown);
    window.removeEventListener('resize', handleWindowResize);
    window.removeEventListener('scroll', handleWindowScroll);
  }

  function setButtonLabels(videoWrapper, title) {
    var playButtons = videoWrapper.querySelectorAll(selectors.playVideoBtn);
    var closeButton = videoWrapper.querySelector(selectors.closeVideoBtn);
    var pauseButton = videoWrapper.querySelector(selectors.pauseVideoBtn);
    var closeButtonText = closeButton.querySelector(selectors.fallbackText);

    var pauseButtonStop = pauseButton.querySelector(selectors.pauseVideoStop);
    var pauseButtonStopText = pauseButtonStop.querySelector(
      selectors.fallbackText
    );

    var pauseButtonResume = pauseButton.querySelector(
      selectors.pauseVideoResume
    );
    var pauseButtonResumeText = pauseButtonResume.querySelector(
      selectors.fallbackText
    );

    // Insert the video title retrieved from YouTube into the instructional text
    // for each button
    playButtons.forEach(function(playButton) {
      var playButtonText = playButton.querySelector(selectors.fallbackText);

      playButtonText.textContent = playButtonText.textContent.replace(
        '[video_title]',
        title
      );
    });
    closeButtonText.textContent = closeButtonText.textContent.replace(
      '[video_title]',
      title
    );
    pauseButtonStopText.textContent = pauseButtonStopText.textContent.replace(
      '[video_title]',
      title
    );
    pauseButtonResumeText.textContent = pauseButtonResumeText.textContent.replace(
      '[video_title]',
      title
    );
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

theme.ProductVideo = (function() {
  var videos = {};

  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };

  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer) {
      return;
    }

    var videoElement = videoContainer.querySelector('iframe, video');

    if (!videoElement) {
      return;
    }

    var mediaId = videoContainer.getAttribute('data-media-id');

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    var video = videos[mediaId];

    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '1.0',
            onLoad: setupPlyrVideos
          }
        ]);
        theme.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        theme.LibraryLoader.load('youtubeSdk', setupYouTubeVideos);
        break;
    }
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }

    loadVideos(hosts.html5);
  }

  function setupYouTubeVideos() {
    if (!window.YT.Player) return;

    loadVideos(hosts.youtube);
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );

    var enableLooping = productMediaWrapper.getAttribute(
      'data-' + attributes.enableVideoLooping
    );

    switch (video.host) {
      case hosts.html5:
        // eslint-disable-next-line no-undef
        video.player = new Shopify.Plyr(video.element, {
          loop: { active: enableLooping }
        });
        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.getAttribute(
          'data-' + attributes.videoId
        );

        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function(event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
            }
          }
        });
        break;
    }

    var pauseVideo = function() {
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.pause();
      }

      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();
      }
    };

    productMediaWrapper.addEventListener('mediaHidden', pauseVideo);
    productMediaWrapper.addEventListener('xrLaunch', pauseVideo);

    productMediaWrapper.addEventListener('mediaVisible', function() {
      if (theme.Helpers.isTouch()) return;
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.play();
      }

      if (video.host === hosts.youtube && video.player.playVideo) {
        video.player.playVideo();
      }
    });
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }

    if (video.tagName === 'IFRAME') {
      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          video.src
        )
      ) {
        return hosts.youtube;
      }
    }
    return null;
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.nativeVideo) continue;

        if (video.host === hosts.html5) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();

theme.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.forEach(function(modelViewerContainer, index) {
      var mediaId = modelViewerContainer.getAttribute('data-media-id');
      var modelViewerElement = modelViewerContainer.querySelector(
        'model-viewer'
      );
      var modelId = modelViewerElement.getAttribute('data-model-id');

      if (index === 0) {
        var mediaGroup = modelViewerContainer.closest(selectors.mediaGroup);
        var xrButton = mediaGroup.querySelector(selectors.xrButton);
        xrButtons[sectionId] = {
          element: xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        container: modelViewerContainer,
        element: modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var modelJson = document.querySelector('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];

    model.container.addEventListener('mediaVisible', function() {
      xrButton.element.setAttribute('data-shopify-model3d-id', model.modelId);
      if (theme.Helpers.isTouch()) return;
      model.modelViewerUi.play();
    });

    model.container.addEventListener('mediaHidden', function() {
      xrButton.element.setAttribute(
        'data-shopify-model3d-id',
        xrButton.defaultId
      );
      model.modelViewerUi.pause();
    });

    model.container.addEventListener('xrLaunch', function() {
      model.modelViewerUi.pause();
    });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    var statusMessages = document.querySelectorAll(selectors.statusMessage);

    statusMessages.forEach(function(statusMessage) {
      statusMessage.setAttribute('tabindex', -1);
      statusMessage.focus();

      statusMessage.addEventListener(
        'blur',
        function(evt) {
          evt.target.removeAttribute('tabindex');
        },
        { once: true }
      );
    });
  }

  return {
    init: init
  };
})();

theme.Hero = (function() {
  var classes = {
    indexSectionFlush: 'index-section--flush'
  };

  var selectors = {
    heroFixedWidthContent: '.hero-fixed-width__content',
    heroFixedWidthImage: '.hero-fixed-width__image'
  };

  function hero(el, sectionId) {
    var hero = document.querySelector(el);
    var layout = hero.getAttribute('data-layout');
    var parentSection = document.querySelector('#shopify-section-' + sectionId);
    var heroContent = parentSection.querySelector(
      selectors.heroFixedWidthContent
    );
    var heroImage = parentSection.querySelector(selectors.heroFixedWidthImage);

    if (layout !== 'fixed_width') {
      return;
    }

    parentSection.classList.remove(classes.indexSectionFlush);
    heroFixedHeight();

    window.addEventListener('resize', function() {
      theme.Helpers.debounce(function() {
        heroFixedHeight();
      }, 50);
    });

    function heroFixedHeight() {
      var contentHeight;
      var imageHeight;

      if (heroContent) {
        contentHeight = heroContent.offsetHeight + 50;
      }

      if (heroImage) {
        imageHeight = heroImage.offsetHeight;
      }

      if (contentHeight > imageHeight) {
        heroImage.style.minHeight = contentHeight + 'px';
      }
    }
  }

  return hero;
})();

// prettier-ignore
window.theme = window.theme || {};

theme.SearchResultsTemplate = (function() {
  function renderResults(products, isLoading, searchQuery) {
    return [
      '<div class="predictive-search">',
      renderHeader(products, isLoading),
      renderProducts(products, searchQuery),
      '</div>'
    ].join('');
  }

  function renderHeader(products, isLoading) {
    if (products.length === 0) {
      return '';
    }

    return [
      '<div class="predictive-search-title">',
      '<h3 id="predictive-search" class="predictive-search-title__content">' +
        theme.strings.products +
        '</h3>',
      '<span class="predictive-search-title__loading-spinner">' +
        (isLoading
          ? '<span class= "icon-predictive-search-spinner" ></span >'
          : '') +
        '</span>',
      '</div>'
    ].join('');
  }

  function loadingState() {
    return [
      '<div class="predictive-search">',
      '<div class="predictive-search-loading">',
      '<span class="visually-hidden">' + theme.strings.loading + '</span>',
      '<span class="predictive-search-loading__icon">',
      '<span class="icon-predictive-search-spinner"></span>',
      '</span>',
      '</div>',
      '</div>'
    ].join('');
  }

  function renderViewAll(searchQuery) {
    return [
      '<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
      theme.strings.searchFor +
        '<span class="predictive-search-view-all__query"> &ldquo;' +
        _htmlEscape(searchQuery) +
        '&rdquo;</span>',
      '</button>'
    ].join('');
  }

  function renderProducts(products, searchQuery) {
    var resultsCount = products.length;

    return [
      '<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
      products
        .map(function(product, index) {
          return renderProduct(normalizeProduct(product), index, resultsCount);
        })
        .join(''),
      '<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>' +
        renderViewAll(searchQuery) +
        '</li>',
      '</ul>'
    ].join('');
  }

  function renderProduct(product, index, resultsCount) {
    return [
      '<li id="search-result-' +
        index +
        '" class="predictive-search-item" role="option" data-search-result>',
      '<a class="predictive-search-item__link" href="' +
        product.url +
        '" tabindex="-1">',
      '<div class="predictive-search__column predictive-search__column--image" data-image-loading-animation>',
      renderProductImage(product),
      '</div>',
      '<div class="predictive-search__column predictive-search__column--content ' +
        (getDetailsCount() ? '' : 'predictive-search__column--center') +
        '">',
      '<span class="predictive-search-item__title">',
      '<span class="predictive-search-item__title-text">' +
        product.title +
        '</span>',
      '</span>' + (getDetailsCount() ? renderProductDetails(product) : ''),
      '<span class="visually-hidden">, </span>',
      '<span class="visually-hidden">' +
        getNumberOfResultsString(index + 1, resultsCount) +
        '</span>',
      '</div>',
      '</a>',
      '</li>'
    ].join('');
  }

  function renderProductImage(product) {
    if (product.image === null) {
      return '';
    }

    return (
      '<img class="predictive-search-item__image lazyload" src="' +
      product.image.url +
      '" data-src="' +
      product.image.url +
      '" data-image alt="' +
      product.image.alt +
      '" />'
    );
  }

  function renderProductDetails(product) {
    return [
      '<dl class="predictive-search-item__details price' +
        (product.isOnSale ? ' price--on-sale' : '') +
        (!product.available ? ' price--sold-out' : '') +
        (!product.isPriceVaries && product.isCompareVaries
          ? ' price--compare-price-hidden'
          : '') +
        '">',
      '<div class="predictive-search-item__detail">',
      renderVendor(product),
      '</div>',
      '<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
        renderProductPrice(product),
      '</div>',
      '</dl>'
    ].join('');
  }
  function renderProductPrice(product) {
    if (!theme.settings.predictiveSearchShowPrice) {
      return '';
    }

    var accessibilityAnnounceComma = '<span class="visually-hidden">, </span>';

    var priceMarkup =
      '<div class="price__regular">' + renderPrice(product) + '</div>';

    var salePriceMarkup =
      '<div class="price__sale">' + renderSalePrice(product) + '</div>';

    return (
      accessibilityAnnounceComma +
      '<div class="price__pricing-group">' +
      (product.isOnSale ? salePriceMarkup : priceMarkup) +
      '</div>'
    );
  }

  function renderSalePrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.salePrice + '</span>',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price predictive-search-item__price--sale">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace('[price]', product.price)
          : product.price) +
        '</span>',
      '</dd>',
      '<div class="price__compare">' + renderCompareAtPrice(product) + '</div>'
    ].join('');
  }

  function renderCompareAtPrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' +
        theme.strings.regularPrice +
        '</span> ',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price predictive-search-item__price--compare">' +
        product.compareAtPrice +
        '</span>',
      '</dd>'
    ].join('');
  }

  function renderPrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.regularPrice + '</span>',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace('[price]', product.price)
          : product.price) +
        '</span>',
      '</dd>'
    ].join('');
  }

  function renderVendor(product) {
    if (!theme.settings.predictiveSearchShowVendor || product.vendor === '') {
      return '';
    }

    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.vendor + '</span>',
      '</dt>',
      '<dd class="predictive-search-item__vendor">' + product.vendor + '</dd>'
    ].join('');
  }

  function normalizeProduct(product) {
    var productOrVariant =
      product.variants.length > 0 ? product.variants[0] : product;

    return {
      url: productOrVariant.url,
      image: getProductImage(product),
      title: product.title,
      vendor: product.vendor || '',
      price: theme.Currency.formatMoney(product.price_min, theme.moneyFormat),
      compareAtPrice: theme.Currency.formatMoney(
        product.compare_at_price_min,
        theme.moneyFormat
      ),
      available: product.available,
      isOnSale: isOnSale(product),
      isPriceVaries: isPriceVaries(product),
      isCompareVaries: isCompareVaries(product)
    };
  }

  function getProductImage(product) {
    var image;
    var featuredImage;

    if (product.variants.length > 0 && product.variants[0].image !== null) {
      featuredImage = product.variants[0].featured_image;
    } else if (product.image) {
      featuredImage = product.featured_image;
    } else {
      image = null;
    }

    if (image !== null) {
      image = {
        url: theme.Images.getSizedImageUrl(featuredImage.url, '100x'),
        alt: featuredImage.alt
      };
    }

    return image;
  }

  function isOnSale(product) {
    return (
      product.compare_at_price_min !== null &&
      parseInt(product.compare_at_price_min, 10) >
        parseInt(product.price_min, 10)
    );
  }

  function isPriceVaries(product) {
    return product.price_max !== product.price_min;
  }

  function isCompareVaries(product) {
    return product.compare_at_price_max !== product.compare_at_price_min;
  }

  // Returns the number of optional product details to be shown,
  // values of the detailsList need to be boolean.
  function getDetailsCount() {
    var detailsList = [
      theme.settings.predictiveSearchShowPrice,
      theme.settings.predictiveSearchShowVendor
    ];

    var detailsCount = detailsList.reduce(function(acc, detail) {
      return acc + (detail ? 1 : 0);
    }, 0);

    return detailsCount;
  }

  function getNumberOfResultsString(resultNumber, resultsCount) {
    return theme.strings.number_of_results
      .replace('[result_number]', resultNumber)
      .replace('[results_count]', resultsCount);
  }

  function _htmlEscape(input) {
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  return function(data) {
    var products = data.products || [];
    var isLoading = data.isLoading;
    var searchQuery = data.searchQuery || '';

    if (isLoading && products.length === 0) {
      return loadingState();
    }

    return renderResults(products, isLoading, searchQuery);
  };
})();

window.theme = window.theme || {};

(function() {
  // (a11y) This function will be used by the Predictive Search Component
  // to announce the number of search results
  function numberOfResultsTemplateFct(data) {
    if (data.products.length === 1) {
      return theme.strings.one_result_found;
    } else {
      return theme.strings.number_of_results_found.replace(
        '[results_count]',
        data.products.length
      );
    }
  }

  // (a11y) This function will be used by the Predictive Search Component
  // to announce that it's loading results
  function loadingResultsMessageTemplateFct() {
    return theme.strings.loading;
  }

  function isPredictiveSearchSupported() {
    var shopifyFeatures = JSON.parse(
      document.getElementById('shopify-features').textContent
    );

    return shopifyFeatures.predictiveSearch;
  }

  function isPredictiveSearchEnabled() {
    return window.theme.settings.predictiveSearchEnabled;
  }

  function canInitializePredictiveSearch() {
    return isPredictiveSearchSupported() && isPredictiveSearchEnabled();
  }

  // listen for search submits and validate query
  function validateSearchHandler(searchEl, submitEl) {
    submitEl.addEventListener(
      'click',
      validateSearchInput.bind(this, searchEl)
    );
  }

  // if there is nothing in the search field, prevent submit
  function validateSearchInput(searchEl, evt) {
    var isInputValueEmpty = searchEl.value.trim().length === 0;
    if (!isInputValueEmpty) {
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchEl.focus();
  }

  window.theme.SearchPage = (function() {
    var selectors = {
      searchReset: '[data-search-page-predictive-search-clear]',
      searchInput: '[data-search-page-predictive-search-input]',
      searchSubmit: '[data-search-page-predictive-search-submit]',
      searchResults: '[data-predictive-search-mount="default"]'
    };

    var componentInstance;
    var searchInput = document.querySelector(selectors.searchInput);
    var searchSubmit = document.querySelector(selectors.searchSubmit);

    function init(config) {
      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          reset: selectors.searchReset,
          result: selectors.searchResults
        },
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onOpen: function(nodes) {
          if (config.isTabletAndUp) {
            return;
          }

          var searchInputBoundingRect = searchInput.getBoundingClientRect();
          var bodyHeight = document.body.offsetHeight;
          var offset = 50;
          var resultsMaxHeight =
            bodyHeight - searchInputBoundingRect.bottom - offset;

          nodes.result.style.maxHeight = resultsMaxHeight + 'px';
        },
        onBeforeDestroy: function(nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          nodes.result.style.maxHeight = '';
        }
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }
      componentInstance.destroy();
      componentInstance = null;
    }

    return {
      init: init,
      unload: unload
    };
  })();

  window.theme.SearchHeader = (function() {
    var selectors = {
      searchInput: '[data-predictive-search-drawer-input]',
      searchResults: '[data-predictive-search-mount="drawer"]',
      searchFormContainer: '[data-search-form-container]',
      searchSubmit: '[data-search-form-submit]'
    };

    var componentInstance;
    var searchInput = document.querySelector(selectors.searchInput);
    var searchSubmit = document.querySelector(selectors.searchSubmit);

    function init(config) {
      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          result: selectors.searchResults
        },
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        numberOfResults: config.numberOfResults,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onInputBlur: function() {
          return false;
        },
        onOpen: function(nodes) {
          var searchInputBoundingRect = searchInput.getBoundingClientRect();

          // For tablet screens and up, stop the scroll area from extending past
          // the bottom of the screen because we're locking the body scroll
          var maxHeight =
            window.innerHeight -
            searchInputBoundingRect.bottom -
            (config.isTabletAndUp ? 20 : 0);

          nodes.result.style.top = config.isTabletAndUp
            ? ''
            : searchInputBoundingRect.bottom + 'px';
          nodes.result.style.maxHeight = maxHeight + 'px';
        },
        onClose: function(nodes) {
          nodes.result.style.maxHeight = '';
        },
        onBeforeDestroy: function(nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          nodes.result.style.top = '';
        }
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }

      componentInstance.destroy();
      componentInstance = null;
    }

    function clearAndClose() {
      if (!componentInstance) {
        return;
      }

      componentInstance.clearAndClose();
    }

    return {
      init: init,
      unload: unload,
      clearAndClose: clearAndClose
    };
  })();

  window.theme.Search = (function() {
    var classes = {
      searchTemplate: 'template-search'
    };
    var selectors = {
      siteHeader: '.site-header'
    };
    var mediaQueryList = {
      mobile: window.matchMedia('(max-width: 749px)'),
      tabletAndUp: window.matchMedia('(min-width: 750px)')
    };

    function init() {
      if (!document.querySelector(selectors.siteHeader)) {
        return;
      }

      if (!canInitializePredictiveSearch()) {
        return;
      }

      Object.keys(mediaQueryList).forEach(function(device) {
        mediaQueryList[device].addListener(initSearchAccordingToViewport);
      });

      initSearchAccordingToViewport();
    }

    function initSearchAccordingToViewport() {
      theme.SearchDrawer.close();
      theme.SearchHeader.unload();
      theme.SearchPage.unload();

      if (mediaQueryList.mobile.matches) {
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: false
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: false });
        }
      } else {
        // Tablet and up
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: true
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: true });
        }
      }
    }

    function isSearchPage() {
      return document.body.classList.contains(classes.searchTemplate);
    }

    function unload() {
      theme.SearchHeader.unload();
      theme.SearchPage.unload();
    }

    return {
      init: init,
      unload: unload
    };
  })();
})();

window.theme = window.theme || {};

theme.SearchDrawer = (function() {
  var selectors = {
    headerSection: '[data-header-section]',
    drawer: '[data-predictive-search-drawer]',
    drawerOpenButton: '[data-predictive-search-open-drawer]',
    headerSearchInput: '[data-predictive-search-drawer-input]',
    predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]'
  };

  var drawerInstance;

  function init() {
    setAccessibilityProps();

    drawerInstance = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: function() {
        setHeight();
        theme.MobileNav.closeMobileNav();
        lockBodyScroll();
      },
      onDrawerClose: function() {
        theme.SearchHeader.clearAndClose();
        var drawerOpenButton = document.querySelector(
          selectors.drawerOpenButton
        );

        if (drawerOpenButton) drawerOpenButton.focus();

        unlockBodyScroll();
      },
      withPredictiveSearch: true,
      elementToFocusOnOpen: document.querySelector(selectors.headerSearchInput)
    });
  }

  function setAccessibilityProps() {
    var drawerOpenButton = document.querySelector(selectors.drawerOpenButton);

    if (drawerOpenButton) {
      drawerOpenButton.setAttribute('aria-controls', 'SearchDrawer');
      drawerOpenButton.setAttribute('aria-expanded', 'false');
      drawerOpenButton.setAttribute('aria-controls', 'dialog');
    }
  }

  function setHeight() {
    var searchDrawer = document.querySelector(selectors.drawer);
    var headerHeight = document.querySelector(selectors.headerSection)
      .offsetHeight;

    searchDrawer.style.height = headerHeight + 'px';
  }

  function close() {
    drawerInstance.close();
  }

  function lockBodyScroll() {
    theme.Helpers.enableScrollLock();
  }

  function unlockBodyScroll() {
    theme.Helpers.disableScrollLock();
  }

  return {
    init: init,
    close: close
  };
})();

theme.Disclosure = (function() {
  var selectors = {
    disclosureForm: '[data-disclosure-form]',
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure(disclosure) {
    this.container = disclosure;
    this._cacheSelectors();
    this._setupListeners();
  }

  Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        disclosureForm: this.container.closest(selectors.disclosureForm),
        disclosureList: this.container.querySelector(selectors.disclosureList),
        disclosureToggle: this.container.querySelector(
          selectors.disclosureToggle
        ),
        disclosureInput: this.container.querySelector(
          selectors.disclosureInput
        ),
        disclosureOptions: this.container.querySelectorAll(
          selectors.disclosureOptions
        )
      };
    },

    _setupListeners: function() {
      this.eventHandlers = this._setupEventHandlers();

      this.cache.disclosureToggle.addEventListener(
        'click',
        this.eventHandlers.toggleList
      );

      this.cache.disclosureOptions.forEach(function(disclosureOption) {
        disclosureOption.addEventListener(
          'click',
          this.eventHandlers.connectOptions
        );
      }, this);

      this.container.addEventListener(
        'keyup',
        this.eventHandlers.onDisclosureKeyUp
      );

      this.cache.disclosureList.addEventListener(
        'focusout',
        this.eventHandlers.onDisclosureListFocusOut
      );

      this.cache.disclosureToggle.addEventListener(
        'focusout',
        this.eventHandlers.onDisclosureToggleFocusOut
      );

      document.body.addEventListener('click', this.eventHandlers.onBodyClick);
    },

    _setupEventHandlers: function() {
      return {
        connectOptions: this._connectOptions.bind(this),
        toggleList: this._toggleList.bind(this),
        onBodyClick: this._onBodyClick.bind(this),
        onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
        onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
        onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this)
      };
    },

    _connectOptions: function(event) {
      event.preventDefault();

      this._submitForm(event.currentTarget.dataset.value);
    },

    _onDisclosureToggleFocusOut: function(event) {
      var disclosureLostFocus =
        this.container.contains(event.relatedTarget) === false;

      if (disclosureLostFocus) {
        this._hideList();
      }
    },

    _onDisclosureListFocusOut: function(event) {
      var childInFocus = event.currentTarget.contains(event.relatedTarget);

      var isVisible = this.cache.disclosureList.classList.contains(
        classes.listVisible
      );

      if (isVisible && !childInFocus) {
        this._hideList();
      }
    },

    _onDisclosureKeyUp: function(event) {
      if (event.which !== slate.utils.keyboardKeys.ESCAPE) return;
      this._hideList();
      this.cache.disclosureToggle.focus();
    },

    _onBodyClick: function(event) {
      var isOption = this.container.contains(event.target);
      var isVisible = this.cache.disclosureList.classList.contains(
        classes.listVisible
      );

      if (isVisible && !isOption) {
        this._hideList();
      }
    },

    _submitForm: function(value) {
      this.cache.disclosureInput.value = value;
      this.cache.disclosureForm.submit();
    },

    _hideList: function() {
      this.cache.disclosureList.classList.remove(classes.listVisible);
      this.cache.disclosureToggle.setAttribute('aria-expanded', false);
    },

    _toggleList: function() {
      var ariaExpanded =
        this.cache.disclosureToggle.getAttribute('aria-expanded') === 'true';
      this.cache.disclosureList.classList.toggle(classes.listVisible);
      this.cache.disclosureToggle.setAttribute('aria-expanded', !ariaExpanded);
    },

    destroy: function() {
      this.cache.disclosureToggle.removeEventListener(
        'click',
        this.eventHandlers.toggleList
      );

      this.cache.disclosureOptions.forEach(function(disclosureOption) {
        disclosureOption.removeEventListener(
          'click',
          this.eventHandlers.connectOptions
        );
      }, this);

      this.container.removeEventListener(
        'keyup',
        this.eventHandlers.onDisclosureKeyUp
      );

      this.cache.disclosureList.removeEventListener(
        'focusout',
        this.eventHandlers.onDisclosureListFocusOut
      );

      this.cache.disclosureToggle.removeEventListener(
        'focusout',
        this.eventHandlers.onDisclosureToggleFocusOut
      );

      document.body.removeEventListener(
        'click',
        this.eventHandlers.onBodyClick
      );
    }
  });

  return Disclosure;
})();

theme.Zoom = (function() {
  var selectors = {
    imageZoom: '[data-image-zoom]'
  };

  var classes = {
    zoomImg: 'zoomImg'
  };

  var attributes = {
    imageZoomTarget: 'data-image-zoom-target'
  };

  function Zoom(container) {
    this.container = container;
    this.cache = {};
    this.url = container.dataset.zoom;

    this._cacheSelectors();

    if (!this.cache.sourceImage) return;

    this._duplicateImage();
  }

  Zoom.prototype = Object.assign({}, Zoom.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        sourceImage: this.container.querySelector(selectors.imageZoom)
      };
    },

    _init: function() {
      var targetWidth = this.cache.targetImage.width;
      var targetHeight = this.cache.targetImage.height;

      if (this.cache.sourceImage === this.cache.targetImage) {
        this.sourceWidth = targetWidth;
        this.sourceHeight = targetHeight;
      } else {
        this.sourceWidth = this.cache.sourceImage.width;
        this.sourceHeight = this.cache.sourceImage.height;
      }

      this.xRatio =
        (this.cache.sourceImage.width - targetWidth) / this.sourceWidth;
      this.yRatio =
        (this.cache.sourceImage.height - targetHeight) / this.sourceHeight;
    },

    _start: function(e) {
      this._init();
      this._move(e);
    },

    _stop: function() {
      this.cache.targetImage.style.opacity = 0;
    },

    /**
     * Sets the correct coordinates top and left position in px
     * It sets a limit within between 0 and the max height of the image
     * So when the mouse leaves the target image, it could
     * never go above or beyond the target image zone
     */
    _setTopLeftMaxValues: function(top, left) {
      return {
        left: Math.max(Math.min(left, this.sourceWidth), 0),
        top: Math.max(Math.min(top, this.sourceHeight), 0)
      };
    },

    _move: function(e) {
      // get left and top position within the "source image" zone
      var left =
        e.pageX -
        (this.cache.sourceImage.getBoundingClientRect().left + window.scrollX);
      var top =
        e.pageY -
        (this.cache.sourceImage.getBoundingClientRect().top + window.scrollY);
      // make sure the left and top position don't go
      // above or beyond the target image zone
      var position = this._setTopLeftMaxValues(top, left);

      top = position.top;
      left = position.left;

      this.cache.targetImage.style.left = -(left * -this.xRatio) + 'px';
      this.cache.targetImage.style.top = -(top * -this.yRatio) + 'px';
      this.cache.targetImage.style.opacity = 1;
    },

    /**
     * This loads a high resolution image
     * via the data attributes url
     * It adds all necessary CSS styles and adds to the container
     */
    _duplicateImage: function() {
      this._loadImage()
        .then(
          function(image) {
            this.cache.targetImage = image;
            image.style.width = image.width + 'px';
            image.style.height = image.height + 'px';
            image.style.position = 'absolute';
            image.style.maxWidth = 'none';
            image.style.maxHeight = 'none';
            image.style.opacity = 0;
            image.style.border = 'none';
            image.style.left = 0;
            image.style.top = 0;

            this.container.appendChild(image);

            this._init();

            this._start = this._start.bind(this);
            this._stop = this._stop.bind(this);
            this._move = this._move.bind(this);

            this.container.addEventListener('mouseenter', this._start);
            this.container.addEventListener('mouseleave', this._stop);
            this.container.addEventListener('mousemove', this._move);

            this.container.style.position = 'relative';
            this.container.style.overflow = 'hidden';
          }.bind(this)
        )
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.warn('Error fetching image', error);
        });
    },

    _loadImage: function() {
      // eslint-disable-next-line
      return new Promise(function(resolve, reject) {
          var image = new Image();
          image.setAttribute('role', 'presentation');
          image.setAttribute(attributes.imageZoomTarget, true);
          image.classList.add(classes.zoomImg);
          image.src = this.url;

          image.addEventListener('load', function() {
            resolve(image);
          });

          image.addEventListener('error', function(error) {
            reject(error);
          });
        }.bind(this)
      );
    },

    unload: function() {
      var targetImage = this.container.querySelector(
        '[' + attributes.imageZoomTarget + ']'
      );
      if (targetImage) {
        targetImage.remove();
      }

      this.container.removeEventListener('mouseenter', this._start);
      this.container.removeEventListener('mouseleave', this._stop);
      this.container.removeEventListener('mousemove', this._move);
    }
  });

  return Zoom;
})();


/* ================ TEMPLATES ================ */
(function() {
  var filterBys = document.querySelectorAll('[data-blog-tag-filter]');

  if (!filterBys.length) return;

  slate.utils.resizeSelects(filterBys);

  filterBys.forEach(function(filterBy) {
    filterBy.addEventListener('change', function(evt) {
      location.href = evt.target.value;
    });
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  var selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  };

  function initEventListeners() {
    this.recoverHeading = document.querySelector(selectors.RecoverHeading);
    this.recoverEmail = document.querySelector(selectors.RecoverEmail);
    this.loginHeading = document.querySelector(selectors.LoginHeading);
    var recoverPassword = document.getElementById('RecoverPassword');
    var hideRecoverPasswordLink = document.getElementById(
      'HideRecoverPasswordLink'
    );

    // Show reset password form
    if (recoverPassword) {
      recoverPassword.addEventListener(
        'click',
        function(evt) {
          evt.preventDefault();
          showRecoverPasswordForm();
          this.recoverHeading.setAttribute('tabindex', '-1');
          this.recoverHeading.focus();
        }.bind(this)
      );
    }

    // Hide reset password form
    if (hideRecoverPasswordLink) {
      hideRecoverPasswordLink.addEventListener(
        'click',
        function(evt) {
          evt.preventDefault();
          hideRecoverPasswordForm();
          this.loginHeading.setAttribute('tabindex', '-1');
          this.loginHeading.focus();
        }.bind(this)
      );
    }

    if (this.recoverHeading) {
      this.recoverHeading.addEventListener('blur', function(evt) {
        evt.target.removeAttribute('tabindex');
      });
    }

    if (this.loginHeading) {
      this.loginHeading.addEventListener('blur', function(evt) {
        evt.target.removeAttribute('tabindex');
      });
    }
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').classList.remove('hide');
    document.getElementById('CustomerLoginForm').classList.add('hide');

    if (this.recoverEmail.getAttribute('aria-invalid') === 'true') {
      this.recoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    document.getElementById('RecoverPasswordForm').classList.add('hide');
    document.getElementById('CustomerLoginForm').classList.remove('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var formState = document.querySelector('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!formState) {
      return;
    }

    // show success message
    var resetSuccess = document.getElementById('ResetSuccess');
    resetSuccess.classList.remove('hide');
    resetSuccess.focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var newAddressForm = document.getElementById('AddressNewForm');
    var newAddressFormButton = document.getElementById('AddressNewButton');

    if (!newAddressForm) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    document
      .querySelectorAll('.address-country-option')
      .forEach(function(option) {
        var formId = option.dataset.formId;
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector
        });
      });

    // Toggle new/edit address forms
    document.querySelectorAll('.address-new-toggle').forEach(function(button) {
      button.addEventListener('click', function() {
        var isExpanded =
          newAddressFormButton.getAttribute('aria-expanded') === 'true';

        newAddressForm.classList.toggle('hide');
        newAddressFormButton.setAttribute('aria-expanded', !isExpanded);
        newAddressFormButton.focus();
      });
    });

    document.querySelectorAll('.address-edit-toggle').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        var formId = evt.target.dataset.formId;
        var editButton = document.getElementById('EditFormButton_' + formId);
        var editAddress = document.getElementById('EditAddress_' + formId);
        var isExpanded = editButton.getAttribute('aria-expanded') === 'true';

        editAddress.classList.toggle('hide');
        editButton.setAttribute('aria-expanded', !isExpanded);
        editButton.focus();
      });
    });

    document.querySelectorAll('.address-delete').forEach(function(button) {
      button.addEventListener('click', function(evt) {
        var target = evt.target.dataset.target;
        var confirmMessage = evt.target.dataset.confirmMessage;

        // eslint-disable-next-line no-alert
        if (
          confirm(
            confirmMessage || 'Are you sure you wish to delete this address?'
          )
        ) {
          Shopify.postLink(target, {
            parameters: { _method: 'delete' }
          });
        }
      });
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function() {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    cartCount: '[data-cart-count]',
    cartCountBubble: '[data-cart-count-bubble]',
    cartDiscount: '[data-cart-discount]',
    cartDiscountTitle: '[data-cart-discount-title]',
    cartDiscountAmount: '[data-cart-discount-amount]',
    cartDiscountWrapper: '[data-cart-discount-wrapper]',
    cartErrorMessage: '[data-cart-error-message]',
    cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
    cartItem: '[data-cart-item]',
    cartItemDetails: '[data-cart-item-details]',
    cartItemDiscount: '[data-cart-item-discount]',
    cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
    cartItemDiscountTitle: '[data-cart-item-discount-title]',
    cartItemDiscountAmount: '[data-cart-item-discount-amount]',
    cartItemDiscountList: '[data-cart-item-discount-list]',
    cartItemFinalPrice: '[data-cart-item-final-price]',
    cartItemImage: '[data-cart-item-image]',
    cartItemLinePrice: '[data-cart-item-line-price]',
    cartItemOriginalPrice: '[data-cart-item-original-price]',
    cartItemPrice: '[data-cart-item-price]',
    cartItemPriceList: '[data-cart-item-price-list]',
    cartItemProperty: '[data-cart-item-property]',
    cartItemPropertyName: '[data-cart-item-property-name]',
    cartItemPropertyValue: '[data-cart-item-property-value]',
    cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
    cartItemRegularPrice: '[data-cart-item-regular-price]',
    cartItemTitle: '[data-cart-item-title]',
    cartItemOption: '[data-cart-item-option]',
    cartLineItems: '[data-cart-line-items]',
    cartNote: '[data-cart-notes]',
    cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
    cartQuantityErrorMessageWrapper:
      '[data-cart-quantity-error-message-wrapper]',
    cartRemove: '[data-cart-remove]',
    cartStatus: '[data-cart-status]',
    cartSubtotal: '[data-cart-subtotal]',
    cartTableCell: '[data-cart-table-cell]',
    cartWrapper: '[data-cart-wrapper]',
    emptyPageContent: '[data-empty-page-content]',
    quantityInput: '[data-quantity-input]',
    quantityInputMobile: '[data-quantity-input-mobile]',
    quantityInputDesktop: '[data-quantity-input-desktop]',
    quantityLabelMobile: '[data-quantity-label-mobile]',
    quantityLabelDesktop: '[data-quantity-label-desktop]',
    inputQty: '[data-quantity-input]',
    thumbnails: '.cart__image',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]',
    unitPriceGroup: '[data-unit-price-group]'
  };

  var classes = {
    cartNoCookies: 'cart--no-cookies',
    cartRemovedProduct: 'cart__removed-product',
    thumbnails: 'cart__image',
    hide: 'hide',
    inputError: 'input--error'
  };

  var attributes = {
    cartItemIndex: 'data-cart-item-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemUrl: 'data-cart-item-url',
    quantityItem: 'data-quantity-item'
  };

  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

  function Cart(container) {
    this.container = container;
    this.thumbnails = this.container.querySelectorAll(selectors.thumbnails);
    this.quantityInputs = this.container.querySelectorAll(selectors.inputQty);

    this.ajaxEnabled = this.container.getAttribute('data-ajax-enabled');

    this._handleInputQty = theme.Helpers.debounce(
      this._handleInputQty.bind(this),
      500
    );
    this.setQuantityFormControllers = this.setQuantityFormControllers.bind(
      this
    );
    this._onNoteChange = this._onNoteChange.bind(this);
    this._onRemoveItem = this._onRemoveItem.bind(this);

    if (!theme.Helpers.cookiesEnabled()) {
      this.container.classList.add(classes.cartNoCookies);
    }

    this.thumbnails.forEach(function(element) {
      element.style.cursor = 'pointer';
    });

    this.container.addEventListener('click', this._handleThumbnailClick);
    this.container.addEventListener('change', this._handleInputQty);

    this.mql = window.matchMedia(mediumUpQuery);
    this.mql.addListener(this.setQuantityFormControllers);

    this.setQuantityFormControllers();

    if (this.ajaxEnabled) {
      /**
       * Because the entire cart is recreated when a cart item is updated,
       * we cannot cache the elements in the cart. Instead, we add the event
       * listeners on the cart's container to allow us to retain the event
       * listeners after rebuilding the cart when an item is updated.
       */
      this.container.addEventListener('click', this._onRemoveItem);
      this.container.addEventListener('change', this._onNoteChange);

      this._setupCartTemplates();
    }
  }

  Cart.prototype = Object.assign({}, Cart.prototype, {
    _setupCartTemplates: function() {
      var cartItem = this.container.querySelector(selectors.cartItem);
      if (!cartItem) return;

      this.itemTemplate = this.container
        .querySelector(selectors.cartItem)
        .cloneNode(true);

      this.itemDiscountTemplate = this.itemTemplate
        .querySelector(selectors.cartItemDiscount)
        .cloneNode(true);

      this.cartDiscountTemplate = this.container
        .querySelector(selectors.cartDiscount)
        .cloneNode(true);

      this.itemPriceListTemplate = this.itemTemplate
        .querySelector(selectors.cartItemPriceList)
        .cloneNode(true);

      this.itemOptionTemplate = this.itemTemplate
        .querySelector(selectors.cartItemOption)
        .cloneNode(true);

      this.itemPropertyTemplate = this.itemTemplate
        .querySelector(selectors.cartItemProperty)
        .cloneNode(true);
    },

    _handleInputQty: function(evt) {
      if (!evt.target.hasAttribute('data-quantity-input')) return;

      var input = evt.target;
      var itemElement = input.closest(selectors.cartItem);

      var itemIndex = Number(input.getAttribute('data-quantity-item'));

      var itemQtyInputs = this.container.querySelectorAll(
        "[data-quantity-item='" + itemIndex + "']"
      );

      var value = parseInt(input.value);

      var isValidValue = !(value < 0 || isNaN(value));

      itemQtyInputs.forEach(function(element) {
        element.value = value;
      });

      this._hideCartError();
      this._hideQuantityErrorMessage();

      if (!isValidValue) {
        this._showQuantityErrorMessages(itemElement);
        return;
      }

      if (isValidValue && this.ajaxEnabled) {
        this._updateItemQuantity(itemIndex, itemElement, itemQtyInputs, value);
      }
    },

    _updateItemQuantity: function(
      itemIndex,
      itemElement,
      itemQtyInputs,
      value
    ) {
      var key = itemElement.getAttribute(attributes.cartItemKey);
      var index = Number(itemElement.getAttribute(attributes.cartItemIndex));

      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          line: index,
          quantity: value
        })
      };

      fetch('/cart/change.js', request)
        .then(function(response) {
          return response.json();
        })
        .then(
          function(state) {
            this._setCartCountBubble(state.item_count);

            if (!state.item_count) {
              this._emptyCart();
              return;
            }

            this._createCart(state);

            if (!value) {
              this._showRemoveMessage(itemElement.cloneNode(true));
              return;
            }

            var lineItem = document.querySelector(
              "[data-cart-item-key='" + key + "']"
            );

            var item = this.getItem(key, state);

            var inputSelector = this.mql.matches
              ? selectors.quantityInputDesktop
              : selectors.quantityInputMobile;

            this._updateLiveRegion(item);

            if (!lineItem) return;
            lineItem.querySelector(inputSelector).focus();
          }.bind(this)
        )
        .catch(
          function() {
            this._showCartError(null);
          }.bind(this)
        );
    },

    getItem: function(key, state) {
      return state.items.find(function(item) {
        return item.key === key;
      });
    },

    _liveRegionText: function(item) {
      // Dummy content for live region
      var liveRegionText =
        theme.strings.update +
        ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';

      // Update Quantity
      liveRegionText = liveRegionText
        .replace('[QuantityLabel]', theme.strings.quantity)
        .replace('[Quantity]', item.quantity);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        item.original_line_price,
        theme.moneyFormat
      );
      var discountLabel = '';
      var discountPrice = '';
      var discountInformation = '';

      if (item.original_line_price > item.final_line_price) {
        regularLabel = theme.strings.regularTotal;

        discountLabel = theme.strings.discountedTotal;
        discountPrice = theme.Currency.formatMoney(
          item.final_line_price,
          theme.moneyFormat
        );

        discountInformation = theme.strings.priceColumn;
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[DiscountedPrice]', discountLabel)
        .replace('[$]', discountPrice)
        .replace('[PriceInformation]', discountInformation)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(item) {
      if (!item) return;

      var liveRegion = this.container.querySelector(selectors.cartStatus);

      liveRegion.textContent = this._liveRegionText(item);
      liveRegion.setAttribute('aria-hidden', false);

      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _createCart: function(state) {
      var cartDiscountList = this._createCartDiscountList(state);

      var cartTable = this.container.querySelector(selectors.cartLineItems);
      cartTable.innerHTML = '';

      this._createLineItemList(state).forEach(function(lineItem) {
        cartTable.appendChild(lineItem);
      });

      this.setQuantityFormControllers();

      this.cartNotes =
        this.cartNotes || this.container.querySelector(selectors.cartNote);

      if (this.cartNotes) {
        this.cartNotes.value = state.note;
      }

      var discountWrapper = this.container.querySelector(
        selectors.cartDiscountWrapper
      );

      if (cartDiscountList.length === 0) {
        discountWrapper.innerHTML = '';
        discountWrapper.classList.add(classes.hide);
      } else {
        discountWrapper.innerHTML = '';

        cartDiscountList.forEach(function(discountItem) {
          discountWrapper.appendChild(discountItem);
        });

        discountWrapper.classList.remove(classes.hide);
      }

      this.container.querySelector(
        selectors.cartSubtotal
      ).textContent = theme.Currency.formatMoney(
        state.total_price,
        theme.moneyFormatWithCurrency
      );
    },

    _createCartDiscountList: function(cart) {
      return cart.cart_level_discount_applications.map(
        function(discount) {
          var discountNode = this.cartDiscountTemplate.cloneNode(true);

          discountNode.querySelector(selectors.cartDiscountTitle).textContent =
            discount.title;

          discountNode.querySelector(
            selectors.cartDiscountAmount
          ).textContent = theme.Currency.formatMoney(
            discount.total_allocated_amount,
            theme.moneyFormat
          );

          return discountNode;
        }.bind(this)
      );
    },

    _createLineItemList: function(state) {
      return state.items.map(
        function(item, index) {
          var itemNode = this.itemTemplate.cloneNode(true);

          var itemPriceList = this.itemPriceListTemplate.cloneNode(true);

          this._setLineItemAttributes(itemNode, item, index);
          this._setLineItemImage(itemNode, item.featured_image);

          var cartItemTitle = itemNode.querySelector(selectors.cartItemTitle);
          cartItemTitle.textContent = item.product_title;
          cartItemTitle.setAttribute('href', item.url);

          var productDetailsList = this._createProductDetailsList(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties
          );

          this._setProductDetailsList(itemNode, productDetailsList);

          this._setItemRemove(itemNode, item.title);

          itemPriceList.innerHTML = this._createItemPrice(
            item.original_price,
            item.final_price
          ).outerHTML;

          if (item.unit_price_measurement) {
            itemPriceList.appendChild(
              this._createUnitPrice(
                item.unit_price,
                item.unit_price_measurement
              )
            );
          }

          this._setItemPrice(itemNode, itemPriceList);

          var itemDiscountList = this._createItemDiscountList(item);
          this._setItemDiscountList(itemNode, itemDiscountList);
          this._setQuantityInputs(itemNode, item, index);

          var itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price
          );

          this._setItemLinePrice(itemNode, itemLinePrice);

          return itemNode;
        }.bind(this)
      );
    },

    _setLineItemAttributes: function(itemNode, item, index) {
      itemNode.setAttribute(attributes.cartItemKey, item.key);
      itemNode.setAttribute(attributes.cartItemUrl, item.url);
      itemNode.setAttribute(attributes.cartItemTitle, item.title);
      itemNode.setAttribute(attributes.cartItemIndex, index + 1);
      itemNode.setAttribute(attributes.cartItemQuantity, item.quantity);
    },

    _setLineItemImage: function(itemNode, featuredImage) {
      var image = itemNode.querySelector(selectors.cartItemImage);

      var sizedImageUrl =
        featuredImage.url !== null
          ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190')
          : null;

      if (sizedImageUrl) {
        image.setAttribute('alt', featuredImage.alt);
        image.setAttribute('src', sizedImageUrl);
        image.classList.remove(classes.hide);
      } else {
        image.parentNode.removeChild(image);
      }
    },

    _setProductDetailsList: function(item, productDetailsList) {
      var itemDetails = item.querySelector(selectors.cartItemDetails);

      if (productDetailsList.length) {
        itemDetails.classList.remove(classes.hide);
        itemDetails.innerHTML = productDetailsList.reduce(function(
          result,
          element
        ) {
          return result + element.outerHTML;
        },
        '');

        return;
      }

      itemDetails.classList.add(classes.hide);
      itemDetails.textContent = '';
    },

    _setItemPrice: function(item, price) {
      item.querySelector(selectors.cartItemPrice).innerHTML = price.outerHTML;
    },

    _setItemDiscountList: function(item, discountList) {
      var itemDiscountList = item.querySelector(selectors.cartItemDiscountList);

      if (discountList.length === 0) {
        itemDiscountList.innerHTML = '';
        itemDiscountList.classList.add(classes.hide);
      } else {
        itemDiscountList.innerHTML = discountList.reduce(function(
          result,
          element
        ) {
          return result + element.outerHTML;
        },
        '');

        itemDiscountList.classList.remove(classes.hide);
      }
    },

    _setItemRemove: function(item, title) {
      item
        .querySelector(selectors.cartRemove)
        .setAttribute(
          'aria-label',
          theme.strings.removeLabel.replace('[product]', title)
        );
    },

    _setQuantityInputs: function(itemNode, item, index) {
      var mobileInput = itemNode.querySelector(selectors.quantityInputMobile);
      var desktopInput = itemNode.querySelector(selectors.quantityInputDesktop);

      mobileInput.setAttribute('id', 'updates_' + item.key);
      desktopInput.setAttribute('id', 'updates_large_' + item.key);

      [mobileInput, desktopInput].forEach(function(element) {
        element.setAttribute(attributes.quantityItem, index + 1);
        element.value = item.quantity;
      });

      itemNode
        .querySelector(selectors.quantityLabelMobile)
        .setAttribute('for', 'updates_' + item.key);

      itemNode
        .querySelector(selectors.quantityLabelDesktop)
        .setAttribute('for', 'updates_large_' + item.key);
    },

    setQuantityFormControllers: function() {
      var desktopQuantityInputs = document.querySelectorAll(
        selectors.quantityInputDesktop
      );

      var mobileQuantityInputs = document.querySelectorAll(
        selectors.quantityInputMobile
      );

      if (this.mql.matches) {
        addNameAttribute(desktopQuantityInputs);
        removeNameAttribute(mobileQuantityInputs);
      } else {
        addNameAttribute(mobileQuantityInputs);
        removeNameAttribute(desktopQuantityInputs);
      }

      function addNameAttribute(inputs) {
        inputs.forEach(function(element) {
          element.setAttribute('name', 'updates[]');
        });
      }

      function removeNameAttribute(inputs) {
        inputs.forEach(function(element) {
          element.removeAttribute('name');
        });
      }
    },

    _setItemLinePrice: function(item, price) {
      item.querySelector(selectors.cartItemLinePrice).innerHTML =
        price.outerHTML;
    },

    _createProductDetailsList: function(
      product_has_only_default_variant,
      options,
      properties
    ) {
      var optionsPropertiesHTML = [];

      if (!product_has_only_default_variant) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getOptionList(options)
        );
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getPropertyList(properties)
        );
      }

      return optionsPropertiesHTML;
    },

    _getOptionList: function(options) {
      return options.map(
        function(option) {
          var optionElement = this.itemOptionTemplate.cloneNode(true);

          optionElement.textContent = option.name + ': ' + option.value;
          optionElement.classList.remove(classes.hide);

          return optionElement;
        }.bind(this)
      );
    },

    _getPropertyList: function(properties) {
      var propertiesArray =
        properties !== null ? Object.entries(properties) : [];

      return propertiesArray.map(
        function(property) {
          var propertyElement = this.itemPropertyTemplate.cloneNode(true);

          // Line item properties prefixed with an underscore are not to be displayed
          if (property[0].charAt(0) === '_') return;

          // if the property value has a length of 0 (empty), don't display it
          if (property[1].length === 0) return;

          propertyElement.querySelector(
            selectors.cartItemPropertyName
          ).textContent = property[0];

          if (property[0].indexOf('/uploads/') === -1) {
            propertyElement.querySelector(
              selectors.cartItemPropertyValue
            ).textContent = ': ' + property[1];
          } else {
            propertyElement.querySelector(
              selectors.cartItemPropertyValue
            ).innerHTML =
              ': <a href="' +
              property[1] +
              '"> ' +
              property[1].split('/').pop() +
              '</a>';
          }

          propertyElement.classList.remove(classes.hide);

          return propertyElement;
        }.bind(this)
      );
    },

    _createItemPrice: function(original_price, final_price) {
      var originalPriceHTML = theme.Currency.formatMoney(
        original_price,
        theme.moneyFormat
      );

      var resultHTML;

      if (original_price !== final_price) {
        resultHTML = this.itemPriceListTemplate
          .querySelector(selectors.cartItemDiscountedPriceGroup)
          .cloneNode(true);

        resultHTML.querySelector(
          selectors.cartItemOriginalPrice
        ).innerHTML = originalPriceHTML;

        resultHTML.querySelector(
          selectors.cartItemFinalPrice
        ).innerHTML = theme.Currency.formatMoney(
          final_price,
          theme.moneyFormat
        );
      } else {
        resultHTML = this.itemPriceListTemplate
          .querySelector(selectors.cartItemRegularPriceGroup)
          .cloneNode(true);

        resultHTML.querySelector(
          selectors.cartItemRegularPrice
        ).innerHTML = originalPriceHTML;
      }

      resultHTML.classList.remove(classes.hide);
      return resultHTML;
    },

    _createUnitPrice: function(unitPrice, unitPriceMeasurement) {
      var unitPriceGroup = this.itemPriceListTemplate
        .querySelector(selectors.unitPriceGroup)
        .cloneNode(true);

      var unitPriceBaseUnit =
        (unitPriceMeasurement.reference_value !== 1
          ? unitPriceMeasurement.reference_value
          : '') + unitPriceMeasurement.reference_unit;

      unitPriceGroup.querySelector(
        selectors.unitPriceBaseUnit
      ).textContent = unitPriceBaseUnit;

      unitPriceGroup.querySelector(
        selectors.unitPrice
      ).innerHTML = theme.Currency.formatMoney(unitPrice, theme.moneyFormat);

      unitPriceGroup.classList.remove(classes.hide);

      return unitPriceGroup;
    },

    _createItemDiscountList: function(item) {
      return item.line_level_discount_allocations.map(
        function(discount) {
          var discountNode = this.itemDiscountTemplate.cloneNode(true);

          discountNode.querySelector(
            selectors.cartItemDiscountTitle
          ).textContent = discount.discount_application.title;

          discountNode.querySelector(
            selectors.cartItemDiscountAmount
          ).textContent = theme.Currency.formatMoney(
            discount.amount,
            theme.moneyFormat
          );

          return discountNode;
        }.bind(this)
      );
    },

    _showQuantityErrorMessages: function(itemElement) {
      itemElement
        .querySelectorAll(selectors.cartQuantityErrorMessage)
        .forEach(function(element) {
          element.textContent = theme.strings.quantityMinimumMessage;
        });

      itemElement
        .querySelectorAll(selectors.cartQuantityErrorMessageWrapper)
        .forEach(function(element) {
          element.classList.remove(classes.hide);
        });

      itemElement
        .querySelectorAll(selectors.inputQty)
        .forEach(function(element) {
          element.classList.add(classes.inputError);
          element.focus();
        });
    },

    _hideQuantityErrorMessage: function() {
      var errorMessages = document.querySelectorAll(
        selectors.cartQuantityErrorMessageWrapper
      );

      errorMessages.forEach(function(element) {
        element.classList.add(classes.hide);

        element.querySelector(selectors.cartQuantityErrorMessage).textContent =
          '';
      });

      this.container
        .querySelectorAll(selectors.inputQty)
        .forEach(function(element) {
          element.classList.remove(classes.inputError);
        });
    },

    _handleThumbnailClick: function(evt) {
      if (!evt.target.classList.contains(classes.thumbnails)) return;

      window.location.href = evt.target
        .closest(selectors.cartItem)
        .getAttribute('data-cart-item-url');
    },

    _onNoteChange: function(evt) {
      if (!evt.target.hasAttribute('data-cart-notes')) return;

      var note = evt.target.value;
      this._hideCartError();
      this._hideQuantityErrorMessage();

      var headers = new Headers({ 'Content-Type': 'application/json' });

      var request = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ note: note })
      };

      fetch('/cart/update.js', request).catch(
        function() {
          this._showCartError(evt.target);
        }.bind(this)
      );
    },

    _showCartError: function(elementToFocus) {
      document.querySelector(selectors.cartErrorMessage).textContent =
        theme.strings.cartError;

      document
        .querySelector(selectors.cartErrorMessageWrapper)
        .classList.remove(classes.hide);

      if (!elementToFocus) return;
      elementToFocus.focus();
    },

    _hideCartError: function() {
      document
        .querySelector(selectors.cartErrorMessageWrapper)
        .classList.add(classes.hide);
      document.querySelector(selectors.cartErrorMessage).textContent = '';
    },

    _onRemoveItem: function(evt) {
      if (!evt.target.hasAttribute('data-cart-remove')) return;

      evt.preventDefault();
      var lineItem = evt.target.closest(selectors.cartItem);
      var index = Number(lineItem.getAttribute(attributes.cartItemIndex));

      this._hideCartError();

      var request = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json;'
        },
        body: JSON.stringify({
          line: index,
          quantity: 0
        })
      };

      fetch('/cart/change.js', request)
        .then(function(response) {
          return response.json();
        })
        .then(
          function(state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);
              this._showRemoveMessage(lineItem.cloneNode(true));
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .catch(
          function() {
            this._showCartError(null);
          }.bind(this)
        );
    },

    _showRemoveMessage: function(lineItem) {
      var index = lineItem.getAttribute('data-cart-item-index');
      var removeMessage = this._getRemoveMessage(lineItem);

      if (index - 1 === 0) {
        this.container
          .querySelector('[data-cart-item-index="1"]')
          .insertAdjacentHTML('beforebegin', removeMessage.outerHTML);
      } else {
        this.container
          .querySelector("[data-cart-item-index='" + (index - 1) + "']")
          .insertAdjacentHTML('afterend', removeMessage.outerHTML);
      }

      this.container.querySelector('[data-removed-item-row]').focus();
    },

    _getRemoveMessage: function(lineItem) {
      var formattedMessage = this._formatRemoveMessage(lineItem);

      var tableCell = lineItem
        .querySelector(selectors.cartTableCell)
        .cloneNode(true);

      tableCell.removeAttribute('class');
      tableCell.classList.add(classes.cartRemovedProduct);
      tableCell.setAttribute('colspan', '4');
      tableCell.innerHTML = formattedMessage;

      lineItem.setAttribute('role', 'alert');
      lineItem.setAttribute('tabindex', '-1');
      lineItem.setAttribute('data-removed-item-row', true);
      lineItem.innerHTML = tableCell.outerHTML;

      return lineItem;
    },

    _formatRemoveMessage: function(lineItem) {
      var quantity = lineItem.getAttribute('data-cart-item-quantity');
      var url = lineItem.getAttribute(attributes.cartItemUrl);
      var title = lineItem.getAttribute(attributes.cartItemTitle);

      return theme.strings.removedItemMessage
        .replace('[quantity]', quantity)
        .replace(
          '[link]',
          '<a ' +
            'href="' +
            url +
            '" class="text-link text-link--accent">' +
            title +
            '</a>'
        );
    },

    _setCartCountBubble: function(quantity) {
      this.cartCountBubble =
        this.cartCountBubble ||
        document.querySelector(selectors.cartCountBubble);

      this.cartCount =
        this.cartCount || document.querySelector(selectors.cartCount);

      if (quantity > 0) {
        this.cartCountBubble.classList.remove(classes.hide);
        this.cartCount.textContent = quantity;
      } else {
        this.cartCountBubble.classList.add(classes.hide);
        this.cartCount.textContent = '';
      }
    },

    _emptyCart: function() {
      this.emptyPageContent =
        this.emptyPageContent ||
        this.container.querySelector(selectors.emptyPageContent);

      this.cartWrapper =
        this.cartWrapper || this.container.querySelector(selectors.cartWrapper);

      this.emptyPageContent.classList.remove(classes.hide);
      this.cartWrapper.classList.add(classes.hide);
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var settings = {
    mediaQueryMediumUp: '(min-width: ' + theme.breakpoints.medium + 'px)'
  };

  var selectors = {
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    selectInput: '[data-select-input]'
  };

  function Filters(container) {
    this.filterSelect = container.querySelector(selectors.filterSelection);
    this.sortSelect = container.querySelector(selectors.sortSelection);

    this.selects = document.querySelectorAll(selectors.selectInput);

    if (this.sortSelect) {
      this.defaultSort = this._getDefaultSortValue();
    }

    if (this.selects.length) {
      this.selects.forEach(function(select) {
        select.classList.remove('hidden');
      });
    }

    this.initBreakpoints = this._initBreakpoints.bind(this);

    this.mql = window.matchMedia(settings.mediaQueryMediumUp);
    this.mql.addListener(this.initBreakpoints);

    if (this.filterSelect) {
      this.filterSelect.addEventListener(
        'change',
        this._onFilterChange.bind(this)
      );
    }

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this._onSortChange.bind(this));
    }

    theme.Helpers.promiseStylesheet().then(
      function() {
        this._initBreakpoints();
      }.bind(this)
    );
    this._initParams();
  }

  Filters.prototype = Object.assign({}, Filters.prototype, {
    _initBreakpoints: function() {
      if (this.mql.matches) {
        slate.utils.resizeSelects(this.selects);
      }
    },

    _initParams: function() {
      this.queryParams = {};
      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            this.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    _onSortChange: function() {
      this.queryParams.sort_by = this._getSortValue();

      if (this.queryParams.page) {
        delete this.queryParams.page;
      }

      window.location.search = decodeURIComponent(
        new URLSearchParams(Object.entries(this.queryParams)).toString()
      );
    },

    _onFilterChange: function() {
      document.location.href = this._getFilterValue();
    },

    _getFilterValue: function() {
      return this.filterSelect.value;
    },

    _getSortValue: function() {
      return this.sortSelect.value || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.sortSelect.dataset.defaultSortby;
    },

    onUnload: function() {
      if (this.filterSelect) {
        this.filterSelect.removeEventListener('change', this._onFilterChange);
      }

      if (this.sortSelect) {
        this.sortSelect.removeEventListener('change', this._onSortChange);
      }

      this.mql.removeListener(this.initBreakpoints);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.SearchDrawer.init();
    theme.Search.init();
  }

  Header.prototype = Object.assign({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
      theme.Search.unload();
      theme.MobileNav.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    document.querySelector(selectors.section).classList.add(classes.mapError);
    document.querySelector(selectors.map).remove();
    document
      .querySelector(selectors.mapOverlay)
      .insertAdjacentHTML(
        'afterend',
        '<div class="' +
          classes.errorMsg +
          '">' +
          theme.strings.authError +
          '</div>'
      );
  };

  function Map(container) {
    this.map = container.querySelector(selectors.map);
    if (!this.map) return;
    this.key = this.map.dataset.apiKey;

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          theme.Helpers.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    mapsToLoad.forEach(function(map) {
      map.createMap();
    });
  }

  function geolocate(map) {
    return new Promise(function(resolve, reject) {
      var geocoder = new google.maps.Geocoder();
      var address = map.dataset.addressSetting;

      geocoder.geocode({ address: address }, function(results, status) {
        if (status !== google.maps.GeocoderStatus.OK) {
          reject(status);
        }

        resolve(results);
      });
    });
  }

  Map.prototype = Object.assign({}, Map.prototype, {
    createMap: function() {
      return geolocate(this.map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map(this.map, mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              theme.Helpers.debounce(
                function() {
                  google.maps.event.trigger(map, 'resize');
                  map.setCenter(center);
                  this.map.removeAttribute('style');
                }.bind(this),
                250
              )
            );
          }.bind(this)
        )
        .catch(
          function() {
            var errorMessage;

            switch (status) {
              case 'ZERO_RESULTS':
                errorMessage = errors.addressNoResults;
                break;
              case 'OVER_QUERY_LIMIT':
                errorMessage = errors.addressQueryLimit;
                break;
              case 'REQUEST_DENIED':
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              this.map.parentNode.classList.add(classes.mapError);
              this.map.parentNode.innerHTML =
                '<div class="' +
                classes.errorMsg +
                '">' +
                errorMessage +
                '</div>';
            }
          }.bind(this)
        );
    },

    onUnload: function() {
      if (this.map) {
        google.maps.event.clearListeners(this.map, 'resize');
      }
    }
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    this.zoomPictures = [];
    this.ajaxEnabled = container.getAttribute('data-ajax-enabled') === 'true';

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState:
        container.getAttribute('data-enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      cartCount: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartPopup: '[data-cart-popup]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupClose: '[data-cart-popup-close]',
      cartPopupDismiss: '[data-cart-popup-dismiss]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-image-loading-animation]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
      cartPopupTitle: '[data-cart-popup-title]',
      cartPopupWrapper: '[data-cart-popup-wrapper]',
      loader: '[data-loader]',
      loaderStatus: '[data-loader-status]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      imageZoomWrapper: '[data-image-zoom-wrapper]',
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      productMediaTypeVideo: '[data-product-media-type-video]',
      productMediaTypeModel: '[data-product-media-type-model]',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      productPolicies: '[data-product-policies]'
    };

    this.classes = {
      cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
      hidden: 'hide',
      visibilityHidden: 'visibility-hidden',
      inputError: 'input--error',
      jsZoomEnabled: 'js-zoom-enabled',
      productOnSale: 'price--on-sale',
      productUnitAvailable: 'price--unit-available',
      productUnavailable: 'price--unavailable',
      productSoldOut: 'price--sold-out',
      cartImage: 'cart-popup-item__image',
      productFormErrorMessageWrapperHidden:
        'product-form__error-message-wrapper--hidden',
      activeClass: 'active-thumb',
      variantSoldOut: 'product-form--variant-sold-out'
    };

    this.eventHandlers = {};

    this.quantityInput = container.querySelector(this.selectors.quantity);
    this.errorMessageWrapper = container.querySelector(
      this.selectors.errorMessageWrapper
    );
    this.addToCart = container.querySelector(this.selectors.addToCart);
    this.addToCartText = this.addToCart.querySelector(
      this.selectors.addToCartText
    );
    this.shopifyPaymentButton = container.querySelector(
      this.selectors.shopifyPaymentButton
    );
    this.productPolicies = container.querySelector(
      this.selectors.productPolicies
    );

    this.loader = this.addToCart.querySelector(this.selectors.loader);
    this.loaderStatus = container.querySelector(this.selectors.loaderStatus);

    this.imageZoomWrapper = container.querySelectorAll(
      this.selectors.imageZoomWrapper
    );

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    var productJson = document.getElementById('ProductJson-' + sectionId);
    if (!productJson || !productJson.innerHTML.length) {
      return;
    }

    this.productSingleObject = JSON.parse(productJson.innerHTML);

    this.settings.zoomEnabled =
      this.imageZoomWrapper.length > 0
        ? this.imageZoomWrapper[0].classList.contains(
            this.classes.jsZoomEnabled
          )
        : false;

    this.initMobileBreakpoint = this._initMobileBreakpoint.bind(this);
    this.initDesktopBreakpoint = this._initDesktopBreakpoint.bind(this);

    this.mqlSmall = window.matchMedia(this.settings.mediaQuerySmall);
    this.mqlSmall.addListener(this.initMobileBreakpoint);

    this.mqlMediumUp = window.matchMedia(this.settings.mediaQueryMediumUp);
    this.mqlMediumUp.addListener(this.initDesktopBreakpoint);

    this.initMobileBreakpoint();
    this.initDesktopBreakpoint();
    this._stringOverrides();
    this._initVariants();
    this._initMediaSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
    this._initProductVideo();
    this._initModelViewerLibraries();
    this._initShopifyXrLaunch();
  }

  Product.prototype = Object.assign({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      theme.strings = Object.assign({}, theme.strings, theme.productStrings);
    },

    _initMobileBreakpoint: function() {
      if (this.mqlSmall.matches) {
        // initialize thumbnail slider on mobile if more than four thumbnails
        if (
          this.container.querySelectorAll(this.selectors.productThumbImages)
            .length > 4
        ) {
          this._initThumbnailSlider();
        }

        // destroy image zooming if enabled
        if (this.settings.zoomEnabled) {
          this.imageZoomWrapper.forEach(
            function(element, index) {
              this._destroyZoom(index);
            }.bind(this)
          );
        }

        this.settings.bpSmall = true;
      } else {
        if (this.settings.sliderActive) {
          this._destroyThumbnailSlider();
        }

        this.settings.bpSmall = false;
      }
    },

    _initDesktopBreakpoint: function() {
      if (this.mqlMediumUp.matches && this.settings.zoomEnabled) {
        this.imageZoomWrapper.forEach(
          function(element, index) {
            this._enableZoom(element, index);
          }.bind(this)
        );
      }
    },

    _initVariants: function() {
      var options = {
        container: this.container,
        enableHistoryState:
          this.container.getAttribute('data-enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.eventHandlers.updateAvailability = this._updateAvailability.bind(
        this
      );
      this.eventHandlers.updateMedia = this._updateMedia.bind(this);
      this.eventHandlers.updatePrice = this._updatePrice.bind(this);
      this.eventHandlers.updateSKU = this._updateSKU.bind(this);

      this.container.addEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      this.container.addEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );
      this.container.addEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      this.container.addEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );
    },

    _initMediaSwitch: function() {
      if (!document.querySelector(this.selectors.productThumbImages)) {
        return;
      }

      var self = this;

      var productThumbImages = document.querySelectorAll(
        this.selectors.productThumbImages
      );

      this.eventHandlers.handleMediaFocus = this._handleMediaFocus.bind(this);

      productThumbImages.forEach(function(el) {
        el.addEventListener('click', function(evt) {
          evt.preventDefault();
          var mediaId = el.getAttribute('data-thumbnail-id');

          self._switchMedia(mediaId);
          self._setActiveThumbnail(mediaId);
        });
        el.addEventListener('keyup', self.eventHandlers.handleMediaFocus);
      });
    },

    _initAddToCart: function() {
      var productForm = this.container.querySelector(
        this.selectors.productForm
      );
      productForm.addEventListener(
        'submit',
        function(evt) {
          if (this.addToCart.getAttribute('aria-disabled') === 'true') {
            evt.preventDefault();
            return;
          }

          if (!this.ajaxEnabled) return;

          evt.preventDefault();

          this.previouslyFocusedElement = document.activeElement;

          var isInvalidQuantity =
            !!this.quantityInput && this.quantityInput.value <= 0;

          if (isInvalidQuantity) {
            this._showErrorMessage(theme.strings.quantityMinimumMessage);
            return;
          }

          if (!isInvalidQuantity && this.ajaxEnabled) {
            // disable the addToCart and dynamic checkout button while
            // request/cart popup is loading and handle loading state
            this._handleButtonLoadingState(true);
            var form = this.container.querySelector(this.selectors.productForm);
            this._addItemToCart(form);
            return;
          }
        }.bind(this)
      );
    },

    _initProductVideo: function() {
      var sectionId = this.settings.sectionId;

      var productMediaTypeVideo = this.container.querySelectorAll(
        this.selectors.productMediaTypeVideo
      );
      productMediaTypeVideo.forEach(function(el) {
        theme.ProductVideo.init(el, sectionId);
      });
    },

    _initModelViewerLibraries: function() {
      var modelViewerElements = this.container.querySelectorAll(
        this.selectors.productMediaTypeModel
      );
      if (modelViewerElements.length < 1) return;
      theme.ProductModel.init(modelViewerElements, this.settings.sectionId);
    },

    _initShopifyXrLaunch: function() {
      this.eventHandlers.initShopifyXrLaunchHandler = this._initShopifyXrLaunchHandler.bind(
        this
      );
      document.addEventListener(
        'shopify_xr_launch',
        this.eventHandlers.initShopifyXrLaunchHandler
      );
    },

    _initShopifyXrLaunchHandler: function() {
      var currentMedia = this.container.querySelector(
        this.selectors.productMediaWrapper +
          ':not(.' +
          self.classes.hidden +
          ')'
      );
      currentMedia.dispatchEvent(
        new CustomEvent('xrLaunch', {
          bubbles: true,
          cancelable: true
        })
      );
    },

    _addItemToCart: function(form) {
      var self = this;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: theme.Helpers.serialize(form)
      })
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          if (json.status && json.status !== 200) {
            var error = new Error(json.description);
            error.isFromServer = true;
            throw error;
          }
          self._hideErrorMessage();
          self._setupCartPopup(json);
        })
        .catch(function(error) {
          self.previouslyFocusedElement.focus();
          self._showErrorMessage(
            error.isFromServer && error.message.length
              ? error.message
              : theme.strings.cartError
          );
          self._handleButtonLoadingState(false);
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    _handleButtonLoadingState: function(isLoading) {
      if (isLoading) {
        this.addToCart.setAttribute('aria-disabled', true);
        this.addToCartText.classList.add(this.classes.hidden);
        this.loader.classList.remove(this.classes.hidden);

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.setAttribute('disabled', true);
        }

        this.loaderStatus.setAttribute('aria-hidden', false);
      } else {
        this.addToCart.removeAttribute('aria-disabled');
        this.addToCartText.classList.remove(this.classes.hidden);
        this.loader.classList.add(this.classes.hidden);

        if (this.shopifyPaymentButton) {
          this.shopifyPaymentButton.removeAttribute('disabled');
        }

        this.loaderStatus.setAttribute('aria-hidden', true);
      }
    },

    _showErrorMessage: function(errorMessage) {
      var errorMessageContainer = this.container.querySelector(
        this.selectors.errorMessage
      );
      errorMessageContainer.innerHTML = errorMessage;

      if (this.quantityInput) {
        this.quantityInput.classList.add(this.classes.inputError);
      }

      this.errorMessageWrapper.classList.remove(
        this.classes.productFormErrorMessageWrapperHidden
      );
      this.errorMessageWrapper.setAttribute('aria-hidden', true);
      this.errorMessageWrapper.removeAttribute('aria-hidden');
    },

    _hideErrorMessage: function() {
      this.errorMessageWrapper.classList.add(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.quantityInput) {
        this.quantityInput.classList.remove(this.classes.inputError);
      }
    },

    _setupCartPopup: function(item) {
      this.cartPopup =
        this.cartPopup || document.querySelector(this.selectors.cartPopup);
      this.cartPopupWrapper =
        this.cartPopupWrapper ||
        document.querySelector(this.selectors.cartPopupWrapper);
      this.cartPopupTitle =
        this.cartPopupTitle ||
        document.querySelector(this.selectors.cartPopupTitle);
      this.cartPopupQuantity =
        this.cartPopupQuantity ||
        document.querySelector(this.selectors.cartPopupQuantity);
      this.cartPopupQuantityLabel =
        this.cartPopupQuantityLabel ||
        document.querySelector(this.selectors.cartPopupQuantityLabel);
      this.cartPopupClose =
        this.cartPopupClose ||
        document.querySelector(this.selectors.cartPopupClose);
      this.cartPopupDismiss =
        this.cartPopupDismiss ||
        document.querySelector(this.selectors.cartPopupDismiss);
      this.cartPopupImagePlaceholder =
        this.cartPopupImagePlaceholder ||
        document.querySelector(this.selectors.cartPopupImagePlaceholder);

      this._setupCartPopupEventListeners();

      this._updateCartPopupContent(item);
    },

    _updateCartPopupContent: function(item) {
      var self = this;

      var quantity = this.quantityInput ? this.quantityInput.value : 1;

      this.cartPopupTitle.textContent = item.product_title;
      this.cartPopupQuantity.textContent = quantity;
      this.cartPopupQuantityLabel.textContent = theme.strings.quantityLabel.replace(
        '[count]',
        quantity
      );

      this._setCartPopupPlaceholder(item.featured_image.url);
      this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
      this._setCartPopupProductDetails(
        item.product_has_only_default_variant,
        item.options_with_values,
        item.properties
      );

      fetch('/cart.js')
        .then(function(response) {
          return response.json();
        })
        .then(function(cart) {
          self._setCartQuantity(cart.item_count);
          self._setCartCountBubble(cart.item_count);
          self._showCartPopup();
        })
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },

    _setupCartPopupEventListeners: function() {
      this.eventHandlers.cartPopupWrapperKeyupHandler = this._cartPopupWrapperKeyupHandler.bind(
        this
      );
      this.eventHandlers.hideCartPopup = this._hideCartPopup.bind(this);
      this.eventHandlers.onBodyClick = this._onBodyClick.bind(this);

      this.cartPopupWrapper.addEventListener(
        'keyup',
        this.eventHandlers.cartPopupWrapperKeyupHandler
      );
      this.cartPopupClose.addEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      this.cartPopupDismiss.addEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      document.body.addEventListener('click', this.eventHandlers.onBodyClick);
    },

    _cartPopupWrapperKeyupHandler: function(event) {
      if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
        this._hideCartPopup(event);
      }
    },

    _setCartPopupPlaceholder: function(imageUrl) {
      this.cartPopupImageWrapper =
        this.cartPopupImageWrapper ||
        document.querySelector(this.selectors.cartPopupImageWrapper);

      if (imageUrl === null) {
        this.cartPopupImageWrapper.classList.add(this.classes.hidden);
        return;
      }
    },

    _setCartPopupImage: function(imageUrl, imageAlt) {
      if (imageUrl === null) return;

      this.cartPopupImageWrapper.classList.remove(this.classes.hidden);
      var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
      var image = document.createElement('img');
      image.src = sizedImageUrl;
      image.alt = imageAlt;
      image.classList.add(this.classes.cartImage);
      image.setAttribute('data-cart-popup-image', '');

      image.onload = function() {
        this.cartPopupImagePlaceholder.removeAttribute(
          'data-image-loading-animation'
        );
        this.cartPopupImageWrapper.append(image);
      }.bind(this);
    },

    _setCartPopupProductDetails: function(
      product_has_only_default_variant,
      options,
      properties
    ) {
      this.cartPopupProductDetails =
        this.cartPopupProductDetails ||
        document.querySelector(this.selectors.cartPopupProductDetails);
      var variantPropertiesHTML = '';

      if (!product_has_only_default_variant) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getVariantOptionList(options);
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getPropertyList(properties);
      }

      if (variantPropertiesHTML.length === 0) {
        this.cartPopupProductDetails.innerHTML = '';
        this.cartPopupProductDetails.setAttribute('hidden', '');
      } else {
        this.cartPopupProductDetails.innerHTML = variantPropertiesHTML;
        this.cartPopupProductDetails.removeAttribute('hidden');
      }
    },

    _getVariantOptionList: function(variantOptions) {
      var variantOptionListHTML = '';

      variantOptions.forEach(function(variantOption) {
        variantOptionListHTML =
          variantOptionListHTML +
          '<li class="product-details__item product-details__item--variant-option">' +
          variantOption.name +
          ': ' +
          variantOption.value +
          '</li>';
      });

      return variantOptionListHTML;
    },

    _getPropertyList: function(properties) {
      var propertyListHTML = '';
      var propertiesArray = Object.entries(properties);

      propertiesArray.forEach(function(property) {
        // Line item properties prefixed with an underscore are not to be displayed
        if (property[0].charAt(0) === '_') return;

        // if the property value has a length of 0 (empty), don't display it
        if (property[1].length === 0) return;

        propertyListHTML =
          propertyListHTML +
          '<li class="product-details__item product-details__item--property">' +
          '<span class="product-details__property-label">' +
          property[0] +
          ': </span>' +
          property[1];
        ': ' + '</li>';
      });

      return propertyListHTML;
    },

    _setCartQuantity: function(quantity) {
      this.cartPopupCartQuantity =
        this.cartPopupCartQuantity ||
        document.querySelector(this.selectors.cartPopupCartQuantity);
      var ariaLabel;

      if (quantity === 1) {
        ariaLabel = theme.strings.oneCartCount;
      } else if (quantity > 1) {
        ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
      }

      this.cartPopupCartQuantity.textContent = quantity;
      this.cartPopupCartQuantity.setAttribute('aria-label', ariaLabel);
    },

    _setCartCountBubble: function(quantity) {
      this.cartCountBubble =
        this.cartCountBubble ||
        document.querySelector(this.selectors.cartCountBubble);
      this.cartCount =
        this.cartCount || document.querySelector(this.selectors.cartCount);

      this.cartCountBubble.classList.remove(this.classes.hidden);
      this.cartCount.textContent = quantity;
    },

    _showCartPopup: function() {
      theme.Helpers.prepareTransition(this.cartPopupWrapper);

      this.cartPopupWrapper.classList.remove(
        this.classes.cartPopupWrapperHidden
      );
      this._handleButtonLoadingState(false);

      slate.a11y.trapFocus({
        container: this.cartPopupWrapper,
        elementToFocus: this.cartPopup,
        namespace: 'cartPopupFocus'
      });
    },

    _hideCartPopup: function(event) {
      var setFocus = event.detail === 0 ? true : false;
      theme.Helpers.prepareTransition(this.cartPopupWrapper);
      this.cartPopupWrapper.classList.add(this.classes.cartPopupWrapperHidden);

      var cartPopupImage = document.querySelector(
        this.selectors.cartPopupImage
      );
      if (cartPopupImage) {
        cartPopupImage.remove();
      }
      this.cartPopupImagePlaceholder.setAttribute(
        'data-image-loading-animation',
        ''
      );

      slate.a11y.removeTrapFocus({
        container: this.cartPopupWrapper,
        namespace: 'cartPopupFocus'
      });

      if (setFocus) this.previouslyFocusedElement.focus();

      this.cartPopupWrapper.removeEventListener(
        'keyup',
        this.eventHandlers.cartPopupWrapperKeyupHandler
      );
      this.cartPopupClose.removeEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      this.cartPopupDismiss.removeEventListener(
        'click',
        this.eventHandlers.hideCartPopup
      );
      document.body.removeEventListener(
        'click',
        this.eventHandlers.onBodyClick
      );
    },

    _onBodyClick: function(event) {
      var target = event.target;

      if (
        target !== this.cartPopupWrapper &&
        !target.closest(this.selectors.cartPopup)
      ) {
        this._hideCartPopup(event);
      }
    },

    _setActiveThumbnail: function(mediaId) {
      // If there is no element passed, find it by the current product image
      if (typeof mediaId === 'undefined') {
        var productMediaWrapper = this.container.querySelector(
          this.selectors.productMediaWrapper + ':not(.hide)'
        );

        if (!productMediaWrapper) return;
        mediaId = productMediaWrapper.getAttribute('data-media-id');
      }

      var thumbnailWrappers = this.container.querySelectorAll(
        this.selectors.productThumbListItem + ':not(.slick-cloned)'
      );

      var activeThumbnail;
      thumbnailWrappers.forEach(
        function(el) {
          var current = el.querySelector(
            this.selectors.productThumbImages +
              "[data-thumbnail-id='" +
              mediaId +
              "']"
          );
          if (current) {
            activeThumbnail = current;
          }
        }.bind(this)
      );

      var productThumbImages = document.querySelectorAll(
        this.selectors.productThumbImages
      );
      productThumbImages.forEach(
        function(el) {
          el.classList.remove(this.classes.activeClass);
          el.removeAttribute('aria-current');
        }.bind(this)
      );

      if (activeThumbnail) {
        activeThumbnail.classList.add(this.classes.activeClass);
        activeThumbnail.setAttribute('aria-current', true);
        this._adjustThumbnailSlider(activeThumbnail);
      }
    },

    _adjustThumbnailSlider: function(activeThumbnail) {
      var sliderItem = activeThumbnail.closest('[data-slider-item]');
      if (!sliderItem) return;

      var slideGroupLeaderIndex =
        Math.floor(
          Number(sliderItem.getAttribute('data-slider-slide-index')) / 3
        ) * 3;

      window.setTimeout(
        function() {
          if (!this.slideshow) return;
          this.slideshow.goToSlideByIndex(slideGroupLeaderIndex);
        }.bind(this),
        251
      );
    },

    _switchMedia: function(mediaId) {
      var currentMedia = this.container.querySelector(
        this.selectors.productMediaWrapper +
          ':not(.' +
          this.classes.hidden +
          ')'
      );

      var newMedia = this.container.querySelector(
        this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
      );

      var otherMedia = this.container.querySelectorAll(
        this.selectors.productMediaWrapper +
          ":not([data-media-id='" +
          mediaId +
          "'])"
      );

      currentMedia.dispatchEvent(
        new CustomEvent('mediaHidden', {
          bubbles: true,
          cancelable: true
        })
      );
      newMedia.classList.remove(this.classes.hidden);
      newMedia.dispatchEvent(
        new CustomEvent('mediaVisible', {
          bubbles: true,
          cancelable: true
        })
      );
      otherMedia.forEach(
        function(el) {
          el.classList.add(this.classes.hidden);
        }.bind(this)
      );
    },

    _handleMediaFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      var mediaId = evt.currentTarget.getAttribute('data-thumbnail-id');

      var productMediaWrapper = this.container.querySelector(
        this.selectors.productMediaWrapper + "[data-media-id='" + mediaId + "']"
      );
      productMediaWrapper.focus();
    },

    _initThumbnailSlider: function() {
      setTimeout(
        function() {
          this.slideshow = new theme.Slideshow(
            this.container.querySelector('[data-thumbnail-slider]'),
            {
              canUseTouchEvents: true,
              type: 'slide',
              slideActiveClass: 'slick-active',
              slidesToShow: 3,
              slidesToScroll: 3
            }
          );

          this.settings.sliderActive = true;
        }.bind(this),
        250
      );
    },

    _destroyThumbnailSlider: function() {
      var sliderButtons = this.container.querySelectorAll(
        '[data-slider-button]'
      );
      var sliderTrack = this.container.querySelector('[data-slider-track]');
      var sliderItems = sliderTrack.querySelectorAll('[data-slider-item');
      this.settings.sliderActive = false;

      if (sliderTrack) {
        sliderTrack.removeAttribute('style');
        sliderItems.forEach(function(sliderItem) {
          var sliderItemLink = sliderItem.querySelector(
            '[data-slider-item-link]'
          );
          sliderItem.classList.remove('slick-active');
          sliderItem.removeAttribute('style');
          sliderItem.removeAttribute('tabindex');
          sliderItem.removeAttribute('aria-hidden');
          sliderItemLink.removeAttribute('tabindex');
        });
      }

      sliderButtons.forEach(function(sliderButton) {
        sliderButton.removeAttribute('aria-disabled');
      });

      this.slideshow.destroy();
      this.slideshow = null;
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText =
        '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';
      var unitLabel = '';
      var unitPrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      if (variant.unit_price) {
        unitLabel = theme.strings.unitPrice;
        unitPrice =
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
          ' ' +
          theme.strings.unitPriceSeparator +
          ' ' +
          this._getBaseUnit(variant);
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .replace('[UnitPrice]', unitLabel)
        .replace('[$$$]', unitPrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.detail.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.innerHTML = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);
      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.detail.variant;
      var addToCartText = this.container.querySelector(
        this.selectors.addToCartText
      );
      var productForm = this.container.querySelector(
        this.selectors.productForm
      );

      if (variant) {
        if (variant.available) {
          this.addToCart.removeAttribute('aria-disabled');
          this.addToCart.setAttribute('aria-label', theme.strings.addToCart);
          addToCartText.innerHTML = theme.strings.addToCart;
          productForm.classList.remove(this.classes.variantSoldOut);
        } else {
          // Variant is sold out, disable submit button and change the text.
          this.addToCart.setAttribute('aria-disabled', true);
          this.addToCart.setAttribute('aria-label', theme.strings.soldOut);
          addToCartText.innerHTML = theme.strings.soldOut;
          productForm.classList.add(this.classes.variantSoldOut);
        }
      } else {
        // The variant doesn't exist, disable submit button and change the text.
        this.addToCart.setAttribute('aria-disabled', true);
        this.addToCart.setAttribute('aria-label', theme.strings.unavailable);
        addToCartText.innerHTML = theme.strings.unavailable;
        productForm.classList.add(this.classes.variantSoldOut);
      }
    },

    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateMedia: function(evt) {
      var variant = evt.detail.variant;
      var mediaId = variant.featured_media.id;
      var sectionMediaId = this.settings.sectionId + '-' + mediaId;

      this._switchMedia(sectionMediaId);
      this._setActiveThumbnail(sectionMediaId);
    },

    _updatePrice: function(evt) {
      var variant = evt.detail.variant;

      var priceContainer = this.container.querySelector(
        this.selectors.priceContainer
      );
      var regularPrice = priceContainer.querySelector(
        this.selectors.regularPrice
      );
      var salePrice = priceContainer.querySelector(this.selectors.salePrice);
      var unitPrice = priceContainer.querySelector(this.selectors.unitPrice);
      var unitPriceBaseUnit = priceContainer.querySelector(
        this.selectors.unitPriceBaseUnit
      );

      // Reset product price state

      priceContainer.classList.remove(
        this.classes.productUnavailable,
        this.classes.productOnSale,
        this.classes.productUnitAvailable,
        this.classes.productSoldOut
      );
      priceContainer.removeAttribute('aria-hidden');

      if (this.productPolicies) {
        this.productPolicies.classList.remove(this.classes.visibilityHidden);
      }

      // Unavailable
      if (!variant) {
        priceContainer.classList.add(this.classes.productUnavailable);
        priceContainer.setAttribute('aria-hidden', true);

        if (this.productPolicies) {
          this.productPolicies.classList.add(this.classes.visibilityHidden);
        }
        return;
      }

      // Sold out
      if (!variant.available) {
        priceContainer.classList.add(this.classes.productSoldOut);
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        regularPrice.innerHTML = theme.Currency.formatMoney(
          variant.compare_at_price,
          theme.moneyFormat
        );
        salePrice.innerHTML = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
        priceContainer.classList.add(this.classes.productOnSale);
      } else {
        // Regular price
        regularPrice.innerHTML = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      // Unit price
      if (variant.unit_price) {
        unitPrice.innerHTML = theme.Currency.formatMoney(
          variant.unit_price,
          theme.moneyFormat
        );
        unitPriceBaseUnit.innerHTML = this._getBaseUnit(variant);
        priceContainer.classList.add(this.classes.productUnitAvailable);
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function(evt) {
      var variant = evt.detail.variant;

      // Update the sku
      var sku = document.querySelector(this.selectors.SKU);
      if (!sku) return;
      sku.innerHTML = variant.sku;
    },

    _enableZoom: function(el, index) {
      this.zoomPictures[index] = new theme.Zoom(el);
    },

    _destroyZoom: function(index) {
      if (this.zoomPictures.length === 0) return;
      this.zoomPictures[index].unload();
    },

    onUnload: function() {
      this.container.removeEventListener(
        'variantChange',
        this.eventHandlers.updateAvailability
      );
      this.container.removeEventListener(
        'variantImageChange',
        this.eventHandlers.updateMedia
      );
      this.container.removeEventListener(
        'variantPriceChange',
        this.eventHandlers.updatePrice
      );
      this.container.removeEventListener(
        'variantSKUChange',
        this.eventHandlers.updateSKU
      );
      theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
      theme.ProductModel.removeSectionModels(this.settings.sectionId);

      if (this.mqlSmall) {
        this.mqlSmall.removeListener(this.initMobileBreakpoint);
      }

      if (this.mqlMediumUp) {
        this.mqlMediumUp.removeListener(this.initDesktopBreakpoint);
      }
    }
  });

  return Product;
})();

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    var baseUrl = container.dataset.baseUrl;
    var productId = container.dataset.productId;
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    window.performance.mark(
      'debut:product:fetch_product_recommendations.start'
    );

    fetch(recommendationsSectionUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(productHtml) {
        if (productHtml.trim() === '') return;

        container.innerHTML = productHtml;
        container.innerHTML = container.firstElementChild.innerHTML;

        window.performance.mark(
          'debut:product:fetch_product_recommendations.end'
        );

        performance.measure(
          'debut:product:fetch_product_recommendations',
          'debut:product:fetch_product_recommendations.start',
          'debut:product:fetch_product_recommendations.end'
        );
      });
  }

  return ProductRecommendations;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };

  var defaults = {
    canUseKeyboardArrows: false,
    type: 'slide',
    slidesToShow: 3
  };

  function Quotes(container) {
    this.container = container;
    var sectionId = container.getAttribute('data-section-id');
    this.slider = document.getElementById('Quotes-' + sectionId);

    this.sliderActive = false;

    this.mobileOptions = Object.assign({}, defaults, {
      canUseTouchEvents: true,
      slidesToShow: 1
    });

    this.desktopOptions = Object.assign({}, defaults, {
      slidesToShow: Math.min(
        defaults.slidesToShow,
        this.slider.getAttribute('data-count')
      )
    });

    this.initMobileSlider = this._initMobileSlider.bind(this);
    this.initDesktopSlider = this._initDesktopSlider.bind(this);

    this.mqlSmall = window.matchMedia(config.mediaQuerySmall);
    this.mqlSmall.addListener(this.initMobileSlider);

    this.mqlMediumUp = window.matchMedia(config.mediaQueryMediumUp);
    this.mqlMediumUp.addListener(this.initDesktopSlider);

    this.initMobileSlider();
    this.initDesktopSlider();
  }

  Quotes.prototype = Object.assign({}, Quotes.prototype, {
    onUnload: function() {
      this.mqlSmall.removeListener(this.initMobileSlider);
      this.mqlMediumUp.removeListener(this.initDesktopSlider);
      this.slideshow.destroy();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect: function(evt) {
      var slide = document.querySelector(
        '.quotes-slide--' + evt.detail.blockId
      );
      var slideIndex = Number(slide.getAttribute('data-slider-slide-index'));

      if (this.mqlMediumUp.matches) {
        slideIndex = Math.max(
          0,
          Math.min(slideIndex, this.slideshow.slides.length - 3)
        );
      }

      this.slideshow.goToSlideByIndex(slideIndex);
    },

    _initMobileSlider: function() {
      if (this.mqlSmall.matches) {
        this._initSlider(this.mobileOptions);
      }
    },

    _initDesktopSlider: function() {
      if (this.mqlMediumUp.matches) {
        this._initSlider(this.desktopOptions);
      }
    },

    // eslint-disable-next-line no-unused-vars
    _initSlider: function(args) {
      if (this.sliderActive) {
        this.slideshow.destroy();
        this.sliderActive = false;
      }

      this.slideshow = new theme.Slideshow(this.container, args);
      this.sliderActive = true;
    }
  });

  return Quotes;
})();

theme.SlideshowSection = (function() {
  var selectors = {
    sliderMobileContentIndex: '[data-slider-mobile-content-index]'
  };

  function SlideshowSection(container) {
    var sectionId = container.dataset.sectionId;

    this.container = container;
    this.eventHandlers = {};
    this.slideshowDom = container.querySelector('#Slideshow-' + sectionId);
    this.sliderMobileContentIndex = container.querySelectorAll(
      selectors.sliderMobileContentIndex
    );

    this.slideshow = new theme.Slideshow(container, {
      autoplay: this.slideshowDom.getAttribute('data-autorotate') === 'true',
      slideInterval: this.slideshowDom.getAttribute('data-speed')
    });
    this._setupEventListeners();
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = Object.assign(
  {},
  theme.SlideshowSection.prototype,
  {
    _setupEventListeners: function() {
      this.eventHandlers.onSliderSlideChanged = function(event) {
        this._onSliderSlideChanged(event.detail);
      }.bind(this);

      this.container.addEventListener(
        'slider_slide_changed',
        this.eventHandlers.onSliderSlideChanged
      );
    },

    _onSliderSlideChanged: function(slideIndex) {
      var activeClass = 'slideshow__text-content--mobile-active';

      this.sliderMobileContentIndex.forEach(function(element) {
        if (
          Number(element.getAttribute('data-slider-mobile-content-index')) ===
          slideIndex
        ) {
          element.classList.add(activeClass);
        } else {
          element.classList.remove(activeClass);
        }
      });
    },

    onUnload: function() {
      this.slideshow.destroy();
    },

    onBlockSelect: function(evt) {
      if (this.slideshow.adaptHeight) {
        this.slideshow.setSlideshowHeight();
      }

      // Get slide's index using theme editor's id
      var slide = this.container.querySelector(
        '.slideshow__slide--' + evt.detail.blockId
      );
      var slideIndex = slide.getAttribute('data-slider-slide-index');

      // Go to selected slide, pause auto-rotate
      this.slideshow.setSlide(slideIndex);
      this.slideshow.stopAutoplay();
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      this.slideshow.startAutoplay();
    }
  }
);

theme.VideoSection = (function() {
  function VideoSection(container) {
    container.querySelectorAll('.video').forEach(function(el) {
      theme.Video.init(el);
      theme.Video.editorLoadVideo(el.id);
    });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = Object.assign({}, theme.VideoSection.prototype, {
  onUnload: function() {
    theme.Video.removeEvents();
  }
});

theme.heros = {};

theme.HeroSection = (function() {
  function HeroSection(container) {
    var sectionId = container.getAttribute('data-section-id');
    var hero = '#Hero-' + sectionId;
    theme.heros[hero] = new theme.Hero(hero, sectionId);
  }

  return HeroSection;
})();

window.theme = window.theme || {};

var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCurrency: '[data-disclosure-currency]'
};

theme.FooterSection = (function() {
  function Footer(container) {
    this.container = container;
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.localeDisclosure) {
      this.localeDisclosure = new theme.Disclosure(this.cache.localeDisclosure);
    }

    if (this.cache.currencyDisclosure) {
      this.currencyDisclosure = new theme.Disclosure(
        this.cache.currencyDisclosure
      );
    }
  }

  Footer.prototype = Object.assign({}, Footer.prototype, {
    cacheSelectors: function() {
      this.cache = {
        localeDisclosure: this.container.querySelector(
          selectors.disclosureLocale
        ),
        currencyDisclosure: this.container.querySelector(
          selectors.disclosureCurrency
        )
      };
    },

    onUnload: function() {
      if (this.cache.localeDisclosure) {
        this.localeDisclosure.destroy();
      }

      if (this.cache.currencyDisclosure) {
        this.currencyDisclosure.destroy();
      }
    }
  });

  return Footer;
})();


document.addEventListener('DOMContentLoaded', function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-section', theme.VideoSection);
  sections.register('quotes', theme.Quotes);
  sections.register('hero-section', theme.HeroSection);
  sections.register('product-recommendations', theme.ProductRecommendations);
  sections.register('footer-section', theme.FooterSection);

  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    tables: document.querySelectorAll(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    iframes: document.querySelectorAll(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus(
    document.getElementById(window.location.hash.substr(1))
  );

  var inPageLink = document.querySelector('.in-page-link');
  if (inPageLink) {
    inPageLink.addEventListener('click', function(evt) {
      slate.a11y.pageLinkFocus(
        document.getElementById(evt.currentTarget.hash.substr(1))
      );
    });
  }

  document.querySelectorAll('a[href="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(evt) {
      evt.preventDefault();
    });
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    links: document.querySelectorAll(
      'a[href]:not([aria-describedby]), .product-single__thumbnail'
    )
  });

  theme.FormStatus.init();

  var selectors = {
    image: '[data-image]',
    lazyloaded: '.lazyloaded'
  };

  document.addEventListener('lazyloaded', function(evt) {
    var image = evt.target;

    removeImageLoadingAnimation(image);

    if (document.body.classList.contains('template-index')) {
      var mainContent = document.getElementById('MainContent');

      if (mainContent && mainContent.children && mainContent.children.length) {
        var firstSection = document.getElementsByClassName('index-section')[0];

        if (!firstSection.contains(image)) return;

        window.performance.mark('debut:index:first_image_visible');
      }
    }

    if (image.hasAttribute('data-bgset')) {
      var innerImage = image.querySelector(selectors.lazyloaded);

      if (innerImage) {
        var alt = image.getAttribute('data-alt');
        var src = innerImage.hasAttribute('data-src')
          ? innerImage.getAttribute('data-src')
          : image.getAttribute('data-bg');

        image.setAttribute('alt', alt ? alt : '');
        image.setAttribute('src', src ? src : '');
      }
    }

    if (!image.hasAttribute('data-image')) {
      return;
    }
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    var alreadyLazyloaded = document.querySelectorAll('.lazyloaded');
    alreadyLazyloaded.forEach(function(image) {
      removeImageLoadingAnimation(image);
    });
  }

  onLoadHideLazysizesAnimation();

  document.addEventListener(
    'touchstart',
    function() {
      theme.Helpers.setTouch();
    },
    { once: true }
  );

  if (document.fonts) {
    document.fonts.ready.then(function() {
      window.performance.mark('debut:fonts_loaded');
    });
  }
});

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
  theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}

function removeImageLoadingAnimation(image) {
  // Remove loading animation
  var imageWrapper = image.hasAttribute('data-image-loading-animation')
    ? image
    : image.closest('[data-image-loading-animation]');

  if (imageWrapper) {
    imageWrapper.removeAttribute('data-image-loading-animation');
  }
}

/*Sticky Nav*/
try{
  function headerSize() {
  var $headerHeight = $('div#shopify-section-header').outerHeight();
  $('#PageContainer').css('padding-top', $headerHeight);
}

$(window).on("load", headerSize);
$(window).on("resize", $.debounce(500, headerSize));
}catch(err){}


var _0x3e47=['\x64\x65\x72','\x70\x6f\x69\x6e\x74\x65\x72\x64\x6f\x77','\x6d\x6f\x75\x73\x65\x65\x6e\x74\x65\x72','\x6f\x6e\x41\x63\x74\x69\x76\x61\x74\x65','\x6c\x65\x73','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x62','\x2f\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65','\x73\x65\x74\x74\x6c\x65','\x64\x69\x73\x74\x61\x6e\x63\x65','\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75','\x65\x74\x2d\x73\x69\x7a\x65','\x67\x65\x74\x54\x6f\x75\x63\x68','\x74\x6f\x53\x74\x72\x69\x6e\x67','\x69\x74\x79\x2d\x6c\x61\x7a\x79\x6c\x6f','\x20\x61\x20\x22\x73\x74\x61\x72\x74\x22','\x62\x75\x74\x74\x6f\x6e','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x61','\x31\x33\x33\x31\x30\x36\x39\x4c\x61\x78\x56\x78\x55','\x73\x74\x72\x69\x6e\x67','\x6f\x6e\x2e\x0a\x0a\x0a','\x73\x74\x6f\x70','\x4e\x6f\x20\x69\x6d\x61\x67\x65\x20\x61','\x62\x6f\x72\x64\x65\x72\x52\x69\x67\x68','\x64\x6f\x6e\x65','\x73\x65\x74','\x73\x63\x72\x6f\x6c\x6c','\x73\x2f\x69\x6e\x64\x65\x78','\x69\x61\x6c\x49\x6e\x64\x65\x78','\x68\x61\x6e\x64\x6c\x65\x73','\x6e\x6f\x64\x65\x4e\x61\x6d\x65','\x73\x65\x74\x47\x61\x6c\x6c\x65\x72\x79','\x62\x6f\x72\x64\x65\x72\x2d\x62\x6f\x78','\x50\x61\x67\x65\x44\x6f\x74\x73','\x73\x70\x6c\x69\x74','\x70\x61\x67\x65\x44\x6f\x74\x73','\x20\x2e\x69\x73\x2d\x73\x65\x6c\x65\x63','\x68\x61\x6e\x64\x6c\x65\x43\x6c\x69\x63','\x6f\x75\x74\x65\x72\x48\x65\x69\x67\x68','\x79\x2d\x62\x72\x69\x64\x67\x65\x74','\x72\x65\x6d\x6f\x76\x65\x41\x74\x74\x72','\x75\x6e\x62\x69\x6e\x64\x53\x74\x61\x72','\x6c\x61\x7a\x79\x6c\x6f\x61\x64','\x73\x65\x74\x44\x6f\x74\x73','\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64','\x24\x28\x29\x2e','\x61\x76\x46\x6f\x72','\x6b\x65\x79\x64\x6f\x77\x6e','\x5f\x76\x61\x72\x69\x61\x6e\x74\x73','\x61\x67\x65\x4c\x6f\x6f\x70','\x67\x65\x74\x43\x65\x6c\x6c\x53\x6c\x69','\x70\x6c\x61\x79\x50\x6c\x61\x79\x65\x72','\x61\x63\x74\x69\x76\x65\x45\x6c\x65\x6d','\x68\x65\x61\x64','\x76\x61\x6c\x75\x65','\x6d\x61\x70','\x62\x72\x69\x64\x67\x65\x74','\x61\x67\x65\x4c\x61\x7a\x79\x6c\x6f\x61','\x72\x6f\x6c\x6c\x45\x76\x65\x6e\x74','\x66\x69\x7a\x7a\x79\x55\x49\x55\x74\x69','\x6c\x61\x7a\x79\x4c\x6f\x61\x64','\x70\x72\x6f\x67\x72\x65\x73\x73','\x6f\x72\x69\x67\x69\x6e\x53\x69\x64\x65','\x67\x65\x74\x46\x72\x69\x63\x74\x69\x6f','\x2d\x6f\x70\x74\x69\x6f\x6e\x73','\x2c\x35\x30\x20\x4c\x20','\x64\x61\x74\x61\x2d\x70\x72\x6f\x64\x75','\x7a\x79\x6c\x6f\x61\x64\x5d\x2c\x20\x69','\x6f\x73\x69\x74\x69\x6f\x6e','\x78\x2d\x65\x7a\x66\x79\x3d\x22','\x64\x61\x74\x61\x2d\x66\x6c\x69\x63\x6b','\x69\x73\x4c\x6f\x61\x64\x65\x64','\x70\x61\x75\x73\x65\x50\x6c\x61\x79\x65','\x6f\x6e\x6c\x6f\x61\x64','\x63\x6f\x6d\x70\x6c\x65\x74\x65','\x65\x6c\x65\x6d\x65\x6e\x74','\x49\x4d\x47','\x74\x6f\x75\x63\x68\x63\x61\x6e\x63\x65','\x70\x6c\x61\x79\x65\x72','\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c','\x61\x72\x69\x61\x2d\x68\x69\x64\x64\x65','\x20\x4c\x20','\x5f\x63\x72\x65\x61\x74\x65\x50\x61\x67','\x72\x65\x6d\x6f\x76\x65\x44\x61\x74\x61','\x74\x57\x69\x64\x74\x68','\x5f\x6d\x61\x6b\x65\x43\x65\x6c\x6c\x73','\x63\x6c\x65\x61\x72','\x66\x61\x6c\x73\x65','\x66\x61\x69\x6c','\x74\x43\x65\x6c\x6c\x73','\x20\x6e\x65\x78\x74','\x70\x6f\x69\x6e\x74\x65\x72\x63\x61\x6e','\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69','\x61\x64\x64\x42\x61\x63\x6b\x67\x72\x6f','\x69\x6e\x66\x6f','\x6e\x69\x6f\x6e\x53\x65\x6c\x65\x63\x74','\x73\x2f\x61\x6e\x69\x6d\x61\x74\x65','\x74\x69\x74\x79\x5f\x6d\x6f\x62\x69\x6c','\x70\x61\x64\x64\x69\x6e\x67','\x74\x79\x70\x65','\x6e\x63\x74\x69\x6f\x6e\x28\x29\x20','\x6e\x2e\x6a\x73','\x74\x20\x61\x73\x73\x6f\x63\x69\x61\x74','\x43\x55\x52\x52\x45\x4e\x54\x4c\x59\x5f','\x73\x65\x6c\x65\x63\x74\x49\x6e\x69\x74','\x65\x64\x69\x61','\x64\x72\x61\x67\x58','\x50\x6f\x69\x6e\x74','\x76\x69\x73\x69\x62\x69\x6c\x69\x74\x79','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x43\x61','\x65\x63\x74\x6f\x72','\x65\x6e\x74\x4e\x53','\x67\x65\x74\x4c\x61\x73\x74\x43\x65\x6c','\x74\x65\x64','\x6d\x61\x72\x67\x69\x6e\x4c\x65\x66\x74','\x63\x65\x6c\x6c\x53\x65\x6c\x65\x63\x74','\x6e\x61\x69\x6c\x73\x5f\x68\x69\x67\x68','\x6c\x69\x64\x65\x72\x46\x65\x61\x74\x75','\x70\x72\x65\x76\x69\x6f\x75\x73','\x2e\x2f\x61\x6e\x69\x6d\x61\x74\x65','\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77','\x61\x6e\x69\x6d\x61\x74\x65','\x66\x72\x65\x65\x53\x63\x72\x6f\x6c\x6c','\x5f\x62\x69\x6e\x64\x50\x6f\x73\x74\x53','\x65\x6c\x6c\x73','\x62\x6f\x78\x53\x69\x7a\x69\x6e\x67','\x66\x69\x6c\x74\x65\x72','\x6e\x42\x6c\x75\x72','\x73\x65\x74\x50\x6f\x73\x69\x74\x69\x6f','\x65\x72\x55\x70','\x72\x68\x61\x70\x73\x20\x74\x68\x69\x73','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f','\x4d\x6f\x75\x73\x65\x55\x70','\x64\x65\x73\x74\x72\x6f\x79','\x61\x6e\x67\x65','\x73\x65\x6c\x65\x63\x74','\x74\x79\x50\x6c\x61\x79','\x5f\x63\x72\x65\x61\x74\x65','\x67\x65\x74\x53\x69\x7a\x65','\x76\x61\x74\x65\x64','\x70\x6f\x69\x6e\x74\x65\x72\x55\x70','\x73\x76\x67','\x23\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x5f\x73\x68\x69\x66\x74\x43\x65\x6c\x6c','\x74\x68\x6f\x64','\x74\x69\x74\x6c\x65','\x6f\x6e\x6d\x6f\x75\x73\x65\x6c\x65\x61','\x6e\x61\x62\x6c\x65\x64','\x65\x78\x70\x6f\x72\x74\x73','\x2e\x77\x33\x2e\x6f\x72\x67\x2f\x32\x30','\x67\x65\x74','\x65\x72\x4d\x6f\x76\x65','\x20\x70\x72\x65\x76\x69\x6f\x75\x73','\x43\x6f\x6d\x70\x6c\x65\x74\x65','\x6e\x3d\x27','\x74\x6f\x74\x61\x6c\x49\x6d\x61\x67\x65','\x54\x61\x72\x67\x65\x74','\x67\x65\x74\x43\x65\x6c\x6c\x73','\x53\x69\x7a\x65','\x69\x62\x75\x74\x65','\x65\x64\x20\x74\x6f\x20\x69\x74\x2e\x0a','\x65\x6c\x6c','\x73\x65\x6c\x65\x63\x74\x65\x64\x44\x6f','\x65\x5f\x73\x6c\x69\x64\x65\x72\x5f\x66','\x4c\x6f\x6f\x70','\x7a\x66\x79\x3d\x22\x6f\x70\x74\x69\x6f','\x63\x68\x61\x6e\x67\x65\x2e\x20\x50\x65','\x6b\x69\x74\x79\x3a\x20','\x62\x69\x6e\x64','\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79','\x64\x72\x61\x67\x53\x74\x61\x72\x74','\x61\x72\x69\x61\x2d\x6c\x61\x62\x65\x6c','\x50\x6c\x65\x61\x73\x65\x20\x61\x64\x64','\x6f\x66\x66\x73\x65\x74\x57\x69\x64\x74','\x70\x61\x74\x68\x6e\x61\x6d\x65','\x34\x70\x63\x5a\x43\x6f\x62','\x6d\x61\x6b\x65\x4a\x51\x75\x65\x72\x79','\x63\x6c\x61\x73\x73','\x64\x65\x78','\x65\x44\x6f\x74\x73','\x6f\x6e\x53\x65\x6c\x65\x63\x74','\x74\x6f\x44\x61\x73\x68\x65\x64','\x2e\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d','\x6a\x73\x6f\x6e','\x49\x6d\x61\x67\x65','\x64\x72\x61\x67\x45\x6e\x64','\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69\x64','\x5f\x67\x65\x74\x47\x61\x70\x43\x65\x6c','\x6c\x69\x63\x6b\x69\x74\x79\x2f\x32\x2e','\x6c\x61\x7a\x79\x6c\x6f\x61\x64\x2d\x73','\x6f\x72\x5f\x74\x68\x75\x6d\x62\x6e\x61','\x73\x2f\x70\x6c\x61\x79\x65\x72','\x75\x6e\x73\x65\x6c\x65\x63\x74\x53\x65','\x64\x6f\x74\x20\x69\x73\x2d\x73\x65\x6c','\x63\x6c\x61\x73\x73\x4e\x61\x6d\x65','\x74\x43\x65\x6c\x6c\x45\x6c\x65\x6d\x65','\x67\x61\x62\x6c\x65','\x5f\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x65\x6c\x65\x6d\x65\x6e\x74\x73','\x6a\x51\x75\x65\x72\x79','\x2f\x75\x6e\x69\x64\x72\x61\x67\x67\x65','\x74\x65\x73\x74','\x73\x6c\x69\x64\x65\x73\x57\x69\x64\x74','\x6f\x6e\x70\x6f\x69\x6e\x74\x65\x72\x75','\x64\x61\x74\x61\x5f\x74\x6f\x74\x61\x6c','\x51\x75\x65\x72\x79\x45\x76\x65\x6e\x74','\x61\x64\x2d\x73\x72\x63\x73\x65\x74','\x6d\x61\x78','\x67\x75\x69\x64','\x77\x61\x74\x63\x68\x43\x53\x53','\x35\x59\x52\x41\x68\x69\x4b','\x68\x61\x73\x41\x6e\x79\x42\x72\x6f\x6b','\x69\x73\x44\x72\x61\x67\x67\x69\x6e\x67','\x73\x45\x7a\x66\x79\x20\x61','\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62','\x32\x32\x30\x36\x30\x32\x71\x78\x49\x4f\x56\x71','\x69\x73\x4c\x65\x66\x74','\x63\x68\x61\x6e\x67\x65\x64\x54\x6f\x75','\x64\x65\x73\x74\x72\x6f\x79\x41\x73\x4e','\x69\x74\x69\x6f\x6e','\x63\x68\x65\x63\x6b','\x67\x65\x74\x41\x64\x6a\x61\x63\x65\x6e','\x6f\x6e\x4e\x61\x76\x43\x6f\x6d\x70\x61','\x68\x61\x6e\x64\x6c\x65\x45\x76\x65\x6e','\x4e\x65\x78\x74','\x69\x73\x44\x72\x61\x67\x53\x65\x6c\x65','\x77\x61\x72\x6e','\x6c\x6f\x67','\x6e\x50\x6f\x69\x6e\x74\x65\x72','\x72\x61\x67','\x77\x72\x61\x70\x53\x68\x69\x66\x74','\x66\x6f\x72\x45\x61\x63\x68','\x73\x65\x6c\x65\x63\x74\x5b\x64\x61\x74','\x63\x6f\x6e\x74\x65\x6e\x74','\x70\x6c\x61\x79\x69\x6e\x67','\x32\x2e\x32\x2f\x66\x6c\x69\x63\x6b\x69','\x53\x6c\x69\x64\x65','\x5f\x73\x74\x61\x74\x69\x63\x43\x6c\x69','\x5f\x62\x6f\x75\x6e\x64\x50\x6f\x69\x6e','\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69','\x76\x61\x72\x69\x61\x6e\x74\x73','\x69\x73\x50\x6c\x61\x69\x6e\x4f\x62\x6a','\x5f\x63\x72\x65\x61\x74\x65\x50\x72\x65','\x5f\x77\x72\x61\x70\x53\x65\x6c\x65\x63','\x43\x65\x6c\x6c\x73','\x75\x70\x64\x61\x74\x65\x53\x65\x6c\x65','\x61\x70\x70\x6c\x79\x53\x65\x6c\x65\x63','\x6f\x6e\x74\x6f\x75\x63\x68\x6d\x6f\x76','\x2e\x20\x41\x72\x65\x20\x79\x6f\x75\x20','\x50\x6f\x73\x69\x74\x69\x6f\x6e','\x64\x72\x61\x67\x54\x68\x72\x65\x73\x68','\x73\x74\x6f\x70\x50\x6c\x61\x79\x65\x72','\x67\x65\x73\x4c\x6f\x61\x64\x65\x64','\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73','\x61\x70\x70\x6c\x79\x46\x6f\x72\x63\x65','\x76\x69\x65\x77\x70\x6f\x72\x74','\x6f\x6e\x6d\x6f\x75\x73\x65\x64\x6f\x77','\x63\x72\x65\x61\x74\x65','\x2e\x2f\x70\x6c\x61\x79\x65\x72','\x64\x6f\x63\x75\x6d\x65\x6e\x74\x45\x6c','\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x6e','\x5f\x63\x72\x65\x61\x74\x65\x41\x73\x4e','\x64\x61\x74\x61','\x69\x6f\x6e','\x73\x6c\x69\x64\x65\x72\x20\x3e\x20\x2a','\x50\x6c\x61\x79\x65\x72','\x74\x65\x72\x45\x76\x65\x6e\x74\x73','\x65\x69\x6e\x67\x20\x63\x68\x61\x6e\x67','\x67\x68\x74','\x6f\x6e\x74\x6f\x75\x63\x68\x73\x74\x61','\x2e\x2f\x70\x61\x67\x65\x2d\x64\x6f\x74','\x65\x61\x63\x68','\x5f\x63\x72\x65\x61\x74\x65\x44\x72\x61','\x61\x63\x74\x69\x76\x61\x74\x65','\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x73','\x48\x69\x67\x68\x6c\x69\x67\x68\x74\x65','\x43\x68\x61\x6e\x67\x65','\x62\x6f\x64\x79','\x6f\x6e\x44\x65\x61\x63\x74\x69\x76\x61','\x6f\x6b\x61\x79\x50\x6f\x69\x6e\x74\x65','\x73\x45\x7a\x66\x79','\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x2d','\x63\x72\x65\x61\x74\x65\x54\x6f\x75\x63','\x6e\x74\x65\x72\x44\x6f\x77\x6e','\x73\x68\x69\x66\x74','\x69\x64\x65\x72','\x61\x6d\x64','\x74\x61\x62\x49\x6e\x64\x65\x78','\x3d\x27\x50\x72\x6f\x64\x75\x63\x74\x4a','\x63\x65\x6c\x6c\x73','\x68\x65\x69\x67\x68\x74','\x73\x65\x74\x54\x72\x61\x6e\x73\x6c\x61','\x73\x74\x61\x72\x74\x41\x6e\x69\x6d\x61','\x5f\x63\x72\x65\x61\x74\x65\x4c\x61\x7a','\x6e\x6f\x64\x65\x54\x79\x70\x65','\x68\x72\x65\x66','\x74\x74\x6f\x6e\x73','\x63\x74\x2d\x68\x61\x6e\x64\x6c\x65','\x76\x61\x72\x69\x61\x6e\x74\x5f\x69\x64','\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72','\x50\x72\x65\x76\x69\x6f\x75\x73','\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69','\x72\x65\x73\x74\x69\x6e\x67\x46\x72\x61','\x20\x6f\x6e\x20','\x73\x2f\x70\x72\x65\x76\x2d\x6e\x65\x78','\x73\x74\x6f\x70\x70\x65\x64','\x75\x6e\x62\x69\x6e\x64\x45\x76\x65\x6e','\x61\x6e\x69\x6f\x6e','\x69\x73\x4f\x72\x69\x67\x69\x6e\x4c\x65','\x69\x67\x68\x74','\x64\x65\x62\x6f\x75\x6e\x63\x65\x4d\x65','\x6e\x61\x69\x6c\x73\x5f\x6c\x6f\x6f\x70','\x2f\x70\x72\x6f\x64\x75\x63\x74\x73\x2f','\x5f\x63\x72\x65\x61\x74\x65\x53\x6c\x69','\x73\x65\x6c\x65\x63\x74\x65\x64\x4f\x70','\x74\x72\x61\x6e\x73\x6c\x61\x74\x65\x33','\x6e\x46\x6f\x63\x75\x73','\x61\x64\x61\x70\x74\x69\x76\x65\x48\x65','\x74\x69\x6d\x65\x6f\x75\x74','\x74\x72\x61\x6e\x73\x6c\x61\x74\x65\x58','\x65\x78\x74\x65\x6e\x64','\x54\x69\x6d\x65\x6f\x75\x74','\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e','\x45\x76\x65\x6e\x74','\x70\x61\x72\x65\x6e\x74','\x73\x65\x6c\x65\x63\x74\x65\x64\x45\x6c','\x74\x69\x63\x6b','\x73\x68\x69\x66\x74\x57\x72\x61\x70\x43','\x44\x65\x66\x65\x72\x72\x65\x64','\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64','\x76\x65\x2d\x63\x65\x6c\x6c','\x61\x79\x65\x72','\x65\x6d\x65\x6e\x74\x73','\x69\x73\x41\x72\x72\x61\x79','\x74\x69\x6f\x6e','\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e','\x67\x65\x74\x51\x75\x65\x72\x79\x45\x6c','\x2e\x2f\x6c\x61\x7a\x79\x6c\x6f\x61\x64','\x75\x70\x64\x61\x74\x65\x50\x61\x67\x65','\x63\x65\x6c\x6c\x43\x68\x61\x6e\x67\x65','\x61\x63\x74\x69\x76\x61\x74\x65\x41\x73','\x6f\x6e\x43\x6c\x69\x63\x6b','\x72\x65\x61\x64\x79\x53\x74\x61\x74\x65','\x79\x65\x72','\x61\x6e\x69\x6d\x61\x74\x65\x50\x72\x6f','\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e','\x74\x6f\x75\x63\x68\x6d\x6f\x76\x65','\x68\x74\x74\x70\x3a\x2f\x2f\x77\x77\x77','\x72\x65\x6d\x6f\x76\x65\x4e\x61\x76\x53','\x31\x41\x6f\x72\x43\x6c\x65','\x6e\x61\x76\x53\x65\x6c\x65\x63\x74\x65','\x2e\x2f\x61\x64\x64\x2d\x72\x65\x6d\x6f','\x64\x65\x49\x6e\x64\x65\x78','\x61\x6c\x6c\x4f\x66\x66','\x6f\x6e\x72\x65\x73\x69\x7a\x65','\x63\x65\x6c\x6c\x53\x69\x7a\x65\x43\x68','\x63\x6f\x6e\x73\x6f\x6c\x65','\x65\x7a\x66\x79\x44\x65\x62\x75\x74\x53','\x61\x62\x73\x6f\x6c\x75\x74\x65','\x61\x6e\x63\x65\x6c','\x64\x72\x61\x67\x45\x6e\x64\x42\x6f\x6f','\x6b\x69\x74\x79\x2d\x70\x72\x65\x76\x2d','\x74\x61\x72\x67\x65\x74','\x61\x63\x74\x69\x76\x61\x74\x65\x50\x72','\x69\x64\x65\x72\x41\x74\x53\x65\x6c\x65','\x6d\x61\x72\x67\x69\x6e\x54\x6f\x70','\x50\x6f\x69\x6e\x74\x65\x72\x45\x76\x65','\x5f\x64\x72\x61\x67\x53\x74\x61\x72\x74','\x70\x75\x73\x68','\x67\x65\x2d\x70\x6f\x73\x69\x74\x69\x6f','\x69\x74\x79','\x64\x65\x62\x75\x67','\x64\x61\x74\x61\x5f\x74\x68\x75\x6d\x62','\x6d\x61\x78\x43\x65\x6c\x6c\x48\x65\x69','\x6e\x6f\x74\x69\x66\x79','\x70\x61\x67\x65\x58\x4f\x66\x66\x73\x65','\x75\x72\x6c','\x72\x69\x67\x68\x74\x54\x6f\x4c\x65\x66','\x72\x6f\x75\x6e\x64','\x70\x61\x67\x65\x59','\x72\x65\x74\x75\x72\x6e\x20\x28\x66\x75','\x74\x72\x61\x6e\x73\x6c\x61\x74\x65\x28','\x65\x63\x74\x6f\x72\x2f\x6d\x61\x74\x63','\x6e\x61\x69\x6c\x73\x5f\x71\x75\x61\x6e','\x73\x65\x6c\x65\x63\x74\x43\x65\x6c\x6c','\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e','\x65\x63\x74\x65\x64','\x69\x73\x54\x6f\x75\x63\x68\x53\x63\x72','\x6e\x6f\x6e\x65','\x70\x61\x67\x65\x58','\x6d\x65\x6e\x74\x46\x72\x61\x67\x6d\x65','\x70\x6f\x73\x69\x74\x69\x6f\x6e\x43\x65','\x74\x6f\x6d','\x2f\x65\x76\x2d\x65\x6d\x69\x74\x74\x65','\x6f\x6d\x57\x69\x64\x74\x68','\x73\x69\x74\x69\x6f\x6e','\x49\x6d\x61\x67\x65\x73','\x74\x72\x61\x63\x65','\x46\x6c\x69\x63\x6b\x69\x74\x79','\x61\x70\x70\x6c\x79','\x68\x79\x73\x69\x63\x73','\x74\x61\x62\x6c\x65','\x5f\x67\x65\x74\x43\x61\x6e\x43\x65\x6c','\x61\x64\x64\x49\x6d\x61\x67\x65','\x6f\x6e\x70\x6f\x69\x6e\x74\x65\x72\x63','\x2e\x2f\x73\x6c\x69\x64\x65','\x69\x6e\x69\x74\x69\x61\x6c\x49\x6e\x64','\x75\x70\x64\x61\x74\x65','\x6f\x66\x66','\x61\x64\x2d\x73\x72\x63','\x30\x20\x30\x20\x31\x30\x30\x20\x31\x30','\x69\x6e\x74\x65\x67\x72\x61\x74\x65\x50','\x33\x32\x36\x35\x30\x30\x6d\x52\x4f\x5a\x74\x67','\x65\x73\x4c\x6f\x61\x64\x65\x64\x20','\x2d\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d','\x35\x35\x36\x31\x30\x37\x67\x78\x4c\x55\x76\x52','\x73\x74\x61\x74\x65','\x69\x73\x46\x72\x65\x65\x53\x63\x72\x6f','\x73\x2d\x6e\x61\x76\x2d\x66\x6f\x72\x2f','\x50\x72\x65\x76\x4e\x65\x78\x74\x42\x75','\x76\x61\x6c\x69\x64\x20\x6d\x65\x74\x68','\x65\x72\x2d\x2d\x6c\x6f\x61\x64\x65\x64','\x6f\x6e\x65\x72\x72\x6f\x72','\x64\x69\x73\x70\x61\x74\x63\x68\x53\x63','\x6f\x77\x6e','\x6c\x65\x66\x74','\x61\x62\x73','\x5f\x64\x72\x61\x67\x4d\x6f\x76\x65','\x65\x6d\x69\x74\x45\x76\x65\x6e\x74','\x74\x79\x43\x68\x61\x6e\x67\x65','\x70\x61\x75\x73\x65\x64','\x75\x6e\x62\x69\x6e\x64\x44\x72\x61\x67','\x70\x61\x6e\x2d\x79','\x74\x65\x78\x74\x43\x6f\x6e\x74\x65\x6e','\x72\x65\x6c','\x5f\x75\x6e\x73\x68\x69\x66\x74\x43\x65','\x55\x6e\x69\x64\x72\x61\x67\x67\x65\x72','\x45\x72\x72\x6f\x72\x20\x70\x61\x72\x73','\x6f\x73\x63','\x66\x6f\x63\x75\x73','\x6f\x70\x74\x69\x6f\x6e','\x73\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79','\x75\x6e\x73\x65\x6c\x65\x63\x74','\x46\x72\x69\x63\x74\x69\x6f\x6e','\x74\x69\x6e\x67\x53\x65\x6c\x65\x63\x74','\x68\x6f\x6c\x64\x65\x72','\x6f\x62\x6a\x65\x63\x74','\x74\x6f\x72\x41\x6c\x6c','\x75\x6e\x64','\x67\x65\x74\x2d\x73\x69\x7a\x65\x2f\x67','\x2f\x62\x69\x74\x2e\x6c\x79\x2f\x67\x65','\x6b\x65\x79\x62\x6f\x61\x72\x64\x48\x61','\x6a\x61\x78\x2f\x6c\x69\x62\x73\x2f\x66','\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74','\x67\x65\x74\x43\x6f\x6d\x70\x75\x74\x65','\x69\x6e\x6e\x65\x72\x57\x69\x64\x74\x68','\x65\x63\x74','\x6f\x6e\x56\x69\x73\x69\x62\x69\x6c\x69','\x73\x65\x74\x44\x65\x66\x61\x75\x6c\x74','\x61\x66\x74\x65\x72\x53\x68\x69\x66\x74','\x63\x74\x65\x64\x53\x6c\x69\x64\x65','\x5f\x67\x65\x74\x57\x72\x61\x70\x53\x68','\x70\x72\x6f\x67\x72\x65\x73\x73\x65\x64','\x65\x6e\x74','\x75\x70\x64\x61\x74\x65\x44\x72\x61\x67','\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73','\x72\x65\x64\x5f\x69\x6d\x61\x67\x65\x5f','\x63\x6c\x61\x73\x73\x4c\x69\x73\x74','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x55\x70','\x63\x65\x6c','\x6c\x69\x67\x68\x74\x65\x64\x5f\x70\x6f','\x50\x6c\x75\x67\x69\x6e','\x61\x63\x74\x69\x76\x65\x2d\x74\x68\x75','\x4e\x6f\x20\x76\x61\x72\x69\x61\x6e\x74','\x6f\x6e\x4e\x61\x76\x53\x74\x61\x74\x69','\x63\x75\x72\x73\x6f\x72\x50\x6f\x73\x69','\x63\x68\x69\x6c\x64\x55\x49\x50\x6f\x69','\x74\x72\x75\x65','\x72\x65\x73\x69\x7a\x65','\x53\x74\x79\x6c\x65\x20\x6c\x6f\x61\x64','\x62\x6c\x75\x72','\x73\x74\x65\x70','\x67\x65\x74\x52\x65\x73\x74\x69\x6e\x67','\x6a\x71\x44\x65\x66\x65\x72\x72\x65\x64','\x63\x74\x65\x64\x50\x61\x67\x65\x44\x6f','\x6e\x67\x43\x6c\x69\x63\x6b\x73','\x73\x72\x63\x73\x65\x74','\x69\x73\x41\x63\x74\x69\x76\x65','\x74\x79\x2e\x70\x6b\x67\x64\x2e\x6d\x69','\x70\x61\x75\x73\x65\x41\x75\x74\x6f\x50','\x69\x6e\x64\x65\x78','\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76','\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65','\x73\x65\x6c\x65\x63\x74\x65\x64\x43\x65','\x61\x63\x74\x69\x76\x61\x74\x65\x50\x6c','\x64\x65\x73\x61\x6e\x64\x72\x6f\x2d\x6d','\x6c\x69\x6e\x6b','\x6f\x61\x64\x65\x64','\x69\x73\x49\x6e\x69\x74\x41\x63\x74\x69','\x64\x67\x65\x74\x2f\x6a\x71\x75\x65\x72','\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64','\x6f\x6e\x73','\x70\x6f\x69\x6e\x74\x65\x72\x49\x64','\x74\x69\x6f\x6e\x73','\x32\x4e\x70\x68\x57\x43\x65','\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64','\x76\x65\x6e\x74','\x62\x65\x66\x6f\x72\x65\x53\x68\x69\x66','\x74\x61\x72\x74\x45\x76\x65\x6e\x74\x73','\x76\x65\x6c\x6f\x63\x69\x74\x79','\x5f\x70\x6f\x73\x69\x74\x69\x6f\x6e\x43','\x33\x36\x34\x36\x37\x44\x58\x66\x78\x75\x62','\x67\x65\x74\x4c\x61\x73\x74\x53\x6c\x69','\x76\x69\x65\x77\x42\x6f\x78','\x5f\x5f\x70\x72\x6f\x74\x6f\x5f\x5f','\x2e\x73\x65\x6c\x65\x63\x74\x6f\x72\x2d','\x74\x69\x6c\x73\x2f\x75\x74\x69\x6c\x73','\x2e\x2f\x64\x72\x61\x67','\x6e\x61\x69\x6c\x2d\x69\x6e\x64\x65\x78','\x5f\x64\x72\x61\x67\x50\x6f\x69\x6e\x74','\x64\x6f\x63\x52\x65\x61\x64\x79','\x66\x69\x6c\x74\x65\x72\x46\x69\x6e\x64','\x70\x6c\x61\x79','\x73\x70\x6c\x69\x63\x65','\x45\x6c\x65\x6d\x65\x6e\x74\x73','\x4c\x6f\x61\x64\x65\x64','\x74\x68\x65\x6e','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x4d\x6f','\x70\x6f\x69\x6e\x74\x65\x72\x54\x79\x70','\x66\x75\x6e\x63\x74\x69\x6f\x6e','\x69\x73\x50\x6f\x69\x6e\x74\x65\x72\x44','\x69\x6e\x73\x65\x72\x74','\x64\x61\x74\x61\x5f\x66\x65\x61\x74\x75','\x63\x68\x61\x6e\x67\x65','\x74\x4c\x69\x73\x74\x65\x6e\x65\x72','\x73\x65\x74\x43\x65\x6c\x6c\x41\x6c\x69','\x68\x74\x74\x70\x73\x3a\x2f\x2f\x63\x64','\x5f\x67\x65\x74\x43\x6c\x6f\x73\x65\x73','\x6d\x6f\x7a','\x37\x35\x30\x37\x39\x30\x62\x44\x77\x55\x58\x77','\x74\x6f\x72','\x69\x66\x74\x43\x65\x6c\x6c\x73','\x73\x74\x53\x65\x6c\x65\x63\x74','\x63\x65\x6e\x74\x65\x72','\x66\x6c\x69\x63\x6b\x69\x74\x79','\x68\x74\x74\x70\x73\x3a\x2f\x2f','\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d','\x61\x7a\x79\x65\x72\x72\x6f\x72','\x67\x65\x74\x50\x6f\x73\x69\x74\x69\x6f','\x6c\x69\x64\x65\x72','\x65\x66\x61\x75\x6c\x74','\x66\x72\x69\x63\x74\x69\x6f\x6e','\x6f\x64\x73','\x20\x61\x20\x68\x69\x64\x64\x65\x6e\x20','\x72\x65\x6d\x6f\x76\x65\x46\x72\x6f\x6d','\x65\x78\x65\x63','\x66\x6c\x69\x63\x6b\x69\x74\x79\x47\x55','\x62\x6f\x72\x64\x65\x72\x54\x6f\x70\x57','\x30\x30\x2f\x73\x76\x67','\x61\x67\x58','\x69\x73\x50\x72\x65\x76\x69\x6f\x75\x73','\x74\x69\x6c\x73','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x72','\x64\x6f\x74','\x6c\x69\x64\x65\x72\x50\x72\x6f','\x73\x65\x6c\x65\x63\x74\x2e\x70\x72\x6f','\x44\x4f\x4d\x43\x6f\x6e\x74\x65\x6e\x74','\x77\x69\x64\x74\x68','\x6e\x75\x6d\x62\x65\x72','\x74\x72\x69\x6d','\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63','\x62\x6f\x72\x64\x65\x72\x53\x74\x79\x6c','\x63\x72\x65\x61\x74\x65\x44\x6f\x63\x75','\x6d\x69\x6e','\x77\x6e\x50\x72\x65\x76\x65\x6e\x74\x44','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x65','\x73\x2f\x70\x61\x67\x65\x2d\x64\x6f\x74','\x20\x6e\x6f\x20\x76\x61\x72\x69\x61\x6e','\x6f\x6e\x74\x6f\x75\x63\x68\x65\x6e\x64','\x64\x72\x61\x67\x53\x74\x61\x72\x74\x50','\x2c\x20\x2e','\x67\x65\x74\x43\x65\x6c\x6c\x45\x6c\x65','\x69\x64\x65','\x63\x6c\x69\x63\x6b','\x6d\x61\x74\x63\x68','\x65\x6e\x61\x62\x6c\x65','\x6c\x65\x6e\x67\x74\x68','\x20\x5b\x64\x61\x74\x61\x2d\x69\x6d\x61','\x67\x65\x74\x43\x65\x6c\x6c','\x5f\x62\x69\x6e\x64\x53\x74\x61\x72\x74','\x63\x6f\x6e\x73\x74\x72\x75\x63\x74\x6f','\x65\x78\x63\x65\x70\x74\x69\x6f\x6e','\x75\x74\x74\x6f\x6e\x20\x66\x6c\x69\x63','\x6d\x6f\x75\x73\x65\x6d\x6f\x76\x65','\x72\x44\x6f\x77\x6e','\x61\x74\x63\x68\x65\x73\x2d\x73\x65\x6c','\x24\x65\x6c\x65\x6d\x65\x6e\x74','\x72\x65\x6d\x6f\x76\x65\x44\x6f\x74\x73','\x71\x75\x65\x72\x79\x43\x65\x6c\x6c','\x61\x73\x2d\x6e\x61\x76\x2d\x66\x6f\x72','\x6e\x65\x78\x74\x2d\x62\x75\x74\x74\x6f','\x69\x64\x65\x73','\x74\x53\x74\x61\x72\x74\x45\x76\x65\x6e','\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75','\x73\x6c\x69\x64\x65\x61\x62\x6c\x65\x57','\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d','\x64\x61\x74\x61\x2d\x73\x6c\x69\x64\x65','\x6e\x56\x61\x6c\x75\x65','\x62\x69\x6e\x64\x53\x74\x61\x72\x74\x45','\x75\x69\x43\x68\x61\x6e\x67\x65','\x4e\x61\x76\x46\x6f\x72','\x6d\x6f\x75\x73\x65\x75\x70','\x70\x72\x6f\x78\x79\x49\x6d\x61\x67\x65','\x6c\x61\x79\x4f\x6e\x48\x6f\x76\x65\x72','\x73\x74\x65\x6e\x65\x72','\x65\x6c\x65\x63\x74\x65\x64\x45\x6c\x65','\x50\x61\x67\x65\x20\x64\x6f\x74\x20','\x5f\x64\x72\x61\x67\x45\x6e\x64','\x74\x20\x66\x6f\x72\x20\x46\x6c\x69\x63','\x61\x67\x65\x41\x6e\x69\x6d\x61\x74\x69','\x69\x73\x41\x6e\x69\x6d\x61\x74\x69\x6e','\x74\x72\x61\x63\x74\x69\x6f\x6e','\x75\x6e\x64\x65\x66\x69\x6e\x65\x64','\x67\x65\x74\x50\x6f\x69\x6e\x74\x65\x72','\x6c\x61\x72\x65\x2e\x63\x6f\x6d\x2f\x61','\x64\x69\x73\x61\x62\x6c\x65\x64','\x2d\x69\x6e\x64\x65\x78','\x63\x43\x6c\x69\x63\x6b','\x63\x74\x2d\x6d\x65\x64\x69\x61\x2d\x74','\x5f\x62\x69\x6e\x64\x48\x61\x6e\x64\x6c','\x67\x65\x74\x50\x61\x72\x65\x6e\x74','\x64\x65\x66\x61\x75\x6c\x74\x73','\x72\x74\x65\x64','\x64\x72\x61\x67\x67\x61\x62\x6c\x65','\x70\x72\x65\x76\x65\x6e\x74\x44\x65\x66','\x68\x69\x64\x64\x65\x6e','\x5f\x65\x76\x65\x6e\x74\x73','\x46\x69\x72\x65\x66\x6f\x78\x3f\x20\x53','\x64\x61\x74\x61\x2d\x69\x6d\x61\x67\x65','\x3a\x20\x37\x36\x37\x70\x78\x29','\x62\x6e\x61\x69\x6c\x2d\x69\x6e\x64\x65','\x5f\x73\x69\x7a\x65\x43\x65\x6c\x6c\x73','\x73\x6c\x69\x63\x65','\x6a\x51\x75\x65\x72\x79\x42\x72\x69\x64','\x64\x45\x6c\x65\x6d\x65\x6e\x74\x73','\x73\x6c\x69\x64\x65\x73','\x6f\x75\x74\x65\x72\x57\x69\x64\x74\x68','\x5f\x75\x6e\x62\x69\x6e\x64\x50\x6f\x73','\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75','\x63\x74\x65\x64','\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c','\x77\x6e\x44\x65\x66\x61\x75\x6c\x74','\x63\x61\x6c\x6c','\x74\x45\x76\x65\x6e\x74','\x42\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64','\x31\x35\x33\x37\x30\x37\x73\x47\x53\x50\x43\x58','\x64\x72\x61\x67\x4d\x6f\x76\x65','\x73\x74\x61\x74\x69\x63\x43\x6c\x69\x63','\x6c\x46\x69\x74','\x61\x72\x69\x61\x2d\x63\x75\x72\x72\x65','\x73\x6f\x6c\x69\x64','\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x6d','\x75\x6e\x62\x69\x6e\x64\x48\x61\x6e\x64','\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74','\x66\x69\x72\x73\x74\x4d\x61\x72\x67\x69','\x64\x69\x72\x65\x63\x74\x69\x6f\x6e','\x5f\x6f\x6e\x63\x65\x45\x76\x65\x6e\x74','\x61\x2d\x6f\x70\x74\x69\x6f\x6e\x2d\x65','\x6f\x6e\x70\x6f\x69\x6e\x74\x65\x72\x64','\x5f\x70\x6f\x69\x6e\x74\x65\x72\x52\x65','\x64\x69\x73\x70\x6c\x61\x79','\x4c\x61\x7a\x79\x4c\x6f\x61\x64\x65\x72','\x5f\x69\x6e\x69\x74','\x70\x65\x72\x63\x65\x6e\x74\x50\x6f\x73','\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65','\x69\x6e\x64\x65\x78\x4f\x66','\x74\x6f\x4c\x6f\x77\x65\x72\x43\x61\x73','\x75\x6e\x70\x61\x75\x73\x65\x50\x6c\x61','\x70\x6f\x69\x6e\x74\x65\x72\x49\x64\x65','\x74\x6f\x75\x63\x68\x73\x74\x61\x72\x74','\x2d\x64\x6f\x77\x6e','\x6d\x61\x74\x63\x68\x65\x73\x53\x65\x6c','\x64\x72\x61\x67\x45\x6e\x64\x52\x65\x73','\x6d\x6f\x75\x73\x65\x64\x6f\x77\x6e','\x63\x68\x69\x6c\x64\x72\x65\x6e','\x20\x70\x61\x72\x61\x6d\x65\x74\x65\x72','\x75\x6e\x70\x61\x75\x73\x65','\x20\x6f\x6e\x20\x69\x6d\x61\x67\x65\x20','\x69\x6e\x6e\x65\x72\x48\x65\x69\x67\x68','\x66\x6c\x6f\x6f\x72','\x20\x65\x72\x72\x6f\x72\x20\x66\x6f\x72','\x74\x68\x69\x73\x20\x73\x65\x6c\x65\x63','\x70\x61\x75\x73\x65','\x6d\x61\x6b\x65\x41\x72\x72\x61\x79','\x6a\x71\x75\x65\x72\x79\x2d\x62\x72\x69','\x63\x6f\x6e\x66\x69\x72\x6d','\x69\x6d\x61\x67\x65\x20\x69\x73\x20\x62','\x61\x6c\x69\x7a\x65\x64\x2e\x20\x43\x61','\x74\x74\x6f\x6e','\x6f\x6c\x6c\x69\x6e\x67','\x6d\x61\x74\x63\x68\x4d\x65\x64\x69\x61','\x73\x74\x61\x6e\x63\x65','\x6e\x63\x65\x6c','\x6f\x6e\x56\x61\x6c\x75\x65','\x45\x76\x45\x6d\x69\x74\x74\x65\x72','\x69\x6d\x61\x67\x65\x73\x6c\x6f\x61\x64','\x61\x63\x74\x69\x76\x61\x74\x65\x50\x61','\x2e\x66\x6c\x69\x63\x6b\x69\x74\x79','\x70\x61\x72\x65\x6e\x74\x4e\x6f\x64\x65','\x62\x6f\x72\x64\x65\x72\x42\x6f\x74\x74','\x61\x72\x72\x6f\x77','\x74\x6f\x75\x63\x68\x65\x6e\x64','\x69\x73\x43\x6f\x6d\x70\x6c\x65\x74\x65','\x20\x72\x65\x61\x64\x79','\x70\x72\x65\x70\x65\x6e\x64','\x74\x65\x58','\x69\x73\x45\x6e\x61\x62\x6c\x65\x64','\x5f\x63\x72\x65\x61\x74\x65\x50\x6c\x61','\x73\x65\x74\x4a\x51\x75\x65\x72\x79','\x41\x73\x4e\x61\x76\x46\x6f\x72','\x41\x43\x54\x49\x56\x45\x5f\x49\x4e\x44','\x6e\x61\x76\x43\x6f\x6d\x70\x61\x6e\x69','\x73\x73\x6f\x63\x69\x61\x74\x65\x64\x2e','\x69\x73\x20\x63\x6f\x64\x65\x20\x69\x6e','\x62\x6f\x72\x64\x65\x72\x57\x69\x64\x74','\x70\x61\x64\x64\x69\x6e\x67\x52\x69\x67','\x68\x65\x73\x2d\x73\x65\x6c\x65\x63\x74','\x2c\x30\x2c\x30\x29','\x44\x72\x61\x67','\x6e\x64\x6c\x65\x72\x73','\x73\x65\x6c\x65\x63\x74\x65\x64\x53\x6c','\x64\x6f\x77\x6e\x20\x76\x61\x6c\x75\x65','\x68\x74\x6d\x6c\x49\x6e\x69\x74','\x64\x6f\x74\x73','\x43\x6f\x75\x6e\x74','\x72\x65\x6e\x64\x65\x72\x50\x6f\x73\x69','\x69\x6d\x67','\x65\x6e\x74\x72\x69\x65\x73','\x6d\x6f\x75\x73\x65\x6c\x65\x61\x76\x65','\x75\x74\x65\x72','\x72\x75\x6e\x6e\x69\x6e\x67\x20\x74\x68','\x55\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72','\x6e\x53\x63\x72\x6f\x6c\x6c','\x61\x70\x70\x65\x6e\x64','\x72\x65\x6d\x6f\x76\x65\x43\x68\x69\x6c','\x6c\x6f\x63\x61\x74\x69\x6f\x6e','\x61\x67\x65\x2d\x64\x6f\x74\x73','\x74\x72\x69\x67\x67\x65\x72','\x6e\x46\x61\x63\x74\x6f\x72','\x6e\x65\x78\x74','\x2e\x6a\x73\x2d','\x6f\x6e\x63\x6c\x69\x63\x6b','\x69\x64\x65\x6e\x74\x69\x66\x69\x65\x72','\x61\x75\x6c\x74','\x70\x72\x6f\x67\x72\x65\x73\x73\x3a\x20','\x70\x72\x65\x76\x69\x6f\x75\x73\x44\x72','\x79\x70\x65\x2d\x76\x69\x64\x65\x6f','\x7b\x7d\x2e\x63\x6f\x6e\x73\x74\x72\x75','\x64\x69\x76','\x6d\x65\x73','\x72\x65\x6c\x6f\x61\x64\x43\x65\x6c\x6c','\x65\x64\x20\x76\x69\x61\x20\x64\x72\x6f','\x6f\x6e\x54\x61\x70','\x65\x6d\x65\x6e\x74','\x70\x72\x6f\x74\x6f\x74\x79\x70\x65','\x62\x69\x6e\x64\x48\x61\x6e\x64\x6c\x65','\x67\x65\x74\x49\x73\x49\x6d\x61\x67\x65','\x69\x73\x44\x72\x61\x67\x67\x61\x62\x6c','\x74\x65\x44\x72\x61\x67','\x61\x75\x74\x6f\x50\x6c\x61\x79','\x6d\x61\x74\x63\x68\x65\x73','\x61\x64\x64\x45\x6c\x65\x6d\x65\x6e\x74','\x70\x61\x67\x65\x59\x4f\x66\x66\x73\x65','\x72\x65\x70\x6f\x73\x69\x74\x69\x6f\x6e','\x6e\x65\x78\x74\x42\x75\x74\x74\x6f\x6e','\x70\x6f\x69\x6e\x74\x65\x72\x43\x61\x6e','\x72\x6e\x20\x74\x68\x69\x73\x22\x29\x28','\x62\x6f\x72\x64\x65\x72\x4c\x65\x66\x74','\x6c\x65\x63\x74\x65\x64\x53\x6c\x69\x64','\x69\x73\x2d\x73\x65\x6c\x65\x63\x74\x65','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x6c','\x73\x6c\x69\x64\x65\x72','\x65\x64\x2f\x69\x6d\x61\x67\x65\x73\x6c','\x73\x74\x79\x6c\x65\x73\x68\x65\x65\x74','\x2e\x6a\x73\x6f\x6e','\x69\x73\x2d\x64\x72\x61\x67\x67\x61\x62','\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c','\x64\x69\x73\x61\x62\x6c\x65','\x73\x2f\x73\x6c\x69\x64\x65','\x74\x73\x69\x7a\x65\x62\x75\x67\x31','\x73\x2f\x61\x64\x64\x2d\x72\x65\x6d\x6f','\x64\x43\x65\x6c\x6c\x45\x6c\x65\x6d\x65','\x6a\x71\x75\x65\x72\x79','\x6c\x6c\x69\x6e\x67','\x6e\x61\x74\x75\x72\x61\x6c\x57\x69\x64','\x6c\x6c\x73','\x6d\x6f\x64\x75\x6c\x6f','\x31\x70\x78\x20\x32\x70\x78\x20\x33\x70','\x66\x6c\x69\x63\x6b\x69\x74\x79\x2f\x6a','\x70\x6f\x69\x6e\x74\x65\x72\x75\x70','\x2e\x2f\x63\x65\x6c\x6c','\x74\x69\x74\x79','\x6d\x61\x67\x65','\x74\x6f\x74\x79\x70\x65','\x6f\x6e\x73\x63\x72\x6f\x6c\x6c','\x5f\x75\x69\x43\x68\x61\x6e\x67\x65\x44','\x69\x73\x50\x72\x65\x76\x65\x6e\x74\x69','\x63\x68\x61\x72\x41\x74','\x69\x65\x77\x70\x6f\x72\x74','\x63\x74\x5f\x6a\x73\x6f\x6e','\x63\x6f\x6e\x74\x61\x69\x6e','\x69\x6d\x61\x67\x65\x73','\x70\x61\x74\x68','\x61\x64\x64','\x72\x65\x61\x64\x79','\x2c\x20\x69\x6d\x67\x5b\x64\x61\x74\x61','\x72\x65\x70\x6c\x61\x63\x65','\x6d\x65\x6e\x74\x73','\x5f\x70\x72\x6f\x64\x75\x63\x74\x73','\x74\x79\x4d\x6f\x62\x69\x6c\x65','\x6f\x6e\x63\x65','\x67\x65\x74\x53\x6c\x69\x64\x65\x44\x69','\x69\x64\x74\x68','\x74\x2d\x62\x75\x74\x74\x6f\x6e','\x65\x76\x2d\x65\x6d\x69\x74\x74\x65\x72','\x75\x74\x74\x6f\x6e\x2d\x69\x63\x6f\x6e','\x68\x6f\x73\x74','\x64\x61\x74\x61\x2d\x74\x68\x75\x6d\x62','\x75\x70\x64\x61\x74\x65\x54\x61\x72\x67','\x61\x6c\x77\x61\x79\x73','\x6f\x70\x74\x69\x6f\x6e\x73','\x69\x73\x49\x67\x6e\x6f\x72\x69\x6e\x67','\x64\x75\x63\x74\x2d\x66\x6f\x72\x6d\x5f','\x73\x6f\x6e\x27\x5d','\x68\x61\x73\x44\x72\x61\x67\x53\x74\x61','\x63\x68\x65\x73','\x65\x72\x72\x6f\x72','\x67\x65\x44\x6f\x74\x73','\x70\x61\x72\x73\x65','\x63\x68\x61\x6e\x67\x65\x4e\x61\x76\x53','\x73\x72\x63','\x42\x61\x64\x20\x65\x6c\x65\x6d\x65\x6e','\x72\x65\x6d\x6f\x76\x65','\x5f\x63\x6f\x6e\x74\x61\x69\x6e\x53\x6c','\x75\x70\x64\x61\x74\x65\x53\x6c\x69\x64','\x64\x72\x61\x67\x4d\x6f\x76\x65\x54\x69','\x31\x30\x30\x2c\x20\x31\x30\x30\x29\x20','\x73\x65\x6c\x65\x63\x74\x65\x64\x41\x74','\x70\x61\x64\x64\x69\x6e\x67\x42\x6f\x74','\x70\x72\x65\x76\x42\x75\x74\x74\x6f\x6e','\x64\x65\x72\x20\x2e\x70\x72\x6f\x64\x75','\x70\x72\x65\x76\x4e\x65\x78\x74\x42\x75','\x63\x72\x65\x61\x74\x65\x4d\x65\x74\x68','\x2e\x2f\x70\x72\x65\x76\x2d\x6e\x65\x78','\x5f\x74\x6f\x75\x63\x68\x41\x63\x74\x69','\x63\x72\x65\x61\x74\x65\x53\x56\x47','\x6d\x61\x72\x67\x69\x6e\x52\x69\x67\x68','\x75\x6e\x69\x64\x72\x61\x67\x67\x65\x72','\x6f\x6e\x6d\x6f\x75\x73\x65\x65\x6e\x74','\x72\x65\x6a\x65\x63\x74','\x63\x6f\x6e\x63\x61\x74','\x69\x6e\x6e\x65\x72\x48\x54\x4d\x4c','\x73\x69\x7a\x65','\x6e\x74\x73','\x67\x65\x74\x50\x61\x72\x65\x6e\x74\x43','\x70\x6f\x69\x6e\x74\x65\x72\x4d\x6f\x76','\x6c\x6f\x61\x64','\x75\x63\x74\x2d\x68\x61\x6e\x64\x6c\x65','\x6e\x74\x69\x66\x69\x65\x72','\x69\x6e\x64\x20\x70\x6f\x73\x69\x74\x69','\x43\x65\x6c\x6c','\x72\x69\x67\x68\x74','\x73\x74\x79\x6c\x65','\x57\x69\x64\x74\x68','\x70\x6f\x73\x69\x74\x69\x6f\x6e','\x65\x6c\x65\x63\x74\x65\x64\x43\x6c\x61','\x61\x72\x72\x6f\x77\x53\x68\x61\x70\x65','\x77\x65\x62\x6b\x69\x74','\x6e\x61\x6d\x65\x73\x70\x61\x63\x65\x4a'];var _0xda54=function(_0x31da1e,_0x3c4ac4){_0x31da1e=_0x31da1e-0x141;var _0x7a8d5f=_0x3e47[_0x31da1e];return _0x7a8d5f;};var _0x2da85f=_0xda54;(function(_0x2c0d80,_0x595ec6){var _0x4d6319=_0xda54;while(!![]){try{var _0x355bde=parseInt(_0x4d6319(0x269))+parseInt(_0x4d6319(0x1a3))*parseInt(_0x4d6319(0x17b))+parseInt(_0x4d6319(0x26c))+parseInt(_0x4d6319(0x44d))+-parseInt(_0x4d6319(0x2c5))*parseInt(_0x4d6319(0x2e8))+-parseInt(_0x4d6319(0x22a))*parseInt(_0x4d6319(0x2cc))+parseInt(_0x4d6319(0x35c))*-parseInt(_0x4d6319(0x19e));if(_0x355bde===_0x595ec6)break;else _0x2c0d80['push'](_0x2c0d80['shift']());}catch(_0x16424d){_0x2c0d80['push'](_0x2c0d80['shift']());}}}(_0x3e47,0xc0bfe),window[_0x2da85f(0x232)+_0x2da85f(0x301)]=window[_0x2da85f(0x232)+_0x2da85f(0x301)]||{},ezfyDebutSliderPro=function(){var _0x37e750=_0x2da85f,_0x1c68a6=function(){var _0x507b22=!![];return function(_0x5c5bec,_0x8200a2){var _0x2cc7a3=_0x507b22?function(){var _0x557a60=_0xda54;if(_0x8200a2){var _0x1d6680=_0x8200a2[_0x557a60(0x25c)](_0x5c5bec,arguments);return _0x8200a2=null,_0x1d6680;}}:function(){};return _0x507b22=![],_0x2cc7a3;};}();const _0x540451=_0x37e750(0x2ef)+'\x61\x67\x65\x53\x6c\x69\x64\x65\x72';window[_0x37e750(0x4a2)+_0x37e750(0x39d)+'\x45\x58']=0x0;const _0x3fb2db=0x32,_0x1cb9b8=0x32,_0x3ed496=_0x1cb9b8*0x3,_0x37279f=_0x3fb2db-0x14;let _0xc61995=![],_0x3f92c9=![],_0xda74cf=![];const _0x48a9f2={'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x41\x6e\x69\x6d\x61\x74\x69\x6f\x6e':_0x2e7fca('\x64\x61\x74\x61\x5f\x66\x65\x61\x74\x75'+_0x37e750(0x29f)+'\x61\x6e\x69\x6d\x61\x74\x69\x6f\x6e'),'\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69\x74\x79\x4d\x6f\x62\x69\x6c\x65':_0x2e7fca(_0x37e750(0x241)+_0x37e750(0x24c)+_0x37e750(0x49c)+'\x65'),'\x64\x61\x74\x61\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69\x74\x79':_0x2e7fca(_0x37e750(0x241)+_0x37e750(0x24c)+_0x37e750(0x3ee)),'\x74\x6f\x74\x61\x6c\x49\x6d\x61\x67\x65\x73':_0x2e7fca(_0x37e750(0x198)+'\x5f\x69\x6d\x61\x67\x65\x73'),'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x4c\x6f\x6f\x70':_0x2e7fca('\x64\x61\x74\x61\x5f\x66\x65\x61\x74\x75'+_0x37e750(0x29f)+'\x6c\x6f\x6f\x70'),'\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74\x6f\x70':_0x2e7fca('\x64\x61\x74\x61\x5f\x65\x6e\x61\x62\x6c'+_0x37e750(0x16f)+_0x37e750(0x18a)+'\x69\x6c\x73\x5f\x64\x65\x73\x6b\x74\x6f'+'\x70'),'\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x48\x69\x67\x68\x6c\x69\x67\x68\x74\x65\x64\x50\x6f\x73\x69\x74\x69\x6f\x6e':_0x2e7fca('\x64\x61\x74\x61\x5f\x74\x68\x75\x6d\x62'+_0x37e750(0x4af)+_0x37e750(0x2a3)+_0x37e750(0x258)),'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x4c\x61\x7a\x79\x6c\x6f\x61\x64':_0x2e7fca(_0x37e750(0x2e1)+_0x37e750(0x29f)+_0x37e750(0x465)),'\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x4c\x6f\x6f\x70':_0x2e7fca(_0x37e750(0x241)+_0x37e750(0x204))};console[_0x37e750(0x1af)](_0x48a9f2);const _0x554a58={'\x70\x61\x67\x65\x44\x6f\x74\x73':![],'\x63\x6f\x6e\x74\x61\x69\x6e':!![],'\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64\x65\x64':!![],'\x61\x64\x61\x70\x74\x69\x76\x65\x48\x65\x69\x67\x68\x74':!![],'\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64':_0x48a9f2[_0x37e750(0x2ef)+'\x61\x67\x65\x4c\x6f\x6f\x70'],'\x66\x61\x64\x65':!![],'\x6c\x61\x7a\x79\x4c\x6f\x61\x64':_0x48a9f2['\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d'+_0x37e750(0x474)+'\x64'],'\x73\x65\x6c\x65\x63\x74\x65\x64\x41\x74\x74\x72\x61\x63\x74\x69\x6f\x6e':_0x48a9f2[_0x37e750(0x2ef)+_0x37e750(0x338)+'\x6f\x6e']?0.025:0x1,'\x66\x72\x69\x63\x74\x69\x6f\x6e':_0x48a9f2[_0x37e750(0x2ef)+_0x37e750(0x338)+'\x6f\x6e']?0.28:0x1},_0x37bf5a={'\x61\x73\x4e\x61\x76\x46\x6f\x72':'\x23'+_0x540451,'\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64':_0x48a9f2[_0x37e750(0x29e)+_0x37e750(0x170)],'\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64\x65\x64':!![],'\x63\x6f\x6e\x74\x61\x69\x6e':![],'\x70\x61\x67\x65\x44\x6f\x74\x73':![],'\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c\x69\x74\x79':![],'\x70\x72\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f\x6e\x73':!![],'\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e':_0x368033()?_0x37e750(0x276):_0x48a9f2['\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73'+_0x37e750(0x1e0)+'\x64\x50\x6f\x73\x69\x74\x69\x6f\x6e'],'\x67\x72\x6f\x75\x70\x43\x65\x6c\x6c\x73':_0x368033()};function _0x368033(){var _0x3f51fb=_0x37e750;const _0x260b6d=parseInt(_0x48a9f2[_0x3f51fb(0x167)+'\x73']),_0x36c0f0=parseInt(_0x48a9f2[_0x3f51fb(0x24e)+'\x61\x69\x6c\x73\x51\x75\x61\x6e\x74\x69'+_0x3f51fb(0x400)]),_0x180552=parseInt(_0x48a9f2[_0x3f51fb(0x24e)+_0x3f51fb(0x497)+'\x74\x79']);console[_0x3f51fb(0x1af)](_0x3f51fb(0x283),_0x260b6d,_0x36c0f0,_0x180552);if(_0x43efad()&&_0x260b6d>_0x36c0f0)return![];else{if(!_0x43efad()&&_0x260b6d>_0x180552)return![];}return!![];}function _0x43efad(){var _0x2c62af=_0x37e750;return window[_0x2c62af(0x389)]('\x28\x6d\x61\x78\x2d\x77\x69\x64\x74\x68'+_0x2c62af(0x34c))[_0x2c62af(0x3cf)];}function _0x25aa17(_0x1217de){return new Promise(function(_0x46a630,_0x51ddb0){var _0x4adabd=_0xda54,_0x20145e;_0x20145e=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+'\x65\x6e\x74']('\x73\x63\x72\x69\x70\x74'),_0x20145e[_0x4adabd(0x415)]=_0x1217de,_0x20145e[_0x4adabd(0x484)]=_0x46a630,_0x20145e['\x6f\x6e\x65\x72\x72\x6f\x72']=_0x51ddb0,document[_0x4adabd(0x470)][_0x4adabd(0x3df)+'\x64'](_0x20145e);});}function _0x2e7fca(_0xf9b747){var _0x531f93=_0x37e750,_0x4d9364=_0x1c68a6(this,function(){var _0x24cb26=_0xda54,_0x1aee62;try{var _0xac18fd=Function(_0x24cb26(0x249)+_0x24cb26(0x49f)+(_0x24cb26(0x3c2)+'\x63\x74\x6f\x72\x28\x22\x72\x65\x74\x75'+_0x24cb26(0x3d5)+'\x20\x29')+'\x29\x3b');_0x1aee62=_0xac18fd();}catch(_0x3a7863){_0x1aee62=window;}var _0x7959a8=_0x1aee62[_0x24cb26(0x231)]=_0x1aee62['\x63\x6f\x6e\x73\x6f\x6c\x65']||{},_0x20f38d=[_0x24cb26(0x1af),_0x24cb26(0x1ae),_0x24cb26(0x499),_0x24cb26(0x411),_0x24cb26(0x31c),_0x24cb26(0x25e),_0x24cb26(0x25a)];for(var _0x48a32a=0x0;_0x48a32a<_0x20f38d[_0x24cb26(0x317)];_0x48a32a++){var _0x2e3e16=_0x1c68a6['\x63\x6f\x6e\x73\x74\x72\x75\x63\x74\x6f'+'\x72'][_0x24cb26(0x3c9)][_0x24cb26(0x174)](_0x1c68a6),_0x34febe=_0x20f38d[_0x48a32a],_0x53baea=_0x7959a8[_0x34febe]||_0x2e3e16;_0x2e3e16[_0x24cb26(0x2cf)]=_0x1c68a6[_0x24cb26(0x174)](_0x1c68a6),_0x2e3e16[_0x24cb26(0x448)]=_0x53baea[_0x24cb26(0x448)][_0x24cb26(0x174)](_0x53baea),_0x7959a8[_0x34febe]=_0x2e3e16;}});_0x4d9364();const _0x9ae2c1=document[_0x531f93(0x307)+_0x531f93(0x2e9)]('\x5b'+_0xf9b747+'\x5d');if(!_0x9ae2c1)return null;const _0x53a711=_0x9ae2c1[_0x531f93(0x328)+'\x74\x65'](_0xf9b747);if(_0x53a711==='\x74\x72\x75\x65')return!![];else return _0x53a711===_0x531f93(0x492)?![]:_0x53a711;}function _0x2155e8(_0xe8abce,_0x34703c,_0xbe6b26){var _0x1b33f4=_0x37e750;if(!_0x34703c||!_0xbe6b26)throw new Error(_0x1b33f4(0x178)+_0x1b33f4(0x44a)+'\x20\x61\x6e\x64\x20\x22\x65\x6e\x64\x22'+_0x1b33f4(0x37a));return _0xe8abce[_0x1b33f4(0x45d)](_0x34703c)[0x1][_0x1b33f4(0x45d)](_0xbe6b26)[0x0];}function _0x4a00f4(_0xddddc8){return new Promise(function(_0x4f016a,_0xfacf3){var _0xfe51da=_0xda54;let _0x56f6a6=document[_0xfe51da(0x32a)+_0xfe51da(0x29c)](_0xfe51da(0x2bd));_0x56f6a6['\x68\x72\x65\x66']=_0xddddc8,_0x56f6a6[_0xfe51da(0x27f)]=_0xfe51da(0x3dc),_0x56f6a6[_0xfe51da(0x484)]=()=>_0x4f016a(_0x56f6a6),_0x56f6a6[_0xfe51da(0x273)]=()=>_0xfacf3(new Error(_0xfe51da(0x2ac)+_0xfe51da(0x37f)+'\x20'+_0xddddc8)),document[_0xfe51da(0x470)][_0xfe51da(0x3b4)](_0x56f6a6);});}function _0x41def6(_0x3a90ad,_0x26db70){var _0x59b2ec=_0x37e750;document[_0x59b2ec(0x307)+_0x59b2ec(0x2e9)](_0x3a90ad)[_0x59b2ec(0x3df)+'\x64'](document[_0x59b2ec(0x307)+'\x74\x6f\x72'](_0x26db70));}function _0x2d4e55(){var _0x28cb8f=_0x37e750;return/product/[_0x28cb8f(0x195)](window[_0x28cb8f(0x3b6)][_0x28cb8f(0x1f4)]);}function _0x238435(_0x2a0b15){return new Promise(_0x4a75ed=>setTimeout(_0x4a75ed,_0x2a0b15));}function _0x234a96(){var _0x14bf70=_0x37e750;return/cart/[_0x14bf70(0x195)](window[_0x14bf70(0x3b6)][_0x14bf70(0x1f4)]);}function _0x139b37(_0xbd0c71,_0x282d45=0x32,_0x37b7c8=0xfa){var _0x5bbd17=_0x37e750;const _0x46f468=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x5bbd17(0x2e9)](_0xbd0c71);!window['\x5f\x5f'+_0xbd0c71]&&(window['\x5f\x5f'+_0xbd0c71]=0x0);function _0x566326(){return new Promise(_0xe689bb=>{window['\x5f\x5f'+_0xbd0c71]++,setTimeout(_0xe689bb,_0x282d45);});}if(_0x46f468===null){if(window['\x5f\x5f'+_0xbd0c71]>=_0x37b7c8)return window['\x5f\x5f'+_0xbd0c71]=0x0,Promise[_0x5bbd17(0x428)](null);return _0x566326()[_0x5bbd17(0x2db)](()=>_0x139b37(_0xbd0c71));}else return Promise['\x72\x65\x73\x6f\x6c\x76\x65'](_0x46f468);}function _0x247d5b(_0x2fd381){var _0x4e6b3f=_0x37e750;const _0x207ec3=document[_0x4e6b3f(0x32a)+_0x4e6b3f(0x29c)](_0x4e6b3f(0x435));_0x207ec3[_0x4e6b3f(0x27e)+'\x74']=_0x2fd381,document[_0x4e6b3f(0x470)][_0x4e6b3f(0x3b4)](_0x207ec3);}async function _0x447076(_0x2040ab){return new Promise(async(_0x451194,_0x21a1c9)=>{var _0x54ad83=_0xda54;try{const _0x569a12=document[_0x54ad83(0x307)+'\x74\x6f\x72'](_0x54ad83(0x302)+_0x54ad83(0x40d)+_0x54ad83(0x46b)),_0x527e8d=_0x569a12[_0x54ad83(0x207)+_0x54ad83(0x2c4)][0x0],_0x12372b=parseInt(_0x527e8d[_0x54ad83(0x471)][_0x54ad83(0x306)]()[_0x54ad83(0x371)+'\x65']());variant=_0x2040ab['\x76\x61\x72\x69\x61\x6e\x74\x73'][_0x54ad83(0x14a)](_0x3c8bd3=>_0x3c8bd3['\x69\x64']===_0x12372b)[0x0],_0x451194(variant);}catch(_0x49d741){_0x451194(null);}});}async function _0x2335a5(_0x164b4e){return new Promise(async(_0x54fef2,_0x381325)=>{var _0x367a53=_0xda54;const _0x3a9749=await _0x8df129();var _0x105c05=_0x3a9749['\x69\x6d\x61\x67\x65\x73'][_0x367a53(0x14a)](_0x102720=>_0x102720['\x69\x64']===parseInt(_0x164b4e))[0x0][_0x367a53(0x1f7)+'\x73'][0x0],_0x418b3b=_0x3a9749[_0x367a53(0x1bc)][_0x367a53(0x14a)](_0x219184=>_0x219184['\x69\x64']===parseInt(_0x105c05))[0x0][_0x367a53(0x15d)][_0x367a53(0x45d)]('\x2f')[_0x367a53(0x472)](_0x4d91c4=>_0x4d91c4['\x74\x72\x69\x6d']());_0x54fef2(_0x418b3b);});}async function _0x4eea74(_0x42a650){return new Promise(async(_0x1fb24b,_0x22688f)=>{var _0x2cfd54=_0xda54;const _0x56c11e=await _0x3cf8f0();try{_0x56c11e[_0x2cfd54(0x1bc)][_0x2cfd54(0x14a)](_0xea9d3a=>{var _0x31c004=_0x2cfd54;if(_0x31c004(0x1fa)+_0x31c004(0x3ef)in _0xea9d3a&&_0xea9d3a[_0x31c004(0x1fa)+_0x31c004(0x3ef)])return _0xea9d3a;})[_0x2cfd54(0x472)](_0x3d2595=>{var _0x2e8666=_0x2cfd54;if(!_0x3d2595)return;const _0x3cb7e2=_0x3d2595[_0x2e8666(0x1fa)+_0x2e8666(0x3ef)]!==undefined?_0x3d2595['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69'+_0x2e8666(0x3ef)]:null;_0x3cb7e2&&'\x69\x64'in _0x3cb7e2&&_0x3cb7e2['\x69\x64']===parseInt(_0x42a650)&&_0x1fb24b(_0x3d2595);});}catch(_0x3c793e){console['\x6c\x6f\x67']('\x43\x6f\x75\x6c\x64\x6e\x27\x74\x20\x63'+'\x68\x61\x6e\x67\x65\x20\x64\x72\x6f\x70'+_0x2cfd54(0x3a8)+_0x2cfd54(0x37c)+_0x2cfd54(0x172)+_0x2cfd54(0x14e)+'\x20\x69\x6d\x61\x67\x65\x20\x68\x61\x73'+_0x2cfd54(0x30e)+_0x2cfd54(0x4a1)+_0x2cfd54(0x16c)+'\x0a\x0a',_0x3c793e),_0x1fb24b(null);}});}async function _0x5c8552(){var _0x7d8f88=_0x37e750;if(window[_0x7d8f88(0x36f)+_0x7d8f88(0x3ff)])return window[_0x7d8f88(0x36f)+_0x7d8f88(0x3ff)];return new Promise(async(_0x4082cf,_0x374293)=>{var _0x5ef91c=_0x7d8f88;let _0x41ca18=_0x5ef91c(0x2ee)+(window[_0x5ef91c(0x3b6)][_0x5ef91c(0x407)]+window[_0x5ef91c(0x3b6)]['\x70\x61\x74\x68\x6e\x61\x6d\x65'])+_0x5ef91c(0x3dd),_0x382490=await fetch(_0x41ca18),{product:_0x505fc2}=await _0x382490[_0x5ef91c(0x183)]();window[_0x5ef91c(0x36f)+_0x5ef91c(0x3ff)]=_0x505fc2[_0x5ef91c(0x3f8)],_0x4082cf(_0x505fc2[_0x5ef91c(0x3f8)]);});}async function _0x8df129(){var _0x16cee6=_0x37e750;if(window[_0x16cee6(0x445)+_0x16cee6(0x3f6)])return window[_0x16cee6(0x445)+_0x16cee6(0x3f6)];return new Promise(async(_0xe3a940,_0x2ff8c7)=>{var _0x33e77c=_0x16cee6;let _0x39dd6a='\x68\x74\x74\x70\x73\x3a\x2f\x2f'+(window[_0x33e77c(0x3b6)][_0x33e77c(0x407)]+window[_0x33e77c(0x3b6)][_0x33e77c(0x17a)])+_0x33e77c(0x3dd),_0xb42b9a=await fetch(_0x39dd6a),{product:_0x53e998}=await _0xb42b9a[_0x33e77c(0x183)]();window[_0x33e77c(0x445)+_0x33e77c(0x3f6)]=_0x53e998,_0xe3a940(_0x53e998);});}async function _0x879d5d(_0x11a7e1){return new Promise(async(_0x9b702f,_0x4be0f5)=>{var _0x53b6d6=_0xda54;const _0x57cc84=await _0x5c8552();try{_0x57cc84[_0x53b6d6(0x14a)](_0x1c8cb5=>{var _0x51543f=_0x53b6d6;_0x1c8cb5['\x69\x64']===parseInt(_0x11a7e1)&&_0x9b702f(_0x1c8cb5[_0x51543f(0x437)]);});}catch(_0x100b79){console[_0x53b6d6(0x1af)]('\x43\x6f\x75\x6c\x64\x6e\x27\x74\x20\x66'+_0x53b6d6(0x432)+_0x53b6d6(0x44f),_0x100b79),_0x9b702f(null);}});}async function _0x3cf8f0(){var _0x271be3=_0x37e750;const _0x3cc625=document[_0x271be3(0x307)+_0x271be3(0x2e9)]('\x73\x63\x72\x69\x70\x74\x5b\x69\x64\x2a'+_0x271be3(0x1ed)+_0x271be3(0x40e));if(_0x3cc625)return JSON[_0x271be3(0x413)](_0x3cc625[_0x271be3(0x42a)]);let _0x40b40a;if(_hasFeaturedProduct()){const _0x55ebde=document[_0x271be3(0x307)+_0x271be3(0x2e9)]('\x5b\x64\x61\x74\x61\x2d\x70\x72\x6f\x64'+_0x271be3(0x430)+'\x5d');if(!_0x55ebde)return;const _0xa3df98=_0x55ebde['\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x271be3(0x47d)+_0x271be3(0x1f6));_0x40b40a=_0x271be3(0x2ee)+window[_0x271be3(0x3b6)][_0x271be3(0x407)]+_0x271be3(0x205)+_0xa3df98+_0x271be3(0x3dd);}else _0x40b40a=_0x271be3(0x2ee)+(window[_0x271be3(0x3b6)][_0x271be3(0x407)]+window[_0x271be3(0x3b6)][_0x271be3(0x17a)])+_0x271be3(0x3dd);if(window[_0x271be3(0x445)+'\x63\x74'])return window[_0x271be3(0x445)+'\x63\x74'];return new Promise(async(_0xda2d88,_0x43f74a)=>{var _0x19680c=_0x271be3;let _0x2471c0=await fetch(_0x40b40a),{product:_0x114492}=await _0x2471c0['\x6a\x73\x6f\x6e']();window[_0x19680c(0x445)+'\x63\x74']=_0x114492,_0xda2d88(_0x114492);});}async function _0x138324(){try{const _0x2958f0=await _0x3cf8f0(),_0x3f4396=await _0x447076(_0x2958f0);return _0x3f4396;}catch(_0x184f88){return null;}}function _0x5b4daf(){var _0x1a31d5=_0x37e750;if(window[_0x1a31d5(0x25b)]!==undefined)return!![];return new Promise(async(_0x351bf3,_0x5f59cc)=>{var _0x46f77f=_0x1a31d5;!function(_0x297524,_0x76b65c){var _0x10bf3e=_0xda54;_0x10bf3e(0x2de)==typeof define&&define[_0x10bf3e(0x1eb)]?define(_0x10bf3e(0x383)+_0x10bf3e(0x2c0)+_0x10bf3e(0x462),[_0x10bf3e(0x3e5)],function(_0x2264f3){return _0x76b65c(_0x297524,_0x2264f3);}):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module['\x65\x78\x70\x6f\x72\x74\x73']?module[_0x10bf3e(0x160)]=_0x76b65c(_0x297524,require(_0x10bf3e(0x3e5))):_0x297524[_0x10bf3e(0x350)+_0x10bf3e(0x162)]=_0x76b65c(_0x297524,_0x297524[_0x10bf3e(0x193)]);}(window,function(_0x53b165,_0x5d4546){'use strict';var _0x4237cb=_0xda54;var _0x5303c1=Array[_0x4237cb(0x3c9)]['\x73\x6c\x69\x63\x65'],_0x14cd19=_0x53b165['\x63\x6f\x6e\x73\x6f\x6c\x65'],_0x1b52bd=void 0x0===_0x14cd19?function(){}:function(_0x1488aa){var _0x324cc4=_0x4237cb;_0x14cd19[_0x324cc4(0x411)](_0x1488aa);};function _0xab3af9(_0x41f09f,_0x5c8caa,_0x1835a2){var _0x3f6b19=_0x4237cb;(_0x1835a2=_0x1835a2||_0x5d4546||_0x53b165[_0x3f6b19(0x193)])&&(_0x5c8caa['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x3f6b19(0x285)]||(_0x5c8caa[_0x3f6b19(0x3c9)]['\x6f\x70\x74\x69\x6f\x6e']=function(_0xdf0a1c){var _0x1b73c1=_0x3f6b19;_0x1835a2[_0x1b73c1(0x1bd)+_0x1b73c1(0x295)](_0xdf0a1c)&&(this[_0x1b73c1(0x40b)]=_0x1835a2[_0x1b73c1(0x20d)](!0x0,this[_0x1b73c1(0x40b)],_0xdf0a1c));}),_0x1835a2['\x66\x6e'][_0x41f09f]=function(_0x48b4d4){var _0x342f7c=_0x3f6b19;return _0x342f7c(0x44e)==typeof _0x48b4d4?function(_0x4d68da,_0x12f4c2,_0x2c8bb5){var _0x552bd5=_0x342f7c,_0x210a2f,_0x1ee531=_0x552bd5(0x468)+_0x41f09f+'\x28\x22'+_0x12f4c2+'\x22\x29';return _0x4d68da[_0x552bd5(0x1db)](function(_0x51adbd,_0x50361d){var _0x5cb3f4=_0x552bd5,_0x21fb8b=_0x1835a2[_0x5cb3f4(0x1d2)](_0x50361d,_0x41f09f);if(_0x21fb8b){var _0x587429=_0x21fb8b[_0x12f4c2];if(_0x587429&&'\x5f'!=_0x12f4c2[_0x5cb3f4(0x3f4)](0x0)){var _0x2ef2d7=_0x587429['\x61\x70\x70\x6c\x79'](_0x21fb8b,_0x2c8bb5);_0x210a2f=void 0x0===_0x210a2f?_0x2ef2d7:_0x210a2f;}else _0x1b52bd(_0x1ee531+('\x20\x69\x73\x20\x6e\x6f\x74\x20\x61\x20'+_0x5cb3f4(0x271)+'\x6f\x64'));}else _0x1b52bd(_0x41f09f+('\x20\x6e\x6f\x74\x20\x69\x6e\x69\x74\x69'+_0x5cb3f4(0x386)+'\x6e\x6e\x6f\x74\x20\x63\x61\x6c\x6c\x20'+'\x6d\x65\x74\x68\x6f\x64\x73\x2c\x20\x69'+'\x2e\x65\x2e\x20')+_0x1ee531);}),void 0x0!==_0x210a2f?_0x210a2f:_0x4d68da;}(this,_0x48b4d4,_0x5303c1['\x63\x61\x6c\x6c'](arguments,0x1)):(function(_0xd6daac,_0x353d62){var _0x4028f8=_0x342f7c;_0xd6daac[_0x4028f8(0x1db)](function(_0xa820f9,_0x496486){var _0x72110e=_0x4028f8,_0x1f9677=_0x1835a2['\x64\x61\x74\x61'](_0x496486,_0x41f09f);_0x1f9677?(_0x1f9677[_0x72110e(0x285)](_0x353d62),_0x1f9677[_0x72110e(0x36d)]()):(_0x1f9677=new _0x5c8caa(_0x496486,_0x353d62),_0x1835a2[_0x72110e(0x1d2)](_0x496486,_0x41f09f,_0x1f9677));});}(this,_0x48b4d4),this);},_0x424b8d(_0x1835a2));}function _0x424b8d(_0x7c70ef){var _0x46e646=_0x4237cb;!_0x7c70ef||_0x7c70ef&&_0x7c70ef[_0x46e646(0x473)]||(_0x7c70ef[_0x46e646(0x473)]=_0xab3af9);}return _0x424b8d(_0x5d4546||_0x53b165['\x6a\x51\x75\x65\x72\x79']),_0xab3af9;}),function(_0x3a951a,_0x597bff){var _0x320cd3=_0xda54;'\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define['\x61\x6d\x64']?define(_0x320cd3(0x405)+_0x320cd3(0x256)+'\x72',_0x597bff):_0x320cd3(0x28b)==typeof module&&module[_0x320cd3(0x160)]?module['\x65\x78\x70\x6f\x72\x74\x73']=_0x597bff():_0x3a951a[_0x320cd3(0x38d)]=_0x597bff();}(_0x46f77f(0x33b)!=typeof window?window:this,function(){var _0x18c0a4=_0x46f77f;function _0x24cf5b(){}var _0xfdbb32=_0x24cf5b[_0x18c0a4(0x3c9)];return _0xfdbb32['\x6f\x6e']=function(_0x2c581b,_0xcb948f){var _0x72965f=_0x18c0a4;if(_0x2c581b&&_0xcb948f){var _0x1e0e0d=this['\x5f\x65\x76\x65\x6e\x74\x73']=this[_0x72965f(0x349)]||{},_0x2ac96f=_0x1e0e0d[_0x2c581b]=_0x1e0e0d[_0x2c581b]||[];return-0x1==_0x2ac96f[_0x72965f(0x370)](_0xcb948f)&&_0x2ac96f[_0x72965f(0x23d)](_0xcb948f),this;}},_0xfdbb32[_0x18c0a4(0x401)]=function(_0x5e405b,_0x1f62cb){var _0x332461=_0x18c0a4;if(_0x5e405b&&_0x1f62cb){this['\x6f\x6e'](_0x5e405b,_0x1f62cb);var _0x44172c=this[_0x332461(0x367)+'\x73']=this[_0x332461(0x367)+'\x73']||{};return(_0x44172c[_0x5e405b]=_0x44172c[_0x5e405b]||{})[_0x1f62cb]=!0x0,this;}},_0xfdbb32[_0x18c0a4(0x265)]=function(_0x26c4a6,_0x56701a){var _0x212a6a=_0x18c0a4,_0x14735a=this[_0x212a6a(0x349)]&&this['\x5f\x65\x76\x65\x6e\x74\x73'][_0x26c4a6];if(_0x14735a&&_0x14735a['\x6c\x65\x6e\x67\x74\x68']){var _0x17839d=_0x14735a[_0x212a6a(0x370)](_0x56701a);return-0x1!=_0x17839d&&_0x14735a['\x73\x70\x6c\x69\x63\x65'](_0x17839d,0x1),this;}},_0xfdbb32[_0x18c0a4(0x279)]=function(_0x3ca3b9,_0x4d2f2a){var _0xb9d2c9=_0x18c0a4,_0x48ef56=this[_0xb9d2c9(0x349)]&&this['\x5f\x65\x76\x65\x6e\x74\x73'][_0x3ca3b9];if(_0x48ef56&&_0x48ef56[_0xb9d2c9(0x317)]){_0x48ef56=_0x48ef56[_0xb9d2c9(0x34f)](0x0),_0x4d2f2a=_0x4d2f2a||[];for(var _0x246d82=this[_0xb9d2c9(0x367)+'\x73']&&this[_0xb9d2c9(0x367)+'\x73'][_0x3ca3b9],_0x15f174=0x0;_0x15f174<_0x48ef56[_0xb9d2c9(0x317)];_0x15f174++){var _0x3e6847=_0x48ef56[_0x15f174];_0x246d82&&_0x246d82[_0x3e6847]&&(this['\x6f\x66\x66'](_0x3ca3b9,_0x3e6847),delete _0x246d82[_0x3e6847]),_0x3e6847[_0xb9d2c9(0x25c)](this,_0x4d2f2a);}return this;}},_0xfdbb32['\x61\x6c\x6c\x4f\x66\x66']=function(){var _0x2fed43=_0x18c0a4;delete this['\x5f\x65\x76\x65\x6e\x74\x73'],delete this[_0x2fed43(0x367)+'\x73'];},_0x24cf5b;}),function(_0x555cbe,_0x2c2968){var _0x358b74=_0x46f77f;_0x358b74(0x2de)==typeof define&&define[_0x358b74(0x1eb)]?define(_0x358b74(0x28e)+_0x358b74(0x446),_0x2c2968):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x358b74(0x160)]?module[_0x358b74(0x160)]=_0x2c2968():_0x555cbe[_0x358b74(0x156)]=_0x2c2968();}(window,function(){'use strict';var _0x21d6f2=_0x46f77f;function _0x3fddd6(_0x215a94){var _0x500ac8=parseFloat(_0x215a94);return-0x1==_0x215a94['\x69\x6e\x64\x65\x78\x4f\x66']('\x25')&&!isNaN(_0x500ac8)&&_0x500ac8;}var _0x32dede=_0x21d6f2(0x33b)==typeof console?function(){}:function(_0x5b10f1){var _0x3f5c93=_0x21d6f2;console[_0x3f5c93(0x411)](_0x5b10f1);},_0x1a8bbb=['\x70\x61\x64\x64\x69\x6e\x67\x4c\x65\x66'+'\x74',_0x21d6f2(0x3a2)+'\x68\x74','\x70\x61\x64\x64\x69\x6e\x67\x54\x6f\x70',_0x21d6f2(0x41d)+_0x21d6f2(0x255),'\x6d\x61\x72\x67\x69\x6e\x4c\x65\x66\x74','\x6d\x61\x72\x67\x69\x6e\x52\x69\x67\x68'+'\x74','\x6d\x61\x72\x67\x69\x6e\x54\x6f\x70','\x6d\x61\x72\x67\x69\x6e\x42\x6f\x74\x74'+'\x6f\x6d',_0x21d6f2(0x3d6)+_0x21d6f2(0x436),_0x21d6f2(0x452)+'\x74\x57\x69\x64\x74\x68',_0x21d6f2(0x2fa)+_0x21d6f2(0x403),_0x21d6f2(0x392)+'\x6f\x6d\x57\x69\x64\x74\x68'],_0x2a6b9f=_0x1a8bbb[_0x21d6f2(0x317)];function _0x51cdec(_0x3120df){var _0x311b98=_0x21d6f2,_0x2ba0cf=getComputedStyle(_0x3120df);return _0x2ba0cf||_0x32dede('\x53\x74\x79\x6c\x65\x20\x72\x65\x74\x75'+'\x72\x6e\x65\x64\x20'+_0x2ba0cf+(_0x311b98(0x1c4)+_0x311b98(0x3b1)+_0x311b98(0x3a0)+_0x311b98(0x2f6)+'\x69\x66\x72\x61\x6d\x65\x20\x6f\x6e\x20'+_0x311b98(0x34a)+'\x65\x65\x20\x68\x74\x74\x70\x73\x3a\x2f'+_0x311b98(0x28f)+_0x311b98(0x3e2))),_0x2ba0cf;}var _0x5913b2,_0x21b812=!0x1;function _0x1b2887(){var _0x5d2a54=_0x21d6f2;if(!_0x21b812){_0x21b812=!0x0;var _0x4a1c36=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+_0x5d2a54(0x29c)]('\x64\x69\x76');_0x4a1c36[_0x5d2a54(0x435)][_0x5d2a54(0x304)]='\x32\x30\x30\x70\x78',_0x4a1c36['\x73\x74\x79\x6c\x65'][_0x5d2a54(0x49d)]=_0x5d2a54(0x3ea)+'\x78\x20\x34\x70\x78',_0x4a1c36[_0x5d2a54(0x435)][_0x5d2a54(0x308)+'\x65']=_0x5d2a54(0x361),_0x4a1c36[_0x5d2a54(0x435)][_0x5d2a54(0x3a1)+'\x68']='\x31\x70\x78\x20\x32\x70\x78\x20\x33\x70'+'\x78\x20\x34\x70\x78',_0x4a1c36[_0x5d2a54(0x435)]['\x62\x6f\x78\x53\x69\x7a\x69\x6e\x67']=_0x5d2a54(0x45b);var _0x2a8f0c=document[_0x5d2a54(0x1e2)]||document[_0x5d2a54(0x1cf)+_0x5d2a54(0x3c8)];_0x2a8f0c[_0x5d2a54(0x3df)+'\x64'](_0x4a1c36);var _0x23079e=_0x51cdec(_0x4a1c36);_0x5913b2=0xc8==Math['\x72\x6f\x75\x6e\x64'](_0x3fddd6(_0x23079e[_0x5d2a54(0x304)])),_0x21ccc7['\x69\x73\x42\x6f\x78\x53\x69\x7a\x65\x4f'+_0x5d2a54(0x3b0)]=_0x5913b2,_0x2a8f0c[_0x5d2a54(0x3b5)+'\x64'](_0x4a1c36);}}function _0x21ccc7(_0x180ac5){var _0x13004b=_0x21d6f2;if(_0x1b2887(),_0x13004b(0x44e)==typeof _0x180ac5&&(_0x180ac5=document[_0x13004b(0x307)+_0x13004b(0x2e9)](_0x180ac5)),_0x180ac5&&'\x6f\x62\x6a\x65\x63\x74'==typeof _0x180ac5&&_0x180ac5[_0x13004b(0x1f3)]){var _0x5776fc=_0x51cdec(_0x180ac5);if(_0x13004b(0x251)==_0x5776fc[_0x13004b(0x36b)])return function(){for(var _0x91fb83={'\x77\x69\x64\x74\x68':0x0,'\x68\x65\x69\x67\x68\x74':0x0,'\x69\x6e\x6e\x65\x72\x57\x69\x64\x74\x68':0x0,'\x69\x6e\x6e\x65\x72\x48\x65\x69\x67\x68\x74':0x0,'\x6f\x75\x74\x65\x72\x57\x69\x64\x74\x68':0x0,'\x6f\x75\x74\x65\x72\x48\x65\x69\x67\x68\x74':0x0},_0x26a4cd=0x0;_0x26a4cd<_0x2a6b9f;_0x26a4cd++)_0x91fb83[_0x1a8bbb[_0x26a4cd]]=0x0;return _0x91fb83;}();var _0x2a3f82={};_0x2a3f82['\x77\x69\x64\x74\x68']=_0x180ac5[_0x13004b(0x179)+'\x68'],_0x2a3f82['\x68\x65\x69\x67\x68\x74']=_0x180ac5['\x6f\x66\x66\x73\x65\x74\x48\x65\x69\x67'+'\x68\x74'];for(var _0x42f1aa=_0x2a3f82['\x69\x73\x42\x6f\x72\x64\x65\x72\x42\x6f'+'\x78']=_0x13004b(0x45b)==_0x5776fc[_0x13004b(0x149)],_0x4b64f2=0x0;_0x4b64f2<_0x2a6b9f;_0x4b64f2++){var _0x653143=_0x1a8bbb[_0x4b64f2],_0x41d5a4=_0x5776fc[_0x653143],_0x12fc49=parseFloat(_0x41d5a4);_0x2a3f82[_0x653143]=isNaN(_0x12fc49)?0x0:_0x12fc49;}var _0x241571=_0x2a3f82['\x70\x61\x64\x64\x69\x6e\x67\x4c\x65\x66'+'\x74']+_0x2a3f82[_0x13004b(0x3a2)+'\x68\x74'],_0x5551aa=_0x2a3f82['\x70\x61\x64\x64\x69\x6e\x67\x54\x6f\x70']+_0x2a3f82['\x70\x61\x64\x64\x69\x6e\x67\x42\x6f\x74'+_0x13004b(0x255)],_0x31922d=_0x2a3f82['\x6d\x61\x72\x67\x69\x6e\x4c\x65\x66\x74']+_0x2a3f82[_0x13004b(0x425)+'\x74'],_0x266ee6=_0x2a3f82[_0x13004b(0x23a)]+_0x2a3f82['\x6d\x61\x72\x67\x69\x6e\x42\x6f\x74\x74'+'\x6f\x6d'],_0x2952b1=_0x2a3f82[_0x13004b(0x3d6)+'\x57\x69\x64\x74\x68']+_0x2a3f82[_0x13004b(0x452)+_0x13004b(0x48f)],_0x5478c4=_0x2a3f82['\x62\x6f\x72\x64\x65\x72\x54\x6f\x70\x57'+_0x13004b(0x403)]+_0x2a3f82[_0x13004b(0x392)+_0x13004b(0x257)],_0x1282b2=_0x42f1aa&&_0x5913b2,_0x14aa08=_0x3fddd6(_0x5776fc[_0x13004b(0x304)]);!0x1!==_0x14aa08&&(_0x2a3f82[_0x13004b(0x304)]=_0x14aa08+(_0x1282b2?0x0:_0x241571+_0x2952b1));var _0x23a19c=_0x3fddd6(_0x5776fc[_0x13004b(0x1ef)]);return!0x1!==_0x23a19c&&(_0x2a3f82[_0x13004b(0x1ef)]=_0x23a19c+(_0x1282b2?0x0:_0x5551aa+_0x5478c4)),_0x2a3f82['\x69\x6e\x6e\x65\x72\x57\x69\x64\x74\x68']=_0x2a3f82[_0x13004b(0x304)]-(_0x241571+_0x2952b1),_0x2a3f82[_0x13004b(0x37d)+'\x74']=_0x2a3f82[_0x13004b(0x1ef)]-(_0x5551aa+_0x5478c4),_0x2a3f82[_0x13004b(0x353)]=_0x2a3f82['\x77\x69\x64\x74\x68']+_0x31922d,_0x2a3f82[_0x13004b(0x461)+'\x74']=_0x2a3f82['\x68\x65\x69\x67\x68\x74']+_0x266ee6,_0x2a3f82;}}return _0x21ccc7;}),function(_0x225592,_0x5a8ffd){'use strict';var _0x1e8044=_0x46f77f;_0x1e8044(0x2de)==typeof define&&define[_0x1e8044(0x1eb)]?define(_0x1e8044(0x2bc)+_0x1e8044(0x320)+'\x65\x63\x74\x6f\x72\x2f\x6d\x61\x74\x63'+_0x1e8044(0x3a3)+'\x6f\x72',_0x5a8ffd):_0x1e8044(0x28b)==typeof module&&module[_0x1e8044(0x160)]?module[_0x1e8044(0x160)]=_0x5a8ffd():_0x225592[_0x1e8044(0x376)+_0x1e8044(0x4a9)]=_0x5a8ffd();}(window,function(){'use strict';var _0x1d8b30=function(){var _0x1488f1=_0xda54,_0x2ebb57=window['\x45\x6c\x65\x6d\x65\x6e\x74'][_0x1488f1(0x3c9)];if(_0x2ebb57[_0x1488f1(0x3cf)])return _0x1488f1(0x3cf);if(_0x2ebb57[_0x1488f1(0x376)+_0x1488f1(0x4a9)])return _0x1488f1(0x376)+'\x65\x63\x74\x6f\x72';for(var _0x53bf22=[_0x1488f1(0x43a),_0x1488f1(0x2e7),'\x6d\x73','\x6f'],_0x15e484=0x0;_0x15e484<_0x53bf22[_0x1488f1(0x317)];_0x15e484++){var _0x5d4933=_0x53bf22[_0x15e484]+('\x4d\x61\x74\x63\x68\x65\x73\x53\x65\x6c'+_0x1488f1(0x4a9));if(_0x2ebb57[_0x5d4933])return _0x5d4933;}}();return function(_0x5d021e,_0x34008a){return _0x5d021e[_0x1d8b30](_0x34008a);};}),function(_0x3e2e9f,_0x3fab78){var _0x47520e=_0x46f77f;_0x47520e(0x2de)==typeof define&&define['\x61\x6d\x64']?define(_0x47520e(0x1de)+_0x47520e(0x2d1),[_0x47520e(0x2bc)+_0x47520e(0x320)+_0x47520e(0x24b)+'\x68\x65\x73\x2d\x73\x65\x6c\x65\x63\x74'+'\x6f\x72'],function(_0x3f1199){return _0x3fab78(_0x3e2e9f,_0x3f1199);}):_0x47520e(0x28b)==typeof module&&module[_0x47520e(0x160)]?module[_0x47520e(0x160)]=_0x3fab78(_0x3e2e9f,require(_0x47520e(0x2bc)+_0x47520e(0x320)+'\x65\x63\x74\x6f\x72')):_0x3e2e9f['\x66\x69\x7a\x7a\x79\x55\x49\x55\x74\x69'+'\x6c\x73']=_0x3fab78(_0x3e2e9f,_0x3e2e9f[_0x47520e(0x376)+_0x47520e(0x4a9)]);}(window,function(_0x92e98e,_0x11ab25){var _0x19d0b5=_0x46f77f,_0x292c4f={'\x65\x78\x74\x65\x6e\x64':function(_0x4a9307,_0x195288){for(var _0x44f2e1 in _0x195288)_0x4a9307[_0x44f2e1]=_0x195288[_0x44f2e1];return _0x4a9307;},'\x6d\x6f\x64\x75\x6c\x6f':function(_0xc1f2bf,_0x222552){return(_0xc1f2bf%_0x222552+_0x222552)%_0x222552;}},_0x518ad0=Array[_0x19d0b5(0x3c9)][_0x19d0b5(0x34f)];_0x292c4f[_0x19d0b5(0x382)]=function(_0x552956){var _0x158039=_0x19d0b5;return Array[_0x158039(0x21a)](_0x552956)?_0x552956:null==_0x552956?[]:_0x158039(0x28b)==typeof _0x552956&&_0x158039(0x305)==typeof _0x552956[_0x158039(0x317)]?_0x518ad0['\x63\x61\x6c\x6c'](_0x552956):[_0x552956];},_0x292c4f[_0x19d0b5(0x2f7)]=function(_0x4461be,_0x3567e7){var _0x3d8488=_0x19d0b5,_0x5c4f23=_0x4461be[_0x3d8488(0x370)](_0x3567e7);-0x1!=_0x5c4f23&&_0x4461be[_0x3d8488(0x2d8)](_0x5c4f23,0x1);},_0x292c4f[_0x19d0b5(0x343)]=function(_0x291283,_0x3a0e9c){var _0x130f99=_0x19d0b5;for(;_0x291283[_0x130f99(0x391)]&&_0x291283!=document['\x62\x6f\x64\x79'];)if(_0x291283=_0x291283['\x70\x61\x72\x65\x6e\x74\x4e\x6f\x64\x65'],_0x11ab25(_0x291283,_0x3a0e9c))return _0x291283;},_0x292c4f[_0x19d0b5(0x21d)+_0x19d0b5(0x3c8)]=function(_0x30bd1b){var _0x12d9ae=_0x19d0b5;return _0x12d9ae(0x44e)==typeof _0x30bd1b?document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x12d9ae(0x2e9)](_0x30bd1b):_0x30bd1b;},_0x292c4f[_0x19d0b5(0x1ab)+'\x74']=function(_0x4eae34){var _0x5f571e=_0x19d0b5,_0x978451='\x6f\x6e'+_0x4eae34[_0x5f571e(0x49e)];this[_0x978451]&&this[_0x978451](_0x4eae34);},_0x292c4f[_0x19d0b5(0x2d6)+_0x19d0b5(0x2d9)]=function(_0x12217e,_0x1dcf42){var _0x1b8bee=_0x19d0b5;_0x12217e=_0x292c4f[_0x1b8bee(0x382)](_0x12217e);var _0xe3d2ae=[];return _0x12217e[_0x1b8bee(0x1b3)](function(_0x3ade5f){var _0x47c279=_0x1b8bee;if(_0x3ade5f instanceof HTMLElement){if(_0x1dcf42){_0x11ab25(_0x3ade5f,_0x1dcf42)&&_0xe3d2ae[_0x47c279(0x23d)](_0x3ade5f);for(var _0x1ff6c4=_0x3ade5f[_0x47c279(0x307)+'\x74\x6f\x72\x41\x6c\x6c'](_0x1dcf42),_0x1ff95e=0x0;_0x1ff95e<_0x1ff6c4['\x6c\x65\x6e\x67\x74\x68'];_0x1ff95e++)_0xe3d2ae[_0x47c279(0x23d)](_0x1ff6c4[_0x1ff95e]);}else _0xe3d2ae[_0x47c279(0x23d)](_0x3ade5f);}}),_0xe3d2ae;},_0x292c4f['\x64\x65\x62\x6f\x75\x6e\x63\x65\x4d\x65'+_0x19d0b5(0x15c)]=function(_0x30bc9c,_0x2ec330,_0x347e1e){var _0x3834d0=_0x19d0b5;_0x347e1e=_0x347e1e||0x64;var _0x3f6615=_0x30bc9c['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x2ec330],_0x547fe7=_0x2ec330+_0x3834d0(0x20e);_0x30bc9c[_0x3834d0(0x3c9)][_0x2ec330]=function(){var _0x4e79be=this[_0x547fe7];clearTimeout(_0x4e79be);var _0x2b6ea1=arguments,_0x4e8cf8=this;this[_0x547fe7]=setTimeout(function(){var _0x18ce5f=_0xda54;_0x3f6615[_0x18ce5f(0x25c)](_0x4e8cf8,_0x2b6ea1),delete _0x4e8cf8[_0x547fe7];},_0x347e1e);};},_0x292c4f[_0x19d0b5(0x2d5)]=function(_0x5349d8){var _0x40445d=_0x19d0b5,_0x49eeb5=document[_0x40445d(0x223)];_0x40445d(0x485)==_0x49eeb5||'\x69\x6e\x74\x65\x72\x61\x63\x74\x69\x76'+'\x65'==_0x49eeb5?setTimeout(_0x5349d8):document[_0x40445d(0x1bb)+_0x40445d(0x333)](_0x40445d(0x303)+_0x40445d(0x2da),_0x5349d8);},_0x292c4f[_0x19d0b5(0x181)]=function(_0x47cae0){var _0x27d245=_0x19d0b5;return _0x47cae0[_0x27d245(0x3fd)](/(.)([A-Z])/g,function(_0x9450d2,_0x3bdbb7,_0x27b23f){return _0x3bdbb7+'\x2d'+_0x27b23f;})[_0x27d245(0x371)+'\x65']();};var _0x4caed3=_0x92e98e[_0x19d0b5(0x231)];return _0x292c4f[_0x19d0b5(0x3a9)]=function(_0x15558c,_0x137830){_0x292c4f['\x64\x6f\x63\x52\x65\x61\x64\x79'](function(){var _0x4c1f53=_0xda54,_0x5d80ac=_0x292c4f[_0x4c1f53(0x181)](_0x137830),_0x1e2b8a='\x64\x61\x74\x61\x2d'+_0x5d80ac,_0x3211cd=document[_0x4c1f53(0x307)+_0x4c1f53(0x28c)]('\x5b'+_0x1e2b8a+'\x5d'),_0x246f7a=document[_0x4c1f53(0x307)+_0x4c1f53(0x28c)](_0x4c1f53(0x3bb)+_0x5d80ac),_0x3bd50a=_0x292c4f[_0x4c1f53(0x382)](_0x3211cd)[_0x4c1f53(0x429)](_0x292c4f[_0x4c1f53(0x382)](_0x246f7a)),_0x4d79a6=_0x1e2b8a+_0x4c1f53(0x47b),_0x16b82d=_0x92e98e[_0x4c1f53(0x193)];_0x3bd50a[_0x4c1f53(0x1b3)](function(_0x2d40b8){var _0x4e0823=_0x4c1f53,_0x5393bc,_0x44bf0c=_0x2d40b8[_0x4e0823(0x328)+'\x74\x65'](_0x1e2b8a)||_0x2d40b8[_0x4e0823(0x328)+'\x74\x65'](_0x4d79a6);try{_0x5393bc=_0x44bf0c&&JSON[_0x4e0823(0x413)](_0x44bf0c);}catch(_0x3f1bfc){return void(_0x4caed3&&_0x4caed3[_0x4e0823(0x411)](_0x4e0823(0x282)+'\x69\x6e\x67\x20'+_0x1e2b8a+_0x4e0823(0x1fc)+_0x2d40b8['\x63\x6c\x61\x73\x73\x4e\x61\x6d\x65']+'\x3a\x20'+_0x3f1bfc));}var _0x80c4e9=new _0x15558c(_0x2d40b8,_0x5393bc);_0x16b82d&&_0x16b82d['\x64\x61\x74\x61'](_0x2d40b8,_0x137830,_0x80c4e9);});});},_0x292c4f;}),function(_0x124426,_0x5bd868){var _0x7d5563=_0x46f77f;_0x7d5563(0x2de)==typeof define&&define[_0x7d5563(0x1eb)]?define(_0x7d5563(0x3eb)+'\x73\x2f\x63\x65\x6c\x6c',[_0x7d5563(0x28e)+'\x65\x74\x2d\x73\x69\x7a\x65'],function(_0x65b9b7){return _0x5bd868(_0x124426,_0x65b9b7);}):_0x7d5563(0x28b)==typeof module&&module[_0x7d5563(0x160)]?module[_0x7d5563(0x160)]=_0x5bd868(_0x124426,require('\x67\x65\x74\x2d\x73\x69\x7a\x65')):(_0x124426['\x46\x6c\x69\x63\x6b\x69\x74\x79']=_0x124426[_0x7d5563(0x25b)]||{},_0x124426['\x46\x6c\x69\x63\x6b\x69\x74\x79'][_0x7d5563(0x433)]=_0x5bd868(_0x124426,_0x124426[_0x7d5563(0x156)]));}(window,function(_0x2252f8,_0x556b75){var _0x40fc49=_0x46f77f;function _0x3187d3(_0x19408f,_0x266c79){var _0xf48b83=_0xda54;this['\x65\x6c\x65\x6d\x65\x6e\x74']=_0x19408f,this[_0xf48b83(0x211)]=_0x266c79,this[_0xf48b83(0x1cd)]();}var _0x571c82=_0x3187d3[_0x40fc49(0x3c9)];return _0x571c82[_0x40fc49(0x1cd)]=function(){var _0x369b08=_0x40fc49;this[_0x369b08(0x486)][_0x369b08(0x435)][_0x369b08(0x437)]=_0x369b08(0x233),this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x369b08(0x355)+'\x74\x65']('\x61\x72\x69\x61\x2d\x68\x69\x64\x64\x65'+'\x6e','\x74\x72\x75\x65'),this['\x78']=0x0,this[_0x369b08(0x1e9)]=0x0;},_0x571c82[_0x40fc49(0x151)]=function(){var _0x2fdfb4=_0x40fc49;this[_0x2fdfb4(0x287)](),this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x2fdfb4(0x435)][_0x2fdfb4(0x437)]='';var _0x457f4b=this[_0x2fdfb4(0x211)][_0x2fdfb4(0x479)];this[_0x2fdfb4(0x486)][_0x2fdfb4(0x435)][_0x457f4b]='',this[_0x2fdfb4(0x486)]['\x72\x65\x6d\x6f\x76\x65\x41\x74\x74\x72'+_0x2fdfb4(0x16b)](_0x2fdfb4(0x48b)+'\x6e');},_0x571c82[_0x40fc49(0x156)]=function(){var _0x3e55f5=_0x40fc49;this[_0x3e55f5(0x42b)]=_0x556b75(this[_0x3e55f5(0x486)]);},_0x571c82[_0x40fc49(0x14c)+'\x6e']=function(_0x8b8f3a){var _0x2c73be=_0x40fc49;this['\x78']=_0x8b8f3a,this[_0x2c73be(0x409)+'\x65\x74'](),this[_0x2c73be(0x3ac)+'\x74\x69\x6f\x6e'](_0x8b8f3a);},_0x571c82['\x75\x70\x64\x61\x74\x65\x54\x61\x72\x67'+'\x65\x74']=_0x571c82[_0x40fc49(0x297)+_0x40fc49(0x168)]=function(){var _0x24d879=_0x40fc49,_0x26204c='\x6c\x65\x66\x74'==this[_0x24d879(0x211)][_0x24d879(0x479)]?'\x6d\x61\x72\x67\x69\x6e\x4c\x65\x66\x74':_0x24d879(0x425)+'\x74';this[_0x24d879(0x237)]=this['\x78']+this['\x73\x69\x7a\x65'][_0x26204c]+this['\x73\x69\x7a\x65'][_0x24d879(0x304)]*this[_0x24d879(0x211)][_0x24d879(0x20f)];},_0x571c82['\x72\x65\x6e\x64\x65\x72\x50\x6f\x73\x69'+'\x74\x69\x6f\x6e']=function(_0x13681a){var _0x54ba88=_0x40fc49,_0x5688b2=this[_0x54ba88(0x211)][_0x54ba88(0x479)];this[_0x54ba88(0x486)][_0x54ba88(0x435)][_0x5688b2]=this[_0x54ba88(0x211)][_0x54ba88(0x2f1)+'\x6e\x56\x61\x6c\x75\x65'](_0x13681a);},_0x571c82[_0x40fc49(0x153)]=function(){var _0xe9fc1e=_0x40fc49;this[_0xe9fc1e(0x486)][_0xe9fc1e(0x2a0)][_0xe9fc1e(0x3fa)]('\x69\x73\x2d\x73\x65\x6c\x65\x63\x74\x65'+'\x64'),this[_0xe9fc1e(0x486)]['\x72\x65\x6d\x6f\x76\x65\x41\x74\x74\x72'+_0xe9fc1e(0x16b)]('\x61\x72\x69\x61\x2d\x68\x69\x64\x64\x65'+'\x6e');},_0x571c82[_0x40fc49(0x287)]=function(){var _0x5c6ee3=_0x40fc49;this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x5c6ee3(0x2a0)][_0x5c6ee3(0x417)](_0x5c6ee3(0x3d8)+'\x64'),this[_0x5c6ee3(0x486)][_0x5c6ee3(0x355)+'\x74\x65'](_0x5c6ee3(0x48b)+'\x6e',_0x5c6ee3(0x2aa));},_0x571c82[_0x40fc49(0x1b2)]=function(_0x2a9f2a){var _0x970040=_0x40fc49;this['\x73\x68\x69\x66\x74']=_0x2a9f2a,this[_0x970040(0x3ac)+_0x970040(0x21b)](this['\x78']+this[_0x970040(0x211)][_0x970040(0x329)+_0x970040(0x403)]*_0x2a9f2a);},_0x571c82[_0x40fc49(0x417)]=function(){var _0x38436a=_0x40fc49;this[_0x38436a(0x486)]['\x70\x61\x72\x65\x6e\x74\x4e\x6f\x64\x65'][_0x38436a(0x3b5)+'\x64'](this['\x65\x6c\x65\x6d\x65\x6e\x74']);},_0x3187d3;}),function(_0x15a38e,_0x4dbd72){var _0x12d381=_0x46f77f;_0x12d381(0x2de)==typeof define&&define[_0x12d381(0x1eb)]?define(_0x12d381(0x3eb)+_0x12d381(0x3e1),_0x4dbd72):_0x12d381(0x28b)==typeof module&&module[_0x12d381(0x160)]?module[_0x12d381(0x160)]=_0x4dbd72():(_0x15a38e[_0x12d381(0x25b)]=_0x15a38e[_0x12d381(0x25b)]||{},_0x15a38e[_0x12d381(0x25b)][_0x12d381(0x1b8)]=_0x4dbd72());}(window,function(){'use strict';var _0x437d93=_0x46f77f;function _0x4c0f0d(_0x114051){var _0x46b010=_0xda54;this['\x70\x61\x72\x65\x6e\x74']=_0x114051,this['\x69\x73\x4f\x72\x69\x67\x69\x6e\x4c\x65'+'\x66\x74']=_0x46b010(0x276)==_0x114051[_0x46b010(0x479)],this['\x63\x65\x6c\x6c\x73']=[],this[_0x46b010(0x353)]=0x0,this[_0x46b010(0x1ef)]=0x0;}var _0x504899=_0x4c0f0d[_0x437d93(0x3c9)];return _0x504899['\x61\x64\x64\x43\x65\x6c\x6c']=function(_0x53ef30){var _0x449091=_0x437d93;if(this[_0x449091(0x1ee)]['\x70\x75\x73\x68'](_0x53ef30),this['\x6f\x75\x74\x65\x72\x57\x69\x64\x74\x68']+=_0x53ef30[_0x449091(0x42b)][_0x449091(0x353)],this[_0x449091(0x1ef)]=Math[_0x449091(0x19b)](_0x53ef30[_0x449091(0x42b)][_0x449091(0x461)+'\x74'],this[_0x449091(0x1ef)]),0x1==this['\x63\x65\x6c\x6c\x73']['\x6c\x65\x6e\x67\x74\x68']){this['\x78']=_0x53ef30['\x78'];var _0x172401=this['\x69\x73\x4f\x72\x69\x67\x69\x6e\x4c\x65'+'\x66\x74']?_0x449091(0x4ad):_0x449091(0x425)+'\x74';this[_0x449091(0x365)+'\x6e']=_0x53ef30[_0x449091(0x42b)][_0x172401];}},_0x504899['\x75\x70\x64\x61\x74\x65\x54\x61\x72\x67'+'\x65\x74']=function(){var _0x9b97e1=_0x437d93,_0x30a2f1=this[_0x9b97e1(0x201)+'\x66\x74']?'\x6d\x61\x72\x67\x69\x6e\x52\x69\x67\x68'+'\x74':_0x9b97e1(0x4ad),_0x32aa8b=this[_0x9b97e1(0x4ab)+'\x6c'](),_0x20d4ff=_0x32aa8b?_0x32aa8b[_0x9b97e1(0x42b)][_0x30a2f1]:0x0,_0x36b426=this[_0x9b97e1(0x353)]-(this[_0x9b97e1(0x365)+'\x6e']+_0x20d4ff);this[_0x9b97e1(0x237)]=this['\x78']+this[_0x9b97e1(0x365)+'\x6e']+_0x36b426*this[_0x9b97e1(0x211)][_0x9b97e1(0x20f)];},_0x504899['\x67\x65\x74\x4c\x61\x73\x74\x43\x65\x6c'+'\x6c']=function(){var _0x2793c2=_0x437d93;return this[_0x2793c2(0x1ee)][this[_0x2793c2(0x1ee)][_0x2793c2(0x317)]-0x1];},_0x504899[_0x437d93(0x153)]=function(){var _0x305dc3=_0x437d93;this[_0x305dc3(0x1ee)][_0x305dc3(0x1b3)](function(_0xcc9487){_0xcc9487['\x73\x65\x6c\x65\x63\x74']();});},_0x504899[_0x437d93(0x287)]=function(){this['\x63\x65\x6c\x6c\x73']['\x66\x6f\x72\x45\x61\x63\x68'](function(_0x1692d4){_0x1692d4['\x75\x6e\x73\x65\x6c\x65\x63\x74']();});},_0x504899[_0x437d93(0x312)+_0x437d93(0x3fe)]=function(){var _0x432327=_0x437d93;return this[_0x432327(0x1ee)][_0x432327(0x472)](function(_0x1e3854){return _0x1e3854['\x65\x6c\x65\x6d\x65\x6e\x74'];});},_0x4c0f0d;}),function(_0x462880,_0x41e493){var _0x51977a=_0x46f77f;_0x51977a(0x2de)==typeof define&&define[_0x51977a(0x1eb)]?define(_0x51977a(0x3eb)+_0x51977a(0x49b),['\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75'+_0x51977a(0x2d1)],function(_0x4f7d19){return _0x41e493(_0x462880,_0x4f7d19);}):_0x51977a(0x28b)==typeof module&&module[_0x51977a(0x160)]?module[_0x51977a(0x160)]=_0x41e493(_0x462880,require(_0x51977a(0x1de)+'\x74\x69\x6c\x73')):(_0x462880[_0x51977a(0x25b)]=_0x462880[_0x51977a(0x25b)]||{},_0x462880[_0x51977a(0x25b)][_0x51977a(0x225)+_0x51977a(0x3f0)]=_0x41e493(_0x462880,_0x462880[_0x51977a(0x476)+'\x6c\x73']));}(window,function(_0x2f9d33,_0x4b5a69){var _0x410029={'\x73\x74\x61\x72\x74\x41\x6e\x69\x6d\x61\x74\x69\x6f\x6e':function(){var _0x43a08b=_0xda54;this[_0x43a08b(0x339)+'\x67']||(this[_0x43a08b(0x339)+'\x67']=!0x0,this['\x72\x65\x73\x74\x69\x6e\x67\x46\x72\x61'+'\x6d\x65\x73']=0x0,this[_0x43a08b(0x145)]());},'\x61\x6e\x69\x6d\x61\x74\x65':function(){var _0xe8c756=_0xda54;this['\x61\x70\x70\x6c\x79\x44\x72\x61\x67\x46'+'\x6f\x72\x63\x65'](),this[_0xe8c756(0x1c2)+'\x74\x65\x64\x41\x74\x74\x72\x61\x63\x74'+_0xe8c756(0x1d3)]();var _0xfc455c=this['\x78'];if(this[_0xe8c756(0x268)+_0xe8c756(0x25d)](),this[_0xe8c756(0x48a)+'\x69\x64\x65\x72'](),this[_0xe8c756(0x443)](_0xfc455c),this[_0xe8c756(0x339)+'\x67']){var _0x871d97=this;requestAnimationFrame(function(){_0x871d97['\x61\x6e\x69\x6d\x61\x74\x65']();});}},'\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c\x69\x64\x65\x72':function(){var _0x3b37af=_0xda54,_0x4ad375=this['\x78'];this[_0x3b37af(0x40b)]['\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64']&&this[_0x3b37af(0x1ee)][_0x3b37af(0x317)]>0x1&&(_0x4ad375=_0x4b5a69[_0x3b37af(0x3e9)](_0x4ad375,this[_0x3b37af(0x329)+'\x69\x64\x74\x68']),_0x4ad375-=this[_0x3b37af(0x329)+_0x3b37af(0x403)],this[_0x3b37af(0x214)+'\x65\x6c\x6c\x73'](_0x4ad375)),this[_0x3b37af(0x1f0)+_0x3b37af(0x398)](_0x4ad375,this[_0x3b37af(0x339)+'\x67']),this[_0x3b37af(0x274)+_0x3b37af(0x475)]();},'\x73\x65\x74\x54\x72\x61\x6e\x73\x6c\x61\x74\x65\x58':function(_0x54a8aa,_0x1c54a8){var _0x3dc353=_0xda54;_0x54a8aa+=this[_0x3dc353(0x2a8)+_0x3dc353(0x21b)],_0x54a8aa=this[_0x3dc353(0x40b)]['\x72\x69\x67\x68\x74\x54\x6f\x4c\x65\x66'+'\x74']?-_0x54a8aa:_0x54a8aa;var _0x2ccdeb=this['\x67\x65\x74\x50\x6f\x73\x69\x74\x69\x6f'+_0x3dc353(0x32c)](_0x54a8aa);this[_0x3dc353(0x3da)][_0x3dc353(0x435)]['\x74\x72\x61\x6e\x73\x66\x6f\x72\x6d']=_0x1c54a8?_0x3dc353(0x208)+'\x64\x28'+_0x2ccdeb+_0x3dc353(0x3a4):_0x3dc353(0x20c)+'\x28'+_0x2ccdeb+'\x29';},'\x64\x69\x73\x70\x61\x74\x63\x68\x53\x63\x72\x6f\x6c\x6c\x45\x76\x65\x6e\x74':function(){var _0x11f6b7=_0xda54,_0x5e149d=this['\x73\x6c\x69\x64\x65\x73'][0x0];if(_0x5e149d){var _0x564498=-this['\x78']-_0x5e149d['\x74\x61\x72\x67\x65\x74'],_0xba964c=_0x564498/this[_0x11f6b7(0x196)+'\x68'];this['\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76'+_0x11f6b7(0x29c)](_0x11f6b7(0x455),null,[_0xba964c,_0x564498]);}},'\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c\x69\x64\x65\x72\x41\x74\x53\x65\x6c\x65\x63\x74\x65\x64':function(){var _0x57d23e=_0xda54;this[_0x57d23e(0x1ee)][_0x57d23e(0x317)]&&(this['\x78']=-this['\x73\x65\x6c\x65\x63\x74\x65\x64\x53\x6c'+'\x69\x64\x65'][_0x57d23e(0x237)],this[_0x57d23e(0x2ca)]=0x0,this[_0x57d23e(0x48a)+_0x57d23e(0x1ea)]());},'\x67\x65\x74\x50\x6f\x73\x69\x74\x69\x6f\x6e\x56\x61\x6c\x75\x65':function(_0x53ed35){var _0x1cde83=_0xda54;return this[_0x1cde83(0x40b)][_0x1cde83(0x36e)+_0x1cde83(0x1a7)]?0.01*Math[_0x1cde83(0x247)](_0x53ed35/this[_0x1cde83(0x42b)]['\x69\x6e\x6e\x65\x72\x57\x69\x64\x74\x68']*0x2710)+'\x25':Math[_0x1cde83(0x247)](_0x53ed35)+'\x70\x78';},'\x73\x65\x74\x74\x6c\x65':function(_0x41e467){var _0x238c07=_0xda54;!this[_0x238c07(0x2df)+_0x238c07(0x275)]&&Math['\x72\x6f\x75\x6e\x64'](0x64*this['\x78'])==Math[_0x238c07(0x247)](0x64*_0x41e467)&&this[_0x238c07(0x1fb)+'\x6d\x65\x73']++,this[_0x238c07(0x1fb)+_0x238c07(0x3c4)]>0x2&&(this['\x69\x73\x41\x6e\x69\x6d\x61\x74\x69\x6e'+'\x67']=!0x1,delete this[_0x238c07(0x26e)+_0x238c07(0x3e6)],this['\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c'+'\x69\x64\x65\x72'](),this['\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76'+_0x238c07(0x29c)](_0x238c07(0x443),null,[this[_0x238c07(0x21c)+_0x238c07(0x17e)]]));},'\x73\x68\x69\x66\x74\x57\x72\x61\x70\x43\x65\x6c\x6c\x73':function(_0x48efcb){var _0x2743cd=_0xda54,_0x54ebca=this['\x63\x75\x72\x73\x6f\x72\x50\x6f\x73\x69'+_0x2743cd(0x21b)]+_0x48efcb;this[_0x2743cd(0x15b)+'\x73'](this['\x62\x65\x66\x6f\x72\x65\x53\x68\x69\x66'+_0x2743cd(0x494)],_0x54ebca,-0x1);var _0x481ab0=this['\x73\x69\x7a\x65'][_0x2743cd(0x294)]-(_0x48efcb+this[_0x2743cd(0x329)+_0x2743cd(0x403)]+this[_0x2743cd(0x2a8)+_0x2743cd(0x21b)]);this[_0x2743cd(0x15b)+'\x73'](this[_0x2743cd(0x298)+_0x2743cd(0x1c0)],_0x481ab0,0x1);},'\x5f\x73\x68\x69\x66\x74\x43\x65\x6c\x6c\x73':function(_0x5931c6,_0x1771cc,_0x18ba06){var _0x24219f=_0xda54;for(var _0x4cb140=0x0;_0x4cb140<_0x5931c6[_0x24219f(0x317)];_0x4cb140++){var _0x4dfff5=_0x5931c6[_0x4cb140],_0x4094a4=_0x1771cc>0x0?_0x18ba06:0x0;_0x4dfff5[_0x24219f(0x1b2)](_0x4094a4),_0x1771cc-=_0x4dfff5[_0x24219f(0x42b)][_0x24219f(0x353)];}},'\x5f\x75\x6e\x73\x68\x69\x66\x74\x43\x65\x6c\x6c\x73':function(_0x3a1127){var _0x4d87a2=_0xda54;if(_0x3a1127&&_0x3a1127[_0x4d87a2(0x317)])for(var _0x4943df=0x0;_0x4943df<_0x3a1127[_0x4d87a2(0x317)];_0x4943df++)_0x3a1127[_0x4943df][_0x4d87a2(0x1b2)](0x0);},'\x69\x6e\x74\x65\x67\x72\x61\x74\x65\x50\x68\x79\x73\x69\x63\x73':function(){var _0x5effc4=_0xda54;this['\x78']+=this[_0x5effc4(0x2ca)],this[_0x5effc4(0x2ca)]*=this[_0x5effc4(0x47a)+_0x5effc4(0x3b9)]();},'\x61\x70\x70\x6c\x79\x46\x6f\x72\x63\x65':function(_0x3ad532){var _0x47b700=_0xda54;this[_0x47b700(0x2ca)]+=_0x3ad532;},'\x67\x65\x74\x46\x72\x69\x63\x74\x69\x6f\x6e\x46\x61\x63\x74\x6f\x72':function(){var _0x57b523=_0xda54;return 0x1-this[_0x57b523(0x40b)][this['\x69\x73\x46\x72\x65\x65\x53\x63\x72\x6f'+_0x57b523(0x3e6)]?_0x57b523(0x146)+_0x57b523(0x288):_0x57b523(0x2f4)];},'\x67\x65\x74\x52\x65\x73\x74\x69\x6e\x67\x50\x6f\x73\x69\x74\x69\x6f\x6e':function(){var _0x4afc88=_0xda54;return this['\x78']+this[_0x4afc88(0x2ca)]/(0x1-this[_0x4afc88(0x47a)+_0x4afc88(0x3b9)]());},'\x61\x70\x70\x6c\x79\x44\x72\x61\x67\x46\x6f\x72\x63\x65':function(){var _0x5a740d=_0xda54;if(this[_0x5a740d(0x3cc)+'\x65']&&this[_0x5a740d(0x2df)+_0x5a740d(0x275)]){var _0x5c7ccb=this['\x64\x72\x61\x67\x58']-this['\x78']-this[_0x5a740d(0x2ca)];this[_0x5a740d(0x1ca)](_0x5c7ccb);}},'\x61\x70\x70\x6c\x79\x53\x65\x6c\x65\x63\x74\x65\x64\x41\x74\x74\x72\x61\x63\x74\x69\x6f\x6e':function(){var _0x2ae1c3=_0xda54;if(!(this['\x69\x73\x44\x72\x61\x67\x67\x61\x62\x6c'+'\x65']&&this[_0x2ae1c3(0x2df)+_0x2ae1c3(0x275)])&&!this['\x69\x73\x46\x72\x65\x65\x53\x63\x72\x6f'+_0x2ae1c3(0x3e6)]&&this['\x73\x6c\x69\x64\x65\x73'][_0x2ae1c3(0x317)]){var _0xe3dcb2=(-0x1*this[_0x2ae1c3(0x3a7)+_0x2ae1c3(0x313)]['\x74\x61\x72\x67\x65\x74']-this['\x78'])*this[_0x2ae1c3(0x40b)][_0x2ae1c3(0x41c)+_0x2ae1c3(0x33a)];this[_0x2ae1c3(0x1ca)](_0xe3dcb2);}}};return _0x410029;}),function(_0x4932fe,_0x3a3ad4){var _0x495eb=_0x46f77f;if('\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define['\x61\x6d\x64'])define(_0x495eb(0x3eb)+_0x495eb(0x286),[_0x495eb(0x405)+_0x495eb(0x256)+'\x72',_0x495eb(0x28e)+_0x495eb(0x446),_0x495eb(0x1de)+_0x495eb(0x2d1),'\x2e\x2f\x63\x65\x6c\x6c',_0x495eb(0x262),_0x495eb(0x143)],function(_0x51bc68,_0xc17d26,_0x46ba92,_0x506607,_0x542d3d,_0x46beec){return _0x3a3ad4(_0x4932fe,_0x51bc68,_0xc17d26,_0x46ba92,_0x506607,_0x542d3d,_0x46beec);});else{if(_0x495eb(0x28b)==typeof module&&module[_0x495eb(0x160)])module[_0x495eb(0x160)]=_0x3a3ad4(_0x4932fe,require(_0x495eb(0x405)),require('\x67\x65\x74\x2d\x73\x69\x7a\x65'),require('\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75'+_0x495eb(0x2fe)),require(_0x495eb(0x3ed)),require(_0x495eb(0x262)),require(_0x495eb(0x143)));else{var _0xe86caa=_0x4932fe[_0x495eb(0x25b)];_0x4932fe['\x46\x6c\x69\x63\x6b\x69\x74\x79']=_0x3a3ad4(_0x4932fe,_0x4932fe[_0x495eb(0x38d)],_0x4932fe[_0x495eb(0x156)],_0x4932fe['\x66\x69\x7a\x7a\x79\x55\x49\x55\x74\x69'+'\x6c\x73'],_0xe86caa[_0x495eb(0x433)],_0xe86caa[_0x495eb(0x1b8)],_0xe86caa[_0x495eb(0x225)+_0x495eb(0x3f0)]);}}}(window,function(_0x2617df,_0x37a241,_0x545f30,_0x2d8ce3,_0x51efbc,_0x4edd2c,_0x32bebf){var _0xad6b33=_0x46f77f,_0x1b05e6=_0x2617df[_0xad6b33(0x193)],_0x288787=_0x2617df[_0xad6b33(0x293)+'\x64\x53\x74\x79\x6c\x65'],_0x21f814=_0x2617df['\x63\x6f\x6e\x73\x6f\x6c\x65'];function _0x2a3252(_0x454436,_0x58e8c5){var _0x49988a=_0xad6b33;for(_0x454436=_0x2d8ce3[_0x49988a(0x382)](_0x454436);_0x454436['\x6c\x65\x6e\x67\x74\x68'];)_0x58e8c5[_0x49988a(0x3df)+'\x64'](_0x454436[_0x49988a(0x1e9)]());}var _0x4a0ade=0x0,_0xe70832={};function _0x196803(_0x21f827,_0x5da96f){var _0x130df8=_0xad6b33,_0x44dd43=_0x2d8ce3['\x67\x65\x74\x51\x75\x65\x72\x79\x45\x6c'+_0x130df8(0x3c8)](_0x21f827);if(_0x44dd43){if(this[_0x130df8(0x486)]=_0x44dd43,this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x130df8(0x2f9)+'\x49\x44']){var _0x32c5b1=_0xe70832[this[_0x130df8(0x486)][_0x130df8(0x2f9)+'\x49\x44']];return _0x32c5b1&&_0x32c5b1[_0x130df8(0x285)](_0x5da96f),_0x32c5b1;}_0x1b05e6&&(this[_0x130df8(0x321)]=_0x1b05e6(this[_0x130df8(0x486)])),this['\x6f\x70\x74\x69\x6f\x6e\x73']=_0x2d8ce3[_0x130df8(0x20d)]({},this[_0x130df8(0x31b)+'\x72'][_0x130df8(0x344)]),this[_0x130df8(0x285)](_0x5da96f),this[_0x130df8(0x155)]();}else _0x21f814&&_0x21f814[_0x130df8(0x411)](_0x130df8(0x416)+_0x130df8(0x337)+_0x130df8(0x173)+(_0x44dd43||_0x21f827));}_0x196803[_0xad6b33(0x344)]={'\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c\x69\x74\x79':!0x0,'\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e':_0xad6b33(0x2ec),'\x66\x72\x65\x65\x53\x63\x72\x6f\x6c\x6c\x46\x72\x69\x63\x74\x69\x6f\x6e':0.075,'\x66\x72\x69\x63\x74\x69\x6f\x6e':0.28,'\x6e\x61\x6d\x65\x73\x70\x61\x63\x65\x4a\x51\x75\x65\x72\x79\x45\x76\x65\x6e\x74\x73':!0x0,'\x70\x65\x72\x63\x65\x6e\x74\x50\x6f\x73\x69\x74\x69\x6f\x6e':!0x0,'\x72\x65\x73\x69\x7a\x65':!0x0,'\x73\x65\x6c\x65\x63\x74\x65\x64\x41\x74\x74\x72\x61\x63\x74\x69\x6f\x6e':0.025,'\x73\x65\x74\x47\x61\x6c\x6c\x65\x72\x79\x53\x69\x7a\x65':!0x0},_0x196803[_0xad6b33(0x421)+_0xad6b33(0x2f5)]=[];var _0x8bebc5=_0x196803[_0xad6b33(0x3c9)];_0x2d8ce3[_0xad6b33(0x20d)](_0x8bebc5,_0x37a241[_0xad6b33(0x3c9)]),_0x8bebc5[_0xad6b33(0x155)]=function(){var _0xd37b4e=_0xad6b33,_0x13c3f0=this[_0xd37b4e(0x19c)]=++_0x4a0ade;for(var _0xb047be in(this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0xd37b4e(0x2f9)+'\x49\x44']=_0x13c3f0,_0xe70832[_0x13c3f0]=this,this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+_0xd37b4e(0x17e)]=0x0,this[_0xd37b4e(0x1fb)+'\x6d\x65\x73']=0x0,this['\x78']=0x0,this[_0xd37b4e(0x2ca)]=0x0,this['\x6f\x72\x69\x67\x69\x6e\x53\x69\x64\x65']=this[_0xd37b4e(0x40b)][_0xd37b4e(0x246)+'\x74']?_0xd37b4e(0x434):_0xd37b4e(0x276),this[_0xd37b4e(0x1cb)]=document[_0xd37b4e(0x32a)+'\x65\x6e\x74'](_0xd37b4e(0x3c3)),this[_0xd37b4e(0x1cb)][_0xd37b4e(0x18e)]='\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x76'+_0xd37b4e(0x3f5),this[_0xd37b4e(0x206)+_0xd37b4e(0x43c)](),(this[_0xd37b4e(0x40b)][_0xd37b4e(0x2ab)]||this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0xd37b4e(0x19d)])&&_0x2617df[_0xd37b4e(0x1bb)+'\x73\x74\x65\x6e\x65\x72'](_0xd37b4e(0x2ab),this),this[_0xd37b4e(0x40b)]['\x6f\x6e'])){var _0x3ec656=this[_0xd37b4e(0x40b)]['\x6f\x6e'][_0xb047be];this['\x6f\x6e'](_0xb047be,_0x3ec656);}_0x196803['\x63\x72\x65\x61\x74\x65\x4d\x65\x74\x68'+'\x6f\x64\x73'][_0xd37b4e(0x1b3)](function(_0x53b219){this[_0x53b219]();},this),this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0xd37b4e(0x19d)]?this['\x77\x61\x74\x63\x68\x43\x53\x53']():this[_0xd37b4e(0x1dd)]();},_0x8bebc5[_0xad6b33(0x285)]=function(_0x5ac6e1){var _0xe37685=_0xad6b33;_0x2d8ce3[_0xe37685(0x20d)](this[_0xe37685(0x40b)],_0x5ac6e1);},_0x8bebc5[_0xad6b33(0x1dd)]=function(){var _0x180aa3=_0xad6b33;this[_0x180aa3(0x2b4)]||(this[_0x180aa3(0x2b4)]=!0x0,this[_0x180aa3(0x486)][_0x180aa3(0x2a0)][_0x180aa3(0x3fa)](_0x180aa3(0x30c)+_0x180aa3(0x15f)),this[_0x180aa3(0x40b)][_0x180aa3(0x246)+'\x74']&&this[_0x180aa3(0x486)][_0x180aa3(0x2a0)][_0x180aa3(0x3fa)](_0x180aa3(0x2ff)+'\x74\x6c'),this[_0x180aa3(0x156)](),_0x2a3252(this['\x5f\x66\x69\x6c\x74\x65\x72\x46\x69\x6e'+_0x180aa3(0x3e4)+'\x6e\x74\x73'](this[_0x180aa3(0x486)][_0x180aa3(0x379)]),this['\x73\x6c\x69\x64\x65\x72']),this[_0x180aa3(0x1cb)][_0x180aa3(0x3df)+'\x64'](this['\x73\x6c\x69\x64\x65\x72']),this[_0x180aa3(0x486)]['\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c'+'\x64'](this['\x76\x69\x65\x77\x70\x6f\x72\x74']),this[_0x180aa3(0x3c5)+'\x73'](),this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x180aa3(0x357)+_0x180aa3(0x23f)]&&(this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x180aa3(0x1ec)]=0x0,this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x180aa3(0x1bb)+'\x73\x74\x65\x6e\x65\x72'](_0x180aa3(0x46a),this)),this[_0x180aa3(0x279)]('\x61\x63\x74\x69\x76\x61\x74\x65'),this[_0x180aa3(0x4a3)+_0x180aa3(0x457)](),this[_0x180aa3(0x2bf)+_0x180aa3(0x157)]=!0x0,this['\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76'+_0x180aa3(0x29c)](_0x180aa3(0x3fb)));},_0x8bebc5[_0xad6b33(0x206)+_0xad6b33(0x43c)]=function(){var _0x34448c=_0xad6b33,_0x4a9f0a=document[_0x34448c(0x32a)+_0x34448c(0x29c)](_0x34448c(0x3c3));_0x4a9f0a[_0x34448c(0x18e)]=_0x34448c(0x1df)+_0x34448c(0x2f2),_0x4a9f0a[_0x34448c(0x435)][this['\x6f\x72\x69\x67\x69\x6e\x53\x69\x64\x65']]=0x0,this['\x73\x6c\x69\x64\x65\x72']=_0x4a9f0a;},_0x8bebc5['\x5f\x66\x69\x6c\x74\x65\x72\x46\x69\x6e'+'\x64\x43\x65\x6c\x6c\x45\x6c\x65\x6d\x65'+_0xad6b33(0x42c)]=function(_0x33196f){var _0x5417ca=_0xad6b33;return _0x2d8ce3[_0x5417ca(0x2d6)+'\x45\x6c\x65\x6d\x65\x6e\x74\x73'](_0x33196f,this[_0x5417ca(0x40b)][_0x5417ca(0x4ae)+'\x6f\x72']);},_0x8bebc5[_0xad6b33(0x3c5)+'\x73']=function(){var _0x2335f2=_0xad6b33;this[_0x2335f2(0x1ee)]=this[_0x2335f2(0x490)](this['\x73\x6c\x69\x64\x65\x72'][_0x2335f2(0x379)]),this[_0x2335f2(0x254)+_0x2335f2(0x3e8)](),this[_0x2335f2(0x29a)+_0x2335f2(0x2ea)](),this[_0x2335f2(0x45a)+_0x2335f2(0x16a)]();},_0x8bebc5[_0xad6b33(0x490)]=function(_0x1476d5){var _0x3c7213=_0xad6b33;return this['\x5f\x66\x69\x6c\x74\x65\x72\x46\x69\x6e'+_0x3c7213(0x3e4)+_0x3c7213(0x42c)](_0x1476d5)['\x6d\x61\x70'](function(_0x30d1a1){return new _0x51efbc(_0x30d1a1,this);},this);},_0x8bebc5['\x67\x65\x74\x4c\x61\x73\x74\x43\x65\x6c'+'\x6c']=function(){var _0x2e5b13=_0xad6b33;return this[_0x2e5b13(0x1ee)][this[_0x2e5b13(0x1ee)]['\x6c\x65\x6e\x67\x74\x68']-0x1];},_0x8bebc5[_0xad6b33(0x2cd)+'\x64\x65']=function(){var _0x28b4f8=_0xad6b33;return this['\x73\x6c\x69\x64\x65\x73'][this['\x73\x6c\x69\x64\x65\x73'][_0x28b4f8(0x317)]-0x1];},_0x8bebc5['\x70\x6f\x73\x69\x74\x69\x6f\x6e\x43\x65'+'\x6c\x6c\x73']=function(){var _0x2e7cac=_0xad6b33;this[_0x2e7cac(0x34e)](this[_0x2e7cac(0x1ee)]),this[_0x2e7cac(0x2cb)+_0x2e7cac(0x148)](0x0);},_0x8bebc5[_0xad6b33(0x2cb)+_0xad6b33(0x148)]=function(_0xe1f6cf){var _0x5263b4=_0xad6b33;_0xe1f6cf=_0xe1f6cf||0x0,this[_0x5263b4(0x242)+_0x5263b4(0x1d8)]=_0xe1f6cf&&this[_0x5263b4(0x242)+'\x67\x68\x74']||0x0;var _0x2555e9=0x0;if(_0xe1f6cf>0x0){var _0x5ee93c=this[_0x5263b4(0x1ee)][_0xe1f6cf-0x1];_0x2555e9=_0x5ee93c['\x78']+_0x5ee93c['\x73\x69\x7a\x65'][_0x5263b4(0x353)];}for(var _0x40c7f1=this[_0x5263b4(0x1ee)][_0x5263b4(0x317)],_0x5912ae=_0xe1f6cf;_0x5912ae<_0x40c7f1;_0x5912ae++){var _0x2918b6=this['\x63\x65\x6c\x6c\x73'][_0x5912ae];_0x2918b6['\x73\x65\x74\x50\x6f\x73\x69\x74\x69\x6f'+'\x6e'](_0x2555e9),_0x2555e9+=_0x2918b6[_0x5263b4(0x42b)]['\x6f\x75\x74\x65\x72\x57\x69\x64\x74\x68'],this[_0x5263b4(0x242)+_0x5263b4(0x1d8)]=Math[_0x5263b4(0x19b)](_0x2918b6['\x73\x69\x7a\x65'][_0x5263b4(0x461)+'\x74'],this[_0x5263b4(0x242)+_0x5263b4(0x1d8)]);}this['\x73\x6c\x69\x64\x65\x61\x62\x6c\x65\x57'+'\x69\x64\x74\x68']=_0x2555e9,this[_0x5263b4(0x419)+'\x65\x73'](),this[_0x5263b4(0x418)+_0x5263b4(0x326)](),this[_0x5263b4(0x196)+'\x68']=_0x40c7f1?this[_0x5263b4(0x2cd)+'\x64\x65']()[_0x5263b4(0x237)]-this[_0x5263b4(0x352)][0x0]['\x74\x61\x72\x67\x65\x74']:0x0;},_0x8bebc5[_0xad6b33(0x34e)]=function(_0x5f264a){var _0x400354=_0xad6b33;_0x5f264a[_0x400354(0x1b3)](function(_0x211296){var _0x12f49f=_0x400354;_0x211296[_0x12f49f(0x156)]();});},_0x8bebc5[_0xad6b33(0x419)+'\x65\x73']=function(){var _0x20ace1=_0xad6b33;if(this[_0x20ace1(0x352)]=[],this[_0x20ace1(0x1ee)][_0x20ace1(0x317)]){var _0x16b789=new _0x4edd2c(this);this[_0x20ace1(0x352)][_0x20ace1(0x23d)](_0x16b789);var _0x39adf5='\x6c\x65\x66\x74'==this[_0x20ace1(0x479)]?_0x20ace1(0x425)+'\x74':_0x20ace1(0x4ad),_0x1fa696=this['\x5f\x67\x65\x74\x43\x61\x6e\x43\x65\x6c'+'\x6c\x46\x69\x74']();this['\x63\x65\x6c\x6c\x73']['\x66\x6f\x72\x45\x61\x63\x68'](function(_0x5bc2ac,_0x89d43){var _0x504e80=_0x20ace1;if(_0x16b789[_0x504e80(0x1ee)][_0x504e80(0x317)]){var _0x47904d=_0x16b789['\x6f\x75\x74\x65\x72\x57\x69\x64\x74\x68']-_0x16b789[_0x504e80(0x365)+'\x6e']+(_0x5bc2ac[_0x504e80(0x42b)][_0x504e80(0x353)]-_0x5bc2ac['\x73\x69\x7a\x65'][_0x39adf5]);_0x1fa696[_0x504e80(0x359)](this,_0x89d43,_0x47904d)?_0x16b789['\x61\x64\x64\x43\x65\x6c\x6c'](_0x5bc2ac):(_0x16b789[_0x504e80(0x409)+'\x65\x74'](),_0x16b789=new _0x4edd2c(this),this[_0x504e80(0x352)][_0x504e80(0x23d)](_0x16b789),_0x16b789['\x61\x64\x64\x43\x65\x6c\x6c'](_0x5bc2ac));}else _0x16b789['\x61\x64\x64\x43\x65\x6c\x6c'](_0x5bc2ac);},this),_0x16b789['\x75\x70\x64\x61\x74\x65\x54\x61\x72\x67'+'\x65\x74'](),this[_0x20ace1(0x1c1)+'\x63\x74\x65\x64\x53\x6c\x69\x64\x65']();}},_0x8bebc5[_0xad6b33(0x25f)+_0xad6b33(0x35f)]=function(){var _0x2a125c=_0xad6b33,_0x25563b=this[_0x2a125c(0x40b)]['\x67\x72\x6f\x75\x70\x43\x65\x6c\x6c\x73'];if(!_0x25563b)return function(){return!0x1;};if(_0x2a125c(0x305)==typeof _0x25563b){var _0x4ffc13=parseInt(_0x25563b,0xa);return function(_0x4052c8){return _0x4052c8%_0x4ffc13!=0x0;};}var _0x47c0d6=_0x2a125c(0x44e)==typeof _0x25563b&&_0x25563b[_0x2a125c(0x315)](/^(\d+)%$/),_0x38ae59=_0x47c0d6?parseInt(_0x47c0d6[0x1],0xa)/0x64:0x1;return function(_0x4e524c,_0x2f5114){var _0x1fe9df=_0x2a125c;return _0x2f5114<=(this[_0x1fe9df(0x42b)][_0x1fe9df(0x294)]+0x1)*_0x38ae59;};},_0x8bebc5[_0xad6b33(0x36d)]=_0x8bebc5[_0xad6b33(0x3d2)]=function(){var _0x4a9703=_0xad6b33;this['\x70\x6f\x73\x69\x74\x69\x6f\x6e\x43\x65'+_0x4a9703(0x3e8)](),this['\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c'+_0x4a9703(0x239)+_0x4a9703(0x356)]();},_0x8bebc5[_0xad6b33(0x156)]=function(){var _0x4d0e32=_0xad6b33;this[_0x4d0e32(0x42b)]=_0x545f30(this[_0x4d0e32(0x486)]),this['\x73\x65\x74\x43\x65\x6c\x6c\x41\x6c\x69'+'\x67\x6e'](),this[_0x4d0e32(0x2a8)+_0x4d0e32(0x21b)]=this[_0x4d0e32(0x42b)][_0x4d0e32(0x294)]*this[_0x4d0e32(0x20f)];};var _0x56a426={'\x63\x65\x6e\x74\x65\x72':{'\x6c\x65\x66\x74':0.5,'\x72\x69\x67\x68\x74':0.5},'\x6c\x65\x66\x74':{'\x6c\x65\x66\x74':0x0,'\x72\x69\x67\x68\x74':0x1},'\x72\x69\x67\x68\x74':{'\x72\x69\x67\x68\x74':0x0,'\x6c\x65\x66\x74':0x1}};return _0x8bebc5[_0xad6b33(0x2e4)+'\x67\x6e']=function(){var _0x16883e=_0xad6b33,_0x3ea7c9=_0x56a426[this[_0x16883e(0x40b)][_0x16883e(0x20f)]];this[_0x16883e(0x20f)]=_0x3ea7c9?_0x3ea7c9[this[_0x16883e(0x479)]]:this[_0x16883e(0x40b)][_0x16883e(0x20f)];},_0x8bebc5[_0xad6b33(0x45a)+_0xad6b33(0x16a)]=function(){var _0x5715e7=_0xad6b33;if(this[_0x5715e7(0x40b)][_0x5715e7(0x45a)+'\x53\x69\x7a\x65']){var _0xd66c8a=this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x5715e7(0x20a)+_0x5715e7(0x202)]&&this[_0x5715e7(0x3a7)+'\x69\x64\x65']?this[_0x5715e7(0x3a7)+'\x69\x64\x65']['\x68\x65\x69\x67\x68\x74']:this['\x6d\x61\x78\x43\x65\x6c\x6c\x48\x65\x69'+_0x5715e7(0x1d8)];this[_0x5715e7(0x1cb)]['\x73\x74\x79\x6c\x65']['\x68\x65\x69\x67\x68\x74']=_0xd66c8a+'\x70\x78';}},_0x8bebc5[_0xad6b33(0x29a)+_0xad6b33(0x2ea)]=function(){var _0x250024=_0xad6b33;if(this[_0x250024(0x40b)][_0x250024(0x2c6)]){this[_0x250024(0x280)+_0x250024(0x3e8)](this[_0x250024(0x2c8)+'\x74\x43\x65\x6c\x6c\x73']),this[_0x250024(0x280)+_0x250024(0x3e8)](this[_0x250024(0x298)+_0x250024(0x1c0)]);var _0x100904=this[_0x250024(0x2a8)+_0x250024(0x21b)],_0x4cf7b7=this[_0x250024(0x1ee)][_0x250024(0x317)]-0x1;this[_0x250024(0x2c8)+_0x250024(0x494)]=this[_0x250024(0x187)+'\x6c\x73'](_0x100904,_0x4cf7b7,-0x1),_0x100904=this['\x73\x69\x7a\x65'][_0x250024(0x294)]-this[_0x250024(0x2a8)+_0x250024(0x21b)],this[_0x250024(0x298)+_0x250024(0x1c0)]=this[_0x250024(0x187)+'\x6c\x73'](_0x100904,0x0,0x1);}},_0x8bebc5[_0xad6b33(0x187)+'\x6c\x73']=function(_0x273c85,_0x553046,_0x1116c8){var _0x5bd64e=_0xad6b33;for(var _0x453a3d=[];_0x273c85>0x0;){var _0x346c0a=this[_0x5bd64e(0x1ee)][_0x553046];if(!_0x346c0a)break;_0x453a3d[_0x5bd64e(0x23d)](_0x346c0a),_0x553046+=_0x1116c8,_0x273c85-=_0x346c0a[_0x5bd64e(0x42b)][_0x5bd64e(0x353)];}return _0x453a3d;},_0x8bebc5[_0xad6b33(0x418)+_0xad6b33(0x326)]=function(){var _0x48153b=_0xad6b33;if(this[_0x48153b(0x40b)][_0x48153b(0x3f7)]&&!this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x48153b(0x2c6)]&&this['\x63\x65\x6c\x6c\x73'][_0x48153b(0x317)]){var _0x525a4d=this[_0x48153b(0x40b)][_0x48153b(0x246)+'\x74'],_0x2bd2a8=_0x525a4d?'\x6d\x61\x72\x67\x69\x6e\x52\x69\x67\x68'+'\x74':_0x48153b(0x4ad),_0xb737fc=_0x525a4d?'\x6d\x61\x72\x67\x69\x6e\x4c\x65\x66\x74':_0x48153b(0x425)+'\x74',_0x524697=this[_0x48153b(0x329)+_0x48153b(0x403)]-this[_0x48153b(0x4ab)+'\x6c']()[_0x48153b(0x42b)][_0xb737fc],_0x1e52a5=_0x524697<this[_0x48153b(0x42b)][_0x48153b(0x294)],_0x532474=this[_0x48153b(0x2a8)+'\x74\x69\x6f\x6e']+this[_0x48153b(0x1ee)][0x0][_0x48153b(0x42b)][_0x2bd2a8],_0x44191b=_0x524697-this[_0x48153b(0x42b)][_0x48153b(0x294)]*(0x1-this[_0x48153b(0x20f)]);this['\x73\x6c\x69\x64\x65\x73'][_0x48153b(0x1b3)](function(_0xc96e2a){var _0x116863=_0x48153b;_0x1e52a5?_0xc96e2a[_0x116863(0x237)]=_0x524697*this[_0x116863(0x20f)]:(_0xc96e2a[_0x116863(0x237)]=Math['\x6d\x61\x78'](_0xc96e2a[_0x116863(0x237)],_0x532474),_0xc96e2a[_0x116863(0x237)]=Math['\x6d\x69\x6e'](_0xc96e2a[_0x116863(0x237)],_0x44191b));},this);}},_0x8bebc5[_0xad6b33(0x2b8)+_0xad6b33(0x29c)]=function(_0x2101ea,_0x13ef7b,_0x3d6aff){var _0x37180e=_0xad6b33,_0xdaae30=_0x13ef7b?[_0x13ef7b][_0x37180e(0x429)](_0x3d6aff):_0x3d6aff;if(this[_0x37180e(0x279)](_0x2101ea,_0xdaae30),_0x1b05e6&&this[_0x37180e(0x321)]){var _0x119326=_0x2101ea+=this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x37180e(0x43b)+_0x37180e(0x199)+'\x73']?_0x37180e(0x390):'';if(_0x13ef7b){var _0x4e16f6=new _0x1b05e6[(_0x37180e(0x210))](_0x13ef7b);_0x4e16f6[_0x37180e(0x49e)]=_0x2101ea,_0x119326=_0x4e16f6;}this[_0x37180e(0x321)][_0x37180e(0x3b8)](_0x119326,_0x3d6aff);}},_0x8bebc5[_0xad6b33(0x153)]=function(_0x207b61,_0x5eca11,_0x59c152){var _0x5858fc=_0xad6b33;if(this['\x69\x73\x41\x63\x74\x69\x76\x65']&&(_0x207b61=parseInt(_0x207b61,0xa),this['\x5f\x77\x72\x61\x70\x53\x65\x6c\x65\x63'+'\x74'](_0x207b61),(this[_0x5858fc(0x40b)][_0x5858fc(0x2c6)]||_0x5eca11)&&(_0x207b61=_0x2d8ce3[_0x5858fc(0x3e9)](_0x207b61,this[_0x5858fc(0x352)][_0x5858fc(0x317)])),this['\x73\x6c\x69\x64\x65\x73'][_0x207b61])){var _0x42e8f1=this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+_0x5858fc(0x17e)];this[_0x5858fc(0x21c)+'\x64\x65\x78']=_0x207b61,this[_0x5858fc(0x1c1)+_0x5858fc(0x299)](),_0x59c152?this[_0x5858fc(0x48a)+_0x5858fc(0x239)+_0x5858fc(0x356)]():this[_0x5858fc(0x1f1)+'\x74\x69\x6f\x6e'](),this[_0x5858fc(0x40b)][_0x5858fc(0x20a)+_0x5858fc(0x202)]&&this[_0x5858fc(0x45a)+'\x53\x69\x7a\x65'](),this[_0x5858fc(0x2b8)+'\x65\x6e\x74'](_0x5858fc(0x153),null,[_0x207b61]),_0x207b61!=_0x42e8f1&&this[_0x5858fc(0x2b8)+'\x65\x6e\x74'](_0x5858fc(0x2e2),null,[_0x207b61]),this[_0x5858fc(0x2b8)+_0x5858fc(0x29c)](_0x5858fc(0x4ae));}},_0x8bebc5[_0xad6b33(0x1bf)+'\x74']=function(_0x48f103){var _0x10f816=_0xad6b33,_0x17ef41=this[_0x10f816(0x352)][_0x10f816(0x317)];if(!(this[_0x10f816(0x40b)][_0x10f816(0x2c6)]&&_0x17ef41>0x1))return _0x48f103;var _0x23608d=_0x2d8ce3['\x6d\x6f\x64\x75\x6c\x6f'](_0x48f103,_0x17ef41),_0x1a5e73=Math[_0x10f816(0x277)](_0x23608d-this[_0x10f816(0x21c)+_0x10f816(0x17e)]),_0x1be0f5=Math['\x61\x62\x73'](_0x23608d+_0x17ef41-this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+_0x10f816(0x17e)]),_0x571251=Math['\x61\x62\x73'](_0x23608d-_0x17ef41-this[_0x10f816(0x21c)+_0x10f816(0x17e)]);!this[_0x10f816(0x1ad)+'\x63\x74']&&_0x1be0f5<_0x1a5e73?_0x48f103+=_0x17ef41:!this[_0x10f816(0x1ad)+'\x63\x74']&&_0x571251<_0x1a5e73&&(_0x48f103-=_0x17ef41),_0x48f103<0x0?this['\x78']-=this[_0x10f816(0x329)+_0x10f816(0x403)]:_0x48f103>=_0x17ef41&&(this['\x78']+=this['\x73\x6c\x69\x64\x65\x61\x62\x6c\x65\x57'+'\x69\x64\x74\x68']);},_0x8bebc5[_0xad6b33(0x142)]=function(_0x1e7273,_0x5bac79){var _0x2056c6=_0xad6b33;this[_0x2056c6(0x153)](this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+'\x64\x65\x78']-0x1,_0x1e7273,_0x5bac79);},_0x8bebc5[_0xad6b33(0x3ba)]=function(_0x404227,_0x4d8454){var _0x53e4fd=_0xad6b33;this[_0x53e4fd(0x153)](this[_0x53e4fd(0x21c)+'\x64\x65\x78']+0x1,_0x404227,_0x4d8454);},_0x8bebc5[_0xad6b33(0x1c1)+_0xad6b33(0x299)]=function(){var _0x4ec3c0=_0xad6b33,_0x23f58d=this[_0x4ec3c0(0x352)][this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+_0x4ec3c0(0x17e)]];_0x23f58d&&(this[_0x4ec3c0(0x18c)+_0x4ec3c0(0x3d7)+'\x65'](),this[_0x4ec3c0(0x3a7)+'\x69\x64\x65']=_0x23f58d,_0x23f58d[_0x4ec3c0(0x153)](),this['\x73\x65\x6c\x65\x63\x74\x65\x64\x43\x65'+'\x6c\x6c\x73']=_0x23f58d[_0x4ec3c0(0x1ee)],this[_0x4ec3c0(0x212)+'\x65\x6d\x65\x6e\x74\x73']=_0x23f58d['\x67\x65\x74\x43\x65\x6c\x6c\x45\x6c\x65'+'\x6d\x65\x6e\x74\x73'](),this[_0x4ec3c0(0x2ba)+'\x6c\x6c']=_0x23f58d[_0x4ec3c0(0x1ee)][0x0],this[_0x4ec3c0(0x212)+'\x65\x6d\x65\x6e\x74']=this[_0x4ec3c0(0x212)+_0x4ec3c0(0x219)][0x0]);},_0x8bebc5[_0xad6b33(0x18c)+_0xad6b33(0x3d7)+'\x65']=function(){var _0xf9f8df=_0xad6b33;this[_0xf9f8df(0x3a7)+_0xf9f8df(0x313)]&&this[_0xf9f8df(0x3a7)+'\x69\x64\x65'][_0xf9f8df(0x287)]();},_0x8bebc5[_0xad6b33(0x4a3)+'\x69\x61\x6c\x49\x6e\x64\x65\x78']=function(){var _0x25de4a=_0xad6b33,_0x59cfa0=this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x25de4a(0x263)+'\x65\x78'];if(this[_0x25de4a(0x2bf)+'\x76\x61\x74\x65\x64'])this[_0x25de4a(0x153)](this[_0x25de4a(0x21c)+_0x25de4a(0x17e)],!0x1,!0x0);else{if(_0x59cfa0&&'\x73\x74\x72\x69\x6e\x67'==typeof _0x59cfa0){if(this[_0x25de4a(0x323)](_0x59cfa0))return void this[_0x25de4a(0x24d)](_0x59cfa0,!0x1,!0x0);}var _0x21e76f=0x0;_0x59cfa0&&this[_0x25de4a(0x352)][_0x59cfa0]&&(_0x21e76f=_0x59cfa0),this['\x73\x65\x6c\x65\x63\x74'](_0x21e76f,!0x1,!0x0);}},_0x8bebc5[_0xad6b33(0x24d)]=function(_0x145132,_0x8d9fec,_0x27b452){var _0x56ad24=_0xad6b33,_0x22f6fe=this[_0x56ad24(0x323)](_0x145132);if(_0x22f6fe){var _0x1e33f5=this[_0x56ad24(0x46d)+_0x56ad24(0x22d)](_0x22f6fe);this[_0x56ad24(0x153)](_0x1e33f5,_0x8d9fec,_0x27b452);}},_0x8bebc5[_0xad6b33(0x46d)+_0xad6b33(0x22d)]=function(_0x573066){var _0x425a9d=_0xad6b33;for(var _0x14b2c6=0x0;_0x14b2c6<this['\x73\x6c\x69\x64\x65\x73'][_0x425a9d(0x317)];_0x14b2c6++){if(-0x1!=this['\x73\x6c\x69\x64\x65\x73'][_0x14b2c6][_0x425a9d(0x1ee)][_0x425a9d(0x370)](_0x573066))return _0x14b2c6;}},_0x8bebc5[_0xad6b33(0x319)]=function(_0x3a93cd){var _0x40dafa=_0xad6b33;for(var _0x448d58=0x0;_0x448d58<this[_0x40dafa(0x1ee)][_0x40dafa(0x317)];_0x448d58++){var _0x39cbd1=this[_0x40dafa(0x1ee)][_0x448d58];if(_0x39cbd1[_0x40dafa(0x486)]==_0x3a93cd)return _0x39cbd1;}},_0x8bebc5[_0xad6b33(0x169)]=function(_0x15afe2){var _0x521c5e=_0xad6b33;_0x15afe2=_0x2d8ce3[_0x521c5e(0x382)](_0x15afe2);var _0x504505=[];return _0x15afe2[_0x521c5e(0x1b3)](function(_0x1888aa){var _0x428d29=_0x521c5e,_0x187d2d=this[_0x428d29(0x319)](_0x1888aa);_0x187d2d&&_0x504505[_0x428d29(0x23d)](_0x187d2d);},this),_0x504505;},_0x8bebc5[_0xad6b33(0x312)+_0xad6b33(0x3fe)]=function(){var _0x2da7f1=_0xad6b33;return this[_0x2da7f1(0x1ee)][_0x2da7f1(0x472)](function(_0x4e833a){var _0x712e21=_0x2da7f1;return _0x4e833a[_0x712e21(0x486)];});},_0x8bebc5[_0xad6b33(0x42d)+_0xad6b33(0x16d)]=function(_0xb04d1c){var _0x4ea91f=_0xad6b33,_0x27fd73=this[_0x4ea91f(0x319)](_0xb04d1c);return _0x27fd73||(_0xb04d1c=_0x2d8ce3[_0x4ea91f(0x343)](_0xb04d1c,_0x4ea91f(0x182)+_0x4ea91f(0x1d4)),this['\x67\x65\x74\x43\x65\x6c\x6c'](_0xb04d1c));},_0x8bebc5[_0xad6b33(0x1a9)+_0xad6b33(0x18f)+'\x6e\x74\x73']=function(_0x503324,_0xa46854){var _0x83a1e2=_0xad6b33;if(!_0x503324)return this[_0x83a1e2(0x3a7)+'\x69\x64\x65'][_0x83a1e2(0x312)+'\x6d\x65\x6e\x74\x73']();_0xa46854=void 0x0===_0xa46854?this[_0x83a1e2(0x21c)+_0x83a1e2(0x17e)]:_0xa46854;var _0x256374=this['\x73\x6c\x69\x64\x65\x73'][_0x83a1e2(0x317)];if(0x1+0x2*_0x503324>=_0x256374)return this[_0x83a1e2(0x312)+_0x83a1e2(0x3fe)]();for(var _0x226f3e=[],_0x57c742=_0xa46854-_0x503324;_0x57c742<=_0xa46854+_0x503324;_0x57c742++){var _0x4e9d01=this[_0x83a1e2(0x40b)]['\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64']?_0x2d8ce3[_0x83a1e2(0x3e9)](_0x57c742,_0x256374):_0x57c742,_0x371497=this[_0x83a1e2(0x352)][_0x4e9d01];_0x371497&&(_0x226f3e=_0x226f3e[_0x83a1e2(0x429)](_0x371497['\x67\x65\x74\x43\x65\x6c\x6c\x45\x6c\x65'+_0x83a1e2(0x3fe)]()));}return _0x226f3e;},_0x8bebc5[_0xad6b33(0x323)]=function(_0x43cdb6){var _0x33968e=_0xad6b33;if('\x6e\x75\x6d\x62\x65\x72'==typeof _0x43cdb6)return this[_0x33968e(0x1ee)][_0x43cdb6];if('\x73\x74\x72\x69\x6e\x67'==typeof _0x43cdb6){if(_0x43cdb6[_0x33968e(0x315)](/^[#.]?[\d/]/))return;_0x43cdb6=this[_0x33968e(0x486)][_0x33968e(0x307)+_0x33968e(0x2e9)](_0x43cdb6);}return this[_0x33968e(0x319)](_0x43cdb6);},_0x8bebc5[_0xad6b33(0x32e)]=function(){var _0x8a8778=_0xad6b33;this[_0x8a8778(0x279)](_0x8a8778(0x32e));},_0x8bebc5['\x63\x68\x69\x6c\x64\x55\x49\x50\x6f\x69'+_0xad6b33(0x1e8)]=function(_0x174525){var _0x38557d=_0xad6b33;_0x38557d(0x374)!=_0x174525[_0x38557d(0x49e)]&&_0x174525[_0x38557d(0x347)+_0x38557d(0x3be)](),this['\x66\x6f\x63\x75\x73']();},_0x8bebc5[_0xad6b33(0x22f)]=function(){var _0x40ee00=_0xad6b33;this[_0x40ee00(0x19d)](),this['\x72\x65\x73\x69\x7a\x65']();},_0x2d8ce3[_0xad6b33(0x203)+'\x74\x68\x6f\x64'](_0x196803,_0xad6b33(0x22f),0x96),_0x8bebc5['\x72\x65\x73\x69\x7a\x65']=function(){var _0xb6388e=_0xad6b33;if(this[_0xb6388e(0x2b4)]){this[_0xb6388e(0x156)](),this[_0xb6388e(0x40b)][_0xb6388e(0x2c6)]&&(this['\x78']=_0x2d8ce3['\x6d\x6f\x64\x75\x6c\x6f'](this['\x78'],this[_0xb6388e(0x329)+_0xb6388e(0x403)])),this[_0xb6388e(0x254)+_0xb6388e(0x3e8)](),this[_0xb6388e(0x29a)+_0xb6388e(0x2ea)](),this['\x73\x65\x74\x47\x61\x6c\x6c\x65\x72\x79'+_0xb6388e(0x16a)](),this['\x65\x6d\x69\x74\x45\x76\x65\x6e\x74']('\x72\x65\x73\x69\x7a\x65');var _0xeb5af=this[_0xb6388e(0x212)+_0xb6388e(0x219)]&&this[_0xb6388e(0x212)+'\x65\x6d\x65\x6e\x74\x73'][0x0];this[_0xb6388e(0x24d)](_0xeb5af,!0x1,!0x0);}},_0x8bebc5[_0xad6b33(0x19d)]=function(){var _0xb8eb30=_0xad6b33;this[_0xb8eb30(0x40b)][_0xb8eb30(0x19d)]&&(-0x1!=_0x288787(this[_0xb8eb30(0x486)],'\x3a\x61\x66\x74\x65\x72')[_0xb8eb30(0x1b5)]['\x69\x6e\x64\x65\x78\x4f\x66'](_0xb8eb30(0x2ed))?this['\x61\x63\x74\x69\x76\x61\x74\x65']():this['\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65']());},_0x8bebc5['\x6f\x6e\x6b\x65\x79\x64\x6f\x77\x6e']=function(_0x3ab2db){var _0x273657=_0xad6b33,_0x49f196=document[_0x273657(0x46f)+'\x65\x6e\x74']&&document[_0x273657(0x46f)+'\x65\x6e\x74']!=this[_0x273657(0x486)];if(this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x273657(0x357)+_0x273657(0x23f)]&&!_0x49f196){var _0xdc396b=_0x196803[_0x273657(0x290)+_0x273657(0x3a6)][_0x3ab2db['\x6b\x65\x79\x43\x6f\x64\x65']];_0xdc396b&&_0xdc396b[_0x273657(0x359)](this);}},_0x196803[_0xad6b33(0x290)+_0xad6b33(0x3a6)]={0x25:function(){var _0x290271=_0xad6b33,_0x52fa62=this['\x6f\x70\x74\x69\x6f\x6e\x73']['\x72\x69\x67\x68\x74\x54\x6f\x4c\x65\x66'+'\x74']?_0x290271(0x3ba):_0x290271(0x142);this[_0x290271(0x32e)](),this[_0x52fa62]();},0x27:function(){var _0x5044d0=_0xad6b33,_0x4b02e5=this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x5044d0(0x246)+'\x74']?_0x5044d0(0x142):'\x6e\x65\x78\x74';this[_0x5044d0(0x32e)](),this[_0x4b02e5]();}},_0x8bebc5['\x66\x6f\x63\x75\x73']=function(){var _0x17ccd6=_0xad6b33,_0xe93869=_0x2617df[_0x17ccd6(0x3d1)+'\x74'];this[_0x17ccd6(0x486)][_0x17ccd6(0x284)]({'\x70\x72\x65\x76\x65\x6e\x74\x53\x63\x72\x6f\x6c\x6c':!0x0}),_0x2617df[_0x17ccd6(0x3d1)+'\x74']!=_0xe93869&&_0x2617df['\x73\x63\x72\x6f\x6c\x6c\x54\x6f'](_0x2617df[_0x17ccd6(0x244)+'\x74'],_0xe93869);},_0x8bebc5[_0xad6b33(0x2b9)]=function(){var _0x103af6=_0xad6b33;this[_0x103af6(0x2b4)]&&(this[_0x103af6(0x486)][_0x103af6(0x2a0)]['\x72\x65\x6d\x6f\x76\x65']('\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x65'+_0x103af6(0x15f)),this[_0x103af6(0x486)]['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x103af6(0x417)](_0x103af6(0x2ff)+'\x74\x6c'),this[_0x103af6(0x18c)+_0x103af6(0x3d7)+'\x65'](),this[_0x103af6(0x1ee)][_0x103af6(0x1b3)](function(_0xf109de){var _0x310e0f=_0x103af6;_0xf109de[_0x310e0f(0x151)]();}),this[_0x103af6(0x486)]['\x72\x65\x6d\x6f\x76\x65\x43\x68\x69\x6c'+'\x64'](this[_0x103af6(0x1cb)]),_0x2a3252(this[_0x103af6(0x3da)][_0x103af6(0x379)],this[_0x103af6(0x486)]),this[_0x103af6(0x40b)][_0x103af6(0x357)+_0x103af6(0x23f)]&&(this[_0x103af6(0x486)][_0x103af6(0x463)+_0x103af6(0x16b)](_0x103af6(0x1ec)),this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x103af6(0x226)+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72']('\x6b\x65\x79\x64\x6f\x77\x6e',this)),this[_0x103af6(0x2b4)]=!0x1,this[_0x103af6(0x279)]('\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65'));},_0x8bebc5[_0xad6b33(0x151)]=function(){var _0x2d66ae=_0xad6b33;this[_0x2d66ae(0x2b9)](),_0x2617df[_0x2d66ae(0x226)+_0x2d66ae(0x2e3)](_0x2d66ae(0x2ab),this),this['\x61\x6c\x6c\x4f\x66\x66'](),this[_0x2d66ae(0x279)]('\x64\x65\x73\x74\x72\x6f\x79'),_0x1b05e6&&this['\x24\x65\x6c\x65\x6d\x65\x6e\x74']&&_0x1b05e6[_0x2d66ae(0x48e)](this['\x65\x6c\x65\x6d\x65\x6e\x74'],_0x2d66ae(0x2ed)),delete this[_0x2d66ae(0x486)][_0x2d66ae(0x2f9)+'\x49\x44'],delete _0xe70832[this['\x67\x75\x69\x64']];},_0x2d8ce3[_0xad6b33(0x20d)](_0x8bebc5,_0x32bebf),_0x196803[_0xad6b33(0x1d2)]=function(_0xa0cf8c){var _0x653aa7=_0xad6b33,_0x2e0189=(_0xa0cf8c=_0x2d8ce3['\x67\x65\x74\x51\x75\x65\x72\x79\x45\x6c'+'\x65\x6d\x65\x6e\x74'](_0xa0cf8c))&&_0xa0cf8c[_0x653aa7(0x2f9)+'\x49\x44'];return _0x2e0189&&_0xe70832[_0x2e0189];},_0x2d8ce3[_0xad6b33(0x3a9)](_0x196803,_0xad6b33(0x2ed)),_0x1b05e6&&_0x1b05e6['\x62\x72\x69\x64\x67\x65\x74']&&_0x1b05e6['\x62\x72\x69\x64\x67\x65\x74']('\x66\x6c\x69\x63\x6b\x69\x74\x79',_0x196803),_0x196803[_0xad6b33(0x39b)]=function(_0x677b26){_0x1b05e6=_0x677b26;},_0x196803[_0xad6b33(0x433)]=_0x51efbc,_0x196803[_0xad6b33(0x1b8)]=_0x4edd2c,_0x196803;}),function(_0x15b763,_0x316360){var _0x3242e2=_0x46f77f;'\x66\x75\x6e\x63\x74\x69\x6f\x6e'==typeof define&&define[_0x3242e2(0x1eb)]?define(_0x3242e2(0x1f8)+_0x3242e2(0x442)+'\x72',[_0x3242e2(0x405)+_0x3242e2(0x256)+'\x72'],function(_0x4fc68d){return _0x316360(_0x15b763,_0x4fc68d);}):_0x3242e2(0x28b)==typeof module&&module[_0x3242e2(0x160)]?module[_0x3242e2(0x160)]=_0x316360(_0x15b763,require(_0x3242e2(0x405))):_0x15b763[_0x3242e2(0x3b2)]=_0x316360(_0x15b763,_0x15b763[_0x3242e2(0x38d)]);}(window,function(_0x121c7a,_0x1925e7){var _0x1aec8b=_0x46f77f;function _0x5966b4(){}var _0x46b4fe=_0x5966b4[_0x1aec8b(0x3c9)]=Object[_0x1aec8b(0x1cd)](_0x1925e7[_0x1aec8b(0x3c9)]);_0x46b4fe['\x62\x69\x6e\x64\x53\x74\x61\x72\x74\x45'+_0x1aec8b(0x2c7)]=function(_0x5eed62){var _0x261e48=_0x1aec8b;this[_0x261e48(0x31a)+_0x261e48(0x210)](_0x5eed62,!0x0);},_0x46b4fe[_0x1aec8b(0x464)+_0x1aec8b(0x35a)]=function(_0xca9503){var _0x3078ed=_0x1aec8b;this[_0x3078ed(0x31a)+_0x3078ed(0x210)](_0xca9503,!0x1);},_0x46b4fe[_0x1aec8b(0x31a)+_0x1aec8b(0x210)]=function(_0x2ad445,_0x4ab1b3){var _0x5d2899=_0x1aec8b,_0x499b9c=(_0x4ab1b3=void 0x0===_0x4ab1b3||_0x4ab1b3)?_0x5d2899(0x1bb)+_0x5d2899(0x333):_0x5d2899(0x226)+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72',_0x1f7541=_0x5d2899(0x378);_0x121c7a['\x50\x6f\x69\x6e\x74\x65\x72\x45\x76\x65'+'\x6e\x74']?_0x1f7541=_0x5d2899(0x43d)+'\x6e':_0x5d2899(0x1d9)+'\x72\x74'in _0x121c7a&&(_0x1f7541=_0x5d2899(0x374)),_0x2ad445[_0x499b9c](_0x1f7541,this);},_0x46b4fe[_0x1aec8b(0x1ab)+'\x74']=function(_0x406972){var _0x11ea02='\x6f\x6e'+_0x406972['\x74\x79\x70\x65'];this[_0x11ea02]&&this[_0x11ea02](_0x406972);},_0x46b4fe[_0x1aec8b(0x447)]=function(_0x2b2cb6){var _0x11fd04=_0x1aec8b;for(var _0x4c9aee=0x0;_0x4c9aee<_0x2b2cb6['\x6c\x65\x6e\x67\x74\x68'];_0x4c9aee++){var _0x1f9317=_0x2b2cb6[_0x4c9aee];if(_0x1f9317[_0x11fd04(0x3bd)]==this[_0x11fd04(0x373)+'\x6e\x74\x69\x66\x69\x65\x72'])return _0x1f9317;}},_0x46b4fe[_0x1aec8b(0x1cc)+'\x6e']=function(_0x3541cd){var _0x299a4a=_0x1aec8b,_0x24439c=_0x3541cd[_0x299a4a(0x44b)];_0x24439c&&0x0!==_0x24439c&&0x1!==_0x24439c||this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f'+'\x77\x6e'](_0x3541cd,_0x3541cd);},_0x46b4fe[_0x1aec8b(0x1d9)+'\x72\x74']=function(_0x11cfdc){var _0x204861=_0x1aec8b;this[_0x204861(0x14f)+'\x77\x6e'](_0x11cfdc,_0x11cfdc[_0x204861(0x1a5)+'\x63\x68\x65\x73'][0x0]);},_0x46b4fe[_0x1aec8b(0x369)+'\x6f\x77\x6e']=function(_0x58b908){var _0x45f02c=_0x1aec8b;this[_0x45f02c(0x14f)+'\x77\x6e'](_0x58b908,_0x58b908);},_0x46b4fe['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f'+'\x77\x6e']=function(_0x5a31b9,_0x2505fd){var _0xb91fc2=_0x1aec8b;_0x5a31b9[_0xb91fc2(0x44b)]||this['\x69\x73\x50\x6f\x69\x6e\x74\x65\x72\x44'+_0xb91fc2(0x275)]||(this[_0xb91fc2(0x2df)+_0xb91fc2(0x275)]=!0x0,this[_0xb91fc2(0x373)+'\x6e\x74\x69\x66\x69\x65\x72']=void 0x0!==_0x2505fd['\x70\x6f\x69\x6e\x74\x65\x72\x49\x64']?_0x2505fd[_0xb91fc2(0x2c3)]:_0x2505fd['\x69\x64\x65\x6e\x74\x69\x66\x69\x65\x72'],this['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e'](_0x5a31b9,_0x2505fd));},_0x46b4fe[_0x1aec8b(0x144)+'\x6e']=function(_0x175945,_0x20600c){var _0x1b3242=_0x1aec8b;this[_0x1b3242(0x147)+_0x1b3242(0x2c9)](_0x175945),this[_0x1b3242(0x279)]('\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e',[_0x175945,_0x20600c]);};var _0x15df14={'\x6d\x6f\x75\x73\x65\x64\x6f\x77\x6e':[_0x1aec8b(0x31e),_0x1aec8b(0x330)],'\x74\x6f\x75\x63\x68\x73\x74\x61\x72\x74':[_0x1aec8b(0x227),_0x1aec8b(0x394),_0x1aec8b(0x488)+'\x6c'],'\x70\x6f\x69\x6e\x74\x65\x72\x64\x6f\x77\x6e':['\x70\x6f\x69\x6e\x74\x65\x72\x6d\x6f\x76'+'\x65',_0x1aec8b(0x3ec),_0x1aec8b(0x496)+_0x1aec8b(0x2a2)]};return _0x46b4fe[_0x1aec8b(0x147)+'\x74\x61\x72\x74\x45\x76\x65\x6e\x74\x73']=function(_0xee8d45){var _0x52667b=_0x1aec8b;if(_0xee8d45){var _0x2ebc9b=_0x15df14[_0xee8d45['\x74\x79\x70\x65']];_0x2ebc9b['\x66\x6f\x72\x45\x61\x63\x68'](function(_0x3f28be){var _0x15fe1b=_0xda54;_0x121c7a[_0x15fe1b(0x1bb)+'\x73\x74\x65\x6e\x65\x72'](_0x3f28be,this);},this),this[_0x52667b(0x1ba)+_0x52667b(0x1d6)]=_0x2ebc9b;}},_0x46b4fe[_0x1aec8b(0x354)+_0x1aec8b(0x327)+'\x74\x73']=function(){var _0x308db0=_0x1aec8b;this[_0x308db0(0x1ba)+'\x74\x65\x72\x45\x76\x65\x6e\x74\x73']&&(this['\x5f\x62\x6f\x75\x6e\x64\x50\x6f\x69\x6e'+'\x74\x65\x72\x45\x76\x65\x6e\x74\x73']['\x66\x6f\x72\x45\x61\x63\x68'](function(_0x513d2a){var _0x71d47c=_0x308db0;_0x121c7a[_0x71d47c(0x226)+_0x71d47c(0x2e3)](_0x513d2a,this);},this),delete this[_0x308db0(0x1ba)+'\x74\x65\x72\x45\x76\x65\x6e\x74\x73']);},_0x46b4fe['\x6f\x6e\x6d\x6f\x75\x73\x65\x6d\x6f\x76'+'\x65']=function(_0x354260){var _0xcc5c17=_0x1aec8b;this[_0xcc5c17(0x2dc)+'\x76\x65'](_0x354260,_0x354260);},_0x46b4fe['\x6f\x6e\x70\x6f\x69\x6e\x74\x65\x72\x6d'+'\x6f\x76\x65']=function(_0x5c38a8){var _0x50ee1a=_0x1aec8b;_0x5c38a8[_0x50ee1a(0x2c3)]==this[_0x50ee1a(0x373)+_0x50ee1a(0x431)]&&this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x4d\x6f'+'\x76\x65'](_0x5c38a8,_0x5c38a8);},_0x46b4fe[_0x1aec8b(0x1c3)+'\x65']=function(_0x59954d){var _0x93faf3=_0x1aec8b,_0x59052c=this[_0x93faf3(0x447)](_0x59954d['\x63\x68\x61\x6e\x67\x65\x64\x54\x6f\x75'+'\x63\x68\x65\x73']);_0x59052c&&this[_0x93faf3(0x2dc)+'\x76\x65'](_0x59954d,_0x59052c);},_0x46b4fe[_0x1aec8b(0x2dc)+'\x76\x65']=function(_0x2c470d,_0x493b9e){this['\x70\x6f\x69\x6e\x74\x65\x72\x4d\x6f\x76'+'\x65'](_0x2c470d,_0x493b9e);},_0x46b4fe[_0x1aec8b(0x42e)+'\x65']=function(_0x41d866,_0xad261f){var _0x4d5901=_0x1aec8b;this[_0x4d5901(0x279)](_0x4d5901(0x42e)+'\x65',[_0x41d866,_0xad261f]);},_0x46b4fe['\x6f\x6e\x6d\x6f\x75\x73\x65\x75\x70']=function(_0x24d773){var _0x4f0f6c=_0x1aec8b;this[_0x4f0f6c(0x2a1)](_0x24d773,_0x24d773);},_0x46b4fe[_0x1aec8b(0x197)+'\x70']=function(_0x12fd7d){var _0x1f0714=_0x1aec8b;_0x12fd7d[_0x1f0714(0x2c3)]==this[_0x1f0714(0x373)+_0x1f0714(0x431)]&&this[_0x1f0714(0x2a1)](_0x12fd7d,_0x12fd7d);},_0x46b4fe[_0x1aec8b(0x30f)]=function(_0x542fef){var _0x1344fe=_0x1aec8b,_0x497334=this[_0x1344fe(0x447)](_0x542fef['\x63\x68\x61\x6e\x67\x65\x64\x54\x6f\x75'+'\x63\x68\x65\x73']);_0x497334&&this[_0x1344fe(0x2a1)](_0x542fef,_0x497334);},_0x46b4fe[_0x1aec8b(0x2a1)]=function(_0x29559f,_0x438630){var _0x28bbdf=_0x1aec8b;this[_0x28bbdf(0x14f)+'\x6e\x65'](),this['\x70\x6f\x69\x6e\x74\x65\x72\x55\x70'](_0x29559f,_0x438630);},_0x46b4fe[_0x1aec8b(0x158)]=function(_0x3d3c26,_0x4d84e7){var _0x4548eb=_0x1aec8b;this[_0x4548eb(0x279)](_0x4548eb(0x158),[_0x3d3c26,_0x4d84e7]);},_0x46b4fe[_0x1aec8b(0x14f)+'\x6e\x65']=function(){var _0x3ef532=_0x1aec8b;this[_0x3ef532(0x36a)+_0x3ef532(0x454)](),this[_0x3ef532(0x354)+_0x3ef532(0x327)+'\x74\x73'](),this['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x6e'+'\x65']();},_0x46b4fe[_0x1aec8b(0x36a)+'\x73\x65\x74']=function(){var _0x353feb=_0x1aec8b;this['\x69\x73\x50\x6f\x69\x6e\x74\x65\x72\x44'+_0x353feb(0x275)]=!0x1,delete this[_0x353feb(0x373)+'\x6e\x74\x69\x66\x69\x65\x72'];},_0x46b4fe[_0x1aec8b(0x1d0)+'\x65']=function(){},_0x46b4fe[_0x1aec8b(0x261)+_0x1aec8b(0x234)]=function(_0x31759f){var _0x5bdcba=_0x1aec8b;_0x31759f[_0x5bdcba(0x2c3)]==this[_0x5bdcba(0x373)+_0x5bdcba(0x431)]&&this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x43\x61'+'\x6e\x63\x65\x6c'](_0x31759f,_0x31759f);},_0x46b4fe['\x6f\x6e\x74\x6f\x75\x63\x68\x63\x61\x6e'+_0x1aec8b(0x2a2)]=function(_0x37492d){var _0x6a2b31=_0x1aec8b,_0x8180af=this[_0x6a2b31(0x447)](_0x37492d[_0x6a2b31(0x1a5)+_0x6a2b31(0x410)]);_0x8180af&&this[_0x6a2b31(0x4a8)+_0x6a2b31(0x38b)](_0x37492d,_0x8180af);},_0x46b4fe[_0x1aec8b(0x4a8)+_0x1aec8b(0x38b)]=function(_0x35d0f0,_0x71d6cb){var _0x392e2d=_0x1aec8b;this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f'+'\x6e\x65'](),this[_0x392e2d(0x3d4)+'\x63\x65\x6c'](_0x35d0f0,_0x71d6cb);},_0x46b4fe[_0x1aec8b(0x3d4)+_0x1aec8b(0x2a2)]=function(_0x1e8275,_0x430396){var _0x412db4=_0x1aec8b;this[_0x412db4(0x279)](_0x412db4(0x3d4)+_0x412db4(0x2a2),[_0x1e8275,_0x430396]);},_0x5966b4[_0x1aec8b(0x33c)+'\x50\x6f\x69\x6e\x74']=function(_0x4bc7ff){var _0x2af2f7=_0x1aec8b;return{'\x78':_0x4bc7ff[_0x2af2f7(0x252)],'\x79':_0x4bc7ff[_0x2af2f7(0x248)]};},_0x5966b4;}),function(_0x47d589,_0x2c08ca){var _0x5ebf3b=_0x46f77f;_0x5ebf3b(0x2de)==typeof define&&define['\x61\x6d\x64']?define(_0x5ebf3b(0x426)+_0x5ebf3b(0x194)+'\x72',[_0x5ebf3b(0x1f8)+_0x5ebf3b(0x442)+'\x72'],function(_0x3ed6eb){return _0x2c08ca(_0x47d589,_0x3ed6eb);}):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x5ebf3b(0x160)]?module[_0x5ebf3b(0x160)]=_0x2c08ca(_0x47d589,require('\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72')):_0x47d589[_0x5ebf3b(0x281)]=_0x2c08ca(_0x47d589,_0x47d589[_0x5ebf3b(0x3b2)]);}(window,function(_0x2f4d0e,_0x21cda4){var _0x47f9be=_0x46f77f;function _0x22b123(){}var _0x5d6a34=_0x22b123[_0x47f9be(0x3c9)]=Object[_0x47f9be(0x1cd)](_0x21cda4['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']);_0x5d6a34['\x62\x69\x6e\x64\x48\x61\x6e\x64\x6c\x65'+'\x73']=function(){var _0x7c4dfb=_0x47f9be;this[_0x7c4dfb(0x342)+'\x65\x73'](!0x0);},_0x5d6a34[_0x47f9be(0x363)+'\x6c\x65\x73']=function(){var _0x415a34=_0x47f9be;this[_0x415a34(0x342)+'\x65\x73'](!0x1);},_0x5d6a34['\x5f\x62\x69\x6e\x64\x48\x61\x6e\x64\x6c'+'\x65\x73']=function(_0x3ab95b){var _0x49a393=_0x47f9be;for(var _0x24a737=(_0x3ab95b=void 0x0===_0x3ab95b||_0x3ab95b)?_0x49a393(0x1bb)+'\x73\x74\x65\x6e\x65\x72':_0x49a393(0x226)+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72',_0x471d68=_0x3ab95b?this[_0x49a393(0x423)+_0x49a393(0x38c)]:'',_0x5e29a6=0x0;_0x5e29a6<this['\x68\x61\x6e\x64\x6c\x65\x73'][_0x49a393(0x317)];_0x5e29a6++){var _0x2463a7=this[_0x49a393(0x458)][_0x5e29a6];this[_0x49a393(0x31a)+_0x49a393(0x210)](_0x2463a7,_0x3ab95b),_0x2463a7[_0x24a737]('\x63\x6c\x69\x63\x6b',this),_0x2f4d0e[_0x49a393(0x23b)+'\x6e\x74']&&(_0x2463a7[_0x49a393(0x435)]['\x74\x6f\x75\x63\x68\x41\x63\x74\x69\x6f'+'\x6e']=_0x471d68);}},_0x5d6a34['\x5f\x74\x6f\x75\x63\x68\x41\x63\x74\x69'+'\x6f\x6e\x56\x61\x6c\x75\x65']=_0x47f9be(0x251),_0x5d6a34[_0x47f9be(0x144)+'\x6e']=function(_0x56653b,_0x4f15c7){var _0x44ad52=_0x47f9be;this[_0x44ad52(0x1e4)+_0x44ad52(0x31f)](_0x56653b)&&(this[_0x44ad52(0x144)+'\x6e\x50\x6f\x69\x6e\x74\x65\x72']={'\x70\x61\x67\x65\x58':_0x4f15c7[_0x44ad52(0x252)],'\x70\x61\x67\x65\x59':_0x4f15c7[_0x44ad52(0x248)]},_0x56653b[_0x44ad52(0x347)+_0x44ad52(0x3be)](),this[_0x44ad52(0x144)+_0x44ad52(0x14b)](),this[_0x44ad52(0x147)+_0x44ad52(0x2c9)](_0x56653b),this[_0x44ad52(0x279)](_0x44ad52(0x144)+'\x6e',[_0x56653b,_0x4f15c7]));};var _0x5626f5={'\x54\x45\x58\x54\x41\x52\x45\x41':!0x0,'\x49\x4e\x50\x55\x54':!0x0,'\x53\x45\x4c\x45\x43\x54':!0x0,'\x4f\x50\x54\x49\x4f\x4e':!0x0},_0x4a94d2={'\x72\x61\x64\x69\x6f':!0x0,'\x63\x68\x65\x63\x6b\x62\x6f\x78':!0x0,'\x62\x75\x74\x74\x6f\x6e':!0x0,'\x73\x75\x62\x6d\x69\x74':!0x0,'\x69\x6d\x61\x67\x65':!0x0,'\x66\x69\x6c\x65':!0x0};return _0x5d6a34[_0x47f9be(0x1e4)+_0x47f9be(0x31f)]=function(_0x4f78ec){var _0x417230=_0x47f9be,_0xf3aeb5=_0x5626f5[_0x4f78ec['\x74\x61\x72\x67\x65\x74']['\x6e\x6f\x64\x65\x4e\x61\x6d\x65']],_0x8d404b=_0x4a94d2[_0x4f78ec['\x74\x61\x72\x67\x65\x74'][_0x417230(0x49e)]],_0x57956a=!_0xf3aeb5||_0x8d404b;return _0x57956a||this[_0x417230(0x36a)+'\x73\x65\x74'](),_0x57956a;},_0x5d6a34[_0x47f9be(0x144)+_0x47f9be(0x14b)]=function(){var _0x3b630e=_0x47f9be,_0x5a9120=document[_0x3b630e(0x46f)+'\x65\x6e\x74'];_0x5a9120&&_0x5a9120[_0x3b630e(0x2ad)]&&_0x5a9120!=document['\x62\x6f\x64\x79']&&_0x5a9120['\x62\x6c\x75\x72']();},_0x5d6a34[_0x47f9be(0x42e)+'\x65']=function(_0x5a0e8c,_0x4786c7){var _0x23a905=_0x47f9be,_0x37e8a8=this[_0x23a905(0x2d4)+_0x23a905(0x163)](_0x5a0e8c,_0x4786c7);this[_0x23a905(0x279)](_0x23a905(0x42e)+'\x65',[_0x5a0e8c,_0x4786c7,_0x37e8a8]),this[_0x23a905(0x278)](_0x5a0e8c,_0x4786c7,_0x37e8a8);},_0x5d6a34[_0x47f9be(0x2d4)+_0x47f9be(0x163)]=function(_0x1e71a1,_0x4a5113){var _0x23d36e=_0x47f9be,_0x5751f2={'\x78':_0x4a5113[_0x23d36e(0x252)]-this[_0x23d36e(0x144)+'\x6e\x50\x6f\x69\x6e\x74\x65\x72']['\x70\x61\x67\x65\x58'],'\x79':_0x4a5113[_0x23d36e(0x248)]-this[_0x23d36e(0x144)+'\x6e\x50\x6f\x69\x6e\x74\x65\x72'][_0x23d36e(0x248)]};return!this[_0x23d36e(0x1a0)]&&this['\x68\x61\x73\x44\x72\x61\x67\x53\x74\x61'+_0x23d36e(0x345)](_0x5751f2)&&this[_0x23d36e(0x23c)](_0x1e71a1,_0x4a5113),_0x5751f2;},_0x5d6a34[_0x47f9be(0x40f)+_0x47f9be(0x345)]=function(_0x792b7c){var _0x42b308=_0x47f9be;return Math[_0x42b308(0x277)](_0x792b7c['\x78'])>0x3||Math[_0x42b308(0x277)](_0x792b7c['\x79'])>0x3;},_0x5d6a34[_0x47f9be(0x158)]=function(_0x62481a,_0x33f21c){var _0x11c7dd=_0x47f9be;this[_0x11c7dd(0x279)](_0x11c7dd(0x158),[_0x62481a,_0x33f21c]),this[_0x11c7dd(0x2d4)+'\x65\x72\x55\x70'](_0x62481a,_0x33f21c);},_0x5d6a34[_0x47f9be(0x2d4)+_0x47f9be(0x14d)]=function(_0xea30f0,_0x13c636){var _0x431efa=_0x47f9be;this[_0x431efa(0x1a0)]?this[_0x431efa(0x336)](_0xea30f0,_0x13c636):this['\x5f\x73\x74\x61\x74\x69\x63\x43\x6c\x69'+'\x63\x6b'](_0xea30f0,_0x13c636);},_0x5d6a34[_0x47f9be(0x23c)]=function(_0x16394e,_0x4ce8cc){var _0x4e7863=_0x47f9be;this[_0x4e7863(0x1a0)]=!0x0,this[_0x4e7863(0x3f3)+'\x6e\x67\x43\x6c\x69\x63\x6b\x73']=!0x0,this[_0x4e7863(0x176)](_0x16394e,_0x4ce8cc);},_0x5d6a34[_0x47f9be(0x176)]=function(_0xb97af6,_0x2bff48){var _0x45c818=_0x47f9be;this[_0x45c818(0x279)](_0x45c818(0x176),[_0xb97af6,_0x2bff48]);},_0x5d6a34[_0x47f9be(0x278)]=function(_0x54662f,_0x314733,_0x3d29ba){var _0xd95a2c=_0x47f9be;this[_0xd95a2c(0x1a0)]&&this[_0xd95a2c(0x35d)](_0x54662f,_0x314733,_0x3d29ba);},_0x5d6a34['\x64\x72\x61\x67\x4d\x6f\x76\x65']=function(_0x1b606,_0x564eb9,_0xce57d9){var _0x1ca832=_0x47f9be;_0x1b606[_0x1ca832(0x347)+_0x1ca832(0x3be)](),this[_0x1ca832(0x279)](_0x1ca832(0x35d),[_0x1b606,_0x564eb9,_0xce57d9]);},_0x5d6a34['\x5f\x64\x72\x61\x67\x45\x6e\x64']=function(_0x55cad1,_0x4d2d55){var _0x42e874=_0x47f9be;this[_0x42e874(0x1a0)]=!0x1,setTimeout(function(){var _0x2000d0=_0x42e874;delete this['\x69\x73\x50\x72\x65\x76\x65\x6e\x74\x69'+_0x2000d0(0x2b2)];}['\x62\x69\x6e\x64'](this)),this[_0x42e874(0x185)](_0x55cad1,_0x4d2d55);},_0x5d6a34['\x64\x72\x61\x67\x45\x6e\x64']=function(_0x59553b,_0x2b134c){var _0x2b91b6=_0x47f9be;this[_0x2b91b6(0x279)](_0x2b91b6(0x185),[_0x59553b,_0x2b134c]);},_0x5d6a34[_0x47f9be(0x3bc)]=function(_0x5827d8){var _0x197ac7=_0x47f9be;this[_0x197ac7(0x3f3)+_0x197ac7(0x2b2)]&&_0x5827d8[_0x197ac7(0x347)+_0x197ac7(0x3be)]();},_0x5d6a34[_0x47f9be(0x1b9)+'\x63\x6b']=function(_0x2e4677,_0x4f5655){var _0x3c5baa=_0x47f9be;this[_0x3c5baa(0x40c)+_0x3c5baa(0x150)]&&'\x6d\x6f\x75\x73\x65\x75\x70'==_0x2e4677[_0x3c5baa(0x49e)]||(this[_0x3c5baa(0x35e)+'\x6b'](_0x2e4677,_0x4f5655),_0x3c5baa(0x330)!=_0x2e4677[_0x3c5baa(0x49e)]&&(this[_0x3c5baa(0x40c)+_0x3c5baa(0x150)]=!0x0,setTimeout(function(){var _0x2cf2ea=_0x3c5baa;delete this[_0x2cf2ea(0x40c)+_0x2cf2ea(0x150)];}['\x62\x69\x6e\x64'](this),0x190)));},_0x5d6a34[_0x47f9be(0x35e)+'\x6b']=function(_0x50d81b,_0x4ce187){var _0x228da1=_0x47f9be;this[_0x228da1(0x279)](_0x228da1(0x35e)+'\x6b',[_0x50d81b,_0x4ce187]);},_0x22b123['\x67\x65\x74\x50\x6f\x69\x6e\x74\x65\x72'+'\x50\x6f\x69\x6e\x74']=_0x21cda4[_0x47f9be(0x33c)+_0x47f9be(0x4a6)],_0x22b123;}),function(_0x5e639e,_0x17df57){var _0x19f0a2=_0x46f77f;_0x19f0a2(0x2de)==typeof define&&define[_0x19f0a2(0x1eb)]?define(_0x19f0a2(0x3eb)+'\x73\x2f\x64\x72\x61\x67',[_0x19f0a2(0x175),_0x19f0a2(0x426)+_0x19f0a2(0x194)+'\x72','\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75'+_0x19f0a2(0x2d1)],function(_0x4778aa,_0x28f6d7,_0xef2ad3){return _0x17df57(_0x5e639e,_0x4778aa,_0x28f6d7,_0xef2ad3);}):_0x19f0a2(0x28b)==typeof module&&module['\x65\x78\x70\x6f\x72\x74\x73']?module[_0x19f0a2(0x160)]=_0x17df57(_0x5e639e,require('\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79'),require(_0x19f0a2(0x426)),require('\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75'+'\x74\x69\x6c\x73')):_0x5e639e['\x46\x6c\x69\x63\x6b\x69\x74\x79']=_0x17df57(_0x5e639e,_0x5e639e[_0x19f0a2(0x25b)],_0x5e639e[_0x19f0a2(0x281)],_0x5e639e[_0x19f0a2(0x476)+'\x6c\x73']);}(window,function(_0x73c117,_0x57c03b,_0x2b65d0,_0x369bd2){var _0x430e1b=_0x46f77f;_0x369bd2[_0x430e1b(0x20d)](_0x57c03b['\x64\x65\x66\x61\x75\x6c\x74\x73'],{'\x64\x72\x61\x67\x67\x61\x62\x6c\x65':'\x3e\x31','\x64\x72\x61\x67\x54\x68\x72\x65\x73\x68\x6f\x6c\x64':0x3}),_0x57c03b[_0x430e1b(0x421)+'\x6f\x64\x73'][_0x430e1b(0x23d)]('\x5f\x63\x72\x65\x61\x74\x65\x44\x72\x61'+'\x67');var _0x32f4a8=_0x57c03b[_0x430e1b(0x3c9)];_0x369bd2['\x65\x78\x74\x65\x6e\x64'](_0x32f4a8,_0x2b65d0['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']),_0x32f4a8['\x5f\x74\x6f\x75\x63\x68\x41\x63\x74\x69'+_0x430e1b(0x38c)]=_0x430e1b(0x27d);var _0x55689f=_0x430e1b(0x1e7)+'\x68'in document,_0x57c7a4=!0x1;_0x32f4a8[_0x430e1b(0x1dc)+'\x67']=function(){var _0x408875=_0x430e1b;this['\x6f\x6e']('\x61\x63\x74\x69\x76\x61\x74\x65',this[_0x408875(0x43f)+_0x408875(0x3a5)]),this['\x6f\x6e']('\x75\x69\x43\x68\x61\x6e\x67\x65',this[_0x408875(0x3f2)+_0x408875(0x1b1)]),this['\x6f\x6e'](_0x408875(0x2b9),this[_0x408875(0x1e3)+_0x408875(0x3cd)]),this['\x6f\x6e'](_0x408875(0x220),this[_0x408875(0x29d)+_0x408875(0x190)]),_0x55689f&&!_0x57c7a4&&(_0x73c117[_0x408875(0x1bb)+_0x408875(0x333)](_0x408875(0x227),function(){}),_0x57c7a4=!0x0);},_0x32f4a8[_0x430e1b(0x43f)+'\x44\x72\x61\x67']=function(){var _0x319852=_0x430e1b;this[_0x319852(0x458)]=[this[_0x319852(0x1cb)]],this[_0x319852(0x3ca)+'\x73'](),this[_0x319852(0x29d)+_0x319852(0x190)]();},_0x32f4a8[_0x430e1b(0x1e3)+'\x74\x65\x44\x72\x61\x67']=function(){var _0x373fe4=_0x430e1b;this[_0x373fe4(0x363)+_0x373fe4(0x440)](),this['\x65\x6c\x65\x6d\x65\x6e\x74']['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74']['\x72\x65\x6d\x6f\x76\x65'](_0x373fe4(0x3de)+'\x6c\x65');},_0x32f4a8[_0x430e1b(0x29d)+_0x430e1b(0x190)]=function(){var _0x2dae26=_0x430e1b;'\x3e\x31'==this[_0x2dae26(0x40b)][_0x2dae26(0x346)]?this[_0x2dae26(0x3cc)+'\x65']=this['\x73\x6c\x69\x64\x65\x73'][_0x2dae26(0x317)]>0x1:this[_0x2dae26(0x3cc)+'\x65']=this[_0x2dae26(0x40b)][_0x2dae26(0x346)],this[_0x2dae26(0x3cc)+'\x65']?this[_0x2dae26(0x486)][_0x2dae26(0x2a0)][_0x2dae26(0x3fa)](_0x2dae26(0x3de)+'\x6c\x65'):this[_0x2dae26(0x486)][_0x2dae26(0x2a0)][_0x2dae26(0x417)]('\x69\x73\x2d\x64\x72\x61\x67\x67\x61\x62'+'\x6c\x65');},_0x32f4a8['\x62\x69\x6e\x64\x44\x72\x61\x67']=function(){var _0x37f349=_0x430e1b;this[_0x37f349(0x40b)]['\x64\x72\x61\x67\x67\x61\x62\x6c\x65']=!0x0,this['\x75\x70\x64\x61\x74\x65\x44\x72\x61\x67'+'\x67\x61\x62\x6c\x65']();},_0x32f4a8[_0x430e1b(0x27c)]=function(){var _0x2f66a1=_0x430e1b;this[_0x2f66a1(0x40b)][_0x2f66a1(0x346)]=!0x1,this[_0x2f66a1(0x29d)+_0x2f66a1(0x190)]();},_0x32f4a8[_0x430e1b(0x3f2)+'\x72\x61\x67']=function(){var _0x45bb3d=_0x430e1b;delete this[_0x45bb3d(0x26e)+_0x45bb3d(0x3e6)];},_0x32f4a8[_0x430e1b(0x144)+'\x6e']=function(_0x31a3ee,_0x11680b){var _0x2a8b65=_0x430e1b;this[_0x2a8b65(0x3cc)+'\x65']?this[_0x2a8b65(0x1e4)+_0x2a8b65(0x31f)](_0x31a3ee)&&(this['\x5f\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f'+_0x2a8b65(0x30b)+_0x2a8b65(0x2f3)](_0x31a3ee),this['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+_0x2a8b65(0x209)](_0x31a3ee),document[_0x2a8b65(0x46f)+_0x2a8b65(0x29c)]!=this[_0x2a8b65(0x486)]&&this[_0x2a8b65(0x144)+_0x2a8b65(0x14b)](),this[_0x2a8b65(0x4a5)]=this['\x78'],this[_0x2a8b65(0x1cb)][_0x2a8b65(0x2a0)][_0x2a8b65(0x3fa)]('\x69\x73\x2d\x70\x6f\x69\x6e\x74\x65\x72'+_0x2a8b65(0x375)),this['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+_0x2a8b65(0x3b3)]=_0xa24fb9(),_0x73c117['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x2a8b65(0x333)](_0x2a8b65(0x455),this),this[_0x2a8b65(0x14f)+'\x77\x6e\x44\x65\x66\x61\x75\x6c\x74'](_0x31a3ee,_0x11680b)):this[_0x2a8b65(0x14f)+_0x2a8b65(0x358)](_0x31a3ee,_0x11680b);},_0x32f4a8[_0x430e1b(0x14f)+_0x430e1b(0x358)]=function(_0x5364ab,_0x95b630){var _0x59bfcb=_0x430e1b;this[_0x59bfcb(0x144)+_0x59bfcb(0x1b0)]={'\x70\x61\x67\x65\x58':_0x95b630[_0x59bfcb(0x252)],'\x70\x61\x67\x65\x59':_0x95b630[_0x59bfcb(0x248)]},this[_0x59bfcb(0x147)+_0x59bfcb(0x2c9)](_0x5364ab),this[_0x59bfcb(0x2b8)+'\x65\x6e\x74']('\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e',_0x5364ab,[_0x95b630]);};var _0x5f3f4f={'\x49\x4e\x50\x55\x54':!0x0,'\x54\x45\x58\x54\x41\x52\x45\x41':!0x0,'\x53\x45\x4c\x45\x43\x54':!0x0};function _0xa24fb9(){var _0xf75539=_0x430e1b;return{'\x78':_0x73c117[_0xf75539(0x244)+'\x74'],'\x79':_0x73c117['\x70\x61\x67\x65\x59\x4f\x66\x66\x73\x65'+'\x74']};}return _0x32f4a8[_0x430e1b(0x144)+_0x430e1b(0x209)]=function(_0x5844e0){var _0x202a1f=_0x430e1b;_0x5f3f4f[_0x5844e0[_0x202a1f(0x237)]['\x6e\x6f\x64\x65\x4e\x61\x6d\x65']]||this['\x66\x6f\x63\x75\x73']();},_0x32f4a8[_0x430e1b(0x14f)+_0x430e1b(0x30b)+'\x65\x66\x61\x75\x6c\x74']=function(_0x16d1e5){var _0x2ef0a5=_0x430e1b,_0x2d89bd=_0x2ef0a5(0x374)==_0x16d1e5['\x74\x79\x70\x65'],_0x3c57c2='\x74\x6f\x75\x63\x68'==_0x16d1e5[_0x2ef0a5(0x2dd)+'\x65'],_0x1aecf1=_0x5f3f4f[_0x16d1e5[_0x2ef0a5(0x237)][_0x2ef0a5(0x459)]];_0x2d89bd||_0x3c57c2||_0x1aecf1||_0x16d1e5['\x70\x72\x65\x76\x65\x6e\x74\x44\x65\x66'+'\x61\x75\x6c\x74']();},_0x32f4a8['\x68\x61\x73\x44\x72\x61\x67\x53\x74\x61'+_0x430e1b(0x345)]=function(_0x673b6e){var _0x129274=_0x430e1b;return Math[_0x129274(0x277)](_0x673b6e['\x78'])>this[_0x129274(0x40b)][_0x129274(0x1c6)+'\x6f\x6c\x64'];},_0x32f4a8['\x70\x6f\x69\x6e\x74\x65\x72\x55\x70']=function(_0x2ee678,_0x191ba5){var _0x51b572=_0x430e1b;delete this[_0x51b572(0x250)+_0x51b572(0x388)],this['\x76\x69\x65\x77\x70\x6f\x72\x74'][_0x51b572(0x2a0)][_0x51b572(0x417)]('\x69\x73\x2d\x70\x6f\x69\x6e\x74\x65\x72'+_0x51b572(0x375)),this['\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76'+_0x51b572(0x29c)](_0x51b572(0x158),_0x2ee678,[_0x191ba5]),this[_0x51b572(0x2d4)+'\x65\x72\x55\x70'](_0x2ee678,_0x191ba5);},_0x32f4a8[_0x430e1b(0x1d0)+'\x65']=function(){var _0x3af497=_0x430e1b;_0x73c117[_0x3af497(0x226)+_0x3af497(0x2e3)](_0x3af497(0x455),this),delete this[_0x3af497(0x144)+'\x6e\x53\x63\x72\x6f\x6c\x6c'];},_0x32f4a8[_0x430e1b(0x176)]=function(_0x7ed8df,_0x42dd05){var _0x40bce2=_0x430e1b;this['\x69\x73\x44\x72\x61\x67\x67\x61\x62\x6c'+'\x65']&&(this[_0x40bce2(0x310)+'\x6f\x73\x69\x74\x69\x6f\x6e']=this['\x78'],this['\x73\x74\x61\x72\x74\x41\x6e\x69\x6d\x61'+'\x74\x69\x6f\x6e'](),_0x73c117['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x40bce2(0x2e3)](_0x40bce2(0x455),this),this['\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76'+_0x40bce2(0x29c)](_0x40bce2(0x176),_0x7ed8df,[_0x42dd05]));},_0x32f4a8['\x70\x6f\x69\x6e\x74\x65\x72\x4d\x6f\x76'+'\x65']=function(_0x19d7dd,_0x1c07c3){var _0x293017=_0x430e1b,_0x470755=this[_0x293017(0x2d4)+_0x293017(0x163)](_0x19d7dd,_0x1c07c3);this[_0x293017(0x2b8)+_0x293017(0x29c)](_0x293017(0x42e)+'\x65',_0x19d7dd,[_0x1c07c3,_0x470755]),this[_0x293017(0x278)](_0x19d7dd,_0x1c07c3,_0x470755);},_0x32f4a8[_0x430e1b(0x35d)]=function(_0x4b4d48,_0x400729,_0x5d9748){var _0x339c5c=_0x430e1b;if(this[_0x339c5c(0x3cc)+'\x65']){_0x4b4d48['\x70\x72\x65\x76\x65\x6e\x74\x44\x65\x66'+_0x339c5c(0x3be)](),this[_0x339c5c(0x3c0)+_0x339c5c(0x2fc)]=this['\x64\x72\x61\x67\x58'];var _0x59bdc4=this[_0x339c5c(0x40b)]['\x72\x69\x67\x68\x74\x54\x6f\x4c\x65\x66'+'\x74']?-0x1:0x1;this[_0x339c5c(0x40b)][_0x339c5c(0x2c6)]&&(_0x5d9748['\x78']%=this['\x73\x6c\x69\x64\x65\x61\x62\x6c\x65\x57'+_0x339c5c(0x403)]);var _0x25bfed=this['\x64\x72\x61\x67\x53\x74\x61\x72\x74\x50'+_0x339c5c(0x47f)]+_0x5d9748['\x78']*_0x59bdc4;if(!this[_0x339c5c(0x40b)]['\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64']&&this[_0x339c5c(0x352)][_0x339c5c(0x317)]){var _0x39a551=Math[_0x339c5c(0x19b)](-this[_0x339c5c(0x352)][0x0][_0x339c5c(0x237)],this['\x64\x72\x61\x67\x53\x74\x61\x72\x74\x50'+_0x339c5c(0x47f)]);_0x25bfed=_0x25bfed>_0x39a551?0.5*(_0x25bfed+_0x39a551):_0x25bfed;var _0xd50c84=Math[_0x339c5c(0x30a)](-this[_0x339c5c(0x2cd)+'\x64\x65']()[_0x339c5c(0x237)],this['\x64\x72\x61\x67\x53\x74\x61\x72\x74\x50'+_0x339c5c(0x47f)]);_0x25bfed=_0x25bfed<_0xd50c84?0.5*(_0x25bfed+_0xd50c84):_0x25bfed;}this[_0x339c5c(0x4a5)]=_0x25bfed,this[_0x339c5c(0x41a)+'\x6d\x65']=new Date(),this[_0x339c5c(0x2b8)+_0x339c5c(0x29c)]('\x64\x72\x61\x67\x4d\x6f\x76\x65',_0x4b4d48,[_0x400729,_0x5d9748]);}},_0x32f4a8['\x64\x72\x61\x67\x45\x6e\x64']=function(_0x454dd1,_0x4863a7){var _0x2471ef=_0x430e1b;if(this[_0x2471ef(0x3cc)+'\x65']){this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x2471ef(0x146)]&&(this['\x69\x73\x46\x72\x65\x65\x53\x63\x72\x6f'+_0x2471ef(0x3e6)]=!0x0);var _0x1418e4=this[_0x2471ef(0x377)+_0x2471ef(0x289)]();if(this['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x2471ef(0x146)]&&!this[_0x2471ef(0x40b)][_0x2471ef(0x2c6)]){var _0x425d3c=this['\x67\x65\x74\x52\x65\x73\x74\x69\x6e\x67'+_0x2471ef(0x1c5)]();this[_0x2471ef(0x26e)+'\x6c\x6c\x69\x6e\x67']=-_0x425d3c>this['\x73\x6c\x69\x64\x65\x73'][0x0]['\x74\x61\x72\x67\x65\x74']&&-_0x425d3c<this['\x67\x65\x74\x4c\x61\x73\x74\x53\x6c\x69'+'\x64\x65']()['\x74\x61\x72\x67\x65\x74'];}else this[_0x2471ef(0x40b)][_0x2471ef(0x146)]||_0x1418e4!=this[_0x2471ef(0x21c)+'\x64\x65\x78']||(_0x1418e4+=this[_0x2471ef(0x235)+_0x2471ef(0x2eb)]());delete this[_0x2471ef(0x3c0)+_0x2471ef(0x2fc)],this[_0x2471ef(0x1ad)+'\x63\x74']=this[_0x2471ef(0x40b)][_0x2471ef(0x2c6)],this[_0x2471ef(0x153)](_0x1418e4),delete this[_0x2471ef(0x1ad)+'\x63\x74'],this[_0x2471ef(0x2b8)+_0x2471ef(0x29c)](_0x2471ef(0x185),_0x454dd1,[_0x4863a7]);}},_0x32f4a8['\x64\x72\x61\x67\x45\x6e\x64\x52\x65\x73'+'\x74\x69\x6e\x67\x53\x65\x6c\x65\x63\x74']=function(){var _0x42b2a3=_0x430e1b,_0x25353e=this[_0x42b2a3(0x2af)+_0x42b2a3(0x1c5)](),_0x5b52a7=Math[_0x42b2a3(0x277)](this[_0x42b2a3(0x402)+_0x42b2a3(0x38a)](-_0x25353e,this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+_0x42b2a3(0x17e)])),_0x45bcff=this[_0x42b2a3(0x2e6)+'\x74\x52\x65\x73\x74\x69\x6e\x67'](_0x25353e,_0x5b52a7,0x1),_0x295f82=this['\x5f\x67\x65\x74\x43\x6c\x6f\x73\x65\x73'+'\x74\x52\x65\x73\x74\x69\x6e\x67'](_0x25353e,_0x5b52a7,-0x1);return _0x45bcff[_0x42b2a3(0x444)]<_0x295f82[_0x42b2a3(0x444)]?_0x45bcff['\x69\x6e\x64\x65\x78']:_0x295f82[_0x42b2a3(0x2b7)];},_0x32f4a8[_0x430e1b(0x2e6)+'\x74\x52\x65\x73\x74\x69\x6e\x67']=function(_0x40c5d5,_0xd95a77,_0x5b1dff){var _0x23f281=_0x430e1b;for(var _0x1ae659=this[_0x23f281(0x21c)+_0x23f281(0x17e)],_0x17f533=0x1/0x0,_0xec5745=this[_0x23f281(0x40b)][_0x23f281(0x3f7)]&&!this[_0x23f281(0x40b)]['\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64']?function(_0x263878,_0x328af1){return _0x263878<=_0x328af1;}:function(_0x256886,_0x26bdf1){return _0x256886<_0x26bdf1;};_0xec5745(_0xd95a77,_0x17f533)&&(_0x1ae659+=_0x5b1dff,_0x17f533=_0xd95a77,null!==(_0xd95a77=this['\x67\x65\x74\x53\x6c\x69\x64\x65\x44\x69'+_0x23f281(0x38a)](-_0x40c5d5,_0x1ae659)));)_0xd95a77=Math[_0x23f281(0x277)](_0xd95a77);return{'\x64\x69\x73\x74\x61\x6e\x63\x65':_0x17f533,'\x69\x6e\x64\x65\x78':_0x1ae659-_0x5b1dff};},_0x32f4a8[_0x430e1b(0x402)+_0x430e1b(0x38a)]=function(_0xc3e644,_0x201927){var _0x537c74=_0x430e1b,_0x2562bb=this[_0x537c74(0x352)][_0x537c74(0x317)],_0x986b9b=this[_0x537c74(0x40b)][_0x537c74(0x2c6)]&&_0x2562bb>0x1,_0x22dedf=_0x986b9b?_0x369bd2[_0x537c74(0x3e9)](_0x201927,_0x2562bb):_0x201927,_0x90bf98=this[_0x537c74(0x352)][_0x22dedf];if(!_0x90bf98)return null;var _0x562837=_0x986b9b?this['\x73\x6c\x69\x64\x65\x61\x62\x6c\x65\x57'+_0x537c74(0x403)]*Math[_0x537c74(0x37e)](_0x201927/_0x2562bb):0x0;return _0xc3e644-(_0x90bf98['\x74\x61\x72\x67\x65\x74']+_0x562837);},_0x32f4a8[_0x430e1b(0x235)+'\x73\x74\x53\x65\x6c\x65\x63\x74']=function(){var _0x29a55f=_0x430e1b;if(void 0x0===this[_0x29a55f(0x3c0)+_0x29a55f(0x2fc)]||!this[_0x29a55f(0x41a)+'\x6d\x65']||new Date()-this[_0x29a55f(0x41a)+'\x6d\x65']>0x64)return 0x0;var _0xf73f56=this[_0x29a55f(0x402)+'\x73\x74\x61\x6e\x63\x65'](-this[_0x29a55f(0x4a5)],this[_0x29a55f(0x21c)+'\x64\x65\x78']),_0x535e0f=this[_0x29a55f(0x3c0)+'\x61\x67\x58']-this[_0x29a55f(0x4a5)];return _0xf73f56>0x0&&_0x535e0f>0x0?0x1:_0xf73f56<0x0&&_0x535e0f<0x0?-0x1:0x0;},_0x32f4a8['\x73\x74\x61\x74\x69\x63\x43\x6c\x69\x63'+'\x6b']=function(_0x3721dc,_0x5c24d4){var _0x2d90a5=_0x430e1b,_0x34e4f1=this['\x67\x65\x74\x50\x61\x72\x65\x6e\x74\x43'+_0x2d90a5(0x16d)](_0x3721dc['\x74\x61\x72\x67\x65\x74']),_0x4a476e=_0x34e4f1&&_0x34e4f1[_0x2d90a5(0x486)],_0x324cf4=_0x34e4f1&&this['\x63\x65\x6c\x6c\x73'][_0x2d90a5(0x370)](_0x34e4f1);this[_0x2d90a5(0x2b8)+_0x2d90a5(0x29c)](_0x2d90a5(0x35e)+'\x6b',_0x3721dc,[_0x5c24d4,_0x4a476e,_0x324cf4]);},_0x32f4a8[_0x430e1b(0x3f1)]=function(){var _0xab40bc=_0x430e1b,_0x3620cc=_0xa24fb9(),_0x519609=this['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+_0xab40bc(0x3b3)]['\x78']-_0x3620cc['\x78'],_0x577deb=this['\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+_0xab40bc(0x3b3)]['\x79']-_0x3620cc['\x79'];(Math[_0xab40bc(0x277)](_0x519609)>0x3||Math['\x61\x62\x73'](_0x577deb)>0x3)&&this[_0xab40bc(0x14f)+'\x6e\x65']();},_0x57c03b;}),function(_0x372062,_0x3deb7a){var _0x2238fe=_0x46f77f;_0x2238fe(0x2de)==typeof define&&define[_0x2238fe(0x1eb)]?define(_0x2238fe(0x3eb)+_0x2238fe(0x1fd)+_0x2238fe(0x404),[_0x2238fe(0x175),_0x2238fe(0x1f8)+_0x2238fe(0x442)+'\x72',_0x2238fe(0x1de)+_0x2238fe(0x2d1)],function(_0x55cc96,_0x25d471,_0x47d04d){return _0x3deb7a(_0x372062,_0x55cc96,_0x25d471,_0x47d04d);}):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x2238fe(0x160)]?module[_0x2238fe(0x160)]=_0x3deb7a(_0x372062,require(_0x2238fe(0x175)),require(_0x2238fe(0x1f8)),require(_0x2238fe(0x1de)+_0x2238fe(0x2fe))):_0x3deb7a(_0x372062,_0x372062[_0x2238fe(0x25b)],_0x372062[_0x2238fe(0x3b2)],_0x372062[_0x2238fe(0x476)+'\x6c\x73']);}(window,function(_0x3aeaee,_0x3548bf,_0x5ef14c,_0x5bd453){'use strict';var _0x15cf8e=_0x46f77f;var _0xdad44e=_0x15cf8e(0x228)+_0x15cf8e(0x161)+_0x15cf8e(0x2fb);function _0x2a44a1(_0x3259c9,_0x24ae35){var _0x491b1f=_0x15cf8e;this[_0x491b1f(0x366)]=_0x3259c9,this[_0x491b1f(0x211)]=_0x24ae35,this[_0x491b1f(0x155)]();}_0x2a44a1[_0x15cf8e(0x3c9)]=Object['\x63\x72\x65\x61\x74\x65'](_0x5ef14c[_0x15cf8e(0x3c9)]),_0x2a44a1[_0x15cf8e(0x3c9)]['\x5f\x63\x72\x65\x61\x74\x65']=function(){var _0x17eed6=_0x15cf8e;this[_0x17eed6(0x399)]=!0x0,this[_0x17eed6(0x2fd)]=-0x1==this['\x64\x69\x72\x65\x63\x74\x69\x6f\x6e'];var _0x4270d2=this[_0x17eed6(0x211)][_0x17eed6(0x40b)][_0x17eed6(0x246)+'\x74']?0x1:-0x1;this[_0x17eed6(0x1a4)]=this[_0x17eed6(0x366)]==_0x4270d2;var _0x2ef17d=this['\x65\x6c\x65\x6d\x65\x6e\x74']=document[_0x17eed6(0x32a)+_0x17eed6(0x29c)](_0x17eed6(0x44b));_0x2ef17d['\x63\x6c\x61\x73\x73\x4e\x61\x6d\x65']=_0x17eed6(0x441)+_0x17eed6(0x31d)+_0x17eed6(0x236)+_0x17eed6(0x325)+'\x6e',_0x2ef17d[_0x17eed6(0x18e)]+=this[_0x17eed6(0x2fd)]?_0x17eed6(0x164):_0x17eed6(0x495),_0x2ef17d[_0x17eed6(0x355)+'\x74\x65'](_0x17eed6(0x49e),_0x17eed6(0x44b)),this['\x64\x69\x73\x61\x62\x6c\x65'](),_0x2ef17d['\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x17eed6(0x177),this['\x69\x73\x50\x72\x65\x76\x69\x6f\x75\x73']?_0x17eed6(0x1f9):_0x17eed6(0x1ac));var _0x43a087=this[_0x17eed6(0x424)]();_0x2ef17d[_0x17eed6(0x3df)+'\x64'](_0x43a087),this[_0x17eed6(0x211)]['\x6f\x6e']('\x73\x65\x6c\x65\x63\x74',this[_0x17eed6(0x264)]['\x62\x69\x6e\x64'](this)),this['\x6f\x6e']('\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e',this[_0x17eed6(0x211)]['\x63\x68\x69\x6c\x64\x55\x49\x50\x6f\x69'+_0x17eed6(0x1e8)][_0x17eed6(0x174)](this[_0x17eed6(0x211)]));},_0x2a44a1['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x15cf8e(0x1dd)]=function(){var _0x3dc6e8=_0x15cf8e;this['\x62\x69\x6e\x64\x53\x74\x61\x72\x74\x45'+_0x3dc6e8(0x2c7)](this[_0x3dc6e8(0x486)]),this[_0x3dc6e8(0x486)][_0x3dc6e8(0x1bb)+_0x3dc6e8(0x333)](_0x3dc6e8(0x314),this),this[_0x3dc6e8(0x211)]['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x3dc6e8(0x3df)+'\x64'](this['\x65\x6c\x65\x6d\x65\x6e\x74']);},_0x2a44a1[_0x15cf8e(0x3c9)]['\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65']=function(){var _0x24da6d=_0x15cf8e;this[_0x24da6d(0x211)]['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x24da6d(0x3b5)+'\x64'](this[_0x24da6d(0x486)]),this[_0x24da6d(0x464)+'\x74\x45\x76\x65\x6e\x74'](this[_0x24da6d(0x486)]),this[_0x24da6d(0x486)][_0x24da6d(0x226)+_0x24da6d(0x2e3)]('\x63\x6c\x69\x63\x6b',this);},_0x2a44a1[_0x15cf8e(0x3c9)][_0x15cf8e(0x424)]=function(){var _0x1cda6b=_0x15cf8e,_0xbc2660=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+_0x1cda6b(0x4aa)](_0xdad44e,_0x1cda6b(0x159));_0xbc2660[_0x1cda6b(0x355)+'\x74\x65'](_0x1cda6b(0x17d),_0x1cda6b(0x441)+_0x1cda6b(0x406)),_0xbc2660[_0x1cda6b(0x355)+'\x74\x65'](_0x1cda6b(0x2ce),_0x1cda6b(0x267)+'\x30');var _0x54a399=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+_0x1cda6b(0x4aa)](_0xdad44e,_0x1cda6b(0x3f9)),_0x3d0897=function(_0x1ca6ca){var _0x366e19=_0x1cda6b;if(_0x366e19(0x44e)==typeof _0x1ca6ca)return _0x1ca6ca;return'\x4d\x20'+_0x1ca6ca['\x78\x30']+_0x366e19(0x47c)+_0x1ca6ca['\x78\x31']+'\x2c'+(_0x1ca6ca['\x79\x31']+0x32)+_0x366e19(0x48c)+_0x1ca6ca['\x78\x32']+'\x2c'+(_0x1ca6ca['\x79\x32']+0x32)+_0x366e19(0x48c)+_0x1ca6ca['\x78\x33']+'\x2c\x35\x30\x20\x20\x4c\x20'+_0x1ca6ca['\x78\x32']+'\x2c'+(0x32-_0x1ca6ca['\x79\x32'])+_0x366e19(0x48c)+_0x1ca6ca['\x78\x31']+'\x2c'+(0x32-_0x1ca6ca['\x79\x31'])+'\x20\x5a';}(this[_0x1cda6b(0x211)][_0x1cda6b(0x40b)][_0x1cda6b(0x439)]);return _0x54a399[_0x1cda6b(0x355)+'\x74\x65']('\x64',_0x3d0897),_0x54a399[_0x1cda6b(0x355)+'\x74\x65'](_0x1cda6b(0x17d),_0x1cda6b(0x393)),this[_0x1cda6b(0x1a4)]||_0x54a399[_0x1cda6b(0x355)+'\x74\x65']('\x74\x72\x61\x6e\x73\x66\x6f\x72\x6d',_0x1cda6b(0x24a)+_0x1cda6b(0x41b)+'\x72\x6f\x74\x61\x74\x65\x28\x31\x38\x30'+'\x29\x20'),_0xbc2660[_0x1cda6b(0x3df)+'\x64'](_0x54a399),_0xbc2660;},_0x2a44a1[_0x15cf8e(0x3c9)]['\x68\x61\x6e\x64\x6c\x65\x45\x76\x65\x6e'+'\x74']=_0x5bd453[_0x15cf8e(0x1ab)+'\x74'],_0x2a44a1[_0x15cf8e(0x3c9)]['\x6f\x6e\x63\x6c\x69\x63\x6b']=function(){var _0x3474e7=_0x15cf8e;if(this[_0x3474e7(0x399)]){this['\x70\x61\x72\x65\x6e\x74'][_0x3474e7(0x32e)]();var _0x57fcf1=this['\x69\x73\x50\x72\x65\x76\x69\x6f\x75\x73']?_0x3474e7(0x142):_0x3474e7(0x3ba);this[_0x3474e7(0x211)][_0x57fcf1]();}},_0x2a44a1['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x15cf8e(0x316)]=function(){var _0xd20bf2=_0x15cf8e;this[_0xd20bf2(0x399)]||(this[_0xd20bf2(0x486)]['\x64\x69\x73\x61\x62\x6c\x65\x64']=!0x1,this[_0xd20bf2(0x399)]=!0x0);},_0x2a44a1[_0x15cf8e(0x3c9)][_0x15cf8e(0x3e0)]=function(){var _0xc3508c=_0x15cf8e;this[_0xc3508c(0x399)]&&(this[_0xc3508c(0x486)][_0xc3508c(0x33e)]=!0x0,this[_0xc3508c(0x399)]=!0x1);},_0x2a44a1['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x15cf8e(0x264)]=function(){var _0x2229f3=_0x15cf8e,_0x256a9f=this['\x70\x61\x72\x65\x6e\x74'][_0x2229f3(0x352)];if(this[_0x2229f3(0x211)]['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x2229f3(0x2c6)]&&_0x256a9f[_0x2229f3(0x317)]>0x1)this['\x65\x6e\x61\x62\x6c\x65']();else{var _0x25e5ce=_0x256a9f['\x6c\x65\x6e\x67\x74\x68']?_0x256a9f['\x6c\x65\x6e\x67\x74\x68']-0x1:0x0,_0x3b9f48=this['\x69\x73\x50\x72\x65\x76\x69\x6f\x75\x73']?0x0:_0x25e5ce;this[this['\x70\x61\x72\x65\x6e\x74']['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+_0x2229f3(0x17e)]==_0x3b9f48?'\x64\x69\x73\x61\x62\x6c\x65':'\x65\x6e\x61\x62\x6c\x65']();}},_0x2a44a1['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x15cf8e(0x151)]=function(){var _0x1b8361=_0x15cf8e;this[_0x1b8361(0x2b9)](),this[_0x1b8361(0x22e)]();},_0x5bd453[_0x15cf8e(0x20d)](_0x3548bf[_0x15cf8e(0x344)],{'\x70\x72\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f\x6e\x73':!0x0,'\x61\x72\x72\x6f\x77\x53\x68\x61\x70\x65':{'\x78\x30':0xa,'\x78\x31':0x3c,'\x79\x31':0x32,'\x78\x32':0x46,'\x79\x32':0x28,'\x78\x33':0x1e}}),_0x3548bf[_0x15cf8e(0x421)+'\x6f\x64\x73'][_0x15cf8e(0x23d)](_0x15cf8e(0x1be)+'\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f'+'\x6e\x73');var _0x1f040b=_0x3548bf[_0x15cf8e(0x3c9)];return _0x1f040b['\x5f\x63\x72\x65\x61\x74\x65\x50\x72\x65'+'\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f'+'\x6e\x73']=function(){var _0x1e2e34=_0x15cf8e;this[_0x1e2e34(0x40b)][_0x1e2e34(0x420)+_0x1e2e34(0x1f5)]&&(this['\x70\x72\x65\x76\x42\x75\x74\x74\x6f\x6e']=new _0x2a44a1(-0x1,this),this['\x6e\x65\x78\x74\x42\x75\x74\x74\x6f\x6e']=new _0x2a44a1(0x1,this),this['\x6f\x6e'](_0x1e2e34(0x1dd),this[_0x1e2e34(0x238)+_0x1e2e34(0x292)+'\x6f\x6e\x73']));},_0x1f040b[_0x15cf8e(0x238)+'\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74'+_0x15cf8e(0x2c2)]=function(){var _0x1daa43=_0x15cf8e;this['\x70\x72\x65\x76\x42\x75\x74\x74\x6f\x6e'][_0x1daa43(0x1dd)](),this[_0x1daa43(0x3d3)][_0x1daa43(0x1dd)](),this['\x6f\x6e'](_0x1daa43(0x2b9),this[_0x1daa43(0x2b9)+'\x50\x72\x65\x76\x4e\x65\x78\x74\x42\x75'+'\x74\x74\x6f\x6e\x73']);},_0x1f040b[_0x15cf8e(0x2b9)+_0x15cf8e(0x270)+_0x15cf8e(0x1f5)]=function(){var _0x262cf7=_0x15cf8e;this[_0x262cf7(0x41e)][_0x262cf7(0x2b9)](),this[_0x262cf7(0x3d3)][_0x262cf7(0x2b9)](),this[_0x262cf7(0x265)]('\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65',this[_0x262cf7(0x2b9)+'\x50\x72\x65\x76\x4e\x65\x78\x74\x42\x75'+_0x262cf7(0x1f5)]);},_0x3548bf[_0x15cf8e(0x270)+_0x15cf8e(0x387)]=_0x2a44a1,_0x3548bf;}),function(_0x49591f,_0x8be584){var _0xb8f7c0=_0x46f77f;_0xb8f7c0(0x2de)==typeof define&&define[_0xb8f7c0(0x1eb)]?define('\x66\x6c\x69\x63\x6b\x69\x74\x79\x2f\x6a'+_0xb8f7c0(0x30d)+'\x73',[_0xb8f7c0(0x175),_0xb8f7c0(0x1f8)+_0xb8f7c0(0x442)+'\x72',_0xb8f7c0(0x1de)+_0xb8f7c0(0x2d1)],function(_0x58d863,_0x39ac59,_0x2cf9d2){return _0x8be584(_0x49591f,_0x58d863,_0x39ac59,_0x2cf9d2);}):_0xb8f7c0(0x28b)==typeof module&&module[_0xb8f7c0(0x160)]?module[_0xb8f7c0(0x160)]=_0x8be584(_0x49591f,require(_0xb8f7c0(0x175)),require('\x75\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72'),require(_0xb8f7c0(0x1de)+_0xb8f7c0(0x2fe))):_0x8be584(_0x49591f,_0x49591f[_0xb8f7c0(0x25b)],_0x49591f['\x55\x6e\x69\x70\x6f\x69\x6e\x74\x65\x72'],_0x49591f[_0xb8f7c0(0x476)+'\x6c\x73']);}(window,function(_0x1b41da,_0x172e58,_0x1bc8dd,_0x36ab3b){var _0x50c4ae=_0x46f77f;function _0x5a722b(_0x599a38){var _0x3364a1=_0xda54;this[_0x3364a1(0x211)]=_0x599a38,this[_0x3364a1(0x155)]();}_0x5a722b['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']=Object[_0x50c4ae(0x1cd)](_0x1bc8dd[_0x50c4ae(0x3c9)]),_0x5a722b['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x50c4ae(0x155)]=function(){var _0x32f55d=_0x50c4ae;this[_0x32f55d(0x28a)]=document[_0x32f55d(0x32a)+'\x65\x6e\x74']('\x6f\x6c'),this[_0x32f55d(0x28a)][_0x32f55d(0x18e)]='\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x70'+_0x32f55d(0x3b7),this['\x64\x6f\x74\x73']=[],this[_0x32f55d(0x460)+'\x6b']=this[_0x32f55d(0x222)][_0x32f55d(0x174)](this),this['\x6f\x6e'](_0x32f55d(0x144)+'\x6e',this[_0x32f55d(0x211)][_0x32f55d(0x2a9)+_0x32f55d(0x1e8)][_0x32f55d(0x174)](this['\x70\x61\x72\x65\x6e\x74']));},_0x5a722b[_0x50c4ae(0x3c9)][_0x50c4ae(0x1dd)]=function(){var _0x11709a=_0x50c4ae;this['\x73\x65\x74\x44\x6f\x74\x73'](),this[_0x11709a(0x28a)][_0x11709a(0x1bb)+_0x11709a(0x333)]('\x63\x6c\x69\x63\x6b',this[_0x11709a(0x460)+'\x6b']),this[_0x11709a(0x32d)+_0x11709a(0x2c7)](this[_0x11709a(0x28a)]),this[_0x11709a(0x211)][_0x11709a(0x486)][_0x11709a(0x3df)+'\x64'](this[_0x11709a(0x28a)]);},_0x5a722b[_0x50c4ae(0x3c9)][_0x50c4ae(0x2b9)]=function(){var _0x381ac0=_0x50c4ae;this[_0x381ac0(0x28a)]['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x381ac0(0x2e3)](_0x381ac0(0x314),this[_0x381ac0(0x460)+'\x6b']),this['\x75\x6e\x62\x69\x6e\x64\x53\x74\x61\x72'+_0x381ac0(0x35a)](this[_0x381ac0(0x28a)]),this[_0x381ac0(0x211)][_0x381ac0(0x486)][_0x381ac0(0x3b5)+'\x64'](this['\x68\x6f\x6c\x64\x65\x72']);},_0x5a722b[_0x50c4ae(0x3c9)]['\x73\x65\x74\x44\x6f\x74\x73']=function(){var _0x36afa5=_0x50c4ae,_0xb38dff=this['\x70\x61\x72\x65\x6e\x74'][_0x36afa5(0x352)]['\x6c\x65\x6e\x67\x74\x68']-this[_0x36afa5(0x3aa)][_0x36afa5(0x317)];_0xb38dff>0x0?this['\x61\x64\x64\x44\x6f\x74\x73'](_0xb38dff):_0xb38dff<0x0&&this[_0x36afa5(0x322)](-_0xb38dff);},_0x5a722b[_0x50c4ae(0x3c9)]['\x61\x64\x64\x44\x6f\x74\x73']=function(_0xe828dc){var _0x179b1d=_0x50c4ae;for(var _0x4e754d=document[_0x179b1d(0x309)+_0x179b1d(0x253)+'\x6e\x74'](),_0x31b4c5=[],_0x45066b=this['\x64\x6f\x74\x73'][_0x179b1d(0x317)],_0x433768=_0x45066b+_0xe828dc,_0x3789ce=_0x45066b;_0x3789ce<_0x433768;_0x3789ce++){var _0x579b70=document['\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d'+_0x179b1d(0x29c)]('\x6c\x69');_0x579b70[_0x179b1d(0x18e)]=_0x179b1d(0x300),_0x579b70[_0x179b1d(0x355)+'\x74\x65'](_0x179b1d(0x177),_0x179b1d(0x335)+(_0x3789ce+0x1)),_0x4e754d['\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c'+'\x64'](_0x579b70),_0x31b4c5[_0x179b1d(0x23d)](_0x579b70);}this[_0x179b1d(0x28a)][_0x179b1d(0x3df)+'\x64'](_0x4e754d),this[_0x179b1d(0x3aa)]=this[_0x179b1d(0x3aa)][_0x179b1d(0x429)](_0x31b4c5);},_0x5a722b[_0x50c4ae(0x3c9)][_0x50c4ae(0x322)]=function(_0x4116d5){var _0x58088a=_0x50c4ae;this[_0x58088a(0x3aa)]['\x73\x70\x6c\x69\x63\x65'](this[_0x58088a(0x3aa)][_0x58088a(0x317)]-_0x4116d5,_0x4116d5)[_0x58088a(0x1b3)](function(_0x54d0ec){var _0x39f789=_0x58088a;this[_0x39f789(0x28a)][_0x39f789(0x3b5)+'\x64'](_0x54d0ec);},this);},_0x5a722b['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']['\x75\x70\x64\x61\x74\x65\x53\x65\x6c\x65'+_0x50c4ae(0x356)]=function(){var _0x2a6847=_0x50c4ae;this['\x73\x65\x6c\x65\x63\x74\x65\x64\x44\x6f'+'\x74']&&(this['\x73\x65\x6c\x65\x63\x74\x65\x64\x44\x6f'+'\x74']['\x63\x6c\x61\x73\x73\x4e\x61\x6d\x65']=_0x2a6847(0x300),this[_0x2a6847(0x16e)+'\x74'][_0x2a6847(0x463)+'\x69\x62\x75\x74\x65'](_0x2a6847(0x360)+'\x6e\x74')),this[_0x2a6847(0x3aa)][_0x2a6847(0x317)]&&(this[_0x2a6847(0x16e)+'\x74']=this[_0x2a6847(0x3aa)][this[_0x2a6847(0x211)][_0x2a6847(0x21c)+'\x64\x65\x78']],this[_0x2a6847(0x16e)+'\x74'][_0x2a6847(0x18e)]=_0x2a6847(0x18d)+_0x2a6847(0x24f),this['\x73\x65\x6c\x65\x63\x74\x65\x64\x44\x6f'+'\x74'][_0x2a6847(0x355)+'\x74\x65'](_0x2a6847(0x360)+'\x6e\x74',_0x2a6847(0x2ae)));},_0x5a722b['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x50c4ae(0x3c7)]=_0x5a722b[_0x50c4ae(0x3c9)]['\x6f\x6e\x43\x6c\x69\x63\x6b']=function(_0x1d9359){var _0x5b9a04=_0x50c4ae,_0x16d0c2=_0x1d9359['\x74\x61\x72\x67\x65\x74'];if('\x4c\x49'==_0x16d0c2[_0x5b9a04(0x459)]){this['\x70\x61\x72\x65\x6e\x74'][_0x5b9a04(0x32e)]();var _0x2d8d93=this[_0x5b9a04(0x3aa)]['\x69\x6e\x64\x65\x78\x4f\x66'](_0x16d0c2);this[_0x5b9a04(0x211)][_0x5b9a04(0x153)](_0x2d8d93);}},_0x5a722b['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x50c4ae(0x151)]=function(){var _0x418228=_0x50c4ae;this[_0x418228(0x2b9)](),this[_0x418228(0x22e)]();},_0x172e58[_0x50c4ae(0x45c)]=_0x5a722b,_0x36ab3b[_0x50c4ae(0x20d)](_0x172e58[_0x50c4ae(0x344)],{'\x70\x61\x67\x65\x44\x6f\x74\x73':!0x0}),_0x172e58[_0x50c4ae(0x421)+_0x50c4ae(0x2f5)]['\x70\x75\x73\x68'](_0x50c4ae(0x48d)+_0x50c4ae(0x17f));var _0x1769f0=_0x172e58[_0x50c4ae(0x3c9)];return _0x1769f0['\x5f\x63\x72\x65\x61\x74\x65\x50\x61\x67'+'\x65\x44\x6f\x74\x73']=function(){var _0x501102=_0x50c4ae;this[_0x501102(0x40b)][_0x501102(0x45e)]&&(this[_0x501102(0x45e)]=new _0x5a722b(this),this['\x6f\x6e'](_0x501102(0x1dd),this['\x61\x63\x74\x69\x76\x61\x74\x65\x50\x61'+_0x501102(0x412)]),this['\x6f\x6e'](_0x501102(0x153),this[_0x501102(0x1c1)+_0x501102(0x2b1)+'\x74\x73']),this['\x6f\x6e'](_0x501102(0x220),this[_0x501102(0x21f)+'\x44\x6f\x74\x73']),this['\x6f\x6e'](_0x501102(0x2ab),this[_0x501102(0x21f)+'\x44\x6f\x74\x73']),this['\x6f\x6e'](_0x501102(0x2b9),this[_0x501102(0x2b9)+'\x50\x61\x67\x65\x44\x6f\x74\x73']));},_0x1769f0[_0x50c4ae(0x38f)+_0x50c4ae(0x412)]=function(){var _0x240c28=_0x50c4ae;this[_0x240c28(0x45e)][_0x240c28(0x1dd)]();},_0x1769f0['\x75\x70\x64\x61\x74\x65\x53\x65\x6c\x65'+_0x50c4ae(0x2b1)+'\x74\x73']=function(){var _0x11dba5=_0x50c4ae;this[_0x11dba5(0x45e)][_0x11dba5(0x1c1)+_0x11dba5(0x356)]();},_0x1769f0[_0x50c4ae(0x21f)+'\x44\x6f\x74\x73']=function(){var _0x9bbbbe=_0x50c4ae;this[_0x9bbbbe(0x45e)][_0x9bbbbe(0x466)]();},_0x1769f0[_0x50c4ae(0x2b9)+_0x50c4ae(0x45c)]=function(){var _0x1fee53=_0x50c4ae;this[_0x1fee53(0x45e)]['\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65']();},_0x172e58['\x50\x61\x67\x65\x44\x6f\x74\x73']=_0x5a722b,_0x172e58;}),function(_0x168e7e,_0x3001d2){var _0x178776=_0x46f77f;_0x178776(0x2de)==typeof define&&define[_0x178776(0x1eb)]?define(_0x178776(0x3eb)+_0x178776(0x18b),[_0x178776(0x405)+_0x178776(0x256)+'\x72','\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75'+_0x178776(0x2d1),_0x178776(0x175)],function(_0x5b3b92,_0x37d35c,_0x15ec6e){return _0x3001d2(_0x5b3b92,_0x37d35c,_0x15ec6e);}):_0x178776(0x28b)==typeof module&&module['\x65\x78\x70\x6f\x72\x74\x73']?module['\x65\x78\x70\x6f\x72\x74\x73']=_0x3001d2(require(_0x178776(0x405)),require('\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75'+'\x74\x69\x6c\x73'),require('\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79')):_0x3001d2(_0x168e7e[_0x178776(0x38d)],_0x168e7e[_0x178776(0x476)+'\x6c\x73'],_0x168e7e[_0x178776(0x25b)]);}(window,function(_0x1545e6,_0x58ad05,_0x58bac3){var _0x1ae501=_0x46f77f;function _0x22a0fc(_0x1638cf){var _0x31525b=_0xda54;this[_0x31525b(0x211)]=_0x1638cf,this[_0x31525b(0x26d)]=_0x31525b(0x1fe),this[_0x31525b(0x296)+'\x74\x79\x43\x68\x61\x6e\x67\x65']=this[_0x31525b(0x4a7)+'\x43\x68\x61\x6e\x67\x65'][_0x31525b(0x174)](this),this[_0x31525b(0x296)+_0x31525b(0x154)]=this['\x76\x69\x73\x69\x62\x69\x6c\x69\x74\x79'+'\x50\x6c\x61\x79'][_0x31525b(0x174)](this);}_0x22a0fc[_0x1ae501(0x3c9)]=Object[_0x1ae501(0x1cd)](_0x1545e6[_0x1ae501(0x3c9)]),_0x22a0fc[_0x1ae501(0x3c9)][_0x1ae501(0x2d7)]=function(){var _0x4e44c7=_0x1ae501;_0x4e44c7(0x1b6)!=this[_0x4e44c7(0x26d)]&&(document['\x68\x69\x64\x64\x65\x6e']?document['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x4e44c7(0x333)](_0x4e44c7(0x4a7)+'\x63\x68\x61\x6e\x67\x65',this['\x6f\x6e\x56\x69\x73\x69\x62\x69\x6c\x69'+_0x4e44c7(0x154)]):(this[_0x4e44c7(0x26d)]=_0x4e44c7(0x1b6),document[_0x4e44c7(0x1bb)+_0x4e44c7(0x333)]('\x76\x69\x73\x69\x62\x69\x6c\x69\x74\x79'+_0x4e44c7(0x2e2),this[_0x4e44c7(0x296)+_0x4e44c7(0x27a)]),this['\x74\x69\x63\x6b']()));},_0x22a0fc[_0x1ae501(0x3c9)][_0x1ae501(0x213)]=function(){var _0x1a3796=_0x1ae501;if(_0x1a3796(0x1b6)==this['\x73\x74\x61\x74\x65']){var _0x3b3599=this[_0x1a3796(0x211)][_0x1a3796(0x40b)][_0x1a3796(0x3ce)];_0x3b3599=_0x1a3796(0x305)==typeof _0x3b3599?_0x3b3599:0xbb8;var _0xbd992b=this;this[_0x1a3796(0x491)](),this[_0x1a3796(0x20b)]=setTimeout(function(){_0xbd992b['\x70\x61\x72\x65\x6e\x74']['\x6e\x65\x78\x74'](!0x0),_0xbd992b['\x74\x69\x63\x6b']();},_0x3b3599);}},_0x22a0fc[_0x1ae501(0x3c9)]['\x73\x74\x6f\x70']=function(){var _0x444e5b=_0x1ae501;this['\x73\x74\x61\x74\x65']='\x73\x74\x6f\x70\x70\x65\x64',this[_0x444e5b(0x491)](),document[_0x444e5b(0x226)+_0x444e5b(0x2e3)](_0x444e5b(0x4a7)+_0x444e5b(0x2e2),this[_0x444e5b(0x296)+_0x444e5b(0x27a)]);},_0x22a0fc[_0x1ae501(0x3c9)][_0x1ae501(0x491)]=function(){var _0x471600=_0x1ae501;clearTimeout(this[_0x471600(0x20b)]);},_0x22a0fc[_0x1ae501(0x3c9)][_0x1ae501(0x381)]=function(){var _0x349390=_0x1ae501;_0x349390(0x1b6)==this['\x73\x74\x61\x74\x65']&&(this['\x73\x74\x61\x74\x65']=_0x349390(0x27b),this[_0x349390(0x491)]());},_0x22a0fc[_0x1ae501(0x3c9)][_0x1ae501(0x37b)]=function(){var _0x1a6601=_0x1ae501;_0x1a6601(0x27b)==this[_0x1a6601(0x26d)]&&this[_0x1a6601(0x2d7)]();},_0x22a0fc[_0x1ae501(0x3c9)]['\x76\x69\x73\x69\x62\x69\x6c\x69\x74\x79'+_0x1ae501(0x1e1)]=function(){var _0x4ba0cd=_0x1ae501;this[document[_0x4ba0cd(0x348)]?'\x70\x61\x75\x73\x65':_0x4ba0cd(0x37b)]();},_0x22a0fc[_0x1ae501(0x3c9)][_0x1ae501(0x4a7)+'\x50\x6c\x61\x79']=function(){var _0x2fa2f9=_0x1ae501;this[_0x2fa2f9(0x2d7)](),document['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72']('\x76\x69\x73\x69\x62\x69\x6c\x69\x74\x79'+_0x2fa2f9(0x2e2),this[_0x2fa2f9(0x296)+_0x2fa2f9(0x154)]);},_0x58ad05['\x65\x78\x74\x65\x6e\x64'](_0x58bac3[_0x1ae501(0x344)],{'\x70\x61\x75\x73\x65\x41\x75\x74\x6f\x50\x6c\x61\x79\x4f\x6e\x48\x6f\x76\x65\x72':!0x0}),_0x58bac3['\x63\x72\x65\x61\x74\x65\x4d\x65\x74\x68'+'\x6f\x64\x73'][_0x1ae501(0x23d)](_0x1ae501(0x39a)+'\x79\x65\x72');var _0x56a47c=_0x58bac3['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'];return _0x56a47c[_0x1ae501(0x39a)+_0x1ae501(0x224)]=function(){var _0x2d1dfd=_0x1ae501;this[_0x2d1dfd(0x489)]=new _0x22a0fc(this),this['\x6f\x6e']('\x61\x63\x74\x69\x76\x61\x74\x65',this[_0x2d1dfd(0x2bb)+'\x61\x79\x65\x72']),this['\x6f\x6e'](_0x2d1dfd(0x32e),this['\x73\x74\x6f\x70\x50\x6c\x61\x79\x65\x72']),this['\x6f\x6e']('\x70\x6f\x69\x6e\x74\x65\x72\x44\x6f\x77'+'\x6e',this[_0x2d1dfd(0x1c7)]),this['\x6f\x6e'](_0x2d1dfd(0x2b9),this[_0x2d1dfd(0x2b9)+_0x2d1dfd(0x1d5)]);},_0x56a47c[_0x1ae501(0x2bb)+_0x1ae501(0x218)]=function(){var _0x26d4e8=_0x1ae501;this[_0x26d4e8(0x40b)]['\x61\x75\x74\x6f\x50\x6c\x61\x79']&&(this[_0x26d4e8(0x489)][_0x26d4e8(0x2d7)](),this[_0x26d4e8(0x486)][_0x26d4e8(0x1bb)+_0x26d4e8(0x333)](_0x26d4e8(0x43e),this));},_0x56a47c[_0x1ae501(0x46e)]=function(){var _0x2c14d0=_0x1ae501;this[_0x2c14d0(0x489)][_0x2c14d0(0x2d7)]();},_0x56a47c[_0x1ae501(0x1c7)]=function(){var _0x3e0c5c=_0x1ae501;this['\x70\x6c\x61\x79\x65\x72'][_0x3e0c5c(0x450)]();},_0x56a47c[_0x1ae501(0x483)+'\x72']=function(){var _0x272912=_0x1ae501;this[_0x272912(0x489)][_0x272912(0x381)]();},_0x56a47c[_0x1ae501(0x372)+_0x1ae501(0x224)]=function(){var _0x1aa4c4=_0x1ae501;this[_0x1aa4c4(0x489)][_0x1aa4c4(0x37b)]();},_0x56a47c['\x64\x65\x61\x63\x74\x69\x76\x61\x74\x65'+_0x1ae501(0x1d5)]=function(){var _0x273466=_0x1ae501;this[_0x273466(0x489)][_0x273466(0x450)](),this[_0x273466(0x486)]['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x273466(0x2e3)](_0x273466(0x43e),this);},_0x56a47c[_0x1ae501(0x427)+'\x65\x72']=function(){var _0x67790d=_0x1ae501;this[_0x67790d(0x40b)][_0x67790d(0x2b6)+_0x67790d(0x332)]&&(this[_0x67790d(0x489)][_0x67790d(0x381)](),this['\x65\x6c\x65\x6d\x65\x6e\x74'][_0x67790d(0x1bb)+_0x67790d(0x333)]('\x6d\x6f\x75\x73\x65\x6c\x65\x61\x76\x65',this));},_0x56a47c[_0x1ae501(0x15e)+'\x76\x65']=function(){var _0x4b573c=_0x1ae501;this['\x70\x6c\x61\x79\x65\x72'][_0x4b573c(0x37b)](),this['\x65\x6c\x65\x6d\x65\x6e\x74']['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x4b573c(0x2e3)](_0x4b573c(0x3af),this);},_0x58bac3[_0x1ae501(0x1d5)]=_0x22a0fc,_0x58bac3;}),function(_0x14f24a,_0x245068){var _0x4cedd6=_0x46f77f;_0x4cedd6(0x2de)==typeof define&&define[_0x4cedd6(0x1eb)]?define('\x66\x6c\x69\x63\x6b\x69\x74\x79\x2f\x6a'+_0x4cedd6(0x3e3)+_0x4cedd6(0x217),[_0x4cedd6(0x175),_0x4cedd6(0x1de)+'\x74\x69\x6c\x73\x2f\x75\x74\x69\x6c\x73'],function(_0x56360a,_0x3d5b9f){return _0x245068(_0x14f24a,_0x56360a,_0x3d5b9f);}):_0x4cedd6(0x28b)==typeof module&&module[_0x4cedd6(0x160)]?module['\x65\x78\x70\x6f\x72\x74\x73']=_0x245068(_0x14f24a,require('\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79'),require('\x66\x69\x7a\x7a\x79\x2d\x75\x69\x2d\x75'+'\x74\x69\x6c\x73')):_0x245068(_0x14f24a,_0x14f24a[_0x4cedd6(0x25b)],_0x14f24a['\x66\x69\x7a\x7a\x79\x55\x49\x55\x74\x69'+'\x6c\x73']);}(window,function(_0x21ba88,_0x49d676,_0x480b6d){var _0x554fa4=_0x46f77f,_0xa71eeb=_0x49d676['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'];return _0xa71eeb['\x69\x6e\x73\x65\x72\x74']=function(_0x310afd,_0x491acb){var _0x3fea7c=_0xda54,_0x770d5c=this[_0x3fea7c(0x490)](_0x310afd);if(_0x770d5c&&_0x770d5c[_0x3fea7c(0x317)]){var _0x5d8264=this[_0x3fea7c(0x1ee)][_0x3fea7c(0x317)];_0x491acb=void 0x0===_0x491acb?_0x5d8264:_0x491acb;var _0x2b3aae=function(_0x4fdf19){var _0x211e94=_0x3fea7c,_0xca95b0=document['\x63\x72\x65\x61\x74\x65\x44\x6f\x63\x75'+_0x211e94(0x253)+'\x6e\x74']();return _0x4fdf19[_0x211e94(0x1b3)](function(_0x3e0e0d){var _0x45af11=_0x211e94;_0xca95b0[_0x45af11(0x3df)+'\x64'](_0x3e0e0d[_0x45af11(0x486)]);}),_0xca95b0;}(_0x770d5c),_0x298798=_0x491acb==_0x5d8264;if(_0x298798)this[_0x3fea7c(0x3da)]['\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c'+'\x64'](_0x2b3aae);else{var _0x104e72=this[_0x3fea7c(0x1ee)][_0x491acb][_0x3fea7c(0x486)];this[_0x3fea7c(0x3da)]['\x69\x6e\x73\x65\x72\x74\x42\x65\x66\x6f'+'\x72\x65'](_0x2b3aae,_0x104e72);}if(0x0===_0x491acb)this[_0x3fea7c(0x1ee)]=_0x770d5c[_0x3fea7c(0x429)](this['\x63\x65\x6c\x6c\x73']);else{if(_0x298798)this[_0x3fea7c(0x1ee)]=this['\x63\x65\x6c\x6c\x73'][_0x3fea7c(0x429)](_0x770d5c);else{var _0xd2e2eb=this[_0x3fea7c(0x1ee)][_0x3fea7c(0x2d8)](_0x491acb,_0x5d8264-_0x491acb);this[_0x3fea7c(0x1ee)]=this[_0x3fea7c(0x1ee)]['\x63\x6f\x6e\x63\x61\x74'](_0x770d5c)[_0x3fea7c(0x429)](_0xd2e2eb);}}this[_0x3fea7c(0x34e)](_0x770d5c),this[_0x3fea7c(0x220)](_0x491acb,!0x0);}},_0xa71eeb['\x61\x70\x70\x65\x6e\x64']=function(_0x5ce8f6){var _0xb69d5a=_0xda54;this[_0xb69d5a(0x2e0)](_0x5ce8f6,this[_0xb69d5a(0x1ee)][_0xb69d5a(0x317)]);},_0xa71eeb[_0x554fa4(0x397)]=function(_0x442d66){var _0x99de42=_0x554fa4;this[_0x99de42(0x2e0)](_0x442d66,0x0);},_0xa71eeb[_0x554fa4(0x417)]=function(_0x246ed1){var _0x1a81e9=_0x554fa4,_0xe74436=this[_0x1a81e9(0x169)](_0x246ed1);if(_0xe74436&&_0xe74436[_0x1a81e9(0x317)]){var _0x2e1c60=this[_0x1a81e9(0x1ee)]['\x6c\x65\x6e\x67\x74\x68']-0x1;_0xe74436['\x66\x6f\x72\x45\x61\x63\x68'](function(_0x13d754){var _0x306178=_0x1a81e9;_0x13d754[_0x306178(0x417)]();var _0x546db7=this[_0x306178(0x1ee)][_0x306178(0x370)](_0x13d754);_0x2e1c60=Math[_0x306178(0x30a)](_0x546db7,_0x2e1c60),_0x480b6d['\x72\x65\x6d\x6f\x76\x65\x46\x72\x6f\x6d'](this[_0x306178(0x1ee)],_0x13d754);},this),this[_0x1a81e9(0x220)](_0x2e1c60,!0x0);}},_0xa71eeb[_0x554fa4(0x230)+_0x554fa4(0x152)]=function(_0x192ddb){var _0x2061ad=_0x554fa4,_0x40350b=this[_0x2061ad(0x319)](_0x192ddb);if(_0x40350b){_0x40350b[_0x2061ad(0x156)]();var _0x30c538=this[_0x2061ad(0x1ee)][_0x2061ad(0x370)](_0x40350b);this[_0x2061ad(0x220)](_0x30c538);}},_0xa71eeb[_0x554fa4(0x220)]=function(_0x2fdad5,_0x1a903d){var _0x11e641=_0x554fa4,_0x4ef6d0=this[_0x11e641(0x212)+_0x11e641(0x3c8)];this[_0x11e641(0x2cb)+_0x11e641(0x148)](_0x2fdad5),this[_0x11e641(0x29a)+'\x69\x66\x74\x43\x65\x6c\x6c\x73'](),this[_0x11e641(0x45a)+_0x11e641(0x16a)]();var _0x157a0e=this['\x67\x65\x74\x43\x65\x6c\x6c'](_0x4ef6d0);_0x157a0e&&(this[_0x11e641(0x21c)+'\x64\x65\x78']=this[_0x11e641(0x46d)+_0x11e641(0x22d)](_0x157a0e)),this[_0x11e641(0x21c)+_0x11e641(0x17e)]=Math[_0x11e641(0x30a)](this[_0x11e641(0x352)][_0x11e641(0x317)]-0x1,this['\x73\x65\x6c\x65\x63\x74\x65\x64\x49\x6e'+_0x11e641(0x17e)]),this[_0x11e641(0x279)](_0x11e641(0x220),[_0x2fdad5]),this[_0x11e641(0x153)](this[_0x11e641(0x21c)+'\x64\x65\x78']),_0x1a903d&&this[_0x11e641(0x48a)+'\x69\x64\x65\x72\x41\x74\x53\x65\x6c\x65'+_0x11e641(0x356)]();},_0x49d676;}),function(_0x40a01e,_0x39cf00){var _0x469efc=_0x46f77f;_0x469efc(0x2de)==typeof define&&define[_0x469efc(0x1eb)]?define(_0x469efc(0x3eb)+'\x73\x2f\x6c\x61\x7a\x79\x6c\x6f\x61\x64',[_0x469efc(0x175),_0x469efc(0x1de)+_0x469efc(0x2d1)],function(_0x260f8b,_0x564741){return _0x39cf00(_0x40a01e,_0x260f8b,_0x564741);}):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x469efc(0x160)]?module['\x65\x78\x70\x6f\x72\x74\x73']=_0x39cf00(_0x40a01e,require(_0x469efc(0x175)),require(_0x469efc(0x1de)+_0x469efc(0x2fe))):_0x39cf00(_0x40a01e,_0x40a01e[_0x469efc(0x25b)],_0x40a01e[_0x469efc(0x476)+'\x6c\x73']);}(window,function(_0x268a55,_0x3c53b0,_0x2e7eb4){'use strict';var _0x59b2d6=_0x46f77f;_0x3c53b0[_0x59b2d6(0x421)+_0x59b2d6(0x2f5)][_0x59b2d6(0x23d)](_0x59b2d6(0x1f2)+'\x79\x6c\x6f\x61\x64');var _0x56c4a9=_0x3c53b0[_0x59b2d6(0x3c9)];function _0x36b41f(_0x379b0e,_0x4c3ae9){var _0x8f9272=_0x59b2d6;this['\x69\x6d\x67']=_0x379b0e,this[_0x8f9272(0x2ed)]=_0x4c3ae9,this[_0x8f9272(0x42f)]();}return _0x56c4a9['\x5f\x63\x72\x65\x61\x74\x65\x4c\x61\x7a'+'\x79\x6c\x6f\x61\x64']=function(){var _0x4bba02=_0x59b2d6;this['\x6f\x6e'](_0x4bba02(0x153),this[_0x4bba02(0x477)]);},_0x56c4a9[_0x59b2d6(0x477)]=function(){var _0xd4536=_0x59b2d6,_0xd7b1cb=this[_0xd4536(0x40b)][_0xd4536(0x477)];if(_0xd7b1cb){var _0x42cd76=_0xd4536(0x305)==typeof _0xd7b1cb?_0xd7b1cb:0x0,_0x30e3d0=this['\x67\x65\x74\x41\x64\x6a\x61\x63\x65\x6e'+_0xd4536(0x18f)+_0xd4536(0x42c)](_0x42cd76),_0x3d1e0c=[];_0x30e3d0[_0xd4536(0x1b3)](function(_0x374f8e){var _0x25d57f=_0xd4536,_0x547a0c=function(_0x10c1b4){var _0x2487b4=_0xda54;if('\x49\x4d\x47'==_0x10c1b4[_0x2487b4(0x459)]){var _0x361bb0=_0x10c1b4[_0x2487b4(0x328)+'\x74\x65']('\x64\x61\x74\x61\x2d\x66\x6c\x69\x63\x6b'+'\x69\x74\x79\x2d\x6c\x61\x7a\x79\x6c\x6f'+'\x61\x64'),_0x42d2c7=_0x10c1b4[_0x2487b4(0x328)+'\x74\x65'](_0x2487b4(0x481)+_0x2487b4(0x449)+_0x2487b4(0x266)),_0x529767=_0x10c1b4[_0x2487b4(0x328)+'\x74\x65']('\x64\x61\x74\x61\x2d\x66\x6c\x69\x63\x6b'+_0x2487b4(0x449)+_0x2487b4(0x19a));if(_0x361bb0||_0x42d2c7||_0x529767)return[_0x10c1b4];}var _0x313c3e=_0x10c1b4[_0x2487b4(0x307)+_0x2487b4(0x28c)]('\x69\x6d\x67\x5b\x64\x61\x74\x61\x2d\x66'+'\x6c\x69\x63\x6b\x69\x74\x79\x2d\x6c\x61'+_0x2487b4(0x47e)+'\x6d\x67\x5b\x64\x61\x74\x61\x2d\x66\x6c'+'\x69\x63\x6b\x69\x74\x79\x2d\x6c\x61\x7a'+'\x79\x6c\x6f\x61\x64\x2d\x73\x72\x63\x5d'+_0x2487b4(0x3fc)+_0x2487b4(0x26b)+_0x2487b4(0x189)+'\x72\x63\x73\x65\x74\x5d');return _0x2e7eb4[_0x2487b4(0x382)](_0x313c3e);}(_0x374f8e);_0x3d1e0c=_0x3d1e0c[_0x25d57f(0x429)](_0x547a0c);}),_0x3d1e0c[_0xd4536(0x1b3)](function(_0x7e1d59){new _0x36b41f(_0x7e1d59,this);},this);}},_0x36b41f[_0x59b2d6(0x3c9)]['\x68\x61\x6e\x64\x6c\x65\x45\x76\x65\x6e'+'\x74']=_0x2e7eb4['\x68\x61\x6e\x64\x6c\x65\x45\x76\x65\x6e'+'\x74'],_0x36b41f[_0x59b2d6(0x3c9)]['\x6c\x6f\x61\x64']=function(){var _0x40cd41=_0x59b2d6;this[_0x40cd41(0x3ad)][_0x40cd41(0x1bb)+_0x40cd41(0x333)](_0x40cd41(0x42f),this),this[_0x40cd41(0x3ad)][_0x40cd41(0x1bb)+_0x40cd41(0x333)]('\x65\x72\x72\x6f\x72',this);var _0x3c097d=this['\x69\x6d\x67'][_0x40cd41(0x328)+'\x74\x65']('\x64\x61\x74\x61\x2d\x66\x6c\x69\x63\x6b'+_0x40cd41(0x449)+'\x61\x64')||this[_0x40cd41(0x3ad)][_0x40cd41(0x328)+'\x74\x65'](_0x40cd41(0x481)+'\x69\x74\x79\x2d\x6c\x61\x7a\x79\x6c\x6f'+'\x61\x64\x2d\x73\x72\x63'),_0x27704b=this[_0x40cd41(0x3ad)][_0x40cd41(0x328)+'\x74\x65'](_0x40cd41(0x481)+_0x40cd41(0x449)+'\x61\x64\x2d\x73\x72\x63\x73\x65\x74');this[_0x40cd41(0x3ad)]['\x73\x72\x63']=_0x3c097d,_0x27704b&&this['\x69\x6d\x67']['\x73\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x40cd41(0x2b3),_0x27704b),this[_0x40cd41(0x3ad)]['\x72\x65\x6d\x6f\x76\x65\x41\x74\x74\x72'+_0x40cd41(0x16b)](_0x40cd41(0x481)+_0x40cd41(0x449)+'\x61\x64'),this[_0x40cd41(0x3ad)][_0x40cd41(0x463)+_0x40cd41(0x16b)](_0x40cd41(0x481)+_0x40cd41(0x449)+_0x40cd41(0x266)),this[_0x40cd41(0x3ad)][_0x40cd41(0x463)+_0x40cd41(0x16b)]('\x64\x61\x74\x61\x2d\x66\x6c\x69\x63\x6b'+_0x40cd41(0x449)+_0x40cd41(0x19a));},_0x36b41f[_0x59b2d6(0x3c9)]['\x6f\x6e\x6c\x6f\x61\x64']=function(_0x8f5a24){this['\x63\x6f\x6d\x70\x6c\x65\x74\x65'](_0x8f5a24,'\x66\x6c\x69\x63\x6b\x69\x74\x79\x2d\x6c'+'\x61\x7a\x79\x6c\x6f\x61\x64\x65\x64');},_0x36b41f[_0x59b2d6(0x3c9)][_0x59b2d6(0x273)]=function(_0x19a436){var _0x1e2e70=_0x59b2d6;this[_0x1e2e70(0x485)](_0x19a436,_0x1e2e70(0x3d9)+_0x1e2e70(0x2f0));},_0x36b41f[_0x59b2d6(0x3c9)]['\x63\x6f\x6d\x70\x6c\x65\x74\x65']=function(_0x156d18,_0x642c4c){var _0x1a074a=_0x59b2d6;this[_0x1a074a(0x3ad)][_0x1a074a(0x226)+_0x1a074a(0x2e3)](_0x1a074a(0x42f),this),this[_0x1a074a(0x3ad)]['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x1a074a(0x2e3)](_0x1a074a(0x411),this);var _0x1669d0=this[_0x1a074a(0x2ed)][_0x1a074a(0x42d)+'\x65\x6c\x6c'](this[_0x1a074a(0x3ad)]),_0x1b3495=_0x1669d0&&_0x1669d0['\x65\x6c\x65\x6d\x65\x6e\x74'];this['\x66\x6c\x69\x63\x6b\x69\x74\x79'][_0x1a074a(0x230)+'\x61\x6e\x67\x65'](_0x1b3495),this[_0x1a074a(0x3ad)][_0x1a074a(0x2a0)][_0x1a074a(0x3fa)](_0x642c4c),this[_0x1a074a(0x2ed)][_0x1a074a(0x2b8)+'\x65\x6e\x74']('\x6c\x61\x7a\x79\x4c\x6f\x61\x64',_0x156d18,_0x1b3495);},_0x3c53b0[_0x59b2d6(0x36c)]=_0x36b41f,_0x3c53b0;}),function(_0x1d4ad0,_0x466a96){var _0x2cc68e=_0x46f77f;_0x2cc68e(0x2de)==typeof define&&define[_0x2cc68e(0x1eb)]?define(_0x2cc68e(0x3eb)+_0x2cc68e(0x456),['\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79',_0x2cc68e(0x2d2),_0x2cc68e(0x422)+_0x2cc68e(0x404),'\x2e\x2f\x70\x61\x67\x65\x2d\x64\x6f\x74'+'\x73',_0x2cc68e(0x1ce),'\x2e\x2f\x61\x64\x64\x2d\x72\x65\x6d\x6f'+_0x2cc68e(0x217),'\x2e\x2f\x6c\x61\x7a\x79\x6c\x6f\x61\x64'],_0x466a96):_0x2cc68e(0x28b)==typeof module&&module[_0x2cc68e(0x160)]&&(module[_0x2cc68e(0x160)]=_0x466a96(require('\x2e\x2f\x66\x6c\x69\x63\x6b\x69\x74\x79'),require(_0x2cc68e(0x2d2)),require(_0x2cc68e(0x422)+_0x2cc68e(0x404)),require(_0x2cc68e(0x1da)+'\x73'),require('\x2e\x2f\x70\x6c\x61\x79\x65\x72'),require(_0x2cc68e(0x22c)+_0x2cc68e(0x217)),require(_0x2cc68e(0x21e))));}(window,function(_0xa8c601){return _0xa8c601;}),function(_0x355d8b,_0x3ed038){var _0x21b766=_0x46f77f;_0x21b766(0x2de)==typeof define&&define['\x61\x6d\x64']?define(_0x21b766(0x44c)+_0x21b766(0x26f)+_0x21b766(0x324),[_0x21b766(0x3eb)+'\x73\x2f\x69\x6e\x64\x65\x78',_0x21b766(0x1de)+_0x21b766(0x2d1)],_0x3ed038):_0x21b766(0x28b)==typeof module&&module[_0x21b766(0x160)]?module[_0x21b766(0x160)]=_0x3ed038(require('\x66\x6c\x69\x63\x6b\x69\x74\x79'),require(_0x21b766(0x1de)+_0x21b766(0x2fe))):_0x355d8b['\x46\x6c\x69\x63\x6b\x69\x74\x79']=_0x3ed038(_0x355d8b[_0x21b766(0x25b)],_0x355d8b['\x66\x69\x7a\x7a\x79\x55\x49\x55\x74\x69'+'\x6c\x73']);}(window,function(_0xe3a9d5,_0x4f212f){var _0x503d72=_0x46f77f;_0xe3a9d5['\x63\x72\x65\x61\x74\x65\x4d\x65\x74\x68'+_0x503d72(0x2f5)][_0x503d72(0x23d)](_0x503d72(0x1d1)+_0x503d72(0x469));var _0x23a58a=_0xe3a9d5[_0x503d72(0x3c9)];return _0x23a58a[_0x503d72(0x1d1)+_0x503d72(0x469)]=function(){var _0x235780=_0x503d72;this['\x6f\x6e']('\x61\x63\x74\x69\x76\x61\x74\x65',this[_0x235780(0x221)+_0x235780(0x32f)]),this['\x6f\x6e'](_0x235780(0x2b9),this[_0x235780(0x2b9)+_0x235780(0x39c)]),this['\x6f\x6e']('\x64\x65\x73\x74\x72\x6f\x79',this['\x64\x65\x73\x74\x72\x6f\x79\x41\x73\x4e'+_0x235780(0x469)]);var _0x333426=this[_0x235780(0x40b)]['\x61\x73\x4e\x61\x76\x46\x6f\x72'];if(_0x333426){var _0x5e3816=this;setTimeout(function(){var _0x23e39e=_0x235780;_0x5e3816['\x73\x65\x74\x4e\x61\x76\x43\x6f\x6d\x70'+_0x23e39e(0x200)](_0x333426);});}},_0x23a58a['\x73\x65\x74\x4e\x61\x76\x43\x6f\x6d\x70'+_0x503d72(0x200)]=function(_0xb802bd){var _0x1be735=_0x503d72;_0xb802bd=_0x4f212f['\x67\x65\x74\x51\x75\x65\x72\x79\x45\x6c'+_0x1be735(0x3c8)](_0xb802bd);var _0x5288b1=_0xe3a9d5['\x64\x61\x74\x61'](_0xb802bd);if(_0x5288b1&&_0x5288b1!=this){this['\x6e\x61\x76\x43\x6f\x6d\x70\x61\x6e\x69'+'\x6f\x6e']=_0x5288b1;var _0x4e33a8=this;this[_0x1be735(0x1aa)+_0x1be735(0x49a)]=function(){var _0x19b3fd=_0x1be735;_0x4e33a8[_0x19b3fd(0x39e)+_0x19b3fd(0x180)]();},_0x5288b1['\x6f\x6e'](_0x1be735(0x153),this[_0x1be735(0x1aa)+_0x1be735(0x49a)]),this['\x6f\x6e'](_0x1be735(0x35e)+'\x6b',this['\x6f\x6e\x4e\x61\x76\x53\x74\x61\x74\x69'+_0x1be735(0x340)]),this[_0x1be735(0x39e)+'\x6f\x6e\x53\x65\x6c\x65\x63\x74'](!0x0);}},_0x23a58a[_0x503d72(0x39e)+'\x6f\x6e\x53\x65\x6c\x65\x63\x74']=function(_0x300918){var _0x531789=_0x503d72,_0x424b26=this[_0x531789(0x39e)+'\x6f\x6e']&&this[_0x531789(0x39e)+'\x6f\x6e'][_0x531789(0x2ba)+_0x531789(0x3e8)];if(_0x424b26){var _0x58d243=_0x424b26[0x0],_0x1c63f1=this[_0x531789(0x39e)+'\x6f\x6e'][_0x531789(0x1ee)][_0x531789(0x370)](_0x58d243),_0x285514=_0x1c63f1+_0x424b26['\x6c\x65\x6e\x67\x74\x68']-0x1,_0x54f19c=Math[_0x531789(0x37e)](function(_0x4ef54e,_0x546e27,_0x4198e3){return(_0x546e27-_0x4ef54e)*_0x4198e3+_0x4ef54e;}(_0x1c63f1,_0x285514,this['\x6e\x61\x76\x43\x6f\x6d\x70\x61\x6e\x69'+'\x6f\x6e'][_0x531789(0x20f)]));if(this[_0x531789(0x24d)](_0x54f19c,!0x1,_0x300918),this[_0x531789(0x229)+_0x531789(0x334)+_0x531789(0x3fe)](),!(_0x54f19c>=this[_0x531789(0x1ee)][_0x531789(0x317)])){var _0x1436c8=this[_0x531789(0x1ee)][_0x531789(0x34f)](_0x1c63f1,_0x285514+0x1);this['\x6e\x61\x76\x53\x65\x6c\x65\x63\x74\x65'+_0x531789(0x351)]=_0x1436c8[_0x531789(0x472)](function(_0x4457d8){var _0x5bf111=_0x531789;return _0x4457d8[_0x5bf111(0x486)];}),this[_0x531789(0x414)+_0x531789(0x438)+'\x73\x73'](_0x531789(0x3fa));}}},_0x23a58a[_0x503d72(0x414)+_0x503d72(0x438)+'\x73\x73']=function(_0xec493){var _0x4d8f02=_0x503d72;this['\x6e\x61\x76\x53\x65\x6c\x65\x63\x74\x65'+_0x4d8f02(0x351)][_0x4d8f02(0x1b3)](function(_0x40bb72){var _0x141998=_0x4d8f02;_0x40bb72[_0x141998(0x2a0)][_0xec493]('\x69\x73\x2d\x6e\x61\x76\x2d\x73\x65\x6c'+_0x141998(0x24f));});},_0x23a58a[_0x503d72(0x221)+_0x503d72(0x32f)]=function(){var _0x1b81b8=_0x503d72;this[_0x1b81b8(0x39e)+_0x1b81b8(0x180)](!0x0);},_0x23a58a[_0x503d72(0x229)+_0x503d72(0x334)+_0x503d72(0x3fe)]=function(){var _0x416bc5=_0x503d72;this['\x6e\x61\x76\x53\x65\x6c\x65\x63\x74\x65'+'\x64\x45\x6c\x65\x6d\x65\x6e\x74\x73']&&(this[_0x416bc5(0x414)+_0x416bc5(0x438)+'\x73\x73'](_0x416bc5(0x417)),delete this[_0x416bc5(0x22b)+_0x416bc5(0x351)]);},_0x23a58a[_0x503d72(0x2a7)+_0x503d72(0x340)]=function(_0x5a32a6,_0x135758,_0x57a3d4,_0x52e778){var _0x32cc33=_0x503d72;'\x6e\x75\x6d\x62\x65\x72'==typeof _0x52e778&&this[_0x32cc33(0x39e)+'\x6f\x6e'][_0x32cc33(0x24d)](_0x52e778);},_0x23a58a[_0x503d72(0x2b9)+_0x503d72(0x39c)]=function(){var _0x581382=_0x503d72;this[_0x581382(0x229)+'\x65\x6c\x65\x63\x74\x65\x64\x45\x6c\x65'+'\x6d\x65\x6e\x74\x73']();},_0x23a58a[_0x503d72(0x1a6)+_0x503d72(0x469)]=function(){var _0x50209b=_0x503d72;this[_0x50209b(0x39e)+'\x6f\x6e']&&(this['\x6e\x61\x76\x43\x6f\x6d\x70\x61\x6e\x69'+'\x6f\x6e'][_0x50209b(0x265)](_0x50209b(0x153),this[_0x50209b(0x1aa)+_0x50209b(0x49a)]),this['\x6f\x66\x66'](_0x50209b(0x35e)+'\x6b',this[_0x50209b(0x2a7)+'\x63\x43\x6c\x69\x63\x6b']),delete this['\x6e\x61\x76\x43\x6f\x6d\x70\x61\x6e\x69'+'\x6f\x6e']);},_0xe3a9d5;}),function(_0x271b35,_0xdd6f31){'use strict';var _0x5364d8=_0x46f77f;_0x5364d8(0x2de)==typeof define&&define[_0x5364d8(0x1eb)]?define('\x69\x6d\x61\x67\x65\x73\x6c\x6f\x61\x64'+_0x5364d8(0x3db)+_0x5364d8(0x2be),['\x65\x76\x2d\x65\x6d\x69\x74\x74\x65\x72'+_0x5364d8(0x256)+'\x72'],function(_0x449d38){return _0xdd6f31(_0x271b35,_0x449d38);}):'\x6f\x62\x6a\x65\x63\x74'==typeof module&&module[_0x5364d8(0x160)]?module['\x65\x78\x70\x6f\x72\x74\x73']=_0xdd6f31(_0x271b35,require(_0x5364d8(0x405))):_0x271b35[_0x5364d8(0x2c1)+'\x65\x64']=_0xdd6f31(_0x271b35,_0x271b35['\x45\x76\x45\x6d\x69\x74\x74\x65\x72']);}(_0x46f77f(0x33b)!=typeof window?window:this,function(_0x5e1cc4,_0x1449fd){var _0x426fba=_0x46f77f,_0x44317e=_0x5e1cc4[_0x426fba(0x193)],_0x1be97a=_0x5e1cc4[_0x426fba(0x231)];function _0x23cfa7(_0x18b4da,_0x103531){for(var _0xb0ba30 in _0x103531)_0x18b4da[_0xb0ba30]=_0x103531[_0xb0ba30];return _0x18b4da;}var _0x46a1d1=Array['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']['\x73\x6c\x69\x63\x65'];function _0x26c999(_0x1d4606){var _0x3a64fc=_0x426fba;return Array[_0x3a64fc(0x21a)](_0x1d4606)?_0x1d4606:_0x3a64fc(0x28b)==typeof _0x1d4606&&_0x3a64fc(0x305)==typeof _0x1d4606[_0x3a64fc(0x317)]?_0x46a1d1[_0x3a64fc(0x359)](_0x1d4606):[_0x1d4606];}function _0x212a9(_0x147094,_0x481fa6,_0x20bdd7){var _0x54cecb=_0x426fba;if(!(this instanceof _0x212a9))return new _0x212a9(_0x147094,_0x481fa6,_0x20bdd7);var _0x5e4106=_0x147094;_0x54cecb(0x44e)==typeof _0x147094&&(_0x5e4106=document[_0x54cecb(0x307)+_0x54cecb(0x28c)](_0x147094)),_0x5e4106?(this[_0x54cecb(0x192)]=_0x26c999(_0x5e4106),this[_0x54cecb(0x40b)]=_0x23cfa7({},this[_0x54cecb(0x40b)]),_0x54cecb(0x2de)==typeof _0x481fa6?_0x20bdd7=_0x481fa6:_0x23cfa7(this[_0x54cecb(0x40b)],_0x481fa6),_0x20bdd7&&this['\x6f\x6e'](_0x54cecb(0x40a),_0x20bdd7),this['\x67\x65\x74\x49\x6d\x61\x67\x65\x73'](),_0x44317e&&(this['\x6a\x71\x44\x65\x66\x65\x72\x72\x65\x64']=new _0x44317e[(_0x54cecb(0x215))]()),setTimeout(this[_0x54cecb(0x1a8)][_0x54cecb(0x174)](this))):_0x1be97a[_0x54cecb(0x411)]('\x42\x61\x64\x20\x65\x6c\x65\x6d\x65\x6e'+'\x74\x20\x66\x6f\x72\x20\x69\x6d\x61\x67'+_0x54cecb(0x26a)+(_0x5e4106||_0x147094));}_0x212a9['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']=Object['\x63\x72\x65\x61\x74\x65'](_0x1449fd['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']),_0x212a9[_0x426fba(0x3c9)][_0x426fba(0x40b)]={},_0x212a9[_0x426fba(0x3c9)]['\x67\x65\x74\x49\x6d\x61\x67\x65\x73']=function(){var _0x10bd25=_0x426fba;this[_0x10bd25(0x3f8)]=[],this['\x65\x6c\x65\x6d\x65\x6e\x74\x73']['\x66\x6f\x72\x45\x61\x63\x68'](this[_0x10bd25(0x3d0)+_0x10bd25(0x259)],this);},_0x212a9['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']['\x61\x64\x64\x45\x6c\x65\x6d\x65\x6e\x74'+'\x49\x6d\x61\x67\x65\x73']=function(_0x38ea70){var _0x4898b2=_0x426fba;_0x4898b2(0x487)==_0x38ea70[_0x4898b2(0x459)]&&this[_0x4898b2(0x260)](_0x38ea70),!0x0===this[_0x4898b2(0x40b)][_0x4898b2(0x216)]&&this[_0x4898b2(0x3d0)+_0x4898b2(0x35b)+'\x49\x6d\x61\x67\x65\x73'](_0x38ea70);var _0x561886=_0x38ea70['\x6e\x6f\x64\x65\x54\x79\x70\x65'];if(_0x561886&&_0x3fa12c[_0x561886]){for(var _0x366a7c=_0x38ea70[_0x4898b2(0x307)+_0x4898b2(0x28c)](_0x4898b2(0x3ad)),_0x2eb1d0=0x0;_0x2eb1d0<_0x366a7c['\x6c\x65\x6e\x67\x74\x68'];_0x2eb1d0++){var _0x4241b7=_0x366a7c[_0x2eb1d0];this['\x61\x64\x64\x49\x6d\x61\x67\x65'](_0x4241b7);}if('\x73\x74\x72\x69\x6e\x67'==typeof this[_0x4898b2(0x40b)][_0x4898b2(0x216)]){var _0xce4194=_0x38ea70['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x4898b2(0x28c)](this['\x6f\x70\x74\x69\x6f\x6e\x73']['\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64']);for(_0x2eb1d0=0x0;_0x2eb1d0<_0xce4194[_0x4898b2(0x317)];_0x2eb1d0++){var _0x2d7e9a=_0xce4194[_0x2eb1d0];this[_0x4898b2(0x3d0)+'\x42\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64'+_0x4898b2(0x259)](_0x2d7e9a);}}}};var _0x3fa12c={0x1:!0x0,0x9:!0x0,0xb:!0x0};function _0xb0a23a(_0x6a4eef){var _0x52b1c0=_0x426fba;this[_0x52b1c0(0x3ad)]=_0x6a4eef;}function _0x2dc29a(_0x8ab7c2,_0x36daac){var _0x4a58b8=_0x426fba;this[_0x4a58b8(0x245)]=_0x8ab7c2,this[_0x4a58b8(0x486)]=_0x36daac,this[_0x4a58b8(0x3ad)]=new Image();}return _0x212a9[_0x426fba(0x3c9)][_0x426fba(0x3d0)+'\x42\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64'+_0x426fba(0x259)]=function(_0x2fbed5){var _0xfbf01e=_0x426fba,_0xbf84fe=getComputedStyle(_0x2fbed5);if(_0xbf84fe)for(var _0x5298a2=/url\((['"])?(.*?)\1\)/gi,_0x28891c=_0x5298a2[_0xfbf01e(0x2f8)](_0xbf84fe['\x62\x61\x63\x6b\x67\x72\x6f\x75\x6e\x64'+_0xfbf01e(0x184)]);null!==_0x28891c;){var _0x22bf33=_0x28891c&&_0x28891c[0x2];_0x22bf33&&this[_0xfbf01e(0x498)+_0xfbf01e(0x28d)](_0x22bf33,_0x2fbed5),_0x28891c=_0x5298a2[_0xfbf01e(0x2f8)](_0xbf84fe[_0xfbf01e(0x216)+_0xfbf01e(0x184)]);}},_0x212a9[_0x426fba(0x3c9)][_0x426fba(0x260)]=function(_0x394b3d){var _0x48c8e3=new _0xb0a23a(_0x394b3d);this['\x69\x6d\x61\x67\x65\x73']['\x70\x75\x73\x68'](_0x48c8e3);},_0x212a9[_0x426fba(0x3c9)][_0x426fba(0x498)+_0x426fba(0x28d)]=function(_0x1a80d9,_0x318f48){var _0x243eb7=_0x426fba,_0x35150d=new _0x2dc29a(_0x1a80d9,_0x318f48);this['\x69\x6d\x61\x67\x65\x73'][_0x243eb7(0x23d)](_0x35150d);},_0x212a9[_0x426fba(0x3c9)][_0x426fba(0x1a8)]=function(){var _0x5709b9=_0x426fba,_0x2fd00f=this;function _0x50bda8(_0x2d178d,_0x3c357d,_0x2156d4){setTimeout(function(){var _0x43d297=_0xda54;_0x2fd00f[_0x43d297(0x478)](_0x2d178d,_0x3c357d,_0x2156d4);});}this[_0x5709b9(0x29b)+_0x5709b9(0x3ab)]=0x0,this['\x68\x61\x73\x41\x6e\x79\x42\x72\x6f\x6b'+'\x65\x6e']=!0x1,this[_0x5709b9(0x3f8)][_0x5709b9(0x317)]?this[_0x5709b9(0x3f8)][_0x5709b9(0x1b3)](function(_0x59211d){var _0x5254f2=_0x5709b9;_0x59211d[_0x5254f2(0x401)](_0x5254f2(0x478),_0x50bda8),_0x59211d[_0x5254f2(0x1a8)]();}):this['\x63\x6f\x6d\x70\x6c\x65\x74\x65']();},_0x212a9[_0x426fba(0x3c9)][_0x426fba(0x478)]=function(_0x2ce376,_0x4b9b57,_0x8f041f){var _0x2513a3=_0x426fba;this[_0x2513a3(0x29b)+_0x2513a3(0x3ab)]++,this[_0x2513a3(0x19f)+'\x65\x6e']=this[_0x2513a3(0x19f)+'\x65\x6e']||!_0x2ce376[_0x2513a3(0x482)],this[_0x2513a3(0x279)](_0x2513a3(0x478),[this,_0x2ce376,_0x4b9b57]),this[_0x2513a3(0x2b0)]&&this[_0x2513a3(0x2b0)]['\x6e\x6f\x74\x69\x66\x79']&&this[_0x2513a3(0x2b0)][_0x2513a3(0x243)](this,_0x2ce376),this['\x70\x72\x6f\x67\x72\x65\x73\x73\x65\x64'+_0x2513a3(0x3ab)]==this[_0x2513a3(0x3f8)][_0x2513a3(0x317)]&&this[_0x2513a3(0x485)](),this[_0x2513a3(0x40b)][_0x2513a3(0x240)]&&_0x1be97a&&_0x1be97a[_0x2513a3(0x1af)](_0x2513a3(0x3bf)+_0x8f041f,_0x2ce376,_0x4b9b57);},_0x212a9[_0x426fba(0x3c9)][_0x426fba(0x485)]=function(){var _0x25e3ba=_0x426fba,_0x490723=this[_0x25e3ba(0x19f)+'\x65\x6e']?_0x25e3ba(0x493):_0x25e3ba(0x453);if(this[_0x25e3ba(0x395)]=!0x0,this[_0x25e3ba(0x279)](_0x490723,[this]),this['\x65\x6d\x69\x74\x45\x76\x65\x6e\x74'](_0x25e3ba(0x40a),[this]),this[_0x25e3ba(0x2b0)]){var _0x846b45=this['\x68\x61\x73\x41\x6e\x79\x42\x72\x6f\x6b'+'\x65\x6e']?_0x25e3ba(0x428):'\x72\x65\x73\x6f\x6c\x76\x65';this[_0x25e3ba(0x2b0)][_0x846b45](this);}},_0xb0a23a['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65']=Object[_0x426fba(0x1cd)](_0x1449fd[_0x426fba(0x3c9)]),_0xb0a23a[_0x426fba(0x3c9)][_0x426fba(0x1a8)]=function(){var _0x2b1a26=_0x426fba;this[_0x2b1a26(0x3cb)+'\x43\x6f\x6d\x70\x6c\x65\x74\x65']()?this[_0x2b1a26(0x384)](0x0!==this['\x69\x6d\x67'][_0x2b1a26(0x3e7)+'\x74\x68'],_0x2b1a26(0x3e7)+'\x74\x68'):(this['\x70\x72\x6f\x78\x79\x49\x6d\x61\x67\x65']=new Image(),this[_0x2b1a26(0x331)][_0x2b1a26(0x1bb)+_0x2b1a26(0x333)](_0x2b1a26(0x42f),this),this[_0x2b1a26(0x331)][_0x2b1a26(0x1bb)+_0x2b1a26(0x333)]('\x65\x72\x72\x6f\x72',this),this[_0x2b1a26(0x3ad)][_0x2b1a26(0x1bb)+_0x2b1a26(0x333)](_0x2b1a26(0x42f),this),this['\x69\x6d\x67'][_0x2b1a26(0x1bb)+_0x2b1a26(0x333)](_0x2b1a26(0x411),this),this['\x70\x72\x6f\x78\x79\x49\x6d\x61\x67\x65'][_0x2b1a26(0x415)]=this[_0x2b1a26(0x3ad)][_0x2b1a26(0x415)]);},_0xb0a23a['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x426fba(0x3cb)+_0x426fba(0x165)]=function(){var _0x2e2561=_0x426fba;return this[_0x2e2561(0x3ad)]['\x63\x6f\x6d\x70\x6c\x65\x74\x65']&&this[_0x2e2561(0x3ad)][_0x2e2561(0x3e7)+'\x74\x68'];},_0xb0a23a['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x426fba(0x384)]=function(_0x5bb916,_0x707454){var _0x482cc8=_0x426fba;this[_0x482cc8(0x482)]=_0x5bb916,this[_0x482cc8(0x279)](_0x482cc8(0x478),[this,this[_0x482cc8(0x3ad)],_0x707454]);},_0xb0a23a[_0x426fba(0x3c9)]['\x68\x61\x6e\x64\x6c\x65\x45\x76\x65\x6e'+'\x74']=function(_0x13ad83){var _0x12f0f9=_0x426fba,_0x2d2ca2='\x6f\x6e'+_0x13ad83[_0x12f0f9(0x49e)];this[_0x2d2ca2]&&this[_0x2d2ca2](_0x13ad83);},_0xb0a23a[_0x426fba(0x3c9)][_0x426fba(0x484)]=function(){var _0x3c3d4a=_0x426fba;this['\x63\x6f\x6e\x66\x69\x72\x6d'](!0x0,_0x3c3d4a(0x484)),this[_0x3c3d4a(0x1ff)+'\x74\x73']();},_0xb0a23a['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0x426fba(0x273)]=function(){this['\x63\x6f\x6e\x66\x69\x72\x6d'](!0x1,'\x6f\x6e\x65\x72\x72\x6f\x72'),this['\x75\x6e\x62\x69\x6e\x64\x45\x76\x65\x6e'+'\x74\x73']();},_0xb0a23a[_0x426fba(0x3c9)][_0x426fba(0x1ff)+'\x74\x73']=function(){var _0x16ef2e=_0x426fba;this[_0x16ef2e(0x331)][_0x16ef2e(0x226)+_0x16ef2e(0x2e3)](_0x16ef2e(0x42f),this),this[_0x16ef2e(0x331)]['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x16ef2e(0x2e3)](_0x16ef2e(0x411),this),this['\x69\x6d\x67'][_0x16ef2e(0x226)+_0x16ef2e(0x2e3)](_0x16ef2e(0x42f),this),this[_0x16ef2e(0x3ad)][_0x16ef2e(0x226)+'\x74\x4c\x69\x73\x74\x65\x6e\x65\x72'](_0x16ef2e(0x411),this);},_0x2dc29a[_0x426fba(0x3c9)]=Object[_0x426fba(0x1cd)](_0xb0a23a[_0x426fba(0x3c9)]),_0x2dc29a[_0x426fba(0x3c9)][_0x426fba(0x1a8)]=function(){var _0x488a64=_0x426fba;this[_0x488a64(0x3ad)]['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+'\x73\x74\x65\x6e\x65\x72'](_0x488a64(0x42f),this),this['\x69\x6d\x67'][_0x488a64(0x1bb)+_0x488a64(0x333)](_0x488a64(0x411),this),this[_0x488a64(0x3ad)][_0x488a64(0x415)]=this[_0x488a64(0x245)],this[_0x488a64(0x3cb)+_0x488a64(0x165)]()&&(this['\x63\x6f\x6e\x66\x69\x72\x6d'](0x0!==this[_0x488a64(0x3ad)]['\x6e\x61\x74\x75\x72\x61\x6c\x57\x69\x64'+'\x74\x68'],_0x488a64(0x3e7)+'\x74\x68'),this[_0x488a64(0x1ff)+'\x74\x73']());},_0x2dc29a[_0x426fba(0x3c9)][_0x426fba(0x1ff)+'\x74\x73']=function(){var _0x3e5810=_0x426fba;this[_0x3e5810(0x3ad)]['\x72\x65\x6d\x6f\x76\x65\x45\x76\x65\x6e'+_0x3e5810(0x2e3)](_0x3e5810(0x42f),this),this[_0x3e5810(0x3ad)][_0x3e5810(0x226)+_0x3e5810(0x2e3)](_0x3e5810(0x411),this);},_0x2dc29a[_0x426fba(0x3c9)][_0x426fba(0x384)]=function(_0x461094,_0x50f63e){this['\x69\x73\x4c\x6f\x61\x64\x65\x64']=_0x461094,this['\x65\x6d\x69\x74\x45\x76\x65\x6e\x74']('\x70\x72\x6f\x67\x72\x65\x73\x73',[this,this['\x65\x6c\x65\x6d\x65\x6e\x74'],_0x50f63e]);},_0x212a9[_0x426fba(0x17c)+_0x426fba(0x2a4)]=function(_0x24bd87){var _0x291f28=_0x426fba;(_0x24bd87=_0x24bd87||_0x5e1cc4['\x6a\x51\x75\x65\x72\x79'])&&((_0x44317e=_0x24bd87)['\x66\x6e'][_0x291f28(0x2c1)+'\x65\x64']=function(_0x497e07,_0x54a0c2){var _0x8cd247=_0x291f28;return new _0x212a9(this,_0x497e07,_0x54a0c2)[_0x8cd247(0x2b0)]['\x70\x72\x6f\x6d\x69\x73\x65'](_0x44317e(this));});},_0x212a9[_0x426fba(0x17c)+_0x426fba(0x2a4)](),_0x212a9;}),function(_0x2fc02e,_0x4f8a5f){var _0x40e9d5=_0x46f77f;_0x40e9d5(0x2de)==typeof define&&define[_0x40e9d5(0x1eb)]?define([_0x40e9d5(0x3eb)+_0x40e9d5(0x456),'\x69\x6d\x61\x67\x65\x73\x6c\x6f\x61\x64'+_0x40e9d5(0x3db)+_0x40e9d5(0x2be)],function(_0x3ee1d3,_0xc77cf5){return _0x4f8a5f(_0x2fc02e,_0x3ee1d3,_0xc77cf5);}):_0x40e9d5(0x28b)==typeof module&&module[_0x40e9d5(0x160)]?module[_0x40e9d5(0x160)]=_0x4f8a5f(_0x2fc02e,require(_0x40e9d5(0x2ed)),require(_0x40e9d5(0x38e)+'\x65\x64')):_0x2fc02e['\x46\x6c\x69\x63\x6b\x69\x74\x79']=_0x4f8a5f(_0x2fc02e,_0x2fc02e['\x46\x6c\x69\x63\x6b\x69\x74\x79'],_0x2fc02e[_0x40e9d5(0x2c1)+'\x65\x64']);}(window,function(_0x19a336,_0x322a48,_0x596c22){'use strict';var _0xa03c94=_0x46f77f;_0x322a48[_0xa03c94(0x421)+_0xa03c94(0x2f5)][_0xa03c94(0x23d)]('\x5f\x63\x72\x65\x61\x74\x65\x49\x6d\x61'+_0xa03c94(0x1c8));var _0x5e9d0c=_0x322a48['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'];return _0x5e9d0c['\x5f\x63\x72\x65\x61\x74\x65\x49\x6d\x61'+'\x67\x65\x73\x4c\x6f\x61\x64\x65\x64']=function(){var _0x3a23dc=_0xa03c94;this['\x6f\x6e'](_0x3a23dc(0x1dd),this[_0x3a23dc(0x2c1)+'\x65\x64']);},_0x5e9d0c[_0xa03c94(0x2c1)+'\x65\x64']=function(){var _0x181dc2=_0xa03c94;if(this[_0x181dc2(0x40b)][_0x181dc2(0x2c1)+'\x65\x64']){var _0x4d27b9=this;_0x596c22(this[_0x181dc2(0x3da)])['\x6f\x6e']('\x70\x72\x6f\x67\x72\x65\x73\x73',function(_0x5718a8,_0x19b9f5){var _0x1a793b=_0x181dc2,_0x3a7314=_0x4d27b9['\x67\x65\x74\x50\x61\x72\x65\x6e\x74\x43'+_0x1a793b(0x16d)](_0x19b9f5[_0x1a793b(0x3ad)]);_0x4d27b9[_0x1a793b(0x230)+_0x1a793b(0x152)](_0x3a7314&&_0x3a7314[_0x1a793b(0x486)]),_0x4d27b9['\x6f\x70\x74\x69\x6f\x6e\x73'][_0x1a793b(0x146)]||_0x4d27b9['\x70\x6f\x73\x69\x74\x69\x6f\x6e\x53\x6c'+_0x1a793b(0x239)+_0x1a793b(0x356)]();});}},_0x322a48;});while(!window[_0x46f77f(0x25b)]){await new Promise(_0x3cb15b=>setTimeout(_0x3cb15b,0xa));}_0x351bf3(!![]);});}function _0x550c67(){if(window['\x46\x6c\x69\x63\x6b\x69\x74\x79']!==undefined)return!![];return new Promise(async(_0x2913ff,_0x209754)=>{var _0x3f12a3=_0xda54;try{await _0x25aa17(_0x3f12a3(0x2e5)+'\x6e\x6a\x73\x2e\x63\x6c\x6f\x75\x64\x66'+_0x3f12a3(0x33d)+_0x3f12a3(0x291)+_0x3f12a3(0x188)+_0x3f12a3(0x1b7)+_0x3f12a3(0x2b5)+_0x3f12a3(0x4a0));}catch(_0x2b9dc0){await _0x5b4daf();}_0x2913ff(!![]);});}function _0x400f82(_0x309c99){var _0x42ae5d=_0x37e750;if(_0x48a9f2[_0x42ae5d(0x467)+_0x42ae5d(0x1a2)+_0x42ae5d(0x364)+'\x6f\x70'])return;const _0x1783e6=document[_0x42ae5d(0x307)+_0x42ae5d(0x28c)]('\x2e\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c'+'\x73\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69'+_0x42ae5d(0x41f)+'\x63\x74\x2d\x73\x69\x6e\x67\x6c\x65\x5f'+_0x42ae5d(0x191));if(!_0x1783e6)return;for(let _0x1285ba of _0x1783e6){_0x1285ba[_0x42ae5d(0x1bb)+'\x73\x74\x65\x6e\x65\x72']('\x63\x6c\x69\x63\x6b',function(_0x39141d){const _0x13f8c2=()=>{var _0x14e525=_0xda54;const _0x2e211b=_0x1285ba[_0x14e525(0x328)+'\x74\x65'](_0x14e525(0x408)+_0x14e525(0x2d3)+'\x2d\x65\x7a\x66\x79');if(!_0x2e211b)return;const _0xc8fa89=parseInt(_0x2e211b);_0x309c99[_0x14e525(0x153)](_0xc8fa89,_0x48a9f2[_0x14e525(0x2ef)+'\x61\x67\x65\x4c\x6f\x6f\x70'],!![]);};setTimeout(_0x13f8c2,_0x37279f);});}}function _0x51dcea(_0x2b272c){var _0x39347c=_0x37e750;if(_0xc61995)return;const _0x4ec449=document[_0x39347c(0x307)+_0x39347c(0x28c)](_0x39347c(0x2d0)+'\x77\x72\x61\x70\x70\x65\x72');if(!_0x4ec449)return;for(let _0x2f9cbb of _0x4ec449){_0x2f9cbb['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x39347c(0x333)](_0x39347c(0x2e2),async function(){_0x3f92c9=!![];const _0x4756b0=async()=>{var _0x466377=_0xda54;const _0x203b08=await _0x138324();if(!_0x203b08)return;const _0x19c4c8=_0x466377(0x1fa)+_0x466377(0x3ef)in _0x203b08?_0x203b08['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69'+'\x6d\x61\x67\x65']['\x69\x64']:_0x203b08[_0x466377(0x362)+'\x65\x64\x69\x61']['\x69\x64'],_0x384499=_0x203b08[_0x466377(0x1fa)+_0x466377(0x3ef)][_0x466377(0x437)]||_0x203b08[_0x466377(0x362)+_0x466377(0x4a4)][_0x466377(0x437)];if(!_0x19c4c8)return console[_0x466377(0x1af)](_0x466377(0x451)+_0x466377(0x39f));console[_0x466377(0x1af)](_0xc61995);const _0x119f19=document[_0x466377(0x307)+_0x466377(0x2e9)]('\x23'+_0x540451+(_0x466377(0x318)+'\x67\x65\x2d\x70\x6f\x73\x69\x74\x69\x6f'+_0x466377(0x166))+_0x384499+'\x27\x5d');if(!_0x119f19)return;const _0x30cf78=_0x119f19[_0x466377(0x328)+'\x74\x65'](_0x466377(0x32b)+_0x466377(0x33f));!_0xc61995&&_0x2b272c['\x73\x65\x6c\x65\x63\x74'](_0x30cf78);};setTimeout(_0x4756b0,_0x1cb9b8),await _0x238435(_0x1cb9b8),_0x3f92c9=![];});}}async function _0x3a8599(_0x311811){var _0x236c33=_0x37e750;if(!/variant=\d/[_0x236c33(0x195)](window[_0x236c33(0x3b6)][_0x236c33(0x1f4)]))return;_0xda74cf=!![];try{const _0x3e76b8=await _0x138324();console[_0x236c33(0x1af)](_0x236c33(0x42f),_0x3e76b8);if(!_0x3e76b8||_0x3e76b8[_0x236c33(0x317)]<=0x0)return;const _0x15a983=_0x236c33(0x1fa)+_0x236c33(0x3ef)in _0x3e76b8?_0x3e76b8[_0x236c33(0x1fa)+_0x236c33(0x3ef)]['\x69\x64']:_0x3e76b8[_0x236c33(0x362)+'\x65\x64\x69\x61']['\x69\x64'],_0x3a4e46=_0x3e76b8[_0x236c33(0x1fa)+_0x236c33(0x3ef)]['\x70\x6f\x73\x69\x74\x69\x6f\x6e']||_0x3e76b8['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x6d'+'\x65\x64\x69\x61'][_0x236c33(0x437)];if(!_0x15a983||_0x15a983[_0x236c33(0x317)]<=0x0)return console[_0x236c33(0x1af)](_0x236c33(0x2a6)+'\x2e');const _0x4e8afc=document[_0x236c33(0x307)+'\x74\x6f\x72']('\x23'+_0x540451+(_0x236c33(0x318)+_0x236c33(0x23e)+_0x236c33(0x166))+_0x3a4e46+'\x27\x5d');if(!_0x4e8afc)return;const _0x27e301=parseInt(_0x4e8afc[_0x236c33(0x328)+'\x74\x65'](_0x236c33(0x32b)+_0x236c33(0x33f)));_0x311811[_0x236c33(0x153)](_0x27e301,_0x48a9f2[_0x236c33(0x2ef)+_0x236c33(0x46c)],!![]),await _0x238435(_0x1cb9b8),_0xda74cf=![];}catch(_0x3cfdec){return;}}async function _0x2efdb8(){var _0x19c327=_0x37e750;if(_0x3f92c9||_0xda74cf)return console[_0x19c327(0x1af)](_0x19c327(0x385)+_0x19c327(0x1d7)+_0x19c327(0x3c6)+'\x70\x64\x6f\x77\x6e\x2e');await _0x238435(_0x3fb2db);const _0x11652f=document[_0x19c327(0x307)+_0x19c327(0x2e9)]('\x23'+_0x540451+(_0x19c327(0x45f)+_0x19c327(0x4ac)));if(!_0x11652f)return;const _0x5d7047=_0x11652f['\x68\x61\x73\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65']('\x64\x61\x74\x61\x2d\x70\x72\x6f\x64\x75'+_0x19c327(0x341)+_0x19c327(0x3c1));if(_0x5d7047)return;const _0x7e9365=_0x11652f[_0x19c327(0x328)+'\x74\x65'](_0x19c327(0x34b)+'\x2d\x64\x72\x6f\x70\x64\x6f\x77\x6e\x2d'+'\x69\x64'),_0x450a16=await _0x2335a5(_0x7e9365);for(const [_0x192655,_0x28f18d]of _0x450a16[_0x19c327(0x3ae)]()){const _0x364a39=parseInt(_0x192655)+0x1,_0x3c3914=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x19c327(0x2e9)](_0x19c327(0x1b4)+_0x19c327(0x368)+_0x19c327(0x171)+'\x6e'+_0x364a39+'\x22\x5d');console[_0x19c327(0x1af)](_0x19c327(0x380)+'\x74',_0x3c3914);if(!_0x3c3914)return;try{_0x3c3914['\x76\x61\x6c\x75\x65']=_0x28f18d,_0x3c3914[_0x19c327(0x2b8)+'\x65\x6e\x74'](new Event(_0x19c327(0x2e2),{'\x62\x75\x62\x62\x6c\x65\x73':!![]}));}catch(_0x3475b5){}}}function _0x2c8643(){var _0x117fb1=_0x37e750;const _0x688f86=_0x117fb1(0x2a5)+'\x6d\x62',_0x4f0156=_0x117fb1(0x1e6)+'\x2d\x73\x65\x6c\x65\x63\x74\x65\x64',_0x1d035c=window[_0x117fb1(0x4a2)+_0x117fb1(0x39d)+'\x45\x58'],_0x249235=document[_0x117fb1(0x307)+_0x117fb1(0x2e9)]('\x5b\x64\x61\x74\x61\x2d\x74\x68\x75\x6d'+_0x117fb1(0x34d)+_0x117fb1(0x480)+_0x1d035c+'\x22\x5d');if(!_0x249235)return;const _0xe15e5=document[_0x117fb1(0x307)+_0x117fb1(0x28c)]('\x2e'+_0x4f0156+_0x117fb1(0x311)+_0x688f86);if(_0xe15e5&&_0xe15e5['\x6c\x65\x6e\x67\x74\x68']>=0x1)for(const _0x3a2871 of _0xe15e5){_0x3a2871['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x117fb1(0x417)](_0x4f0156),_0x3a2871['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x117fb1(0x417)](_0x688f86);}_0x249235['\x63\x6c\x61\x73\x73\x4c\x69\x73\x74'][_0x117fb1(0x3fa)](_0x4f0156);}function _0xd5e640(){var _0x26940a=_0x37e750;const _0x6b2121=_0x26940a(0x1c9)+_0x26940a(0x186)+_0x26940a(0x272),_0x2911c6=document[_0x26940a(0x307)+_0x26940a(0x2e9)]('\x2e\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c'+'\x73\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69'+_0x26940a(0x43c));if(!_0x2911c6)return;_0x2911c6[_0x26940a(0x2a0)][_0x26940a(0x3fa)](_0x6b2121);}async function _0x261e69(){var _0x579034=_0x37e750;let _0x1e8573=new Flickity('\x23'+_0x540451,{..._0x554a58,'\x6f\x6e':{'\x72\x65\x61\x64\x79':async function(_0x4f4fcd){_0x2c8643(),_0xd5e640();},'\x63\x68\x61\x6e\x67\x65':async function(_0x16e0c8){var _0x3aba69=_0xda54;_0xc61995=!![],window[_0x3aba69(0x4a2)+_0x3aba69(0x39d)+'\x45\x58']=_0x16e0c8,_0x2efdb8(),_0x2c8643(),await _0x238435(_0x3ed496),_0xc61995=![];}}});window['\x65\x7a\x66\x79\x44\x65\x62\x75\x74\x53'+_0x579034(0x141)+'\x72\x65\x64']=_0x1e8573,_0x3a8599(_0x1e8573),_0x51dcea(_0x1e8573),_0x400f82(_0x1e8573);}function _0x199a44(){var _0x1fa3b4=_0x37e750;const _0x4b342e='\x23\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c'+_0x1fa3b4(0x1e5);if(!_0x48a9f2['\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64'+'\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62'+_0x1fa3b4(0x364)+'\x6f\x70'])return;if(!document[_0x1fa3b4(0x307)+'\x74\x6f\x72'](_0x4b342e))return;const _0xd82637=new Flickity(_0x4b342e,_0x37bf5a,{'\x6f\x6e':{'\x72\x65\x61\x64\x79':function(){var _0x52bdcd=_0x1fa3b4;console[_0x52bdcd(0x1af)](_0x52bdcd(0x29e)+_0x52bdcd(0x396));}}});}function _0x363d42(){var _0x47b22a=_0x37e750;const _0x1d70a3=document[_0x47b22a(0x307)+'\x74\x6f\x72\x41\x6c\x6c'](_0x47b22a(0x15a)+_0x47b22a(0x1a1));if(!_0x1d70a3)return;for(let _0x4b9af9 of _0x1d70a3){_0x4b9af9['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x47b22a(0x333)](_0x47b22a(0x314),function(_0x2f30b2){var _0x30ee42=_0x47b22a;_0x2f30b2[_0x30ee42(0x347)+_0x30ee42(0x3be)]();});}}return{'\x69\x6e\x69\x74':async function(){var _0x3f585a=_0x37e750;await _0x550c67(),await _0x238435(0x15e),_0x261e69(),_0x199a44(),_0x363d42(),document[_0x3f585a(0x1bb)+'\x73\x74\x65\x6e\x65\x72'](_0x3f585a(0x303)+_0x3f585a(0x2da),async function(){}),window['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x3f585a(0x333)](_0x3f585a(0x2ab),function(){}),window['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+'\x73\x74\x65\x6e\x65\x72'](_0x3f585a(0x42f),function(){}),window[_0x3f585a(0x1bb)+_0x3f585a(0x333)]('\x73\x63\x72\x6f\x6c\x6c',function(){});}};}(),ezfyDebutSliderPro['\x69\x6e\x69\x74']());